import { MatButtonModule } from '@angular/material/button';
import { ErrorStateMatcher } from '@angular/material/core';
import { MatFormFieldControl } from '@angular/material/form-field';
import { AutofillMonitor } from '@angular/cdk/text-field';
import { CDK_TABLE_TEMPLATE, CdkCellDef, CdkColumnDef, CdkHeaderCellDef, CDK_ROW_TEMPLATE, CdkRow, CdkRowDef, CdkHeaderRow, CdkHeaderRowDef, CdkTableModule } from '@angular/cdk/table';
import { BreakpointObserver } from '@angular/cdk/layout';
import { ViewportRuler, Overlay, ScrollDispatcher, OverlayContainer, OverlayConfig, OverlayModule } from '@angular/cdk/overlay';
import { CdkPortalOutlet, PortalInjector, ComponentPortal, TemplatePortal, PortalModule } from '@angular/cdk/portal';
import { Directionality } from '@angular/cdk/bidi';
import { MAT_MOMENT_DATE_FORMATS, MAT_MOMENT_DATE_ADAPTER_OPTIONS, MomentDateAdapter } from '@angular/material-moment-adapter';
import { ANIMATION_MODULE_TYPE, BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { FocusMonitor, AriaDescriber, FocusTrapFactory } from '@angular/cdk/a11y';
import { Platform } from '@angular/cdk/platform';
import localePt from '@angular/common/locales/pt';
import { DomSanitizer, DOCUMENT, HAMMER_LOADER, Title } from '@angular/platform-browser';
import { MatSnackBar as MatSnackBar$1 } from '@angular/material/snack-bar';
import { finalize, tap, catchError } from 'rxjs/operators';
import { Router, RouterModule } from '@angular/router';
import { FlexLayoutModule } from '@angular/flex-layout';
import { trigger, state, style, transition, animate, keyframes } from '@angular/animations';
import { ToastrService, ToastrModule, ToastPackage, Toast } from 'ngx-toastr';
import { FileUploader, FileSelectDirective, FileDropDirective, FileUploadModule } from 'ng2-file-upload';
import { UniqueSelectionDispatcher, SelectionModel } from '@angular/cdk/collections';
import _ from 'lodash';
import * as moment_ from 'moment';
import { Subject, Subscription, of, EMPTY } from 'rxjs';
import { __extends, __values, __spread, __assign, __awaiter, __generator } from 'tslib';
import { FormGroupDirective, NgControl, NgForm, NG_VALUE_ACCESSOR, NG_VALIDATORS, ReactiveFormsModule, FormsModule, FormControl } from '@angular/forms';
import { TextMaskModule } from 'angular2-text-mask';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Location, CommonModule, CurrencyPipe, DatePipe, PercentPipe, registerLocaleData } from '@angular/common';
import { MatDialogRef, MAT_DIALOG_DATA, MatInput, MAT_INPUT_VALUE_ACCESSOR, MatError, MatFormField, MAT_LABEL_GLOBAL_OPTIONS, MAT_FORM_FIELD_DEFAULT_OPTIONS, matFormFieldAnimations, MatOption, MAT_OPTION_PARENT_COMPONENT, MatOptgroup, MatSelect, matSelectAnimations, MatFormFieldControl as MatFormFieldControl$1, ErrorStateMatcher as ErrorStateMatcher$1, MAT_SELECT_SCROLL_STRATEGY, MatCheckbox, MAT_CHECKBOX_CLICK_ACTION, MatTable, MatIcon, MatAutocomplete, MAT_AUTOCOMPLETE_DEFAULT_OPTIONS, MatAutocompleteTrigger, MAT_AUTOCOMPLETE_SCROLL_STRATEGY, MatButton, MatCellDef, MatColumnDef, MatCell, MatHeaderCell, MatHeaderCellDef, MatRow, MatRowDef, MatHeaderRow, MatHeaderRowDef, MatCard, MatDivider, MatChip, MAT_RIPPLE_GLOBAL_OPTIONS, MatChipInput, MAT_CHIPS_DEFAULT_OPTIONS, MatChipList, MatChipRemove, TooltipComponent, matTooltipAnimations, MatTooltip, MAT_TOOLTIP_SCROLL_STRATEGY, MAT_TOOLTIP_DEFAULT_OPTIONS, MatRadioGroup, MatRadioButton, MatDatepicker, MatDialog, MAT_DATEPICKER_SCROLL_STRATEGY, DateAdapter, MatDatepickerToggle, MatDatepickerIntl, MatDatepickerInput, MAT_DATE_FORMATS, MatDialogActions, matDialogAnimations, MatDialogContainer, MatDialogConfig, MAT_DIALOG_DEFAULT_OPTIONS, MAT_DIALOG_SCROLL_STRATEGY, MatDialogClose, MatDialogContent, MatDialogTitle, MatPaginator, MatPaginatorIntl, MatBadge, MatProgressBar, MAT_PROGRESS_BAR_LOCATION, MatMenuContent, MatMenuItem, MatMenuTrigger, MAT_MENU_SCROLL_STRATEGY, MatMenu, matMenuAnimations, MatSort, matSortAnimations, MatSortHeader, MatSortHeaderIntl, MatAccordion, MAT_ACCORDION, MatExpansionPanelActionRow, matExpansionAnimations, MatExpansionPanel, MAT_EXPANSION_PANEL_DEFAULT_OPTIONS, MatExpansionPanelHeader, MatExpansionPanelDescription, MatExpansionPanelTitle, MatSlider, MatProgressSpinnerModule, MatRippleModule, MatCheckboxModule, MatSelectModule, MatFormFieldModule, MatOptionModule, MatListModule, MatTableModule, MatIconModule, MatAutocompleteModule, MatCardModule, MatDialogModule, MatToolbarModule, MatInputModule, MatDividerModule, MatChipsModule, MatTooltipModule, MatMenuModule, MatSortModule, MAT_DATE_LOCALE, MatButtonToggleModule, MatTableDataSource, MatToolbar, MatIconRegistry, MatPaginatorModule, MatButtonModule as MatButtonModule$1, MatSnackBar, MatTabsModule, MatExpansionModule, MatProgressBarModule } from '@angular/material';
import { Injectable, Component, Input, Inject, forwardRef, Output, EventEmitter, ViewChild, NgModule, ElementRef, Directive, HostListener, InjectionToken, Injector, ComponentFactoryResolver, ViewContainerRef, Pipe, defineInjectable, inject, NgZone, Renderer2, ChangeDetectorRef, Optional, Host, ViewEncapsulation, ChangeDetectionStrategy, Attribute, SkipSelf, ContentChildren, TemplateRef, ApplicationRef, Self, ContentChild } from '@angular/core';

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var RteLibraryService = /** @class */ (function () {
    function RteLibraryService() {
    }
    RteLibraryService.decorators = [
        { type: Injectable, args: [{
                    providedIn: 'root'
                },] }
    ];
    /** @nocollapse */
    RteLibraryService.ctorParameters = function () { return []; };
    /** @nocollapse */ RteLibraryService.ngInjectableDef = defineInjectable({ factory: function RteLibraryService_Factory() { return new RteLibraryService(); }, token: RteLibraryService, providedIn: "root" });
    return RteLibraryService;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var RteLibraryComponent = /** @class */ (function () {
    function RteLibraryComponent() {
    }
    /**
     * @return {?}
     */
    RteLibraryComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
    };
    RteLibraryComponent.decorators = [
        { type: Component, args: [{
                    selector: 'rte-rte-library',
                    template: "\n    <p>\n      rte-library works!\n    </p>\n  "
                }] }
    ];
    /** @nocollapse */
    RteLibraryComponent.ctorParameters = function () { return []; };
    return RteLibraryComponent;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var ActionYesNoButton = /** @class */ (function () {
    function ActionYesNoButton() {
        this.subject = new Subject();
    }
    /**
     * @return {?}
     */
    ActionYesNoButton.prototype.click = /**
     * @return {?}
     */
    function () {
        this.subject.next();
    };
    /**
     * @return {?}
     */
    ActionYesNoButton.prototype.afterClick = /**
     * @return {?}
     */
    function () {
        return this.subject.asObservable();
    };
    return ActionYesNoButton;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
var uniqueId = 0;
/**
 * @template T, R
 */
var  /**
 * @template T, R
 */
RteDialogRef = /** @class */ (function (_super) {
    __extends(RteDialogRef, _super);
    function RteDialogRef(_overlayRef, _containerInstance, _location, id) {
        if (id === void 0) { id = "rte-dialog-" + uniqueId++; }
        var _this = _super.call(this, _overlayRef, _containerInstance, _location, id) || this;
        _this.id = id;
        return _this;
    }
    return RteDialogRef;
}(MatDialogRef));

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var YesNoDialogComponent = /** @class */ (function () {
    function YesNoDialogComponent(dialogRef, data) {
        this.dialogRef = dialogRef;
        this.data = data;
    }
    /**
     * @return {?}
     */
    YesNoDialogComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        var _this = this;
        this.description = this.data.description;
        this.title = this.data.title;
        this.yesNoActions = new Array();
        /** @type {?} */
        var yesButton = new ActionYesNoButton();
        yesButton.description = 'Sim';
        yesButton.disabled = false;
        yesButton.afterClick().subscribe(function (x) {
            _this.onYesClick();
        });
        /** @type {?} */
        var noButton = new ActionYesNoButton();
        noButton.description = 'Não';
        noButton.disabled = false;
        noButton.afterClick().subscribe(function (x) {
            _this.onNoClick();
        });
        this.yesNoActions.push(yesButton);
        this.yesNoActions.push(noButton);
    };
    /**
     * @return {?}
     */
    YesNoDialogComponent.prototype.onNoClick = /**
     * @return {?}
     */
    function () {
        this.dialogRef.close(false);
    };
    /**
     * @return {?}
     */
    YesNoDialogComponent.prototype.onYesClick = /**
     * @return {?}
     */
    function () {
        this.dialogRef.close(true);
    };
    YesNoDialogComponent.decorators = [
        { type: Component, args: [{
                    selector: 'rte-yes-no-dialog',
                    template: "<h2 rte-dialog-title>{{title}}</h2>\r\n<rte-dialog-content>\r\n  <div class=\"row-form\">\r\n    <div class=\"column-form\">\r\n      <p>{{description}}</p>\r\n    </div>\r\n  </div>\r\n</rte-dialog-content>\r\n<rte-dialog-actions>\r\n  <button rtebutton-flat color=\"primary\" (click)=\"onYesClick()\" title=\"Sim\">\r\n    <span class=\"rte-icon\">\r\n      Sim\r\n    </span>\r\n  </button>\r\n  <button rtebutton-stroked (click)=\"onNoClick()\" title=\"N\u00E3o\">\r\n    <span class=\"rte-icon\">\r\n      N\u00E3o\r\n    </span>\r\n  </button>\r\n</rte-dialog-actions>",
                    styles: [""]
                }] }
    ];
    /** @nocollapse */
    YesNoDialogComponent.ctorParameters = function () { return [
        { type: RteDialogRef },
        { type: undefined, decorators: [{ type: Inject, args: [MAT_DIALOG_DATA,] }] }
    ]; };
    return YesNoDialogComponent;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
var RTE_APP_SERVICE_DATA = new InjectionToken('IAppServiceToken');

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var ListButtonsComponent = /** @class */ (function () {
    function ListButtonsComponent(appService) {
        this.appService = appService;
    }
    /**
     * @return {?}
     */
    ListButtonsComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
    };
    /**
     * @param {?} isDisabled
     * @return {?}
     */
    ListButtonsComponent.prototype.getButtonBackgroundColor = /**
     * @param {?} isDisabled
     * @return {?}
     */
    function (isDisabled) {
        if (isDisabled) {
            return "rgba(0, 0, 0, .12)";
        }
        if (this.appService.currentCompany) {
            return this.appService.currentCompany.SelectedBackColor;
        }
        else {
            return "#0054a6";
        }
    };
    /**
     * @return {?}
     */
    ListButtonsComponent.prototype.getForeColor = /**
     * @return {?}
     */
    function () {
        if (this.appService.currentCompany) {
            return this.appService.currentCompany.SelectedForeColor;
        }
        else {
            return "rgba(0,0,0,.26)";
        }
    };
    /**
     * @param {?} element
     * @return {?}
     */
    ListButtonsComponent.prototype.buttonClick = /**
     * @param {?} element
     * @return {?}
     */
    function (element) {
        element.click();
    };
    ListButtonsComponent.decorators = [
        { type: Component, args: [{
                    selector: 'rte-list-buttons',
                    template: "<span class=\"rte-icon\" *ngFor=\"let button of listButton; let i = index\">\r\n  <button mat-stroked-button [class.button-first]=\" i == 0\"\r\n          [class.button-last]=\"i ==  (listButton.length-1)\"\r\n          [class.button-middle]=\"i != 0 && i != (listButton.length-1)\"\r\n          class=\"rte-send-password-button\"\r\n          matBadge=\"1\" matBadgePosition=\"before\"\r\n          (click)=\"buttonClick(button);\" [disabled]=\"button.disabled\"\r\n          >\r\n    {{button.description}}\r\n  </button>\r\n</span>\r\n",
                    styles: [".rte-icon{padding:0;margin-left:1px}"]
                }] }
    ];
    /** @nocollapse */
    ListButtonsComponent.ctorParameters = function () { return [
        { type: undefined, decorators: [{ type: Inject, args: [RTE_APP_SERVICE_DATA,] }] }
    ]; };
    ListButtonsComponent.propDecorators = {
        listButton: [{ type: Input }]
    };
    return ListButtonsComponent;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var RteInputComponent = /** @class */ (function (_super) {
    __extends(RteInputComponent, _super);
    function RteInputComponent(elementRef, renderer, platform, ngControl, parentForm, parentFormGroup, defaultErrorStateMatcher, ngZone, inputValueAccessor, autofillMonitor) {
        var _this = _super.call(this, elementRef, platform, ngControl, parentForm, parentFormGroup, defaultErrorStateMatcher, inputValueAccessor, autofillMonitor, ngZone) || this;
        _this.elementRef = elementRef;
        _this.renderer = renderer;
        _this.platform = platform;
        _this.ngControl = ngControl;
        _this.parentForm = parentForm;
        _this.parentFormGroup = parentFormGroup;
        _this.defaultErrorStateMatcher = defaultErrorStateMatcher;
        _this.ngZone = ngZone;
        _this.stickyCssClass = 'mat-table-sticky';
        _this._changeModelSubscription = Subscription.EMPTY;
        return _this;
    }
    /**
     * @return {?}
     */
    RteInputComponent.prototype.validateFields = /**
     * @return {?}
     */
    function () {
        /** @type {?} */
        var value = this.ngControl.control.value;
        if (typeof this.ngControl.control.value === 'string' && value !== null && value !== '') {
            value = value
                .normalize('NFD')
                .replace(/[\u0300-\u036f]/g, '')
                .replace('´', '')
                .replace('`', '')
                .replace('~', '')
                .replace('^', '');
            value = value.toUpperCase();
            if (!this._elementRef.nativeElement.hasAttribute('ng-reflect-autocomplete')) {
                if (this.ngControl.control.value !== value) {
                    /** @type {?} */
                    var initialSelection = ((/** @type {?} */ (this._elementRef.nativeElement))).selectionStart;
                    this.ngControl.control.setValue(value, { emitEvent: false });
                    this.ngControl.control.updateValueAndValidity({ emitEvent: false });
                    this.setCaretPosition(this._elementRef.nativeElement, initialSelection);
                }
            }
            else {
                this.elementRef.nativeElement.value = value;
            }
        }
    };
    /**
     * @param {?} element
     * @param {?} position
     * @return {?}
     */
    RteInputComponent.prototype.setCaretPosition = /**
     * @param {?} element
     * @param {?} position
     * @return {?}
     */
    function (element, position) {
        if (element.setSelectionRange) {
            element.focus();
            element.setSelectionRange(position, position);
        }
        else if (element.createTextRange) {
            /** @type {?} */
            var range = element.createTextRange();
            range.collapse(true);
            range.moveEnd('character', position);
            range.moveStart('character', position);
            range.select();
        }
    };
    /**
     * @return {?}
     */
    RteInputComponent.prototype.ngAfterContentInit = /**
     * @return {?}
     */
    function () {
        var _this = this;
        if (this.ngControl) {
            this._changeModelSubscription = this.ngControl.valueChanges.subscribe(function () {
                if (!_this._elementRef.nativeElement.hasAttribute('disable-uppercase')) {
                    _this.validateFields();
                }
            });
        }
    };
    /**
     * @return {?}
     */
    RteInputComponent.prototype.ngOnDestroy = /**
     * @return {?}
     */
    function () {
        this._changeModelSubscription.unsubscribe();
        _super.prototype.ngOnDestroy.call(this);
    };
    RteInputComponent.decorators = [
        { type: Directive, args: [{
                    // tslint:disable-next-line:directive-selector
                    selector: "input[rteInput], textarea[rteInput]",
                    exportAs: 'rteMatInput',
                    // tslint:disable-next-line:use-host-property-decorator
                    host: {
                        'class': 'mat-input-element mat-form-field-autofill-control',
                        '[attr.id]': 'id',
                        '[placeholder]': 'placeholder',
                        '[disabled]': 'disabled',
                        '[required]': 'required',
                        '[readonly]': 'readonly',
                        '[attr.aria-describedby]': '_ariaDescribedby || null',
                        '[attr.aria-invalid]': 'errorState',
                        '(blur)': '_focusChanged(false)',
                        '(focus)': '_focusChanged(true)',
                        '(input)': '_onInput()',
                    },
                    providers: [{ provide: MatFormFieldControl, useExisting: RteInputComponent }]
                },] }
    ];
    /** @nocollapse */
    RteInputComponent.ctorParameters = function () { return [
        { type: ElementRef },
        { type: Renderer2 },
        { type: Platform },
        { type: NgControl, decorators: [{ type: Optional }] },
        { type: NgForm, decorators: [{ type: Optional }] },
        { type: FormGroupDirective, decorators: [{ type: Optional }] },
        { type: ErrorStateMatcher },
        { type: NgZone },
        { type: undefined, decorators: [{ type: Optional }, { type: Self }, { type: Inject, args: [MAT_INPUT_VALUE_ACCESSOR,] }] },
        { type: AutofillMonitor }
    ]; };
    return RteInputComponent;
}(MatInput));

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var RteMaterialBaseService = /** @class */ (function () {
    function RteMaterialBaseService() {
        this.locale = 'pt-BR';
        this.currencyCode = 'R$';
    }
    RteMaterialBaseService.decorators = [
        { type: Injectable, args: [{
                    providedIn: 'root'
                },] }
    ];
    /** @nocollapse */
    RteMaterialBaseService.ctorParameters = function () { return []; };
    /** @nocollapse */ RteMaterialBaseService.ngInjectableDef = defineInjectable({ factory: function RteMaterialBaseService_Factory() { return new RteMaterialBaseService(); }, token: RteMaterialBaseService, providedIn: "root" });
    return RteMaterialBaseService;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * Single error message to be shown underneath the form field.
 */
var RteErrorDirective = /** @class */ (function (_super) {
    __extends(RteErrorDirective, _super);
    function RteErrorDirective() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    RteErrorDirective.decorators = [
        { type: Directive, args: [{
                    selector: 'rte-error',
                    host: {
                        'class': 'mat-error',
                        'role': 'alert',
                        '[attr.id]': 'id',
                    }
                },] }
    ];
    return RteErrorDirective;
}(MatError));

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
var RTE_COLOR_SERVICE_DATA = new InjectionToken('IRteColorServiceToken');

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var SafeStylePipe = /** @class */ (function () {
    function SafeStylePipe(sanitizer) {
        this.sanitizer = sanitizer;
    }
    /**
     * @param {?} value
     * @return {?}
     */
    SafeStylePipe.prototype.transform = /**
     * @param {?} value
     * @return {?}
     */
    function (value) {
        return this.sanitizer.bypassSecurityTrustStyle(value);
    };
    SafeStylePipe.decorators = [
        { type: Pipe, args: [{ name: 'safeStyle' },] }
    ];
    /** @nocollapse */
    SafeStylePipe.ctorParameters = function () { return [
        { type: DomSanitizer }
    ]; };
    return SafeStylePipe;
}());
var RteFormFieldComponent = /** @class */ (function (_super) {
    __extends(RteFormFieldComponent, _super);
    function RteFormFieldComponent(elementRef, changeDetectorRef, appService, labelOptions, dir, defaults, rteColorService, platform, ngZone, animationMode) {
        var _this = _super.call(this, elementRef, changeDetectorRef, labelOptions, dir, defaults, platform) || this;
        _this.elementRef = elementRef;
        _this.appService = appService;
        _this.defaults = defaults;
        _this.rteColorService = rteColorService;
        _this.ngZone = ngZone;
        return _this;
    }
    /**
     * @return {?}
     */
    RteFormFieldComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
    };
    /**
     * @return {?}
     */
    RteFormFieldComponent.prototype.ngAfterContentInit = /**
     * @return {?}
     */
    function () {
        for (var i = 0; i < this._rteErrorChildren.length; i++) {
            this._errorChildren.reset(__spread(this._errorChildren.toArray(), [this._rteErrorChildren.toArray()[i]]));
        }
        this._rteErrorChildren.reset([]);
        _super.prototype.ngAfterContentInit.call(this);
    };
    /**
     * @return {?}
     */
    RteFormFieldComponent.prototype.isDisabledOrReadOnly = /**
     * @return {?}
     */
    function () {
        if ((this._control instanceof RteInputComponent)) {
            return (this._control.disabled || this._control.readonly);
        }
        else {
            return this._control.disabled;
        }
    };
    RteFormFieldComponent.decorators = [
        { type: Component, args: [{
                    // tslint:disable-next-line:component-selector
                    selector: 'rte-form-field',
                    template: "\r\n<div class=\"mat-form-field-wrapper\">\r\n  <div class=\"mat-form-field-flex\" #connectionContainer (click)=\"_control.onContainerClick && _control.onContainerClick($event)\">\r\n\r\n    <ng-container *ngIf=\"appearance == 'outline'\">\r\n      <div class=\"mat-form-field-outline\">\r\n        <div class=\"mat-form-field-outline-start\"></div>\r\n        <div class=\"mat-form-field-outline-gap\"></div>\r\n        <div class=\"mat-form-field-outline-end\"></div>\r\n      </div>\r\n      <div class=\"mat-form-field-outline mat-form-field-outline-thick\">\r\n        <div class=\"mat-form-field-outline-start\"></div>\r\n        <div class=\"mat-form-field-outline-gap\"></div>\r\n        <div class=\"mat-form-field-outline-end\"></div>\r\n      </div>\r\n    </ng-container>\r\n\r\n    <div class=\"mat-form-field-prefix\" *ngIf=\"_prefixChildren.length\">\r\n      <ng-content select=\"[matPrefix]\"></ng-content>\r\n    </div>\r\n\r\n    <div class=\"mat-form-field-infix rte-teste\" #inputContainer\r\n      [attr.style]=\"('border-color:' + rteColorService.getInputColor(elementRef) + '!important') | safeStyle\" >\r\n      <ng-content></ng-content>\r\n\r\n      <span class=\"mat-form-field-label-wrapper\" [class.rte]=\"floatLabel != 'never'\">\r\n        <label class=\"mat-form-field-label\" [class.rte]=\"floatLabel != 'never'\" (cdkObserveContent)=\"updateOutlineGap()\" [id]=\"_labelId\" [attr.for]=\"_control.id\" [attr.aria-owns]=\"_control.id\"\r\n          [class.mat-empty]=\"_control.empty && !_shouldAlwaysFloat\" [class.mat-form-field-empty]=\"_control.empty && !_shouldAlwaysFloat\"\r\n          [class.mat-accent]=\"color == 'accent'\" [class.mat-warn]=\"color == 'warn'\" #label *ngIf=\"_hasFloatingLabel()\" [ngSwitch]=\"_hasLabel()\"\r\n                [attr.style]=\"('color:' + rteColorService.getLabelColor(elementRef) + '!important') | safeStyle\" >\r\n\r\n          <ng-container *ngSwitchCase=\"false\">\r\n            <ng-content select=\"mat-placeholder\"></ng-content>\r\n            {{_control.placeholder}}\r\n          </ng-container>\r\n\r\n          <ng-content select=\"mat-label\" *ngSwitchCase=\"true\"></ng-content>\r\n\r\n          <span class=\"mat-placeholder-required mat-form-field-required-marker\" aria-hidden=\"true\" *ngIf=\"!hideRequiredMarker && _control.required && !_control.disabled\">&nbsp;*</span>\r\n        </label>\r\n      </span>\r\n    </div>\r\n\r\n    <div class=\"mat-form-field-suffix\" *ngIf=\"_suffixChildren.length\">\r\n      <ng-content select=\"[matSuffix]\"></ng-content>\r\n    </div>\r\n  </div>\r\n\r\n  <div class=\"mat-form-field-underline\" #underline *ngIf=\"appearance != 'outline'\">\r\n    <span class=\"mat-form-field-ripple\" [class.mat-accent]=\"color == 'accent'\" [class.mat-warn]=\"color == 'warn'\"\r\n          [style.background-color]=\"rteColorService.getBackgroundColor(elementRef)\"></span>\r\n  </div>\r\n\r\n  <div class=\"mat-form-field-subscript-wrapper\" [ngSwitch]=\"_getDisplayedMessages()\">\r\n    <div *ngSwitchCase=\"'error'\" [@transitionMessages]=\"_subscriptAnimationState\">\r\n      <ng-content select=\"rte-error\"></ng-content>\r\n      <ng-content select=\"mat-error\"></ng-content>\r\n    </div>\r\n\r\n    <div class=\"mat-form-field-hint-wrapper\" *ngSwitchCase=\"'hint'\" [@transitionMessages]=\"_subscriptAnimationState\">\r\n      <div *ngIf=\"hintLabel\" [id]=\"_hintLabelId\" class=\"mat-hint\">{{hintLabel}}</div>\r\n      <ng-content select=\"mat-hint:not([align='end'])\"></ng-content>\r\n      <div class=\"mat-form-field-hint-spacer\"></div>\r\n      <ng-content select=\"mat-hint[align='end']\"></ng-content>\r\n    </div>\r\n  </div>\r\n</div>\r\n",
                    // tslint:disable-next-line:use-host-property-decorator
                    host: {
                        'class': 'mat-form-field',
                        '[class.mat-form-field-appearance-standard]': 'appearance == "standard"',
                        '[class.mat-form-field-appearance-fill]': 'appearance == "fill"',
                        '[class.mat-form-field-appearance-outline]': 'appearance == "outline"',
                        '[class.mat-form-field-appearance-legacy]': 'appearance == "legacy"',
                        '[class.mat-form-field-invalid]': '_control.errorState',
                        '[class.mat-form-field-can-float]': '_canLabelFloat',
                        '[class.mat-form-field-should-float]': '_shouldLabelFloat()',
                        '[class.mat-form-field-hide-placeholder]': '_hideControlPlaceholder()',
                        '[class.mat-form-field-disabled]': 'isDisabledOrReadOnly()',
                        '[class.mat-form-field-autofilled]': '_control.autofilled',
                        '[class.mat-focused]': '_control.focused',
                        '[class.mat-accent]': 'color == "accent"',
                        '[class.mat-warn]': 'color == "warn"',
                        '[class.ng-untouched]': '_shouldForward("untouched")',
                        '[class.ng-touched]': '_shouldForward("touched")',
                        '[class.ng-pristine]': '_shouldForward("pristine")',
                        '[class.ng-dirty]': '_shouldForward("dirty")',
                        '[class.ng-valid]': '_shouldForward("valid")',
                        '[class.ng-invalid]': '_shouldForward("invalid")',
                        '[class.ng-pending]': '_shouldForward("pending")',
                        '[class._mat-animation-noopable]': '!_animationsEnabled',
                    },
                    // tslint:disable-next-line:use-input-property-decorator
                    encapsulation: ViewEncapsulation.None,
                    changeDetection: ChangeDetectionStrategy.OnPush,
                    animations: [matFormFieldAnimations.transitionMessages],
                    styles: [".mat-form-field{display:inline-block;position:relative;text-align:left}[dir=rtl] .mat-form-field{text-align:right}.mat-form-field-wrapper{position:relative}.mat-form-field-flex{display:inline-flex;align-items:baseline;box-sizing:border-box;width:100%}.mat-form-field-prefix,.mat-form-field-suffix{white-space:nowrap;flex:none;position:relative}.mat-form-field-infix{display:block;position:relative;flex:auto;min-width:0;width:180px;border-radius:4px;border:1px solid #e0e0e0;box-sizing:border-box}.mat-form-field-label-wrapper{position:absolute;left:0;box-sizing:content-box;width:100%;height:100%;overflow:hidden;pointer-events:none}.rte.mat-form-field-label-wrapper{top:-40px;font-size:12px;margin-left:-2px}.mat-form-field-label{position:absolute;left:0;font:inherit;pointer-events:none;width:100%;white-space:nowrap;text-overflow:ellipsis;overflow:hidden;transform-origin:0 0;transition:transform .4s cubic-bezier(.25,.8,.25,1),color .4s cubic-bezier(.25,.8,.25,1),width .4s cubic-bezier(.25,.8,.25,1);display:none}.rte.mat-form-field-label{transform:none!important}[dir=rtl] .mat-form-field-label{transform-origin:100% 0;left:auto;right:0}.mat-form-field-can-float.mat-form-field-should-float .mat-form-field-label,.mat-form-field-empty.mat-form-field-label{display:block}.mat-form-field-autofill-control:-webkit-autofill+.mat-form-field-label-wrapper .mat-form-field-label{display:none}.mat-form-field-can-float .mat-form-field-autofill-control:-webkit-autofill+.mat-form-field-label-wrapper .mat-form-field-label{display:block;transition:none}.mat-input-server:focus+.mat-form-field-label-wrapper .mat-form-field-label,.mat-input-server[placeholder]:not(:placeholder-shown)+.mat-form-field-label-wrapper .mat-form-field-label{display:none}.mat-form-field-can-float .mat-input-server:focus+.mat-form-field-label-wrapper .mat-form-field-label,.mat-form-field-can-float .mat-input-server[placeholder]:not(:placeholder-shown)+.mat-form-field-label-wrapper .mat-form-field-label{display:block}.mat-form-field-label:not(.mat-form-field-empty){transition:none}.mat-form-field-underline{position:absolute;width:100%;pointer-events:none;transform:scaleY(1.0001);display:none}.mat-form-field-ripple{position:absolute;left:0;width:100%;transform-origin:50%;transform:scaleX(.5);opacity:0;transition:background-color .3s cubic-bezier(.55,0,.55,.2)}.mat-form-field.mat-focused .mat-form-field-ripple,.mat-form-field.mat-form-field-invalid .mat-form-field-ripple{opacity:1;transform:scaleX(1);transition:transform .3s cubic-bezier(.25,.8,.25,1),opacity .1s cubic-bezier(.25,.8,.25,1),background-color .3s cubic-bezier(.25,.8,.25,1)}.mat-form-field-subscript-wrapper{position:absolute;box-sizing:border-box;width:100%;overflow:hidden}.mat-form-field-label-wrapper .mat-icon,.mat-form-field-subscript-wrapper .mat-icon{width:1em;height:1em;font-size:inherit;vertical-align:baseline}.mat-form-field-hint-wrapper{display:flex}.mat-form-field-hint-spacer{flex:1 0 1em}.mat-error{margin-top:10px;display:block}.mat-form-field-appearance-fill .mat-form-field-flex{border-radius:4px 4px 0 0;padding:.75em .75em 0}.mat-form-field-appearance-fill .mat-form-field-underline::before{content:'';display:block;position:absolute;bottom:0;height:1px;width:100%}.mat-form-field-appearance-fill .mat-form-field-ripple{bottom:0;height:2px}.mat-form-field-appearance-fill:not(.mat-form-field-disabled) .mat-form-field-flex:hover~.mat-form-field-underline .mat-form-field-ripple{opacity:1;transform:none;transition:opacity .6s cubic-bezier(.25,.8,.25,1)}.mat-form-field-appearance-fill .mat-form-field-subscript-wrapper{padding:0 1em}.mat-form-field-appearance-legacy .mat-form-field-label{transform:perspective(100px);-ms-transform:none}.mat-form-field-appearance-legacy .mat-form-field-prefix .mat-icon,.mat-form-field-appearance-legacy .mat-form-field-suffix .mat-icon{width:1em}.mat-form-field-appearance-legacy .mat-form-field-prefix .mat-icon-button,.mat-form-field-appearance-legacy .mat-form-field-suffix .mat-icon-button{font:inherit;vertical-align:baseline}.mat-form-field-appearance-legacy .mat-form-field-prefix .mat-icon-button .mat-icon,.mat-form-field-appearance-legacy .mat-form-field-suffix .mat-icon-button .mat-icon{font-size:inherit}.mat-form-field-appearance-legacy .mat-form-field-underline{height:1px}.mat-form-field-appearance-legacy .mat-form-field-ripple{top:0;height:2px}.mat-form-field-appearance-legacy.mat-form-field-disabled .mat-form-field-underline{background-position:0;background-color:transparent}.mat-form-field-appearance-legacy.mat-form-field-invalid:not(.mat-focused) .mat-form-field-ripple{height:1px}.mat-form-field-appearance-outline .mat-form-field-wrapper{margin:.25em 0}.mat-form-field-appearance-outline .mat-form-field-flex{padding:0 .75em;margin-top:-.25em}.mat-form-field-appearance-outline .mat-form-field-prefix,.mat-form-field-appearance-outline .mat-form-field-suffix{top:.25em}.mat-form-field-appearance-outline .mat-form-field-outline{display:flex;position:absolute;top:0;left:0;right:0;pointer-events:none}.mat-form-field-appearance-outline .mat-form-field-outline-end,.mat-form-field-appearance-outline .mat-form-field-outline-start{border:1px solid currentColor;min-width:5px}.mat-form-field-appearance-outline .mat-form-field-outline-start{border-radius:5px 0 0 5px;border-right-style:none}[dir=rtl] .mat-form-field-appearance-outline .mat-form-field-outline-start{border-right-style:solid;border-left-style:none;border-radius:0 5px 5px 0}.mat-form-field-appearance-outline .mat-form-field-outline-end{border-radius:0 5px 5px 0;border-left-style:none;flex-grow:1}[dir=rtl] .mat-form-field-appearance-outline .mat-form-field-outline-end{border-left-style:solid;border-right-style:none;border-radius:5px 0 0 5px}.mat-form-field-appearance-outline .mat-form-field-outline-gap{border-radius:.000001px;border:1px solid currentColor;border-left-style:none;border-right-style:none}.mat-form-field-appearance-outline.mat-form-field-can-float.mat-form-field-should-float .mat-form-field-outline-gap{border-top-color:transparent}.mat-form-field-appearance-outline .mat-form-field-outline-thick{opacity:0}.mat-form-field-appearance-outline .mat-form-field-outline-thick .mat-form-field-outline-end,.mat-form-field-appearance-outline .mat-form-field-outline-thick .mat-form-field-outline-gap,.mat-form-field-appearance-outline .mat-form-field-outline-thick .mat-form-field-outline-start{border-width:2px;transition:border-color .3s cubic-bezier(.25,.8,.25,1)}.mat-form-field-appearance-outline.mat-focused .mat-form-field-outline,.mat-form-field-appearance-outline.mat-form-field-invalid .mat-form-field-outline{opacity:0;transition:opacity .1s cubic-bezier(.25,.8,.25,1)}.mat-form-field-appearance-outline.mat-focused .mat-form-field-outline-thick,.mat-form-field-appearance-outline.mat-form-field-invalid .mat-form-field-outline-thick{opacity:1}.mat-form-field-appearance-outline:not(.mat-form-field-disabled) .mat-form-field-flex:hover~.mat-form-field-outline{opacity:0;transition:opacity .6s cubic-bezier(.25,.8,.25,1)}.mat-form-field-appearance-outline:not(.mat-form-field-disabled) .mat-form-field-flex:hover~.mat-form-field-outline-thick{opacity:1}.mat-form-field-appearance-outline .mat-form-field-subscript-wrapper{padding:0 1em}.mat-form-field-appearance-standard .mat-form-field-flex{padding-top:.75em}.mat-form-field-appearance-standard .mat-form-field-underline{height:1px}.mat-form-field-appearance-standard .mat-form-field-ripple{bottom:0;height:2px}.mat-form-field-appearance-standard.mat-form-field-disabled .mat-form-field-underline{background-position:0;background-color:transparent}.mat-form-field-appearance-standard:not(.mat-form-field-disabled) .mat-form-field-flex:hover~.mat-form-field-underline .mat-form-field-ripple{opacity:1;transform:none;transition:opacity .6s cubic-bezier(.25,.8,.25,1)}.mat-input-element{font:inherit;background:0 0;color:currentColor;border:none;outline:0;padding:0;margin:0;width:100%;max-width:100%;vertical-align:bottom;text-align:inherit}.mat-input-element:-moz-ui-invalid{box-shadow:none}.mat-input-element::-ms-clear,.mat-input-element::-ms-reveal{display:none}.mat-input-element[type=date]::after,.mat-input-element[type=datetime-local]::after,.mat-input-element[type=datetime]::after,.mat-input-element[type=month]::after,.mat-input-element[type=time]::after,.mat-input-element[type=week]::after{content:' ';white-space:pre;width:1px}.mat-input-element::placeholder{transition:color .4s cubic-bezier(.25,.8,.25,1) 133ms}.mat-input-element::-moz-placeholder{transition:color .4s cubic-bezier(.25,.8,.25,1) 133ms}.mat-form-field-hide-placeholder .mat-input-element::placeholder{color:transparent!important;transition:none}.mat-form-field-hide-placeholder .mat-input-element::-moz-placeholder{color:transparent!important;transition:none}.mat-form-field-hide-placeholder .mat-input-element::-webkit-input-placeholder{color:transparent!important;transition:none}.mat-form-field-hide-placeholder .mat-input-element:-ms-input-placeholder{color:transparent!important;transition:none}textarea.mat-input-element{resize:vertical;overflow:auto;padding:2px 0;margin:-2px 0}textarea.mat-input-element.cdk-textarea-autosize{resize:none}.mat-form-field{font-size:16px;line-height:24px}.mat-form-field input{padding:0 12px;max-width:calc(100% - 24px)}.mat-form-field textarea{padding:0 12px!important;max-width:calc(100% - 24px)}.mat-form-field-disabled{background-color:#eee}.mat-input-element:disabled{color:inherit}"]
                }] }
    ];
    /** @nocollapse */
    RteFormFieldComponent.ctorParameters = function () { return [
        { type: ElementRef },
        { type: ChangeDetectorRef },
        { type: RteMaterialBaseService },
        { type: undefined, decorators: [{ type: Optional }, { type: Inject, args: [MAT_LABEL_GLOBAL_OPTIONS,] }] },
        { type: Directionality },
        { type: undefined, decorators: [{ type: Optional }, { type: Inject, args: [MAT_FORM_FIELD_DEFAULT_OPTIONS,] }] },
        { type: undefined, decorators: [{ type: Inject, args: [RTE_COLOR_SERVICE_DATA,] }] },
        { type: Platform },
        { type: NgZone },
        { type: String, decorators: [{ type: Optional }, { type: Inject, args: [ANIMATION_MODULE_TYPE,] }] }
    ]; };
    RteFormFieldComponent.propDecorators = {
        _rteErrorChildren: [{ type: ContentChildren, args: [RteErrorDirective,] }]
    };
    return RteFormFieldComponent;
}(MatFormField));

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var RteOptionComponent = /** @class */ (function (_super) {
    __extends(RteOptionComponent, _super);
    function RteOptionComponent(element, changeDetectorRef, parent, group) {
        var _this = _super.call(this, element, changeDetectorRef, parent, group) || this;
        _this.group = group;
        // tslint:disable-next-line:no-output-on-prefix
        _this.onSelectionChange = new EventEmitter();
        return _this;
    }
    RteOptionComponent.decorators = [
        { type: Component, args: [{
                    // tslint:disable-next-line:component-selector
                    selector: 'rte-option',
                    template: "<mat-pseudo-checkbox *ngIf=\"multiple\" class=\"mat-option-pseudo-checkbox\"\r\n    [state]=\"selected ? 'checked' : ''\" [disabled]=\"disabled\"></mat-pseudo-checkbox>\r\n\r\n<span class=\"mat-option-text\"><ng-content></ng-content></span>\r\n\r\n<div class=\"mat-option-ripple\" mat-ripple\r\n     [matRippleTrigger]=\"_getHostElement()\"\r\n     [matRippleDisabled]=\"disabled || disableRipple\">\r\n</div>\r\n",
                    // tslint:disable-next-line:use-host-property-decorator
                    host: {
                        'role': 'option',
                        '[attr.tabindex]': '_getTabIndex()',
                        '[class.mat-selected]': 'selected',
                        '[class.mat-option-multiple]': 'multiple',
                        '[class.mat-active]': 'active',
                        '[id]': 'id',
                        '[attr.aria-selected]': 'selected.toString()',
                        '[attr.aria-disabled]': 'disabled.toString()',
                        '[class.mat-option-disabled]': 'disabled',
                        '(click)': '_selectViaInteraction()',
                        '(keydown)': '_handleKeydown($event)',
                        'class': 'mat-option'
                    },
                    encapsulation: ViewEncapsulation.None,
                    changeDetection: ChangeDetectionStrategy.OnPush,
                    styles: [".mat-option{white-space:nowrap;overflow:hidden;text-overflow:ellipsis;display:block;line-height:48px;height:48px;padding:0 16px;text-align:left;text-decoration:none;position:relative;cursor:pointer;outline:0;display:flex;flex-direction:row;max-width:100%;box-sizing:border-box;align-items:center}.mat-option[disabled]{cursor:default}[dir=rtl] .mat-option{text-align:right}.mat-option .mat-icon{margin-right:16px;vertical-align:middle}.mat-option .mat-icon svg{vertical-align:top}[dir=rtl] .mat-option .mat-icon{margin-left:16px;margin-right:0}.mat-option[aria-disabled=true]{-webkit-user-select:none;-moz-user-select:none;user-select:none;cursor:default}.mat-optgroup .mat-option:not(.mat-option-multiple){padding-left:32px}[dir=rtl] .mat-optgroup .mat-option:not(.mat-option-multiple){padding-left:16px;padding-right:32px}.mat-option-text{display:inline-block;flex-grow:1;overflow:hidden;text-overflow:ellipsis}.mat-option-ripple{top:0;left:0;right:0;bottom:0;position:absolute;pointer-events:none}@media screen and (-ms-high-contrast:active){.mat-option{margin:0 1px}.mat-option.mat-active{border:1px solid currentColor;margin:0}.mat-option-ripple{opacity:.5}}.mat-option-pseudo-checkbox{margin-right:8px}[dir=rtl] .mat-option-pseudo-checkbox{margin-left:8px;margin-right:0}"]
                }] }
    ];
    /** @nocollapse */
    RteOptionComponent.ctorParameters = function () { return [
        { type: ElementRef },
        { type: ChangeDetectorRef },
        { type: undefined, decorators: [{ type: Optional }, { type: Inject, args: [MAT_OPTION_PARENT_COMPONENT,] }] },
        { type: MatOptgroup, decorators: [{ type: Optional }] }
    ]; };
    RteOptionComponent.propDecorators = {
        onSelectionChange: [{ type: Output }]
    };
    return RteOptionComponent;
}(MatOption));

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var RteSelectComponent = /** @class */ (function (_super) {
    __extends(RteSelectComponent, _super);
    function RteSelectComponent(viewportRuler, changeDetectorRef, ngZone, defaultErrorStateMatcher, elementRef, dir, parentForm, parentFormGroup, parentFormField, ngControl, tabIndex, scrollStrategyFactory) {
        var _this = _super.call(this, viewportRuler, changeDetectorRef, ngZone, defaultErrorStateMatcher, elementRef, dir, parentForm, parentFormGroup, parentFormField, ngControl, tabIndex, scrollStrategyFactory) || this;
        _this.parentFormField = parentFormField;
        _this.ngControl = ngControl;
        return _this;
    }
    /**
     * @return {?}
     */
    RteSelectComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        this._panelDoneAnimatingStream = new Subject();
        _super.prototype.ngOnInit.call(this);
    };
    /**
     * @return {?}
     */
    RteSelectComponent.prototype._getAriaLabel = /**
     * @return {?}
     */
    function () {
        return this.ariaLabelledby ? null : this.ariaLabel || this.placeholder;
    };
    /**
     * @return {?}
     */
    RteSelectComponent.prototype._getAriaLabelledby = /**
     * @return {?}
     */
    function () {
        if (this.ariaLabelledby) {
            return this.ariaLabelledby;
        }
        if (!this.parentFormField || !this.parentFormField._hasFloatingLabel() ||
            this._getAriaLabel()) {
            return null;
        }
        return this.parentFormField._labelId || null;
    };
    RteSelectComponent.decorators = [
        { type: Component, args: [{
                    // tslint:disable-next-line:component-selector
                    selector: 'rte-select',
                    exportAs: 'rteSelect',
                    template: "<div cdk-overlay-origin\r\n     class=\"mat-select-trigger\"\r\n     aria-hidden=\"true\"\r\n     (click)=\"toggle()\"\r\n     #origin=\"cdkOverlayOrigin\"\r\n     #trigger>\r\n  <div class=\"mat-select-value\" [ngSwitch]=\"empty\">\r\n    <span class=\"mat-select-placeholder\" *ngSwitchCase=\"true\">{{placeholder || '\\u00A0'}}</span>\r\n    <span class=\"mat-select-value-text\" *ngSwitchCase=\"false\" [ngSwitch]=\"!!customTrigger\">\r\n      <span *ngSwitchDefault>{{triggerValue || '\\u00A0'}}</span>\r\n      <ng-content select=\"mat-select-trigger\" *ngSwitchCase=\"true\"></ng-content>\r\n    </span>\r\n  </div>\r\n\r\n  <div class=\"mat-select-arrow-wrapper\"><div class=\"mat-select-arrow\"></div></div>\r\n</div>\r\n\r\n<ng-template\r\n  cdk-connected-overlay\r\n  cdkConnectedOverlayLockPosition\r\n  cdkConnectedOverlayHasBackdrop\r\n  cdkConnectedOverlayBackdropClass=\"cdk-overlay-transparent-backdrop\"\r\n  [cdkConnectedOverlayScrollStrategy]=\"_scrollStrategy\"\r\n  [cdkConnectedOverlayOrigin]=\"origin\"\r\n  [cdkConnectedOverlayOpen]=\"panelOpen\"\r\n  [cdkConnectedOverlayPositions]=\"_positions\"\r\n  [cdkConnectedOverlayMinWidth]=\"_triggerRect?.width\"\r\n  [cdkConnectedOverlayOffsetY]=\"_offsetY\"\r\n  (backdropClick)=\"close()\"\r\n  (attach)=\"_onAttached()\"\r\n  (detach)=\"close()\">\r\n\r\n  <div\r\n    #panel\r\n    class=\"mat-select-panel {{ _getPanelTheme() }}\"\r\n    [ngClass]=\"panelClass\"\r\n    [@transformPanel]=\"multiple ? 'showing-multiple' : 'showing'\"\r\n    (@transformPanel.done)=\"_panelDoneAnimatingStream.next($event.toState)\"\r\n    [style.transformOrigin]=\"_transformOrigin\"\r\n    [style.font-size.px]=\"_triggerFontSize\"\r\n    (keydown)=\"_handleKeydown($event)\">\r\n    <ng-content></ng-content>\r\n  </div>\r\n</ng-template>\r\n",
                    // tslint:disable-next-line:use-input-property-decorator
                    inputs: ['disabled', 'disableRipple', 'tabIndex'],
                    encapsulation: ViewEncapsulation.None,
                    changeDetection: ChangeDetectionStrategy.OnPush,
                    // tslint:disable-next-line:use-host-property-decorator
                    host: {
                        'role': 'listbox',
                        '[attr.id]': 'id',
                        '[attr.tabindex]': 'tabIndex',
                        '[attr.aria-label]': '_getAriaLabel()',
                        '[attr.aria-labelledby]': '_getAriaLabelledby()',
                        '[attr.aria-required]': 'required.toString()',
                        '[attr.aria-disabled]': 'disabled.toString()',
                        '[attr.aria-invalid]': 'errorState',
                        '[attr.aria-owns]': 'panelOpen ? _optionIds : null',
                        '[attr.aria-multiselectable]': 'multiple',
                        '[attr.aria-describedby]': '_ariaDescribedby || null',
                        '[attr.aria-activedescendant]': '_getAriaActiveDescendant()',
                        '[class.mat-select-disabled]': 'disabled',
                        '[class.mat-select-invalid]': 'errorState',
                        '[class.mat-select-required]': 'required',
                        '[class.mat-select-empty]': 'empty',
                        'class': 'mat-select',
                        '(keydown)': '_handleKeydown($event)',
                        '(focus)': '_onFocus()',
                        '(blur)': '_onBlur()',
                    },
                    animations: [
                        matSelectAnimations.transformPanel,
                        matSelectAnimations.fadeInContent
                    ],
                    providers: [
                        { provide: MatFormFieldControl$1, useExisting: RteSelectComponent },
                        { provide: MAT_OPTION_PARENT_COMPONENT, useExisting: RteSelectComponent }
                    ],
                    styles: [".mat-select{display:inline-block;width:100%;outline:0}.mat-select-trigger{display:inline-table;cursor:pointer;position:relative;box-sizing:border-box}.mat-select-disabled .mat-select-trigger{-webkit-user-select:none;-moz-user-select:none;user-select:none;cursor:default}.mat-select-value{display:table-cell;max-width:0;width:100%;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;padding-left:12px}.mat-select-value-text{white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.mat-select-arrow-wrapper{display:table-cell;vertical-align:middle}.mat-form-field-appearance-fill .mat-select-arrow-wrapper,.mat-form-field-appearance-standard .mat-select-arrow-wrapper{transform:translateY(-50%)}.mat-form-field-appearance-outline .mat-select-arrow-wrapper{transform:translateY(-25%)}.mat-select-arrow{width:0;height:0;border-left:5px solid transparent;border-right:5px solid transparent;border-top:5px solid;margin:0 12px}.mat-select-panel{min-width:112px;max-width:280px;overflow:auto;-webkit-overflow-scrolling:touch;padding-top:0;padding-bottom:0;max-height:256px;min-width:100%}.mat-select-panel:not([class*=mat-elevation-z]){box-shadow:0 5px 5px -3px rgba(0,0,0,.2),0 8px 10px 1px rgba(0,0,0,.14),0 3px 14px 2px rgba(0,0,0,.12)}@media screen and (-ms-high-contrast:active){.mat-select-panel{outline:solid 1px}}.mat-select-panel .mat-optgroup-label,.mat-select-panel .mat-option{font-size:inherit;line-height:3em;height:3em}.mat-form-field-type-mat-select:not(.mat-form-field-disabled) .mat-form-field-flex{cursor:pointer}.mat-form-field-type-mat-select .mat-form-field-label{width:calc(100% - 18px)}.mat-select-placeholder{transition:color .4s cubic-bezier(.25,.8,.25,1) 133ms}.mat-form-field-hide-placeholder .mat-select-placeholder{color:transparent;transition:none;display:block}"]
                }] }
    ];
    /** @nocollapse */
    RteSelectComponent.ctorParameters = function () { return [
        { type: ViewportRuler },
        { type: ChangeDetectorRef },
        { type: NgZone },
        { type: ErrorStateMatcher$1 },
        { type: ElementRef },
        { type: Directionality, decorators: [{ type: Optional }] },
        { type: NgForm, decorators: [{ type: Optional }] },
        { type: FormGroupDirective, decorators: [{ type: Optional }] },
        { type: RteFormFieldComponent, decorators: [{ type: Optional }] },
        { type: NgControl, decorators: [{ type: Self }, { type: Optional }] },
        { type: String, decorators: [{ type: Attribute, args: ['tabindex',] }] },
        { type: undefined, decorators: [{ type: Inject, args: [MAT_SELECT_SCROLL_STRATEGY,] }] }
    ]; };
    RteSelectComponent.propDecorators = {
        options: [{ type: ContentChildren, args: [RteOptionComponent, { descendants: true },] }]
    };
    return RteSelectComponent;
}(MatSelect));

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
var RTE_CHECKBOX_CONTROL_VALUE_ACCESSOR = {
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(function () { return RteCheckboxComponent; }),
    multi: true
};
var RteCheckboxComponent = /** @class */ (function (_super) {
    __extends(RteCheckboxComponent, _super);
    function RteCheckboxComponent(elementRef, changeDetectorRef, focusMonitor, ngZone, tabIndex, clickAction, _animationMode, appService) {
        var _this = _super.call(this, elementRef, changeDetectorRef, focusMonitor, ngZone, tabIndex, clickAction) || this;
        _this.elementRef = elementRef;
        _this.focusMonitor = focusMonitor;
        _this._animationMode = _animationMode;
        _this.appService = appService;
        return _this;
    }
    /**
     * @return {?}
     */
    RteCheckboxComponent.prototype.getBackgroundColor = /**
     * @return {?}
     */
    function () {
        if ((this.elementRef.nativeElement.classList.contains('mat-checkbox-checked') == true
            || this.elementRef.nativeElement.classList.contains('mat-checkbox-indeterminate'))
            &&
                this.elementRef.nativeElement.classList.contains('mat-checkbox-disabled') == false) {
            return this.appService.SelectedBackColor;
        }
    };
    RteCheckboxComponent.decorators = [
        { type: Component, args: [{
                    selector: 'rte-checkbox',
                    template: "<label [attr.for]=\"inputId\" class=\"mat-checkbox-layout\" #label>\r\n  <div class=\"mat-checkbox-inner-container\"\r\n       [class.mat-checkbox-inner-container-no-side-margin]=\"!checkboxLabel.textContent || !checkboxLabel.textContent.trim()\">\r\n    <input #input\r\n           class=\"mat-checkbox-input cdk-visually-hidden\" type=\"checkbox\"\r\n           [id]=\"inputId\"\r\n           [required]=\"required\"\r\n           [checked]=\"checked\"\r\n           [attr.value]=\"value\"\r\n           [disabled]=\"disabled\"\r\n           [attr.name]=\"name\"\r\n           [tabIndex]=\"tabIndex\"\r\n           [indeterminate]=\"indeterminate\"\r\n           [attr.aria-label]=\"ariaLabel || null\"\r\n           [attr.aria-labelledby]=\"ariaLabelledby\"\r\n           [attr.aria-checked]=\"_getAriaChecked()\"\r\n           (change)=\"_onInteractionEvent($event)\"\r\n           (click)=\"_onInputClick($event)\">\r\n    <div matRipple class=\"mat-checkbox-ripple\"\r\n         [matRippleTrigger]=\"label\"\r\n         [matRippleDisabled]=\"_isRippleDisabled()\"\r\n         [matRippleRadius]=\"25\"\r\n         [matRippleCentered]=\"true\"\r\n         [matRippleAnimation]=\"{enterDuration: 150}\">\r\n    </div>\r\n    <div class=\"mat-checkbox-frame\"></div>\r\n    <div class=\"mat-checkbox-background\"\r\n         [style.background-color]=\"getBackgroundColor()\" >\r\n      <svg version=\"1.1\"\r\n           focusable=\"false\"\r\n           class=\"mat-checkbox-checkmark\"\r\n           viewBox=\"0 0 24 24\"\r\n           xml:space=\"preserve\">\r\n        <path class=\"mat-checkbox-checkmark-path\"\r\n              fill=\"none\"\r\n              stroke=\"white\"\r\n              d=\"M4.1,12.7 9,17.6 20.3,6.3\"/>\r\n      </svg>\r\n      <!-- Element for rendering the indeterminate state checkbox. -->\r\n      <div class=\"mat-checkbox-mixedmark\"></div>\r\n    </div>\r\n  </div>\r\n  <span class=\"mat-checkbox-label\" #checkboxLabel (cdkObserveContent)=\"_onLabelTextChange()\">\r\n    <!-- Add an invisible span so JAWS can read the label -->\r\n    <span style=\"display:none\">&nbsp;</span>\r\n    <ng-content></ng-content>\r\n  </span>\r\n</label>\r\n",
                    exportAs: 'rteCheckbox',
                    host: {
                        'class': 'mat-checkbox',
                        '[id]': 'id',
                        '[class.mat-checkbox-indeterminate]': 'indeterminate',
                        '[class.mat-checkbox-checked]': 'checked',
                        '[class.mat-checkbox-disabled]': 'disabled',
                        '[class.mat-checkbox-label-before]': 'labelPosition == "before"',
                        '[class._mat-animation-noopable]': "_animationMode === 'NoopAnimations'",
                    },
                    providers: [RTE_CHECKBOX_CONTROL_VALUE_ACCESSOR],
                    // tslint:disable-next-line:use-input-property-decorator
                    inputs: ['disableRipple', 'color', 'tabIndex'],
                    encapsulation: ViewEncapsulation.None,
                    changeDetection: ChangeDetectionStrategy.OnPush,
                    styles: ["@keyframes mat-checkbox-fade-in-background{0%{opacity:0}50%{opacity:1}}@keyframes mat-checkbox-fade-out-background{0%,50%{opacity:1}100%{opacity:0}}@keyframes mat-checkbox-unchecked-checked-checkmark-path{0%,50%{stroke-dashoffset:22.91026}50%{animation-timing-function:cubic-bezier(0,0,.2,.1)}100%{stroke-dashoffset:0}}@keyframes mat-checkbox-unchecked-indeterminate-mixedmark{0%,68.2%{transform:scaleX(0)}68.2%{animation-timing-function:cubic-bezier(0,0,0,1)}100%{transform:scaleX(1)}}@keyframes mat-checkbox-checked-unchecked-checkmark-path{from{animation-timing-function:cubic-bezier(.4,0,1,1);stroke-dashoffset:0}to{stroke-dashoffset:-22.91026}}@keyframes mat-checkbox-checked-indeterminate-checkmark{from{animation-timing-function:cubic-bezier(0,0,.2,.1);opacity:1;transform:rotate(0)}to{opacity:0;transform:rotate(45deg)}}@keyframes mat-checkbox-indeterminate-checked-checkmark{from{animation-timing-function:cubic-bezier(.14,0,0,1);opacity:0;transform:rotate(45deg)}to{opacity:1;transform:rotate(360deg)}}@keyframes mat-checkbox-checked-indeterminate-mixedmark{from{animation-timing-function:cubic-bezier(0,0,.2,.1);opacity:0;transform:rotate(-45deg)}to{opacity:1;transform:rotate(0)}}@keyframes mat-checkbox-indeterminate-checked-mixedmark{from{animation-timing-function:cubic-bezier(.14,0,0,1);opacity:1;transform:rotate(0)}to{opacity:0;transform:rotate(315deg)}}@keyframes mat-checkbox-indeterminate-unchecked-mixedmark{0%{animation-timing-function:linear;opacity:1;transform:scaleX(1)}100%,32.8%{opacity:0;transform:scaleX(0)}}.mat-checkbox-checkmark,.mat-checkbox-mixedmark{width:calc(100% - 4px)}.mat-checkbox-background,.mat-checkbox-frame{top:0;left:0;right:0;bottom:0;position:absolute;border-radius:2px;box-sizing:border-box;pointer-events:none}.mat-checkbox{transition:background .4s cubic-bezier(.25,.8,.25,1),box-shadow 280ms cubic-bezier(.4,0,.2,1);cursor:pointer}._mat-animation-noopable.mat-checkbox{transition:none;animation:none}.mat-checkbox-layout{cursor:inherit;align-items:baseline;vertical-align:middle;display:inline-flex;white-space:nowrap}.mat-checkbox-inner-container{display:inline-block;height:20px;line-height:0;margin:auto 8px auto auto;order:0;position:relative;vertical-align:middle;white-space:nowrap;width:20px;flex-shrink:0}[dir=rtl] .mat-checkbox-inner-container{margin-left:8px;margin-right:auto}.mat-checkbox-inner-container-no-side-margin{margin-left:0;margin-right:0}.mat-checkbox-frame{background-color:transparent;transition:border-color 90ms cubic-bezier(0,0,.2,.1);border-width:2px;border-style:solid}._mat-animation-noopable .mat-checkbox-frame{transition:none}.mat-checkbox-background{align-items:center;display:inline-flex;justify-content:center;transition:background-color 90ms cubic-bezier(0,0,.2,.1),opacity 90ms cubic-bezier(0,0,.2,.1)}._mat-animation-noopable .mat-checkbox-background{transition:none}.mat-checkbox-checkmark{top:0;left:0;right:0;bottom:0;position:absolute;width:100%}.mat-checkbox-checkmark-path{stroke-dashoffset:22.91026;stroke-dasharray:22.91026;stroke-width:2.66667px}.mat-checkbox-mixedmark{height:2px;opacity:0;transform:scaleX(0) rotate(0)}.mat-checkbox-label-before .mat-checkbox-inner-container{order:1;margin-left:8px;margin-right:auto}[dir=rtl] .mat-checkbox-label-before .mat-checkbox-inner-container{margin-left:auto;margin-right:8px}.mat-checkbox-checked .mat-checkbox-checkmark{opacity:1}.mat-checkbox-checked .mat-checkbox-checkmark-path{stroke-dashoffset:0}.mat-checkbox-checked .mat-checkbox-mixedmark{transform:scaleX(1) rotate(-45deg)}.mat-checkbox-indeterminate .mat-checkbox-checkmark{opacity:0;transform:rotate(45deg)}.mat-checkbox-indeterminate .mat-checkbox-checkmark-path{stroke-dashoffset:0}.mat-checkbox-indeterminate .mat-checkbox-mixedmark{opacity:1;transform:scaleX(1) rotate(0)}.mat-checkbox-unchecked .mat-checkbox-background{background-color:transparent}.mat-checkbox-disabled{cursor:default}.mat-checkbox-anim-unchecked-checked .mat-checkbox-background{animation:180ms linear mat-checkbox-fade-in-background}.mat-checkbox-anim-unchecked-checked .mat-checkbox-checkmark-path{animation:180ms linear mat-checkbox-unchecked-checked-checkmark-path}.mat-checkbox-anim-unchecked-indeterminate .mat-checkbox-background{animation:180ms linear mat-checkbox-fade-in-background}.mat-checkbox-anim-unchecked-indeterminate .mat-checkbox-mixedmark{animation:90ms linear mat-checkbox-unchecked-indeterminate-mixedmark}.mat-checkbox-anim-checked-unchecked .mat-checkbox-background{animation:180ms linear mat-checkbox-fade-out-background}.mat-checkbox-anim-checked-unchecked .mat-checkbox-checkmark-path{animation:90ms linear mat-checkbox-checked-unchecked-checkmark-path}.mat-checkbox-anim-checked-indeterminate .mat-checkbox-checkmark{animation:90ms linear mat-checkbox-checked-indeterminate-checkmark}.mat-checkbox-anim-checked-indeterminate .mat-checkbox-mixedmark{animation:90ms linear mat-checkbox-checked-indeterminate-mixedmark}.mat-checkbox-anim-indeterminate-checked .mat-checkbox-checkmark{animation:.5s linear mat-checkbox-indeterminate-checked-checkmark}.mat-checkbox-anim-indeterminate-checked .mat-checkbox-mixedmark{animation:.5s linear mat-checkbox-indeterminate-checked-mixedmark}.mat-checkbox-anim-indeterminate-unchecked .mat-checkbox-background{animation:180ms linear mat-checkbox-fade-out-background}.mat-checkbox-anim-indeterminate-unchecked .mat-checkbox-mixedmark{animation:.3s linear mat-checkbox-indeterminate-unchecked-mixedmark}.mat-checkbox-input{bottom:0;left:50%}.mat-checkbox-ripple{position:absolute;left:calc(50% - 25px);top:calc(50% - 25px);height:50px;width:50px;z-index:1;pointer-events:none}"]
                }] }
    ];
    /** @nocollapse */
    RteCheckboxComponent.ctorParameters = function () { return [
        { type: ElementRef },
        { type: ChangeDetectorRef },
        { type: FocusMonitor },
        { type: NgZone },
        { type: String, decorators: [{ type: Attribute, args: ['tabindex',] }] },
        { type: undefined, decorators: [{ type: Optional }, { type: Inject, args: [MAT_CHECKBOX_CLICK_ACTION,] }] },
        { type: undefined, decorators: [{ type: Optional }, { type: Inject, args: [ANIMATION_MODULE_TYPE,] }] },
        { type: RteMaterialBaseService, decorators: [{ type: Injectable }] }
    ]; };
    return RteCheckboxComponent;
}(MatCheckbox));

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @template T
 */
var RteTableComponent = /** @class */ (function (_super) {
    __extends(RteTableComponent, _super);
    function RteTableComponent() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    RteTableComponent.decorators = [
        { type: Component, args: [{
                    // tslint:disable-next-line:component-selector
                    selector: 'rte-table, table[rte-table]',
                    exportAs: 'rteTable',
                    template: CDK_TABLE_TEMPLATE,
                    // tslint:disable-next-line:use-host-property-decorator
                    host: {
                        'class': 'mat-table',
                    },
                    encapsulation: ViewEncapsulation.None,
                    changeDetection: ChangeDetectionStrategy.OnPush,
                    styles: ["rte-header-row{min-height:56px}mat-footer-row,mat-row{min-height:48px}mat-footer-row,mat-header-row,mat-row,rte-header-row{display:flex;border-width:0 0 1px;border-style:solid;border-color:#e0e0e0;align-items:center;box-sizing:border-box}mat-footer-row::after,mat-header-row::after,mat-row::after,rte-header-row::after{display:inline-block;min-height:inherit;content:''}mat-cell:first-of-type,mat-footer-cell:first-of-type,mat-header-cell:first-of-type{padding-left:24px}[dir=rtl] mat-cell:first-of-type,[dir=rtl] mat-footer-cell:first-of-type,[dir=rtl] mat-header-cell:first-of-type{padding-left:0;padding-right:24px}mat-cell:last-of-type,mat-footer-cell:last-of-type,mat-header-cell:last-of-type{padding-right:24px}[dir=rtl] mat-cell:last-of-type,[dir=rtl] mat-footer-cell:last-of-type,[dir=rtl] mat-header-cell:last-of-type{padding-right:0;padding-left:24px}mat-cell,mat-footer-cell,mat-header-cell{flex:1;display:flex;align-items:center;overflow:hidden;word-wrap:break-word;min-height:inherit}[dir=rtl] th.mat-header-cell{text-align:right}[dir=rtl] td.mat-cell:first-of-type,[dir=rtl] td.mat-footer-cell:first-of-type,[dir=rtl] th.mat-header-cell:first-of-type{padding-left:0;padding-right:24px}[dir=rtl] td.mat-cell:last-of-type,[dir=rtl] td.mat-footer-cell:last-of-type,[dir=rtl] th.mat-header-cell:last-of-type{padding-right:0;padding-left:24px}mat-footer-row,mat-header-row,rte-row{display:flex;border-color:#e0e0e0;align-items:center;box-sizing:border-box;display:flex;border-width:0 0 1px;border-style:solid;align-items:center;box-sizing:border-box}mat-footer-cell:first-of-type,rte-cell:first-of-type,rte-header-cell:first-of-type,td.mat-cell:first-of-type,td.mat-footer-cell:first-of-type,th.mat-header-cell:first-of-type{padding-left:24px}mat-footer-cell:last-of-type,rte-cell:last-of-type,rte-header-cell:last-of-type{padding-right:24px}td.mat-cell:last-of-type,td.mat-footer-cell:last-of-type,th.mat-header-cell:last-of-type{padding-right:24px}mat-table{display:block}mat-header-row{min-height:56px}mat-footer-row,rte-row{min-height:48px}mat-footer-row::after,mat-header-row::after,rte-row::after{display:inline-block;min-height:inherit;content:''}mat-footer-cell:first-child,rte-cell:first-child,rte-header-cell:first-child{padding-left:24px}[dir=rtl] mat-footer-cell:first-child,[dir=rtl] rte-cell:first-child,[dir=rtl] rte-header-cell:first-child{padding-left:0;padding-right:24px}mat-footer-cell:last-child,rte-cell:last-child,rte-header-cell:last-child{padding-right:24px}[dir=rtl] mat-footer-cell:last-child,[dir=rtl] rte-cell:last-child,[dir=rtl] rte-header-cell:last-child{padding-right:0;padding-left:24px}mat-footer-cell,rte-cell,rte-header-cell{flex:1;display:flex;align-items:center;overflow:hidden;word-wrap:break-word;min-height:inherit}table.mat-table{border-spacing:0}tr.mat-header-row{height:56px}tr.mat-footer-row,tr.mat-row{height:48px}th.mat-header-cell{text-align:left}td.mat-cell,td.mat-footer-cell,th.mat-header-cell{padding:0;border-bottom-width:1px;border-bottom-style:solid}td.mat-cell:first-child,td.mat-footer-cell:first-child,th.mat-header-cell:first-child{padding-left:24px}td.mat-cell:last-child,td.mat-footer-cell:last-child,th.mat-header-cell:last-child{padding-right:24px}.mat-card-title{margin-bottom:0!important}"]
                }] }
    ];
    return RteTableComponent;
}(MatTable));

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var RteIconComponent = /** @class */ (function (_super) {
    __extends(RteIconComponent, _super);
    function RteIconComponent() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    RteIconComponent.decorators = [
        { type: Component, args: [{
                    // tslint:disable-next-line:component-selector
                    selector: 'rte-icon',
                    exportAs: 'rteIcon',
                    template: "<ng-content></ng-content>",
                    // tslint:disable-next-line:use-input-property-decorator
                    inputs: ['color'],
                    // tslint:disable-next-line:use-host-property-decorator
                    host: {
                        'role': 'img',
                        'class': 'mat-icon',
                        '[class.mat-icon-inline]': 'inline',
                    },
                    encapsulation: ViewEncapsulation.None,
                    changeDetection: ChangeDetectionStrategy.OnPush,
                    styles: [".mat-icon{background-repeat:no-repeat;display:inline-block;fill:currentColor;height:24px;width:24px}.mat-icon.mat-icon-inline{font-size:inherit;height:inherit;line-height:inherit;width:inherit}[dir=rtl] .mat-icon-rtl-mirror{transform:scale(-1,1)}.mat-form-field:not(.mat-form-field-appearance-legacy) .mat-form-field-prefix .mat-icon,.mat-form-field:not(.mat-form-field-appearance-legacy) .mat-form-field-suffix .mat-icon{display:block}.mat-form-field:not(.mat-form-field-appearance-legacy) .mat-form-field-prefix .mat-icon-button .mat-icon,.mat-form-field:not(.mat-form-field-appearance-legacy) .mat-form-field-suffix .mat-icon-button .mat-icon{margin:auto}"]
                }] }
    ];
    return RteIconComponent;
}(MatIcon));

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var RteMatAutocompleteComponent = /** @class */ (function (_super) {
    __extends(RteMatAutocompleteComponent, _super);
    function RteMatAutocompleteComponent(changeDetectorRef, elementRef, defaults) {
        return _super.call(this, changeDetectorRef, elementRef, defaults) || this;
    }
    RteMatAutocompleteComponent.decorators = [
        { type: Component, args: [{
                    // tslint:disable-next-line:component-selector
                    selector: 'rte-matautocomplete',
                    template: "<ng-template>\r\n  <div class=\"mat-autocomplete-panel\" role=\"listbox\" [id]=\"id\" [ngClass]=\"_classList\" #panel>\r\n    <ng-content></ng-content>\r\n  </div>\r\n</ng-template>",
                    encapsulation: ViewEncapsulation.None,
                    changeDetection: ChangeDetectionStrategy.OnPush,
                    exportAs: 'rteMatAutocomplete',
                    // tslint:disable-next-line:use-input-property-decorator
                    inputs: ['disableRipple'],
                    // tslint:disable-next-line:use-host-property-decorator
                    host: {
                        'class': 'mat-autocomplete'
                    },
                    providers: [
                        { provide: MAT_OPTION_PARENT_COMPONENT, useExisting: RteMatAutocompleteComponent }
                    ],
                    styles: [".mat-autocomplete-panel{min-width:112px;max-width:280px;overflow:auto;-webkit-overflow-scrolling:touch;max-width:none;max-height:256px;position:relative;width:100%}.mat-autocomplete-panel:not([class*=mat-elevation-z]){box-shadow:0 5px 5px -3px rgba(0,0,0,.2),0 8px 10px 1px rgba(0,0,0,.14),0 3px 14px 2px rgba(0,0,0,.12)}.mat-autocomplete-panel.mat-autocomplete-visible{visibility:visible}.mat-autocomplete-panel.mat-autocomplete-hidden{visibility:hidden}@media screen and (-ms-high-contrast:active){.mat-autocomplete-panel{outline:solid 1px}}"]
                }] }
    ];
    /** @nocollapse */
    RteMatAutocompleteComponent.ctorParameters = function () { return [
        { type: ChangeDetectorRef },
        { type: ElementRef },
        { type: undefined, decorators: [{ type: Inject, args: [MAT_AUTOCOMPLETE_DEFAULT_OPTIONS,] }] }
    ]; };
    RteMatAutocompleteComponent.propDecorators = {
        options: [{ type: ContentChildren, args: [RteOptionComponent, { descendants: true },] }]
    };
    return RteMatAutocompleteComponent;
}(MatAutocomplete));

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
var MAT_AUTOCOMPLETE_VALUE_ACCESSOR = {
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(function () { return RteMatAutocompleteTrigger; }),
    multi: true
};
var RteMatAutocompleteTrigger = /** @class */ (function (_super) {
    __extends(RteMatAutocompleteTrigger, _super);
    function RteMatAutocompleteTrigger(_element, _overlay, _viewContainerRef, _zone, _changeDetectorRef, _scrollStrategy, _dir, _formField, _document, _viewportRuler) {
        return _super.call(this, _element, _overlay, _viewContainerRef, _zone, _changeDetectorRef, _scrollStrategy, _dir, _formField, _document, _viewportRuler) || this;
    }
    Object.defineProperty(RteMatAutocompleteTrigger.prototype, "activeOption", {
        get: /**
         * @return {?}
         */
        function () {
            if (this.autocomplete && this.autocomplete._keyManager) {
                return this.autocomplete._keyManager.activeItem;
            }
            return null;
        },
        enumerable: true,
        configurable: true
    });
    RteMatAutocompleteTrigger.decorators = [
        { type: Directive, args: [{
                    // tslint:disable-next-line:directive-selector
                    selector: "input[rteMatAutocomplete], textarea[rteMatAutocomplete]",
                    // tslint:disable-next-line:use-host-property-decorator
                    host: {
                        '[attr.autocomplete]': 'autocompleteAttribute',
                        '[attr.role]': 'autocompleteDisabled ? null : "combobox"',
                        '[attr.aria-autocomplete]': 'autocompleteDisabled ? null : "list"',
                        '[attr.aria-activedescendant]': 'activeOption?.id',
                        '[attr.aria-expanded]': 'autocompleteDisabled ? null : panelOpen.toString()',
                        '[attr.aria-owns]': '(autocompleteDisabled || !panelOpen) ? null : autocomplete?.id',
                        '(focusin)': '_handleFocus()',
                        '(blur)': '_onTouched()',
                        '(input)': '_handleInput($event)',
                        '(keydown)': '_handleKeydown($event)',
                    },
                    exportAs: 'rteMatAutocompleteTrigger',
                    providers: [MAT_AUTOCOMPLETE_VALUE_ACCESSOR]
                },] }
    ];
    /** @nocollapse */
    RteMatAutocompleteTrigger.ctorParameters = function () { return [
        { type: ElementRef },
        { type: Overlay },
        { type: ViewContainerRef },
        { type: NgZone },
        { type: ChangeDetectorRef },
        { type: undefined, decorators: [{ type: Inject, args: [MAT_AUTOCOMPLETE_SCROLL_STRATEGY,] }] },
        { type: Directionality, decorators: [{ type: Optional }] },
        { type: RteFormFieldComponent, decorators: [{ type: Optional }, { type: Host }] },
        { type: undefined, decorators: [{ type: Optional }, { type: Inject, args: [DOCUMENT,] }] },
        { type: ViewportRuler }
    ]; };
    RteMatAutocompleteTrigger.propDecorators = {
        autocomplete: [{ type: Input, args: ['rteMatAutocomplete',] }]
    };
    return RteMatAutocompleteTrigger;
}(MatAutocompleteTrigger));

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
var BUTTON_HOST_ATTRIBUTES = [
    'rtebutton',
    'rtebutton-flat',
    'rtebutton-icon',
    'rtebutton-raised',
    'rtebutton-stroked',
    'rtebutton-mini-fab',
    'rtebutton-fab',
];
var RteButtonComponent = /** @class */ (function (_super) {
    __extends(RteButtonComponent, _super);
    function RteButtonComponent(elementRef, 
    // tslint:disable-next-line:no-unused-variable
    platform, focusMonitor, animationMode) {
        var e_1, _a;
        var _this = _super.call(this, elementRef, platform, focusMonitor) || this;
        _this.attrMap = new Map();
        _this._createAttributeMap();
        try {
            for (var BUTTON_HOST_ATTRIBUTES_1 = __values(BUTTON_HOST_ATTRIBUTES), BUTTON_HOST_ATTRIBUTES_1_1 = BUTTON_HOST_ATTRIBUTES_1.next(); !BUTTON_HOST_ATTRIBUTES_1_1.done; BUTTON_HOST_ATTRIBUTES_1_1 = BUTTON_HOST_ATTRIBUTES_1.next()) {
                var attr = BUTTON_HOST_ATTRIBUTES_1_1.value;
                if (_this._hasHostAttributes(attr)) {
                    ((/** @type {?} */ (elementRef.nativeElement))).classList.add(_this.attrMap.get(attr));
                }
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (BUTTON_HOST_ATTRIBUTES_1_1 && !BUTTON_HOST_ATTRIBUTES_1_1.done && (_a = BUTTON_HOST_ATTRIBUTES_1.return)) _a.call(BUTTON_HOST_ATTRIBUTES_1);
            }
            finally { if (e_1) throw e_1.error; }
        }
        return _this;
    }
    /**
     * @return {?}
     */
    RteButtonComponent.prototype._createAttributeMap = /**
     * @return {?}
     */
    function () {
        this.attrMap.set('rtebutton', 'mat-button');
        this.attrMap.set('rtebutton-mini-fab', 'mat-mini-fab');
        this.attrMap.set('rtebutton-raised', 'mat-raised-button');
        this.attrMap.set('rtebutton-icon', 'mat-icon-button');
        this.attrMap.set('rtebutton-fab', 'mat-fab');
        this.attrMap.set('rtebutton-stroked', 'mat-stroked-button');
        this.attrMap.set('rtebutton-flat', 'mat-flat-button');
    };
    RteButtonComponent.decorators = [
        { type: Component, args: [{
                    // tslint:disable-next-line:component-selector
                    selector: "\n      button[rtebutton],\n      button[rtebutton-raised],\n      button[rtebutton-icon],\n      button[rtebutton-fab],\n      button[rtebutton-mini-fab],\n      button[rtebutton-stroked],\n      button[rtebutton-flat]",
                    exportAs: 'rteButton',
                    // tslint:disable-next-line:use-host-property-decorator
                    host: {
                        '[disabled]': 'disabled || null',
                        '[class._mat-animation-noopable]': '_animationMode === "NoopAnimations"',
                    },
                    template: "<span class=\"mat-button-wrapper\"><ng-content></ng-content></span>\r\n<div matRipple class=\"mat-button-ripple\"\r\n     [class.mat-button-ripple-round]=\"isRoundButton || isIconButton\"\r\n     [matRippleDisabled]=\"_isRippleDisabled()\"\r\n     [matRippleCentered]=\"isIconButton\"\r\n     [matRippleTrigger]=\"_getHostElement()\"></div>\r\n<div class=\"mat-button-focus-overlay\"></div>\r\n",
                    // tslint:disable-next-line:use-input-property-decorator
                    inputs: ['disabled', 'disableRipple', 'color'],
                    encapsulation: ViewEncapsulation.None,
                    changeDetection: ChangeDetectionStrategy.OnPush,
                    styles: [".mat-button,.mat-flat-button,.mat-icon-button,.mat-stroked-button{box-sizing:border-box;position:relative;-webkit-user-select:none;-moz-user-select:none;user-select:none;cursor:pointer;outline:0;border:none;-webkit-tap-highlight-color:transparent;display:inline-block;white-space:nowrap;text-decoration:none;vertical-align:baseline;text-align:center;margin:0;min-width:88px;line-height:36px;padding:0 16px;border-radius:2px;overflow:visible}.mat-button[disabled],.mat-flat-button[disabled],.mat-icon-button[disabled],.mat-stroked-button[disabled]{cursor:default}.mat-button.cdk-keyboard-focused .mat-button-focus-overlay,.mat-button.cdk-program-focused .mat-button-focus-overlay,.mat-flat-button.cdk-keyboard-focused .mat-button-focus-overlay,.mat-flat-button.cdk-program-focused .mat-button-focus-overlay,.mat-icon-button.cdk-keyboard-focused .mat-button-focus-overlay,.mat-icon-button.cdk-program-focused .mat-button-focus-overlay,.mat-stroked-button.cdk-keyboard-focused .mat-button-focus-overlay,.mat-stroked-button.cdk-program-focused .mat-button-focus-overlay{opacity:1}.mat-button::-moz-focus-inner,.mat-flat-button::-moz-focus-inner,.mat-icon-button::-moz-focus-inner,.mat-stroked-button::-moz-focus-inner{border:0}.mat-button .mat-button-focus-overlay,.mat-icon-button .mat-button-focus-overlay{transition:none;opacity:0}.mat-button:hover .mat-button-focus-overlay,.mat-stroked-button:hover .mat-button-focus-overlay{opacity:1}.mat-raised-button{box-sizing:border-box;position:relative;-webkit-user-select:none;-moz-user-select:none;user-select:none;cursor:pointer;outline:0;border:none;-webkit-tap-highlight-color:transparent;display:inline-block;white-space:nowrap;text-decoration:none;vertical-align:baseline;text-align:center;margin:0;min-width:88px;line-height:36px;padding:0 16px;border-radius:2px;overflow:visible;transform:translate3d(0,0,0);transition:background .4s cubic-bezier(.25,.8,.25,1),box-shadow 280ms cubic-bezier(.4,0,.2,1)}.mat-raised-button.cdk-keyboard-focused .mat-button-focus-overlay,.mat-raised-button.cdk-program-focused .mat-button-focus-overlay{opacity:1}.mat-raised-button::-moz-focus-inner{border:0}.mat-raised-button:not([class*=mat-elevation-z]){box-shadow:0 3px 1px -2px rgba(0,0,0,.2),0 2px 2px 0 rgba(0,0,0,.14),0 1px 5px 0 rgba(0,0,0,.12)}.mat-raised-button:not([disabled]):active:not([class*=mat-elevation-z]){box-shadow:0 5px 5px -3px rgba(0,0,0,.2),0 8px 10px 1px rgba(0,0,0,.14),0 3px 14px 2px rgba(0,0,0,.12)}.mat-raised-button[disabled]{cursor:default;box-shadow:none}.mat-stroked-button{border:1px solid currentColor;padding:0 15px;line-height:34px}.mat-flat-button:not([class*=mat-elevation-z]),.mat-stroked-button:not([class*=mat-elevation-z]){box-shadow:0 0 0 0 rgba(0,0,0,.2),0 0 0 0 rgba(0,0,0,.14),0 0 0 0 rgba(0,0,0,.12)}.mat-fab{box-sizing:border-box;position:relative;-webkit-user-select:none;-moz-user-select:none;user-select:none;cursor:pointer;outline:0;border:none;-webkit-tap-highlight-color:transparent;display:inline-block;white-space:nowrap;text-decoration:none;vertical-align:baseline;text-align:center;margin:0;min-width:88px;line-height:36px;padding:0;border-radius:50%;overflow:visible;transform:translate3d(0,0,0);transition:background .4s cubic-bezier(.25,.8,.25,1),box-shadow 280ms cubic-bezier(.4,0,.2,1);min-width:0;width:56px;height:56px;flex-shrink:0}.mat-fab.cdk-keyboard-focused .mat-button-focus-overlay,.mat-fab.cdk-program-focused .mat-button-focus-overlay{opacity:1}.mat-fab::-moz-focus-inner{border:0}.mat-fab:not([class*=mat-elevation-z]){box-shadow:0 3px 1px -2px rgba(0,0,0,.2),0 2px 2px 0 rgba(0,0,0,.14),0 1px 5px 0 rgba(0,0,0,.12)}.mat-fab:not([disabled]):active:not([class*=mat-elevation-z]){box-shadow:0 5px 5px -3px rgba(0,0,0,.2),0 8px 10px 1px rgba(0,0,0,.14),0 3px 14px 2px rgba(0,0,0,.12);box-shadow:0 7px 8px -4px rgba(0,0,0,.2),0 12px 17px 2px rgba(0,0,0,.14),0 5px 22px 4px rgba(0,0,0,.12)}.mat-fab[disabled]{cursor:default;box-shadow:none}.mat-fab:not([class*=mat-elevation-z]){box-shadow:0 3px 5px -1px rgba(0,0,0,.2),0 6px 10px 0 rgba(0,0,0,.14),0 1px 18px 0 rgba(0,0,0,.12)}.mat-fab .mat-button-wrapper{padding:16px 0;display:inline-block;line-height:24px}.mat-mini-fab{box-sizing:border-box;position:relative;-webkit-user-select:none;-moz-user-select:none;user-select:none;cursor:pointer;outline:0;border:none;-webkit-tap-highlight-color:transparent;display:inline-block;white-space:nowrap;text-decoration:none;vertical-align:baseline;text-align:center;margin:0;min-width:88px;line-height:36px;padding:0;border-radius:50%;overflow:visible;transform:translate3d(0,0,0);transition:background .4s cubic-bezier(.25,.8,.25,1),box-shadow 280ms cubic-bezier(.4,0,.2,1);min-width:0;width:40px;height:40px;flex-shrink:0}.mat-mini-fab.cdk-keyboard-focused .mat-button-focus-overlay,.mat-mini-fab.cdk-program-focused .mat-button-focus-overlay{opacity:1}.mat-mini-fab::-moz-focus-inner{border:0}.mat-mini-fab:not([class*=mat-elevation-z]){box-shadow:0 3px 1px -2px rgba(0,0,0,.2),0 2px 2px 0 rgba(0,0,0,.14),0 1px 5px 0 rgba(0,0,0,.12)}.mat-mini-fab:not([disabled]):active:not([class*=mat-elevation-z]){box-shadow:0 5px 5px -3px rgba(0,0,0,.2),0 8px 10px 1px rgba(0,0,0,.14),0 3px 14px 2px rgba(0,0,0,.12);box-shadow:0 7px 8px -4px rgba(0,0,0,.2),0 12px 17px 2px rgba(0,0,0,.14),0 5px 22px 4px rgba(0,0,0,.12)}.mat-mini-fab[disabled]{cursor:default;box-shadow:none}.mat-mini-fab:not([class*=mat-elevation-z]){box-shadow:0 3px 5px -1px rgba(0,0,0,.2),0 6px 10px 0 rgba(0,0,0,.14),0 1px 18px 0 rgba(0,0,0,.12)}.mat-mini-fab .mat-button-wrapper{padding:8px 0;display:inline-block;line-height:24px}.mat-icon-button{padding:0;min-width:0;width:40px;height:40px;flex-shrink:0;line-height:40px;border-radius:50%}.mat-icon-button .mat-icon,.mat-icon-button i{line-height:24px}.mat-button-focus-overlay,.mat-button-ripple{top:0;left:0;right:0;bottom:0;position:absolute;pointer-events:none;border-radius:inherit}.mat-button-focus-overlay{background-color:rgba(0,0,0,.12);border-radius:inherit;opacity:0;transition:opacity .2s cubic-bezier(.35,0,.25,1),background-color .2s cubic-bezier(.35,0,.25,1)}.mat-button-ripple-round{border-radius:50%;z-index:1}.mat-button .mat-button-wrapper>*,.mat-fab .mat-button-wrapper>*,.mat-flat-button .mat-button-wrapper>*,.mat-icon-button .mat-button-wrapper>*,.mat-mini-fab .mat-button-wrapper>*,.mat-raised-button .mat-button-wrapper>*,.mat-stroked-button .mat-button-wrapper>*{vertical-align:middle}.mat-form-field:not(.mat-form-field-appearance-legacy) .mat-form-field-prefix .mat-icon-button,.mat-form-field:not(.mat-form-field-appearance-legacy) .mat-form-field-suffix .mat-icon-button{display:block;font-size:inherit;width:2.5em;height:2.5em}@media screen and (-ms-high-contrast:active){.mat-button-focus-overlay{background-color:rgba(255,255,255,.5)}.mat-button,.mat-fab,.mat-flat-button,.mat-icon-button,.mat-mini-fab,.mat-raised-button{outline:solid 1px}}"]
                }] }
    ];
    /** @nocollapse */
    RteButtonComponent.ctorParameters = function () { return [
        { type: ElementRef },
        { type: Platform },
        { type: FocusMonitor },
        { type: String, decorators: [{ type: Optional }, { type: Inject, args: [ANIMATION_MODULE_TYPE,] }] }
    ]; };
    return RteButtonComponent;
}(MatButton));

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var RteCellDefDirective = /** @class */ (function (_super) {
    __extends(RteCellDefDirective, _super);
    function RteCellDefDirective() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    RteCellDefDirective.decorators = [
        { type: Directive, args: [{
                    // tslint:disable-next-line:directive-selector
                    selector: '[rteCellDef]',
                    providers: [{ provide: CdkCellDef, useExisting: RteCellDefDirective }]
                },] }
    ];
    return RteCellDefDirective;
}(MatCellDef));

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var RteColumnDefDirective = /** @class */ (function (_super) {
    __extends(RteColumnDefDirective, _super);
    function RteColumnDefDirective() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(RteColumnDefDirective.prototype, "rteColumnDef", {
        // tslint:disable-next-line:no-input-rename
        get: 
        // tslint:disable-next-line:no-input-rename
        /**
         * @return {?}
         */
        function () { return this.name; },
        set: /**
         * @param {?} val
         * @return {?}
         */
        function (val) {
            this.name = val;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(RteColumnDefDirective.prototype, "rteSticky", {
        get: /**
         * @return {?}
         */
        function () { return this.sticky; },
        set: /**
         * @param {?} val
         * @return {?}
         */
        function (val) {
            this.sticky = val;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(RteColumnDefDirective.prototype, "rteStickyEnd", {
        get: /**
         * @return {?}
         */
        function () { return this.stickyEnd; },
        set: /**
         * @param {?} val
         * @return {?}
         */
        function (val) {
            this.stickyEnd = val;
        },
        enumerable: true,
        configurable: true
    });
    RteColumnDefDirective.decorators = [
        { type: Directive, args: [{
                    // tslint:disable-next-line:directive-selector
                    selector: '[rteColumnDef]',
                    providers: [
                        { provide: CdkColumnDef, useExisting: RteColumnDefDirective },
                        { provide: 'MAT_SORT_HEADER_COLUMN_DEF', useExisting: RteColumnDefDirective }
                    ]
                },] }
    ];
    RteColumnDefDirective.propDecorators = {
        rteColumnDef: [{ type: Input, args: ['rteColumnDef',] }],
        rteSticky: [{ type: Input, args: ['rteSticky',] }],
        rteStickyEnd: [{ type: Input, args: ['rteStickyEnd',] }]
    };
    return RteColumnDefDirective;
}(MatColumnDef));

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var RteCellDirective = /** @class */ (function (_super) {
    __extends(RteCellDirective, _super);
    function RteCellDirective(columnDef, elementRef) {
        var _this = _super.call(this, columnDef, elementRef) || this;
        elementRef.nativeElement.classList.add("mat-column-" + columnDef.cssClassFriendlyName);
        return _this;
    }
    RteCellDirective.decorators = [
        { type: Directive, args: [{
                    // tslint:disable-next-line:directive-selector
                    selector: 'rte-cell, td[rte-cell]',
                    // tslint:disable-next-line:use-host-property-decorator
                    host: {
                        'class': 'mat-cell',
                        'role': 'gridcell',
                    },
                },] }
    ];
    /** @nocollapse */
    RteCellDirective.ctorParameters = function () { return [
        { type: RteColumnDefDirective },
        { type: ElementRef }
    ]; };
    return RteCellDirective;
}(MatCell));

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var RteHeaderCellDirective = /** @class */ (function (_super) {
    __extends(RteHeaderCellDirective, _super);
    function RteHeaderCellDirective(columnDef, elementRef) {
        var _this = _super.call(this, columnDef, elementRef) || this;
        elementRef.nativeElement.classList.add("mat-column-" + columnDef.cssClassFriendlyName);
        return _this;
    }
    RteHeaderCellDirective.decorators = [
        { type: Directive, args: [{
                    // tslint:disable-next-line:directive-selector
                    selector: 'rte-header-cell, th[rte-header-cell]',
                    // tslint:disable-next-line:use-host-property-decorator
                    host: {
                        'class': 'mat-header-cell',
                        'role': 'columnheader',
                    },
                },] }
    ];
    /** @nocollapse */
    RteHeaderCellDirective.ctorParameters = function () { return [
        { type: CdkColumnDef },
        { type: ElementRef }
    ]; };
    return RteHeaderCellDirective;
}(MatHeaderCell));

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var RteHeaderCellDefDirective = /** @class */ (function (_super) {
    __extends(RteHeaderCellDefDirective, _super);
    function RteHeaderCellDefDirective() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    RteHeaderCellDefDirective.decorators = [
        { type: Directive, args: [{
                    // tslint:disable-next-line:directive-selector
                    selector: '[rteHeaderCellDef]',
                    providers: [{ provide: CdkHeaderCellDef, useExisting: RteHeaderCellDefDirective }]
                },] }
    ];
    return RteHeaderCellDefDirective;
}(MatHeaderCellDef));

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var RteRowComponent = /** @class */ (function (_super) {
    __extends(RteRowComponent, _super);
    function RteRowComponent() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    RteRowComponent.decorators = [
        { type: Component, args: [{
                    // tslint:disable-next-line:component-selector
                    selector: 'rte-row, tr[rte-row]',
                    template: CDK_ROW_TEMPLATE,
                    // tslint:disable-next-line:use-host-property-decorator
                    host: {
                        'class': 'mat-row',
                        'role': 'row',
                    },
                    changeDetection: ChangeDetectionStrategy.OnPush,
                    encapsulation: ViewEncapsulation.None,
                    exportAs: 'rteRow',
                    providers: [{ provide: CdkRow, useExisting: RteRowComponent }]
                }] }
    ];
    return RteRowComponent;
}(MatRow));

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @template T
 */
var RteRowDefDirective = /** @class */ (function (_super) {
    __extends(RteRowDefDirective, _super);
    function RteRowDefDirective() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    RteRowDefDirective.decorators = [
        { type: Directive, args: [{
                    // tslint:disable-next-line:directive-selector
                    selector: '[rteRowDef]',
                    providers: [{ provide: CdkRowDef, useExisting: RteRowDefDirective }],
                    // tslint:disable-next-line:use-input-property-decorator
                    inputs: ['columns: rteRowDefColumns', 'when: rteRowDefWhen'],
                },] }
    ];
    return RteRowDefDirective;
}(MatRowDef));

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var RteHeaderRowComponent = /** @class */ (function (_super) {
    __extends(RteHeaderRowComponent, _super);
    function RteHeaderRowComponent() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    RteHeaderRowComponent.decorators = [
        { type: Component, args: [{
                    // tslint:disable-next-line:component-selector
                    selector: 'rte-header-row, tr[rte-header-row]',
                    template: CDK_ROW_TEMPLATE,
                    // tslint:disable-next-line:use-host-property-decorator
                    host: {
                        'class': 'mat-header-row',
                        'role': 'row',
                    },
                    changeDetection: ChangeDetectionStrategy.OnPush,
                    encapsulation: ViewEncapsulation.None,
                    exportAs: 'rteHeaderRow',
                    providers: [{ provide: CdkHeaderRow, useExisting: RteHeaderRowComponent }]
                }] }
    ];
    return RteHeaderRowComponent;
}(MatHeaderRow));

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var RteHeaderRowDefDirective = /** @class */ (function (_super) {
    __extends(RteHeaderRowDefDirective, _super);
    function RteHeaderRowDefDirective() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    RteHeaderRowDefDirective.decorators = [
        { type: Directive, args: [{
                    // tslint:disable-next-line:directive-selector
                    selector: '[rteHeaderRowDef]',
                    providers: [{ provide: CdkHeaderRowDef, useExisting: RteHeaderRowDefDirective }],
                    // tslint:disable-next-line:use-input-property-decorator
                    inputs: ['columns: rteHeaderRowDef', 'sticky: matHeaderRowDefSticky'],
                },] }
    ];
    return RteHeaderRowDefDirective;
}(MatHeaderRowDef));

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var RteCardComponent = /** @class */ (function (_super) {
    __extends(RteCardComponent, _super);
    function RteCardComponent() {
        var _this = _super.call(this) || this;
        _this.showCloseButton = false;
        _this.withMarginCard = false;
        _this.onClose = new EventEmitter();
        return _this;
    }
    RteCardComponent.decorators = [
        { type: Component, args: [{
                    selector: 'rte-card',
                    exportAs: 'rteCard',
                    template: "<ng-content></ng-content>\r\n<ng-content select=\"mat-card-footer\"></ng-content>\r\n",
                    encapsulation: ViewEncapsulation.None,
                    changeDetection: ChangeDetectionStrategy.OnPush,
                    host: { 'class': 'mat-card' },
                    styles: [".mat-card{transition:box-shadow 280ms cubic-bezier(.4,0,.2,1);margin-top:30px;display:block;position:relative;padding:16px;border-radius:4px}.mat-card .mat-divider-horizontal{position:absolute;left:0;width:100%}[dir=rtl] .mat-card .mat-divider-horizontal{left:auto;right:0}.mat-card .mat-divider-horizontal.mat-divider-inset{position:static;margin:0}[dir=rtl] .mat-card .mat-divider-horizontal.mat-divider-inset{margin-right:0}@media (-ms-high-contrast:active){.mat-card{outline:solid 1px}}.mat-card-actions,.mat-card-content,.mat-card-subtitle{display:block;margin-bottom:16px}.mat-card-title{display:block;margin-bottom:8px}.mat-card-actions{margin-left:-8px;margin-right:-8px;padding:8px 0}.mat-card-actions-align-end{display:flex;justify-content:flex-end}.mat-card-image{width:calc(100% + 32px);margin:0 -16px 16px}.mat-card-footer{display:block;margin:0 -16px -16px}.mat-card-actions .mat-button,.mat-card-actions .mat-raised-button{margin:0 8px}.mat-card-header{display:flex;flex-direction:row}.mat-card-header .mat-card-title{margin-bottom:12px}.mat-card-header-text{margin:0 16px}.mat-card-avatar{height:40px;width:40px;border-radius:50%;flex-shrink:0;-o-object-fit:cover;object-fit:cover}.mat-card-title-group{display:flex;justify-content:space-between}.mat-card-sm-image{width:80px;height:80px}.mat-card-md-image{width:112px;height:112px}.mat-card-lg-image{width:152px;height:152px}.mat-card-xl-image{width:240px;height:240px;margin:-8px}.mat-card-title-group>.mat-card-xl-image{margin:-8px 0 8px}@media (max-width:599px){.mat-card-title-group{margin:0}.mat-card-xl-image{margin-left:0;margin-right:0}}.mat-card-content>:first-child,.mat-card>:first-child{margin-top:0}.mat-card-content>:last-child:not(.mat-card-footer),.mat-card>:last-child:not(.mat-card-footer){margin-bottom:0}.mat-card-image:first-child{margin-top:-16px;border-top-left-radius:inherit;border-top-right-radius:inherit}.mat-card>.mat-card-actions:last-child{margin-bottom:-8px;padding-bottom:0}.mat-card-actions .mat-button:first-child,.mat-card-actions .mat-raised-button:first-child{margin-left:0;margin-right:0}.mat-card-subtitle:not(:first-child),.mat-card-title:not(:first-child){margin-top:-4px}.mat-card-header .mat-card-subtitle:not(:first-child),.mat-card>.mat-card-xl-image:first-child{margin-top:-8px}.mat-card>.mat-card-xl-image:last-child{margin-bottom:-8px}"]
                }] }
    ];
    /** @nocollapse */
    RteCardComponent.ctorParameters = function () { return []; };
    RteCardComponent.propDecorators = {
        title: [{ type: Input }],
        showCloseButton: [{ type: Input }],
        withMarginCard: [{ type: Input }],
        onClose: [{ type: Output }]
    };
    return RteCardComponent;
}(MatCard));

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var RteDividerComponent = /** @class */ (function (_super) {
    __extends(RteDividerComponent, _super);
    function RteDividerComponent() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    RteDividerComponent.decorators = [
        { type: Component, args: [{
                    selector: 'rte-divider',
                    host: {
                        'role': 'separator',
                        '[attr.aria-orientation]': 'vertical ? "vertical" : "horizontal"',
                        '[class.mat-divider-vertical]': 'vertical',
                        '[class.mat-divider-horizontal]': '!vertical',
                        '[class.mat-divider-inset]': 'inset',
                        'class': 'mat-divider'
                    },
                    template: '',
                    encapsulation: ViewEncapsulation.None,
                    changeDetection: ChangeDetectionStrategy.OnPush,
                    styles: [".mat-divider{display:block;margin:0;border-top-width:1px;border-top-style:solid}.mat-divider.mat-divider-vertical{border-top:0;border-right-width:1px;border-right-style:solid}.mat-divider.mat-divider-inset{margin-left:80px}[dir=rtl] .mat-divider.mat-divider-inset{margin-left:auto;margin-right:80px}"]
                }] }
    ];
    return RteDividerComponent;
}(MatDivider));

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var RteChipDirective = /** @class */ (function (_super) {
    __extends(RteChipDirective, _super);
    function RteChipDirective(_elementRef, _ngZone, platform, globalRippleOptions) {
        return _super.call(this, _elementRef, _ngZone, platform, globalRippleOptions) || this;
    }
    RteChipDirective.decorators = [
        { type: Directive, args: [{
                    selector: "rte-basic-chip, [rte-basic-chip], rte-chip, [rte-chip]",
                    inputs: ['color', 'disabled', 'disableRipple'],
                    exportAs: 'rteChip',
                    host: {
                        'class': 'mat-chip',
                        '[attr.tabindex]': 'disabled ? null : -1',
                        'role': 'option',
                        '[class.mat-chip-selected]': 'selected',
                        '[class.mat-chip-with-avatar]': 'avatar',
                        '[class.mat-chip-with-trailing-icon]': 'trailingIcon || removeIcon',
                        '[class.mat-chip-disabled]': 'disabled',
                        '[attr.disabled]': 'disabled || null',
                        '[attr.aria-disabled]': 'disabled.toString()',
                        '[attr.aria-selected]': 'ariaSelected',
                        '(click)': '_handleClick($event)',
                        '(keydown)': '_handleKeydown($event)',
                        '(focus)': 'focus()',
                        '(blur)': '_blur()',
                    }
                },] }
    ];
    /** @nocollapse */
    RteChipDirective.ctorParameters = function () { return [
        { type: ElementRef },
        { type: NgZone },
        { type: Platform },
        { type: undefined, decorators: [{ type: Optional }, { type: Inject, args: [MAT_RIPPLE_GLOBAL_OPTIONS,] }] }
    ]; };
    return RteChipDirective;
}(MatChip));

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var RteChipInputDirective = /** @class */ (function (_super) {
    __extends(RteChipInputDirective, _super);
    function RteChipInputDirective(_elementRef, _defaultOptions) {
        return _super.call(this, _elementRef, _defaultOptions) || this;
    }
    RteChipInputDirective.decorators = [
        { type: Directive, args: [{
                    selector: '[rteChipInputFor]',
                    exportAs: 'rteChipInput, rteChipInputFor',
                    host: {
                        'class': 'mat-chip-input mat-input-element',
                        '(keydown)': '_keydown($event)',
                        '(blur)': '_blur()',
                        '(focus)': '_focus()',
                        '(input)': '_onInput()',
                        '[id]': 'id',
                        '[attr.disabled]': 'disabled || null',
                        '[attr.placeholder]': 'placeholder || null',
                        '[attr.aria-invalid]': '_chipList && _chipList.ngControl ? _chipList.ngControl.invalid : null',
                    }
                },] }
    ];
    /** @nocollapse */
    RteChipInputDirective.ctorParameters = function () { return [
        { type: ElementRef },
        { type: undefined, decorators: [{ type: Inject, args: [MAT_CHIPS_DEFAULT_OPTIONS,] }] }
    ]; };
    return RteChipInputDirective;
}(MatChipInput));

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var RteChipListComponent = /** @class */ (function (_super) {
    __extends(RteChipListComponent, _super);
    function RteChipListComponent(_elementRef, _changeDetectorRef, _dir, _parentForm, _parentFormGroup, _defaultErrorStateMatcher, ngControl) {
        var _this = _super.call(this, _elementRef, _changeDetectorRef, _dir, _parentForm, _parentFormGroup, _defaultErrorStateMatcher, ngControl) || this;
        _this._elementRef = _elementRef;
        _this.ngControl = ngControl;
        return _this;
    }
    /**
     * @return {?}
     */
    RteChipListComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
    };
    RteChipListComponent.decorators = [
        { type: Component, args: [{
                    selector: 'rte-chip-list',
                    template: "<div class=\"mat-chip-list-wrapper\">\r\n    <ng-content></ng-content>\r\n</div>",
                    exportAs: 'rteChipList',
                    host: {
                        '[attr.tabindex]': 'disabled ? null : _tabIndex',
                        '[attr.aria-describedby]': '_ariaDescribedby || null',
                        '[attr.aria-required]': 'required.toString()',
                        '[attr.aria-disabled]': 'disabled.toString()',
                        '[attr.aria-invalid]': 'errorState',
                        '[attr.aria-multiselectable]': 'multiple',
                        '[attr.role]': 'role',
                        '[class.mat-chip-list-disabled]': 'disabled',
                        '[class.mat-chip-list-invalid]': 'errorState',
                        '[class.mat-chip-list-required]': 'required',
                        '[attr.aria-orientation]': 'ariaOrientation',
                        'class': 'mat-chip-list',
                        '(focus)': 'focus()',
                        '(blur)': '_blur()',
                        '(keydown)': '_keydown($event)',
                        '[id]': '_uid',
                    },
                    providers: [
                        { provide: MatFormFieldControl$1, useExisting: RteChipListComponent },
                        { provide: RteFormFieldComponent, useExisting: RteChipListComponent }
                    ],
                    encapsulation: ViewEncapsulation.None,
                    changeDetection: ChangeDetectionStrategy.OnPush,
                    styles: [".mat-chip{position:relative;overflow:hidden;box-sizing:border-box;-webkit-tap-highlight-color:transparent;border-radius:3px!important;font-size:11px;line-height:1;text-align:center;text-decoration:none;text-transform:uppercase;min-height:20px!important;align-items:center!important;transform:translateZ(0)}.mat-standard-chip{transition:box-shadow 280ms cubic-bezier(.4,0,.2,1);display:inline-flex;padding:7px 12px;border-radius:16px;align-items:center;cursor:default;min-height:32px;height:1px}.mat-standard-chip .mat-chip-remove.mat-icon{width:18px;height:18px}.mat-standard-chip::after{top:0;left:0;right:0;bottom:0;position:absolute;border-radius:inherit;opacity:0;content:'';pointer-events:none;transition:opacity .2s cubic-bezier(.35,0,.25,1)}.mat-standard-chip:hover::after{opacity:.12}.mat-standard-chip:focus{outline:0}.mat-standard-chip:focus::after{opacity:.16}@media (-ms-high-contrast:active){.mat-standard-chip{outline:solid 1px}.mat-standard-chip:focus{outline:dotted 2px}}.mat-standard-chip.mat-chip-disabled::after{opacity:0}.mat-standard-chip.mat-chip-disabled .mat-chip-remove,.mat-standard-chip.mat-chip-disabled .mat-chip-trailing-icon{cursor:default}.mat-standard-chip.mat-chip-with-avatar,.mat-standard-chip.mat-chip-with-trailing-icon.mat-chip-with-avatar{padding-top:0;padding-bottom:0}.mat-standard-chip.mat-chip-with-trailing-icon.mat-chip-with-avatar{padding-right:8px;padding-left:0}[dir=rtl] .mat-standard-chip.mat-chip-with-trailing-icon.mat-chip-with-avatar{padding-left:8px;padding-right:0}.mat-standard-chip.mat-chip-with-trailing-icon{padding:7px 8px 7px 12px}[dir=rtl] .mat-standard-chip.mat-chip-with-trailing-icon{padding-left:8px;padding-right:12px}.mat-standard-chip.mat-chip-with-avatar{padding-left:0;padding-right:12px}[dir=rtl] .mat-standard-chip.mat-chip-with-avatar{padding-right:0;padding-left:12px}.mat-standard-chip .mat-chip-avatar{width:24px;height:24px;margin-right:8px;margin-left:4px}[dir=rtl] .mat-standard-chip .mat-chip-avatar{margin-left:8px;margin-right:4px}.mat-standard-chip .mat-chip-remove,.mat-standard-chip .mat-chip-trailing-icon{width:18px;height:18px;cursor:pointer;margin-left:8px;margin-right:0}[dir=rtl] .mat-standard-chip .mat-chip-remove,[dir=rtl] .mat-standard-chip .mat-chip-trailing-icon{margin-right:8px;margin-left:0}.mat-chip-list-wrapper{display:flex;flex-direction:row;flex-wrap:wrap;align-items:center;margin:-4px}.mat-chip-list-wrapper .mat-standard-chip,.mat-chip-list-wrapper input.mat-input-element{margin:4px}.mat-chip-list-stacked .mat-chip-list-wrapper{flex-direction:column;align-items:flex-start}.mat-chip-list-stacked .mat-chip-list-wrapper .mat-standard-chip{width:100%}.mat-chip-avatar{border-radius:50%;justify-content:center;align-items:center;display:flex;overflow:hidden;-o-object-fit:cover;object-fit:cover}input.mat-chip-input{width:150px;margin:4px;flex:1 0 150px}"]
                }] }
    ];
    /** @nocollapse */
    RteChipListComponent.ctorParameters = function () { return [
        { type: ElementRef },
        { type: ChangeDetectorRef },
        { type: Directionality, decorators: [{ type: Optional }] },
        { type: NgForm, decorators: [{ type: Optional }] },
        { type: FormGroupDirective, decorators: [{ type: Optional }] },
        { type: ErrorStateMatcher$1 },
        { type: NgControl, decorators: [{ type: Optional }, { type: Self }] }
    ]; };
    return RteChipListComponent;
}(MatChipList));

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var RteChipRemoveDirective = /** @class */ (function (_super) {
    __extends(RteChipRemoveDirective, _super);
    function RteChipRemoveDirective(_parentChip) {
        return _super.call(this, _parentChip) || this;
    }
    RteChipRemoveDirective.decorators = [
        { type: Directive, args: [{
                    selector: '[rteChipRemove]',
                    host: {
                        'class': 'mat-chip-remove mat-chip-trailing-icon',
                        '(click)': '_handleClick($event)',
                    },
                    exportAs: 'rteChipRemove'
                },] }
    ];
    /** @nocollapse */
    RteChipRemoveDirective.ctorParameters = function () { return [
        { type: RteChipDirective }
    ]; };
    RteChipRemoveDirective.propDecorators = {
        removeIcon: [{ type: ContentChild, args: [forwardRef(function () { return RteChipRemoveDirective; }), { read: false },] }]
    };
    return RteChipRemoveDirective;
}(MatChipRemove));

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var RteTooltipComponent = /** @class */ (function (_super) {
    __extends(RteTooltipComponent, _super);
    function RteTooltipComponent(_changeDetectorRef, _breakpointObserver) {
        return _super.call(this, _changeDetectorRef, _breakpointObserver) || this;
    }
    RteTooltipComponent.decorators = [
        { type: Component, args: [{
                    selector: 'rte-tooltip-component',
                    template: "<div class=\"mat-tooltip\"\r\n     [ngClass]=\"tooltipClass\"\r\n     [class.mat-tooltip-handset]=\"(_isHandset | async)?.matches\"\r\n     [@state]=\"_visibility\"\r\n     (@state.start)=\"_animationStart()\"\r\n     (@state.done)=\"_animationDone($event)\">{{message}}</div>",
                    encapsulation: ViewEncapsulation.None,
                    changeDetection: ChangeDetectionStrategy.OnPush,
                    animations: [matTooltipAnimations.tooltipState],
                    host: {
                        // Forces the element to have a layout in IE and Edge. This fixes issues where the element
                        // won't be rendered if the animations are disabled or there is no web animations polyfill.
                        '[style.zoom]': '_visibility === "visible" ? 1 : null',
                        '(body:click)': 'this._handleBodyInteraction()',
                        'aria-hidden': 'true',
                    },
                    styles: [".mat-tooltip-panel{pointer-events:none!important}.mat-tooltip{color:#fff;border-radius:4px;margin:14px;max-width:250px;padding-left:8px;padding-right:8px;overflow:hidden;text-overflow:ellipsis}@media (-ms-high-contrast:active){.mat-tooltip{outline:solid 1px}}.mat-tooltip-handset{margin:24px;padding-left:16px;padding-right:16px}"]
                }] }
    ];
    /** @nocollapse */
    RteTooltipComponent.ctorParameters = function () { return [
        { type: ChangeDetectorRef },
        { type: BreakpointObserver }
    ]; };
    return RteTooltipComponent;
}(TooltipComponent));

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var RteTooltipDirective = /** @class */ (function (_super) {
    __extends(RteTooltipDirective, _super);
    function RteTooltipDirective(_overlay, _elementRef, _scrollDispatcher, _viewContainerRef, _ngZone, platform, _ariaDescriber, _focusMonitor, scrollStrategy, _dir, _defaultOptions, hammerLoader) {
        return _super.call(this, _overlay, _elementRef, _scrollDispatcher, _viewContainerRef, _ngZone, platform, _ariaDescriber, _focusMonitor, scrollStrategy, _dir, _defaultOptions, hammerLoader) || this;
    }
    Object.defineProperty(RteTooltipDirective.prototype, "rteMessage", {
        get: /**
         * @return {?}
         */
        function () { return this.message; },
        set: /**
         * @param {?} value
         * @return {?}
         */
        function (value) {
            this.message = value;
        },
        enumerable: true,
        configurable: true
    });
    RteTooltipDirective.decorators = [
        { type: Directive, args: [{
                    selector: '[rteTooltip]',
                    exportAs: 'rteTooltip',
                    host: {
                        '(longpress)': 'show()',
                        '(keydown)': '_handleKeydown($event)',
                        '(touchend)': '_handleTouchend()',
                    },
                },] }
    ];
    /** @nocollapse */
    RteTooltipDirective.ctorParameters = function () { return [
        { type: Overlay },
        { type: ElementRef },
        { type: ScrollDispatcher },
        { type: ViewContainerRef },
        { type: NgZone },
        { type: Platform },
        { type: AriaDescriber },
        { type: FocusMonitor },
        { type: undefined, decorators: [{ type: Inject, args: [MAT_TOOLTIP_SCROLL_STRATEGY,] }] },
        { type: Directionality, decorators: [{ type: Optional }] },
        { type: undefined, decorators: [{ type: Optional }, { type: Inject, args: [MAT_TOOLTIP_DEFAULT_OPTIONS,] }] },
        { type: undefined, decorators: [{ type: Optional }, { type: Inject, args: [HAMMER_LOADER,] }] }
    ]; };
    RteTooltipDirective.propDecorators = {
        rteMessage: [{ type: Input, args: ['rteTooltip',] }]
    };
    return RteTooltipDirective;
}(MatTooltip));

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
var RTE_RADIO_GROUP_CONTROL_VALUE_ACCESSOR = {
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(function () { return RteRadioGroupDirective; }),
    multi: true
};
var RteRadioGroupDirective = /** @class */ (function (_super) {
    __extends(RteRadioGroupDirective, _super);
    function RteRadioGroupDirective(_changeDetector) {
        return _super.call(this, _changeDetector) || this;
    }
    RteRadioGroupDirective.decorators = [
        { type: Directive, args: [{
                    selector: 'rte-radio-group',
                    exportAs: 'rteRadioGroup',
                    providers: [RTE_RADIO_GROUP_CONTROL_VALUE_ACCESSOR],
                    host: {
                        'role': 'radiogroup',
                        'class': 'mat-radio-group',
                    },
                },] }
    ];
    /** @nocollapse */
    RteRadioGroupDirective.ctorParameters = function () { return [
        { type: ChangeDetectorRef }
    ]; };
    RteRadioGroupDirective.propDecorators = {
        _radios: [{ type: ContentChildren, args: [forwardRef(function () { return RteRadioButtonComponent; }), { descendants: true },] }]
    };
    return RteRadioGroupDirective;
}(MatRadioGroup));
var RteRadioButtonComponent = /** @class */ (function (_super) {
    __extends(RteRadioButtonComponent, _super);
    // radioGroup: RteRadioGroupDirective;
    function RteRadioButtonComponent(radioGroup, elementRef, _changeDetector, _focusMonitor, _radioDispatcher, _animationMode) {
        var _this = _super.call(this, radioGroup, elementRef, _changeDetector, _focusMonitor, _radioDispatcher, _animationMode) || this;
        _this._animationMode = _animationMode;
        return _this;
        //this.radioGroup = radioGroup;
    }
    RteRadioButtonComponent.decorators = [
        { type: Component, args: [{
                    selector: 'rte-radio-button',
                    template: "<!-- TODO(jelbourn): render the radio on either side of the content -->\r\n<!-- TODO(mtlin): Evaluate trade-offs of using native radio vs. cost of additional bindings. -->\r\n<label [attr.for]=\"inputId\" class=\"mat-radio-label\" #label>\r\n    <!-- The actual 'radio' part of the control. -->\r\n    <div class=\"mat-radio-container\">\r\n        <div class=\"mat-radio-outer-circle\"></div>\r\n        <div class=\"mat-radio-inner-circle\"></div>\r\n        <div mat-ripple class=\"mat-radio-ripple\"\r\n             [matRippleTrigger]=\"label\"\r\n             [matRippleDisabled]=\"_isRippleDisabled()\"\r\n             [matRippleCentered]=\"true\"\r\n             [matRippleRadius]=\"20\"\r\n             [matRippleAnimation]=\"{enterDuration: 150}\">\r\n\r\n            <div class=\"mat-ripple-element mat-radio-persistent-ripple\"></div>\r\n        </div>\r\n\r\n        <input #input class=\"mat-radio-input cdk-visually-hidden\" type=\"radio\"\r\n               [id]=\"inputId\"\r\n               [checked]=\"checked\"\r\n               [disabled]=\"disabled\"\r\n               [tabIndex]=\"tabIndex\"\r\n               [attr.name]=\"name\"\r\n               [required]=\"required\"\r\n               [attr.aria-label]=\"ariaLabel\"\r\n               [attr.aria-labelledby]=\"ariaLabelledby\"\r\n               [attr.aria-describedby]=\"ariaDescribedby\"\r\n               (change)=\"_onInputChange($event)\"\r\n               (click)=\"_onInputClick($event)\">\r\n    </div>\r\n\r\n    <!-- The label content for radio control. -->\r\n    <div class=\"mat-radio-label-content\" [class.mat-radio-label-before]=\"labelPosition == 'before'\">\r\n        <!-- Add an invisible span so JAWS can read the label -->\r\n        <span style=\"display:none\">&nbsp;</span>\r\n        <ng-content></ng-content>\r\n    </div>\r\n</label>\r\n",
                    inputs: ['color', 'disableRipple', 'tabIndex'],
                    encapsulation: ViewEncapsulation.None,
                    exportAs: 'rteRadioButton',
                    host: {
                        'class': 'mat-radio-button',
                        '[class.mat-radio-checked]': 'checked',
                        '[class.mat-radio-disabled]': 'disabled',
                        '[class._mat-animation-noopable]': '_animationMode === "NoopAnimations"',
                        // Needs to be -1 so the `focus` event still fires.
                        '[attr.tabindex]': '-1',
                        '[attr.id]': 'id',
                        // Note: under normal conditions focus shouldn't land on this element, however it may be
                        // programmatically set, for example inside of a focus trap, in this case we want to forward
                        // the focus to the native element.
                        '(focus)': '_inputElement.nativeElement.focus()',
                    },
                    changeDetection: ChangeDetectionStrategy.OnPush,
                    styles: [".mat-radio-button{display:inline-block;-webkit-tap-highlight-color:transparent;outline:0}.mat-radio-label{-webkit-user-select:none;-moz-user-select:none;user-select:none;cursor:pointer;display:inline-flex;align-items:center;white-space:nowrap;vertical-align:middle;width:100%}.mat-radio-container{box-sizing:border-box;display:inline-block;position:relative;width:20px;height:20px;flex-shrink:0}.mat-radio-outer-circle{box-sizing:border-box;height:20px;left:0;position:absolute;top:0;transition:border-color 280ms;width:20px;border-width:2px;border-style:solid;border-radius:50%}._mat-animation-noopable .mat-radio-outer-circle{transition:none}.mat-radio-inner-circle{border-radius:50%;box-sizing:border-box;height:20px;left:0;position:absolute;top:0;transition:transform 280ms,background-color 280ms;width:20px;transform:scale(.001)}._mat-animation-noopable .mat-radio-inner-circle{transition:none}.mat-radio-checked .mat-radio-inner-circle{transform:scale(.5)}.mat-radio-label-content{-webkit-user-select:auto;-moz-user-select:auto;user-select:auto;display:inline-block;order:0;line-height:inherit;padding-left:8px;padding-right:0}[dir=rtl] .mat-radio-label-content{padding-right:8px;padding-left:0}.mat-radio-label-content.mat-radio-label-before{order:-1;padding-left:0;padding-right:8px}[dir=rtl] .mat-radio-label-content.mat-radio-label-before{padding-right:0;padding-left:8px}.mat-radio-disabled,.mat-radio-disabled .mat-radio-label{cursor:default}.mat-radio-button .mat-radio-ripple{position:absolute;left:calc(50% - 20px);top:calc(50% - 20px);height:40px;width:40px;z-index:1;pointer-events:none}.mat-radio-button .mat-radio-ripple .mat-ripple-element:not(.mat-radio-persistent-ripple){opacity:.16}.mat-radio-persistent-ripple{width:100%;height:100%;transform:none}.mat-radio-container:hover .mat-radio-persistent-ripple{opacity:.04}.mat-radio-button:not(.mat-radio-disabled).cdk-keyboard-focused .mat-radio-persistent-ripple{opacity:.12}.mat-radio-disabled .mat-radio-container:hover .mat-radio-persistent-ripple,.mat-radio-persistent-ripple{opacity:0}@media (hover:none){.mat-radio-container:hover .mat-radio-persistent-ripple{display:none}}.mat-radio-input{bottom:0;left:50%}@media (-ms-high-contrast:active){.mat-radio-checked .mat-radio-inner-circle{border:10px solid}.mat-radio-disabled{opacity:.5}}"]
                }] }
    ];
    /** @nocollapse */
    RteRadioButtonComponent.ctorParameters = function () { return [
        { type: RteRadioGroupDirective, decorators: [{ type: Optional }] },
        { type: ElementRef },
        { type: ChangeDetectorRef },
        { type: FocusMonitor },
        { type: UniqueSelectionDispatcher },
        { type: String, decorators: [{ type: Optional }, { type: Inject, args: [ANIMATION_MODULE_TYPE,] }] }
    ]; };
    return RteRadioButtonComponent;
}(MatRadioButton));

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @template D
 */
var RteDatepickerComponent = /** @class */ (function (_super) {
    __extends(RteDatepickerComponent, _super);
    function RteDatepickerComponent(_dialog, _overlay, _ngZone, _viewContainerRef, scrollStrategy, _dateAdapter, _dir, _document) {
        return _super.call(this, _dialog, _overlay, _ngZone, _viewContainerRef, scrollStrategy, _dateAdapter, _dir, _document) || this;
    }
    RteDatepickerComponent.decorators = [
        { type: Component, args: [{
                    selector: 'rte-datepicker',
                    template: '',
                    exportAs: 'rteDatepicker',
                    changeDetection: ChangeDetectionStrategy.OnPush,
                    encapsulation: ViewEncapsulation.None
                }] }
    ];
    /** @nocollapse */
    RteDatepickerComponent.ctorParameters = function () { return [
        { type: MatDialog },
        { type: Overlay },
        { type: NgZone },
        { type: ViewContainerRef },
        { type: undefined, decorators: [{ type: Inject, args: [MAT_DATEPICKER_SCROLL_STRATEGY,] }] },
        { type: DateAdapter, decorators: [{ type: Optional }] },
        { type: Directionality, decorators: [{ type: Optional }] },
        { type: undefined, decorators: [{ type: Optional }, { type: Inject, args: [DOCUMENT,] }] }
    ]; };
    return RteDatepickerComponent;
}(MatDatepicker));

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @template D
 */
var RteDatepickerToggle = /** @class */ (function (_super) {
    __extends(RteDatepickerToggle, _super);
    function RteDatepickerToggle(_intl, _changeDetectorRef, defaultTabIndex) {
        return _super.call(this, _intl, _changeDetectorRef, defaultTabIndex) || this;
    }
    RteDatepickerToggle.decorators = [
        { type: Component, args: [{
                    selector: 'rte-datepicker-toggle',
                    template: "<button #button\r\n        mat-icon-button\r\n        type=\"button\"\r\n        aria-haspopup=\"true\"\r\n        [attr.aria-label]=\"_intl.openCalendarLabel\"\r\n        [attr.tabindex]=\"disabled ? -1 : tabIndex\"\r\n        [disabled]=\"disabled\"\r\n        (click)=\"_open($event)\">\r\n\r\n    <svg *ngIf=\"!_customIcon\"\r\n         class=\"mat-datepicker-toggle-default-icon\"\r\n         viewBox=\"0 0 24 24\"\r\n         width=\"24px\"\r\n         height=\"24px\"\r\n         fill=\"currentColor\"\r\n         focusable=\"false\">\r\n        <path d=\"M19 3h-1V1h-2v2H8V1H6v2H5c-1.11 0-1.99.9-1.99 2L3 19c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5V8h14v11zM7 10h5v5H7z\" />\r\n    </svg>\r\n\r\n    <ng-content select=\"[matDatepickerToggleIcon]\"></ng-content>\r\n</button>\r\n",
                    host: {
                        'class': 'mat-datepicker-toggle',
                        // Always set the tabindex to -1 so that it doesn't overlap with any custom tabindex the
                        // consumer may have provided, while still being able to receive focus.
                        '[attr.tabindex]': '-1',
                        '[class.mat-datepicker-toggle-active]': 'datepicker && datepicker.opened',
                        '[class.mat-accent]': 'datepicker && datepicker.color === "accent"',
                        '[class.mat-warn]': 'datepicker && datepicker.color === "warn"',
                        '(focus)': '_button.focus()',
                    },
                    exportAs: 'rteDatepickerToggle',
                    encapsulation: ViewEncapsulation.None,
                    changeDetection: ChangeDetectionStrategy.OnPush,
                    styles: [".mat-form-field-appearance-legacy .mat-form-field-prefix .mat-datepicker-toggle-default-icon,.mat-form-field-appearance-legacy .mat-form-field-suffix .mat-datepicker-toggle-default-icon{width:1em}.mat-form-field:not(.mat-form-field-appearance-legacy) .mat-form-field-prefix .mat-datepicker-toggle-default-icon,.mat-form-field:not(.mat-form-field-appearance-legacy) .mat-form-field-suffix .mat-datepicker-toggle-default-icon{display:block;width:1.5em;height:1.5em}.mat-form-field:not(.mat-form-field-appearance-legacy) .mat-form-field-prefix .mat-icon-button .mat-datepicker-toggle-default-icon,.mat-form-field:not(.mat-form-field-appearance-legacy) .mat-form-field-suffix .mat-icon-button .mat-datepicker-toggle-default-icon{margin:auto}"]
                }] }
    ];
    /** @nocollapse */
    RteDatepickerToggle.ctorParameters = function () { return [
        { type: MatDatepickerIntl },
        { type: ChangeDetectorRef },
        { type: String, decorators: [{ type: Attribute, args: ['tabindex',] }] }
    ]; };
    return RteDatepickerToggle;
}(MatDatepickerToggle));

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
var RTE_DATEPICKER_VALUE_ACCESSOR = {
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(function () { return RteDatepickerInput; }),
    multi: true
};
/**
 * \@docs-private
 * @type {?}
 */
var RTE_DATEPICKER_VALIDATORS = {
    provide: NG_VALIDATORS,
    useExisting: forwardRef(function () { return RteDatepickerInput; }),
    multi: true
};
/**
 * @template D
 */
var RteDatepickerInput = /** @class */ (function (_super) {
    __extends(RteDatepickerInput, _super);
    function RteDatepickerInput(_elementRef, _dateAdapter, _dateFormats, _formField) {
        var _this = _super.call(this, _elementRef, _dateAdapter, _dateFormats, _formField) || this;
        _this.moment = moment_;
        _this.formField = _formField;
        _this.dateChange.subscribe(function (x) {
            if (_this.formField != null && _this.formField._errorChildren.length == 0 && _this.errorTag == null) {
                _this.errorTag = document.createElement('rte-error');
                _this.errorTag.setAttribute('class', 'mat-error');
                _this.errorTag.setAttribute('role', 'alert');
                _this.errorTag.setAttribute('style', 'position: absolute;color: red;font-size: 12px;top: 30px;');
                _this.formField._elementRef.nativeElement.insertBefore(_this.errorTag, _this.formField._elementRef.nativeElement.children[0].nextSibling);
            }
            /** @type {?} */
            var elementValue = x.target._elementRef.nativeElement.value;
            /** @type {?} */
            var dateMoment = _this.moment(elementValue, [
                'DD/MM/YYYY', 'DDMMYYYY', 'DDMM', 'MMYYYY'
            ]);
            if (_this.errorTag != null) {
                if (dateMoment.isValid() === false) {
                    _this.errorTag.innerHTML = elementValue !== '' ? 'Data inválida' : '';
                }
                else {
                    _this.errorTag.innerHTML = '';
                }
            }
        });
        return _this;
    }
    Object.defineProperty(RteDatepickerInput.prototype, "rteDatepicker", {
        get: /**
         * @return {?}
         */
        function () { return this.matDatepicker; },
        set: /**
         * @param {?} value
         * @return {?}
         */
        function (value) {
            this.matDatepicker = value;
        },
        enumerable: true,
        configurable: true
    });
    RteDatepickerInput.decorators = [
        { type: Directive, args: [{
                    selector: 'input[rteDatepicker]',
                    providers: [
                        RTE_DATEPICKER_VALUE_ACCESSOR,
                        RTE_DATEPICKER_VALIDATORS,
                        { provide: MAT_INPUT_VALUE_ACCESSOR, useExisting: RteDatepickerInput }
                    ],
                    host: {
                        '[attr.aria-haspopup]': 'true',
                        '[attr.aria-owns]': '(_datepicker?.opened && _datepicker.id) || null',
                        '[attr.min]': 'min ? _dateAdapter.toIso8601(min) : null',
                        '[attr.max]': 'max ? _dateAdapter.toIso8601(max) : null',
                        '[attr.disable-uppercase]': 'true',
                        '[disabled]': 'disabled',
                        '(input)': '_onInput($event.target.value)',
                        '(change)': '_onChange()',
                        '(blur)': '_onBlur()',
                        '(keydown)': '_onKeydown($event)'
                    },
                    exportAs: 'rteDatepicker',
                },] }
    ];
    /** @nocollapse */
    RteDatepickerInput.ctorParameters = function () { return [
        { type: ElementRef },
        { type: DateAdapter, decorators: [{ type: Optional }] },
        { type: undefined, decorators: [{ type: Optional }, { type: Inject, args: [MAT_DATE_FORMATS,] }] },
        { type: RteFormFieldComponent, decorators: [{ type: Optional }] }
    ]; };
    RteDatepickerInput.propDecorators = {
        rteDatepicker: [{ type: Input, args: ['rteDatepicker',] }]
    };
    return RteDatepickerInput;
}(MatDatepickerInput));

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var RteDialogActionsDirective = /** @class */ (function (_super) {
    __extends(RteDialogActionsDirective, _super);
    function RteDialogActionsDirective() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    RteDialogActionsDirective.decorators = [
        { type: Directive, args: [{
                    selector: "[rte-dialog-actions], rte-dialog-actions, [rteDialogActions]",
                    host: { 'class': 'mat-dialog-actions' }
                },] }
    ];
    return RteDialogActionsDirective;
}(MatDialogActions));

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var TabService = /** @class */ (function () {
    function TabService() {
    }
    /**
     * @param {?} tabComponent
     * @return {?}
     */
    TabService.prototype.setTabComponent = /**
     * @param {?} tabComponent
     * @return {?}
     */
    function (tabComponent) {
        this.tabComponent = tabComponent;
    };
    /**
     * @param {?} ptitle
     * @param {?} plink
     * @param {?} fromSearch
     * @param {?=} breadcrumb
     * @param {?=} parameters
     * @return {?}
     */
    TabService.prototype.openTab = /**
     * @param {?} ptitle
     * @param {?} plink
     * @param {?} fromSearch
     * @param {?=} breadcrumb
     * @param {?=} parameters
     * @return {?}
     */
    function (ptitle, plink, fromSearch, breadcrumb, parameters) {
        if (breadcrumb === void 0) { breadcrumb = ''; }
        if (parameters === void 0) { parameters = []; }
        this.tabComponent.openTab(ptitle, plink, fromSearch, breadcrumb, parameters);
    };
    /**
     * @return {?}
     */
    TabService.prototype.removeCurrentTab = /**
     * @return {?}
     */
    function () {
        this.tabComponent.removeCurrentTab();
    };
    /**
     * @param {?} index
     * @return {?}
     */
    TabService.prototype.removeTab = /**
     * @param {?} index
     * @return {?}
     */
    function (index) {
        this.tabComponent.removeTab(index);
    };
    /**
     * @param {?} fromSideBar
     * @return {?}
     */
    TabService.prototype.transformTabs = /**
     * @param {?} fromSideBar
     * @return {?}
     */
    function (fromSideBar) {
        this.tabComponent.transformTabs(fromSideBar);
    };
    /**
     * @return {?}
     */
    TabService.prototype.getCurrentIndex = /**
     * @return {?}
     */
    function () {
        if (this.tabComponent) {
            return this.tabComponent.currentIndexTab;
        }
        return null;
    };
    TabService.decorators = [
        { type: Injectable, args: [{
                    providedIn: 'root'
                },] }
    ];
    /** @nocollapse */
    TabService.ctorParameters = function () { return []; };
    /** @nocollapse */ TabService.ngInjectableDef = defineInjectable({ factory: function TabService_Factory() { return new TabService(); }, token: TabService, providedIn: "root" });
    return TabService;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var RteDialogContainer = /** @class */ (function (_super) {
    __extends(RteDialogContainer, _super);
    function RteDialogContainer(_rteElementRef, _focusTrapFactory, _changeDetectorRef, _document, _config, appService, tabService) {
        var _this = _super.call(this, _rteElementRef, _focusTrapFactory, _changeDetectorRef, _document, _config) || this;
        _this._rteElementRef = _rteElementRef;
        _this.appService = appService;
        _this.tabService = tabService;
        return _this;
    }
    /**
     * @return {?}
     */
    RteDialogContainer.prototype.ngAfterViewInit = /**
     * @return {?}
     */
    function () {
    };
    /**
     * @return {?}
     */
    RteDialogContainer.prototype.getHeight = /**
     * @return {?}
     */
    function () {
        /** @type {?} */
        var height = this._rteElementRef.nativeElement.offsetHeight;
        return height.toString() + 'px';
    };
    /**
     * @return {?}
     */
    RteDialogContainer.prototype.getWidth = /**
     * @return {?}
     */
    function () {
        /** @type {?} */
        var width = this._rteElementRef.nativeElement.offsetWidth;
        return width.toString() + 'px';
    };
    /**
     * @return {?}
     */
    RteDialogContainer.prototype.showLoadSpinner = /**
     * @return {?}
     */
    function () {
        var _this = this;
        /** @type {?} */
        var isLoading = false;
        this.appService.requestingAPI.forEach(function (value) {
            if (value === _this.tabService.getCurrentIndex()) {
                isLoading = true;
            }
        });
        return isLoading;
    };
    RteDialogContainer.decorators = [
        { type: Component, args: [{
                    selector: 'rte-dialog-container',
                    template: "<rte-spinner #rtespinner \r\n        [class]=\"'rte-dialog'\"\r\n        [style.height]=\"getHeight()\"\r\n        [style.width]=\"getWidth()\"\r\n        [hidden]=\"showLoadSpinner() == false\" ></rte-spinner>\r\n<ng-template cdkPortalOutlet></ng-template>\r\n",
                    encapsulation: ViewEncapsulation.None,
                    changeDetection: ChangeDetectionStrategy.Default,
                    animations: [matDialogAnimations.dialogContainer],
                    host: {
                        'class': 'mat-dialog-container',
                        'tabindex': '-1',
                        'aria-modal': 'true',
                        '[attr.id]': '_id',
                        '[attr.role]': '_config.role',
                        '[attr.aria-labelledby]': '_config.ariaLabel ? null : _ariaLabelledBy',
                        '[attr.aria-label]': '_config.ariaLabel',
                        '[attr.aria-describedby]': '_config.ariaDescribedBy || null',
                        '[@dialogContainer]': '_state',
                        '(@dialogContainer.start)': '_onAnimationStart($event)',
                        '(@dialogContainer.done)': '_onAnimationDone($event)',
                    },
                    styles: [".mat-dialog-container{display:block;padding:24px;border-radius:4px;box-sizing:border-box;overflow:auto;outline:0;height:100%;width:100%;max-height:inherit}@media (-ms-high-contrast:active){.mat-dialog-container{outline:solid 1px}}.mat-dialog-content{display:block;margin:0 -24px;padding:0 24px;max-height:65vh;overflow:auto;-webkit-overflow-scrolling:touch}.mat-dialog-title{margin:0 0 20px;display:block}.mat-dialog-actions{padding:8px 0;display:flex;flex-wrap:wrap;min-height:52px;align-items:center}.mat-dialog-actions[align=end]{justify-content:flex-end}.mat-dialog-actions[align=center]{justify-content:center}.mat-dialog-actions .mat-button+.mat-button,.mat-dialog-actions .mat-button+.mat-raised-button,.mat-dialog-actions .mat-raised-button+.mat-button,.mat-dialog-actions .mat-raised-button+.mat-raised-button{margin-left:8px}[dir=rtl] .mat-dialog-actions .mat-button+.mat-button,[dir=rtl] .mat-dialog-actions .mat-button+.mat-raised-button,[dir=rtl] .mat-dialog-actions .mat-raised-button+.mat-button,[dir=rtl] .mat-dialog-actions .mat-raised-button+.mat-raised-button{margin-left:0;margin-right:8px}"]
                }] }
    ];
    /** @nocollapse */
    RteDialogContainer.ctorParameters = function () { return [
        { type: ElementRef },
        { type: FocusTrapFactory },
        { type: ChangeDetectorRef },
        { type: undefined, decorators: [{ type: Optional }, { type: Inject, args: [DOCUMENT,] }] },
        { type: MatDialogConfig },
        { type: undefined, decorators: [{ type: Inject, args: [RTE_APP_SERVICE_DATA,] }] },
        { type: TabService }
    ]; };
    RteDialogContainer.propDecorators = {
        portalOutlet: [{ type: ViewChild, args: [CdkPortalOutlet,] }],
        rte_spinner: [{ type: ViewChild, args: ['rtespinner',] }]
    };
    return RteDialogContainer;
}(MatDialogContainer));

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var RteDialog = /** @class */ (function (_super) {
    __extends(RteDialog, _super);
    function RteDialog(_overlay, _injector, _location, _defaultOptions, scrollStrategy, parentDialog, _overlayContainer) {
        var _this = _super.call(this, _overlay, _injector, _location, _defaultOptions, scrollStrategy, parentDialog, _overlayContainer) || this;
        _this.ariaHiddenElements = new Map();
        _this.oldOpen = _super.prototype.open;
        _super.prototype.open = _this.customOpen;
        _this.options = _defaultOptions;
        _this.overlay = _overlay;
        _this.scrollStrategy = scrollStrategy;
        _this.injector = _injector;
        _this.location = _location;
        _this.overlayContainer = _overlayContainer;
        return _this;
    }
    /**
     * @private
     * @param {?} dialogConfig
     * @return {?}
     */
    RteDialog.prototype.getOverlayConfig = /**
     * @private
     * @param {?} dialogConfig
     * @return {?}
     */
    function (dialogConfig) {
        /** @type {?} */
        var state$$1 = new OverlayConfig({
            positionStrategy: this.overlay.position().global(),
            scrollStrategy: dialogConfig.scrollStrategy || this.scrollStrategy(),
            panelClass: dialogConfig.panelClass,
            hasBackdrop: dialogConfig.hasBackdrop,
            direction: dialogConfig.direction,
            minWidth: dialogConfig.minWidth,
            minHeight: dialogConfig.minHeight,
            maxWidth: dialogConfig.maxWidth,
            maxHeight: dialogConfig.maxHeight,
            disposeOnNavigation: dialogConfig.closeOnNavigation
        });
        if (dialogConfig.backdropClass) {
            state$$1.backdropClass = dialogConfig.backdropClass;
        }
        return state$$1;
    };
    /**
     * @private
     * @param {?} config
     * @return {?}
     */
    RteDialog.prototype.createOverlay = /**
     * @private
     * @param {?} config
     * @return {?}
     */
    function (config) {
        /** @type {?} */
        var overlayConfig = this.getOverlayConfig(config);
        return this.overlay.create(overlayConfig);
    };
    /**
     * @private
     * @param {?} overlay
     * @param {?} config
     * @return {?}
     */
    RteDialog.prototype.attachDialogContainer = /**
     * @private
     * @param {?} overlay
     * @param {?} config
     * @return {?}
     */
    function (overlay, config) {
        /** @type {?} */
        var userInjector = config && config.viewContainerRef && config.viewContainerRef.injector;
        /** @type {?} */
        var injector = new PortalInjector(userInjector || this.injector, new WeakMap([
            [MatDialogConfig, config]
        ]));
        /** @type {?} */
        var containerPortal = new ComponentPortal(RteDialogContainer, config.viewContainerRef, injector);
        /** @type {?} */
        var containerRef = overlay.attach(containerPortal);
        return containerRef.instance;
    };
    /**
     * @private
     * @template T
     * @param {?} config
     * @param {?} dialogRef
     * @param {?} dialogContainer
     * @return {?}
     */
    RteDialog.prototype.createInjector = /**
     * @private
     * @template T
     * @param {?} config
     * @param {?} dialogRef
     * @param {?} dialogContainer
     * @return {?}
     */
    function (config, dialogRef, dialogContainer) {
        /** @type {?} */
        var userInjector = config && config.viewContainerRef && config.viewContainerRef.injector;
        // The MatDialogContainer is injected in the portal as the MatDialogContainer and the dialog's
        // content are created out of the same ViewContainerRef and as such, are siblings for injector
        // purposes. To allow the hierarchy that is expected, the MatDialogContainer is explicitly
        // added to the injection tokens.
        /** @type {?} */
        var injectionTokens = new WeakMap([
            [MatDialogContainer, dialogContainer],
            [MAT_DIALOG_DATA, config.data],
            [RteDialogRef, dialogRef]
        ]);
        if (config.direction &&
            (!userInjector || !userInjector.get(Directionality, null))) {
            injectionTokens.set(Directionality, {
                value: config.direction,
                change: of()
            });
        }
        return new PortalInjector(userInjector || this.injector, injectionTokens);
    };
    /**
     * @private
     * @template T, R
     * @param {?} componentOrTemplateRef
     * @param {?} dialogContainer
     * @param {?} overlayRef
     * @param {?} config
     * @return {?}
     */
    RteDialog.prototype.attachDialogContent = /**
     * @private
     * @template T, R
     * @param {?} componentOrTemplateRef
     * @param {?} dialogContainer
     * @param {?} overlayRef
     * @param {?} config
     * @return {?}
     */
    function (componentOrTemplateRef, dialogContainer, overlayRef, config) {
        // Create a reference to the dialog we're creating in order to give the user a handle
        // to modify and close it.
        /** @type {?} */
        var dialogRef = new RteDialogRef(overlayRef, dialogContainer, this.location, config.id);
        // When the dialog backdrop is clicked, we want to close it.
        if (config.hasBackdrop) {
            overlayRef.backdropClick().subscribe(function () {
                if (!dialogRef.disableClose) {
                    dialogRef.close();
                }
            });
        }
        if (componentOrTemplateRef instanceof TemplateRef) {
            dialogContainer.attachTemplatePortal(new TemplatePortal(componentOrTemplateRef, (/** @type {?} */ (null)), (/** @type {?} */ ({ $implicit: config.data, dialogRef: dialogRef }))));
        }
        else {
            /** @type {?} */
            var injector = this.createInjector(config, dialogRef, dialogContainer);
            /** @type {?} */
            var contentRef = dialogContainer.attachComponentPortal(new ComponentPortal(componentOrTemplateRef, undefined, injector));
            dialogRef.componentInstance = contentRef.instance;
        }
        dialogRef
            .updateSize(config.width, config.height)
            .updatePosition(config.position);
        return dialogRef;
    };
    /**
     * @private
     * @return {?}
     */
    RteDialog.prototype.hideNonDialogContentFromAssistiveTechnology = /**
     * @private
     * @return {?}
     */
    function () {
        /** @type {?} */
        var overlayContainer = this.overlayContainer.getContainerElement();
        // Ensure that the overlay container is attached to the DOM.
        if (overlayContainer.parentElement) {
            /** @type {?} */
            var siblings = overlayContainer.parentElement.children;
            for (var i = siblings.length - 1; i > -1; i--) {
                /** @type {?} */
                var sibling = siblings[i];
                if (sibling !== overlayContainer &&
                    sibling.nodeName !== 'SCRIPT' &&
                    sibling.nodeName !== 'STYLE' &&
                    !sibling.hasAttribute('aria-live')) {
                    this.ariaHiddenElements.set(sibling, sibling.getAttribute('aria-hidden'));
                    sibling.setAttribute('aria-hidden', 'true');
                }
            }
        }
    };
    /**
     * @private
     * @param {?} dialogRef
     * @return {?}
     */
    RteDialog.prototype.removeOpenDialog = /**
     * @private
     * @param {?} dialogRef
     * @return {?}
     */
    function (dialogRef) {
        /** @type {?} */
        var index = this.openDialogs.indexOf(dialogRef);
        if (index > -1) {
            this.openDialogs.splice(index, 1);
            // If all the dialogs were closed, remove/restore the `aria-hidden`
            // to a the siblings and emit to the `afterAllClosed` stream.
            if (!this.openDialogs.length) {
                this.ariaHiddenElements.forEach(function (previousValue, element) {
                    if (previousValue) {
                        element.setAttribute('aria-hidden', previousValue);
                    }
                    else {
                        element.removeAttribute('aria-hidden');
                    }
                });
                this.ariaHiddenElements.clear();
                this._afterAllClosed.next();
            }
        }
    };
    /**
     * @template T, D, R
     * @param {?} componentOrTemplateRef
     * @param {?=} config
     * @return {?}
     */
    RteDialog.prototype.customOpen = /**
     * @template T, D, R
     * @param {?} componentOrTemplateRef
     * @param {?=} config
     * @return {?}
     */
    function (componentOrTemplateRef, config) {
        var _this = this;
        config = applyConfigDefaults(config, this.options || new MatDialogConfig());
        if (config.id && this.getDialogById(config.id)) {
            throw Error("Dialog with id \"" + config.id + "\" exists already. The dialog id must be unique.");
        }
        /** @type {?} */
        var overlayRef = this.createOverlay(config);
        /** @type {?} */
        var dialogContainer = this.attachDialogContainer(overlayRef, config);
        /** @type {?} */
        var dialogRef = this.attachDialogContent(componentOrTemplateRef, dialogContainer, overlayRef, config);
        // If this is the first dialog that we're opening, hide all the non-overlay content.
        if (!this.openDialogs.length) {
            this.hideNonDialogContentFromAssistiveTechnology();
        }
        this.openDialogs.push(dialogRef);
        dialogRef.afterClosed().subscribe(function () { return _this.removeOpenDialog(dialogRef); });
        this.afterOpened.next(dialogRef);
        return dialogRef;
    };
    RteDialog.decorators = [
        { type: Injectable }
    ];
    /** @nocollapse */
    RteDialog.ctorParameters = function () { return [
        { type: Overlay },
        { type: Injector },
        { type: Location, decorators: [{ type: Optional }] },
        { type: MatDialogConfig, decorators: [{ type: Optional }, { type: Inject, args: [MAT_DIALOG_DEFAULT_OPTIONS,] }] },
        { type: undefined, decorators: [{ type: Inject, args: [MAT_DIALOG_SCROLL_STRATEGY,] }] },
        { type: RteDialog, decorators: [{ type: Optional }, { type: SkipSelf }] },
        { type: OverlayContainer }
    ]; };
    return RteDialog;
}(MatDialog));
/**
 * @param {?=} config
 * @param {?=} defaultOptions
 * @return {?}
 */
function applyConfigDefaults(config, defaultOptions) {
    return __assign({}, defaultOptions, config);
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var RteDialogCloseDirective = /** @class */ (function (_super) {
    __extends(RteDialogCloseDirective, _super);
    function RteDialogCloseDirective(dialogRef, _elementRef, _dialog) {
        return _super.call(this, dialogRef, _elementRef, _dialog) || this;
    }
    RteDialogCloseDirective.decorators = [
        { type: Directive, args: [{
                    selector: "button[rte-dialog-close], button[rteDialogClose]",
                    exportAs: 'rteDialogClose',
                    host: {
                        '(click)': 'dialogRef.close(dialogResult)',
                        '[attr.aria-label]': 'ariaLabel || null',
                        'type': 'button',
                    }
                },] }
    ];
    /** @nocollapse */
    RteDialogCloseDirective.ctorParameters = function () { return [
        { type: MatDialogRef, decorators: [{ type: Optional }] },
        { type: ElementRef },
        { type: RteDialog }
    ]; };
    return RteDialogCloseDirective;
}(MatDialogClose));

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var RteDialogContentDirective = /** @class */ (function (_super) {
    __extends(RteDialogContentDirective, _super);
    function RteDialogContentDirective() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    RteDialogContentDirective.decorators = [
        { type: Directive, args: [{
                    selector: "[rte-dialog-content], rte-dialog-content, [rteDialogContent]",
                    host: { 'class': 'mat-dialog-content' }
                },] }
    ];
    return RteDialogContentDirective;
}(MatDialogContent));

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var RteDialogTitleDirective = /** @class */ (function (_super) {
    __extends(RteDialogTitleDirective, _super);
    function RteDialogTitleDirective(_dialogRef, _elementRef, _dialog) {
        return _super.call(this, _dialogRef, _elementRef, _dialog) || this;
    }
    RteDialogTitleDirective.decorators = [
        { type: Directive, args: [{
                    selector: '[rte-dialog-title], [rteDialogTitle]',
                    exportAs: 'rteDialogTitle',
                    host: {
                        'class': 'mat-dialog-title',
                        '[id]': 'id',
                    },
                },] }
    ];
    /** @nocollapse */
    RteDialogTitleDirective.ctorParameters = function () { return [
        { type: MatDialogRef, decorators: [{ type: Optional }] },
        { type: ElementRef },
        { type: RteDialog }
    ]; };
    return RteDialogTitleDirective;
}(MatDialogTitle));

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var RtePaginatorComponent = /** @class */ (function (_super) {
    __extends(RtePaginatorComponent, _super);
    function RtePaginatorComponent(_intl, _changeDetectorRef) {
        return _super.call(this, _intl, _changeDetectorRef) || this;
    }
    RtePaginatorComponent.decorators = [
        { type: Component, args: [{
                    selector: 'rte-paginator',
                    exportAs: 'rtePaginator',
                    template: "<div class=\"mat-paginator-outer-container\">\r\n    <div class=\"mat-paginator-container\">\r\n        <div class=\"mat-paginator-page-size\" *ngIf=\"!hidePageSize\">\r\n            <div class=\"mat-paginator-page-size-label\">\r\n                {{_intl.itemsPerPageLabel}}\r\n            </div>\r\n\r\n            <mat-form-field *ngIf=\"_displayedPageSizeOptions.length > 1\"\r\n                            [color]=\"color\"\r\n                            class=\"mat-paginator-page-size-select\">\r\n                <rte-select [value]=\"pageSize\"\r\n                            [disabled]=\"disabled\"\r\n                            [aria-label]=\"_intl.itemsPerPageLabel\"\r\n                            (selectionChange)=\"_changePageSize($event.value)\">\r\n                    <rte-option *ngFor=\"let pageSizeOption of _displayedPageSizeOptions\" [value]=\"pageSizeOption\">\r\n                        {{pageSizeOption}}\r\n                    </rte-option>\r\n                </rte-select>\r\n            </mat-form-field>\r\n\r\n            <div *ngIf=\"_displayedPageSizeOptions.length <= 1\">{{pageSize}}</div>\r\n        </div>\r\n\r\n        <div class=\"mat-paginator-range-actions\">\r\n            <div class=\"mat-paginator-range-label\">\r\n                {{_intl.getRangeLabel(pageIndex, pageSize, length)}}\r\n            </div>\r\n\r\n            <button rtebutton-icon type=\"button\"\r\n                    class=\"mat-paginator-navigation-first\"\r\n                    (click)=\"firstPage()\"\r\n                    [attr.aria-label]=\"_intl.firstPageLabel\"\r\n                    [rteTooltip]=\"_intl.firstPageLabel\"\r\n                    [matTooltipDisabled]=\"_previousButtonsDisabled()\"\r\n                    [matTooltipPosition]=\"'above'\"\r\n                    [disabled]=\"_previousButtonsDisabled()\"\r\n                    *ngIf=\"showFirstLastButtons\">\r\n                <svg class=\"mat-paginator-icon\" viewBox=\"0 0 24 24\" focusable=\"false\">\r\n                    <path d=\"M18.41 16.59L13.82 12l4.59-4.59L17 6l-6 6 6 6zM6 6h2v12H6z\" />\r\n                </svg>\r\n            </button>\r\n            <button rtebutton-icon type=\"button\"\r\n                    class=\"mat-paginator-navigation-previous\"\r\n                    (click)=\"previousPage()\"\r\n                    [attr.aria-label]=\"_intl.previousPageLabel\"\r\n                    [matTooltip]=\"_intl.previousPageLabel\"\r\n                    [matTooltipDisabled]=\"_previousButtonsDisabled()\"\r\n                    [matTooltipPosition]=\"'above'\"\r\n                    [disabled]=\"_previousButtonsDisabled()\">\r\n                <svg class=\"mat-paginator-icon\" viewBox=\"0 0 24 24\" focusable=\"false\">\r\n                    <path d=\"M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12z\" />\r\n                </svg>\r\n            </button>\r\n            <button rtebutton-icon type=\"button\"\r\n                    class=\"mat-paginator-navigation-next\"\r\n                    (click)=\"nextPage()\"\r\n                    [attr.aria-label]=\"_intl.nextPageLabel\"\r\n                    [matTooltip]=\"_intl.nextPageLabel\"\r\n                    [matTooltipDisabled]=\"_nextButtonsDisabled()\"\r\n                    [matTooltipPosition]=\"'above'\"\r\n                    [disabled]=\"_nextButtonsDisabled()\">\r\n                <svg class=\"mat-paginator-icon\" viewBox=\"0 0 24 24\" focusable=\"false\">\r\n                    <path d=\"M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z\" />\r\n                </svg>\r\n            </button>\r\n            <button rtebutton-icon type=\"button\"\r\n                    class=\"mat-paginator-navigation-last\"\r\n                    (click)=\"lastPage()\"\r\n                    [attr.aria-label]=\"_intl.lastPageLabel\"\r\n                    [matTooltip]=\"_intl.lastPageLabel\"\r\n                    [matTooltipDisabled]=\"_nextButtonsDisabled()\"\r\n                    [matTooltipPosition]=\"'above'\"\r\n                    [disabled]=\"_nextButtonsDisabled()\"\r\n                    *ngIf=\"showFirstLastButtons\">\r\n                <svg class=\"mat-paginator-icon\" viewBox=\"0 0 24 24\" focusable=\"false\">\r\n                    <path d=\"M5.59 7.41L10.18 12l-4.59 4.59L7 18l6-6-6-6zM16 6h2v12h-2z\" />\r\n                </svg>\r\n            </button>\r\n        </div>\r\n    </div>\r\n</div>\r\n",
                    inputs: ['disabled'],
                    host: {
                        'class': 'mat-paginator',
                    },
                    changeDetection: ChangeDetectionStrategy.OnPush,
                    encapsulation: ViewEncapsulation.None,
                    styles: [".mat-paginator{display:block}.mat-paginator-outer-container{display:flex}.mat-paginator-container{display:flex;align-items:center;justify-content:flex-end;min-height:56px;padding:0 8px;flex-wrap:wrap-reverse;width:100%}.mat-paginator-page-size{display:flex;align-items:baseline;margin-right:8px}[dir=rtl] .mat-paginator-page-size{margin-right:0;margin-left:8px}.mat-paginator-page-size-label{margin:0 4px}.mat-paginator-page-size-select{margin:6px 4px 0;width:56px}.mat-paginator-page-size-select.mat-form-field-appearance-fill,.mat-paginator-page-size-select.mat-form-field-appearance-outline{width:64px}.mat-paginator-range-label{margin:0 32px 0 24px}.mat-paginator-range-actions{display:flex;align-items:center}.mat-paginator-icon{width:28px;fill:currentColor}[dir=rtl] .mat-paginator-icon{transform:rotate(180deg)}"]
                }] }
    ];
    /** @nocollapse */
    RtePaginatorComponent.ctorParameters = function () { return [
        { type: MatPaginatorIntl },
        { type: ChangeDetectorRef }
    ]; };
    return RtePaginatorComponent;
}(MatPaginator));

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var RteBadgeDirective = /** @class */ (function (_super) {
    __extends(RteBadgeDirective, _super);
    function RteBadgeDirective(_ngZone, _elementRef, _ariaDescriber, _renderer) {
        var _this = _super.call(this, null, _ngZone, _elementRef, _ariaDescriber, _renderer) || this;
        _this._rteBadgeColor = 'primary';
        _this._rteBadgeOverlap = true;
        _this._rteBadgePosition = 'above after';
        _this._rteBadgeSize = 'medium';
        return _this;
    }
    Object.defineProperty(RteBadgeDirective.prototype, "rteBadge", {
        get: /**
         * @return {?}
         */
        function () { return this._rteBadge; },
        set: /**
         * @param {?} val
         * @return {?}
         */
        function (val) {
            this._rteBadge = val;
            this.content = val;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(RteBadgeDirective.prototype, "rteBadgecolor", {
        get: /**
         * @return {?}
         */
        function () { return this._rteBadgeColor; },
        set: /**
         * @param {?} value
         * @return {?}
         */
        function (value) {
            this.color = value;
            this._rteBadgeColor = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(RteBadgeDirective.prototype, "rteBadgeOverlap", {
        get: /**
         * @return {?}
         */
        function () { return this._rteBadgeOverlap; },
        set: /**
         * @param {?} val
         * @return {?}
         */
        function (val) {
            this._rteBadgeOverlap = val;
            this.overlap = val;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(RteBadgeDirective.prototype, "rteBadgePosition", {
        get: /**
         * @return {?}
         */
        function () { return this._rteBadgePosition; },
        set: /**
         * @param {?} val
         * @return {?}
         */
        function (val) {
            this._rteBadgePosition = val;
            this.position = val;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(RteBadgeDirective.prototype, "rteBadgeDescription", {
        get: /**
         * @return {?}
         */
        function () { return this._rteBadgeDescription; },
        set: /**
         * @param {?} newDescription
         * @return {?}
         */
        function (newDescription) {
            if (newDescription !== this._rteBadgeDescription) {
                this._rteBadgeDescription = newDescription;
                this.description = newDescription;
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(RteBadgeDirective.prototype, "rteBadgeSize", {
        get: /**
         * @return {?}
         */
        function () { return this._rteBadgeSize; },
        set: /**
         * @param {?} val
         * @return {?}
         */
        function (val) {
            this._rteBadgeSize = val;
            this.size = val;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(RteBadgeDirective.prototype, "rteBadgeHidden", {
        get: /**
         * @return {?}
         */
        function () { return this._rteBadgeHidden; },
        set: /**
         * @param {?} val
         * @return {?}
         */
        function (val) {
            this._rteBadgeHidden = val;
            this.hidden = val;
        },
        enumerable: true,
        configurable: true
    });
    RteBadgeDirective.decorators = [
        { type: Directive, args: [{
                    selector: '[rteBadge]',
                    exportAs: 'rteBadge',
                    inputs: ['disabled: rteBadgeDisabled'],
                    host: {
                        'class': 'mat-badge',
                        '[class.mat-badge-overlap]': 'overlap',
                        '[class.mat-badge-above]': 'isAbove()',
                        '[class.mat-badge-below]': '!isAbove()',
                        '[class.mat-badge-before]': '!isAfter()',
                        '[class.mat-badge-after]': 'isAfter()',
                        '[class.mat-badge-small]': 'size === "small"',
                        '[class.mat-badge-medium]': 'size === "medium"',
                        '[class.mat-badge-large]': 'size === "large"',
                        '[class.mat-badge-hidden]': 'hidden || !_hasContent',
                        '[class.mat-badge-disabled]': 'disabled',
                    },
                },] }
    ];
    /** @nocollapse */
    RteBadgeDirective.ctorParameters = function () { return [
        { type: NgZone },
        { type: ElementRef },
        { type: AriaDescriber },
        { type: Renderer2 }
    ]; };
    RteBadgeDirective.propDecorators = {
        rteBadge: [{ type: Input, args: ['rteBadge',] }],
        rteBadgecolor: [{ type: Input, args: ['rteBadgeColor',] }],
        rteBadgeOverlap: [{ type: Input, args: ['rteBadgeOverlap',] }],
        rteBadgePosition: [{ type: Input, args: ['rteBadgePosition',] }],
        rteBadgeDescription: [{ type: Input, args: ['rteBadgeDescription',] }],
        rteBadgeSize: [{ type: Input, args: ['rteBadgeSize',] }],
        rteBadgeHidden: [{ type: Input, args: ['rteBadgeHidden',] }]
    };
    return RteBadgeDirective;
}(MatBadge));

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var RteProgressBarComponent = /** @class */ (function (_super) {
    __extends(RteProgressBarComponent, _super);
    function RteProgressBarComponent(_elementRef, _ngZone, _animationMode, location) {
        return _super.call(this, _elementRef, _ngZone, _animationMode, location) || this;
    }
    RteProgressBarComponent.decorators = [
        { type: Component, args: [{
                    selector: 'rte-progress-bar',
                    exportAs: 'rteProgressBar',
                    host: {
                        'role': 'progressbar',
                        'aria-valuemin': '0',
                        'aria-valuemax': '100',
                        '[attr.aria-valuenow]': '(mode === "indeterminate" || mode === "query") ? null : value',
                        '[attr.mode]': 'mode',
                        'class': 'mat-progress-bar',
                        '[class._mat-animation-noopable]': '_isNoopAnimation',
                    },
                    inputs: ['color'],
                    template: "<svg width=\"100%\" height=\"4\" focusable=\"false\" class=\"mat-progress-bar-background mat-progress-bar-element\">\r\n    <defs>\r\n      <pattern [id]=\"progressbarId\" x=\"4\" y=\"0\" width=\"8\" height=\"4\" patternUnits=\"userSpaceOnUse\">\r\n        <circle cx=\"2\" cy=\"2\" r=\"2\"/>\r\n      </pattern>\r\n    </defs>\r\n    <rect [attr.fill]=\"_rectangleFillValue\" width=\"100%\" height=\"100%\"/>\r\n  </svg>\r\n  <div class=\"mat-progress-bar-buffer mat-progress-bar-element\" [ngStyle]=\"_bufferTransform()\"></div>\r\n  <div class=\"mat-progress-bar-primary mat-progress-bar-fill mat-progress-bar-element\" [ngStyle]=\"_primaryTransform()\" #primaryValueBar></div>\r\n  <div class=\"mat-progress-bar-secondary mat-progress-bar-fill mat-progress-bar-element\"></div>\r\n  ",
                    changeDetection: ChangeDetectionStrategy.OnPush,
                    encapsulation: ViewEncapsulation.None,
                    styles: [".mat-progress-bar{display:block;height:4px;overflow:hidden;position:relative;transition:opacity 250ms linear;width:100%}.mat-progress-bar .mat-progress-bar-element,.mat-progress-bar .mat-progress-bar-fill::after{height:100%;position:absolute;width:100%}.mat-progress-bar .mat-progress-bar-background{width:calc(100% + 10px)}.mat-progress-bar .mat-progress-bar-buffer{transform-origin:top left;transition:transform 250ms}.mat-progress-bar .mat-progress-bar-secondary{display:none}.mat-progress-bar .mat-progress-bar-fill{animation:none;transform-origin:top left;transition:transform 250ms}@media (-ms-high-contrast:active){.mat-progress-bar .mat-progress-bar-background{display:none}.mat-progress-bar .mat-progress-bar-buffer{border-top:5px solid;opacity:.5}.mat-progress-bar .mat-progress-bar-fill{border-top:4px solid}}.mat-progress-bar .mat-progress-bar-fill::after{animation:none;content:'';display:inline-block;left:0}.mat-progress-bar[dir=rtl],[dir=rtl] .mat-progress-bar{transform:rotateY(180deg)}.mat-progress-bar[mode=query]{transform:rotateZ(180deg)}.mat-progress-bar[mode=query][dir=rtl],[dir=rtl] .mat-progress-bar[mode=query]{transform:rotateZ(180deg) rotateY(180deg)}.mat-progress-bar[mode=indeterminate] .mat-progress-bar-fill,.mat-progress-bar[mode=query] .mat-progress-bar-fill{transition:none}.mat-progress-bar[mode=indeterminate] .mat-progress-bar-primary,.mat-progress-bar[mode=query] .mat-progress-bar-primary{-webkit-backface-visibility:hidden;backface-visibility:hidden;animation:2s linear infinite mat-progress-bar-primary-indeterminate-translate;left:-145.166611%}.mat-progress-bar[mode=indeterminate] .mat-progress-bar-primary.mat-progress-bar-fill::after,.mat-progress-bar[mode=query] .mat-progress-bar-primary.mat-progress-bar-fill::after{-webkit-backface-visibility:hidden;backface-visibility:hidden;animation:2s linear infinite mat-progress-bar-primary-indeterminate-scale}.mat-progress-bar[mode=indeterminate] .mat-progress-bar-secondary,.mat-progress-bar[mode=query] .mat-progress-bar-secondary{-webkit-backface-visibility:hidden;backface-visibility:hidden;animation:2s linear infinite mat-progress-bar-secondary-indeterminate-translate;left:-54.888891%;display:block}.mat-progress-bar[mode=indeterminate] .mat-progress-bar-secondary.mat-progress-bar-fill::after,.mat-progress-bar[mode=query] .mat-progress-bar-secondary.mat-progress-bar-fill::after{-webkit-backface-visibility:hidden;backface-visibility:hidden;animation:2s linear infinite mat-progress-bar-secondary-indeterminate-scale}.mat-progress-bar[mode=buffer] .mat-progress-bar-background{-webkit-backface-visibility:hidden;backface-visibility:hidden;animation:250ms linear infinite mat-progress-bar-background-scroll;display:block}.mat-progress-bar._mat-animation-noopable .mat-progress-bar-background,.mat-progress-bar._mat-animation-noopable .mat-progress-bar-buffer,.mat-progress-bar._mat-animation-noopable .mat-progress-bar-fill,.mat-progress-bar._mat-animation-noopable .mat-progress-bar-fill::after,.mat-progress-bar._mat-animation-noopable .mat-progress-bar-primary,.mat-progress-bar._mat-animation-noopable .mat-progress-bar-primary.mat-progress-bar-fill::after,.mat-progress-bar._mat-animation-noopable .mat-progress-bar-secondary,.mat-progress-bar._mat-animation-noopable .mat-progress-bar-secondary.mat-progress-bar-fill::after{animation:none;transition:none}@keyframes mat-progress-bar-primary-indeterminate-translate{0%{transform:translateX(0)}20%{animation-timing-function:cubic-bezier(.5,0,.70173,.49582);transform:translateX(0)}59.15%{animation-timing-function:cubic-bezier(.30244,.38135,.55,.95635);transform:translateX(83.67142%)}100%{transform:translateX(200.61106%)}}@keyframes mat-progress-bar-primary-indeterminate-scale{0%{transform:scaleX(.08)}36.65%{animation-timing-function:cubic-bezier(.33473,.12482,.78584,1);transform:scaleX(.08)}69.15%{animation-timing-function:cubic-bezier(.06,.11,.6,1);transform:scaleX(.66148)}100%{transform:scaleX(.08)}}@keyframes mat-progress-bar-secondary-indeterminate-translate{0%{animation-timing-function:cubic-bezier(.15,0,.51506,.40969);transform:translateX(0)}25%{animation-timing-function:cubic-bezier(.31033,.28406,.8,.73371);transform:translateX(37.65191%)}48.35%{animation-timing-function:cubic-bezier(.4,.62704,.6,.90203);transform:translateX(84.38617%)}100%{transform:translateX(160.27778%)}}@keyframes mat-progress-bar-secondary-indeterminate-scale{0%{animation-timing-function:cubic-bezier(.15,0,.51506,.40969);transform:scaleX(.08)}19.15%{animation-timing-function:cubic-bezier(.31033,.28406,.8,.73371);transform:scaleX(.4571)}44.15%{animation-timing-function:cubic-bezier(.4,.62704,.6,.90203);transform:scaleX(.72796)}100%{transform:scaleX(.08)}}@keyframes mat-progress-bar-background-scroll{to{transform:translateX(-8px)}}"]
                }] }
    ];
    /** @nocollapse */
    RteProgressBarComponent.ctorParameters = function () { return [
        { type: ElementRef },
        { type: NgZone },
        { type: String, decorators: [{ type: Optional }, { type: Inject, args: [ANIMATION_MODULE_TYPE,] }] },
        { type: undefined, decorators: [{ type: Optional }, { type: Inject, args: [MAT_PROGRESS_BAR_LOCATION,] }] }
    ]; };
    return RteProgressBarComponent;
}(MatProgressBar));

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var RteMenuContentDirective = /** @class */ (function (_super) {
    __extends(RteMenuContentDirective, _super);
    function RteMenuContentDirective(_template, _componentFactoryResolver, _appRef, _injector, _viewContainerRef, _document) {
        return _super.call(this, _template, _componentFactoryResolver, _appRef, _injector, _viewContainerRef, _document) || this;
    }
    RteMenuContentDirective.decorators = [
        { type: Directive, args: [{
                    selector: 'ng-template[rteMenuContent]'
                },] }
    ];
    /** @nocollapse */
    RteMenuContentDirective.ctorParameters = function () { return [
        { type: TemplateRef },
        { type: ComponentFactoryResolver },
        { type: ApplicationRef },
        { type: Injector },
        { type: ViewContainerRef },
        { type: undefined, decorators: [{ type: Inject, args: [DOCUMENT,] }] }
    ]; };
    return RteMenuContentDirective;
}(MatMenuContent));

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var RteMenuItemComponent = /** @class */ (function (_super) {
    __extends(RteMenuItemComponent, _super);
    function RteMenuItemComponent(_elementRef, _focusMonitor) {
        return _super.call(this, _elementRef, null, _focusMonitor, null) || this;
    }
    Object.defineProperty(RteMenuItemComponent.prototype, "rteRole", {
        get: /**
         * @return {?}
         */
        function () { return this._rteRole; },
        set: /**
         * @param {?} val
         * @return {?}
         */
        function (val) {
            this._rteRole = val;
            this.role = val;
        },
        enumerable: true,
        configurable: true
    });
    RteMenuItemComponent.decorators = [
        { type: Component, args: [{
                    selector: '[rte-menu-item]',
                    exportAs: 'rteMenuItem',
                    inputs: ['disabled', 'disableRipple'],
                    host: {
                        '[attr.role]': 'role',
                        'class': 'mat-menu-item',
                        '[class.mat-menu-item-highlighted]': '_highlighted',
                        '[class.mat-menu-item-submenu-trigger]': '_triggersSubmenu',
                        '[attr.tabindex]': '_getTabIndex()',
                        '[attr.aria-disabled]': 'disabled.toString()',
                        '[attr.disabled]': 'disabled || null',
                    },
                    changeDetection: ChangeDetectionStrategy.OnPush,
                    encapsulation: ViewEncapsulation.None,
                    template: "<ng-content></ng-content>\r\n<div class=\"mat-menu-ripple\" matRipple\r\n     [matRippleDisabled]=\"disableRipple || disabled\"\r\n     [matRippleTrigger]=\"_getHostElement()\">\r\n</div>\r\n"
                }] }
    ];
    /** @nocollapse */
    RteMenuItemComponent.ctorParameters = function () { return [
        { type: ElementRef },
        { type: FocusMonitor }
    ]; };
    RteMenuItemComponent.propDecorators = {
        rteRole: [{ type: Input, args: ['rteRole',] }]
    };
    return RteMenuItemComponent;
}(MatMenuItem));

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var RteMenuTriggerDirective = /** @class */ (function (_super) {
    __extends(RteMenuTriggerDirective, _super);
    function RteMenuTriggerDirective(_overlay, _element, _viewContainerRef, scrollStrategy, _parentMenu, _menuItemInstance, _dir, _focusMonitor) {
        return _super.call(this, _overlay, _element, _viewContainerRef, scrollStrategy, _parentMenu, _menuItemInstance, _dir, _focusMonitor) || this;
    }
    Object.defineProperty(RteMenuTriggerDirective.prototype, "rteMenuTriggerFor", {
        get: /**
         * @return {?}
         */
        function () { return this._rteMenuTriggerFor; },
        set: /**
         * @param {?} menu
         * @return {?}
         */
        function (menu) {
            this._rteMenuTriggerFor = menu;
            this.menu = menu;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(RteMenuTriggerDirective.prototype, "rteMenuTriggerData", {
        get: /**
         * @return {?}
         */
        function () { return this._rteMenuTriggerData; },
        set: /**
         * @param {?} data
         * @return {?}
         */
        function (data) {
            this._rteMenuTriggerData = data;
            this.menuData = data;
        },
        enumerable: true,
        configurable: true
    });
    RteMenuTriggerDirective.decorators = [
        { type: Directive, args: [{
                    selector: "[rte-menu-trigger-for], [rteMenuTriggerFor]",
                    host: {
                        'aria-haspopup': 'true',
                        '[attr.aria-expanded]': 'menuOpen || null',
                        '(mousedown)': '_handleMousedown($event)',
                        '(keydown)': '_handleKeydown($event)',
                        '(click)': '_handleClick($event)',
                    },
                    exportAs: 'rteMenuTrigger'
                },] }
    ];
    /** @nocollapse */
    RteMenuTriggerDirective.ctorParameters = function () { return [
        { type: Overlay },
        { type: ElementRef },
        { type: ViewContainerRef },
        { type: undefined, decorators: [{ type: Inject, args: [MAT_MENU_SCROLL_STRATEGY,] }] },
        { type: MatMenu, decorators: [{ type: Optional }] },
        { type: MatMenuItem, decorators: [{ type: Optional }, { type: Self }] },
        { type: Directionality, decorators: [{ type: Optional }] },
        { type: FocusMonitor }
    ]; };
    RteMenuTriggerDirective.propDecorators = {
        rteMenuTriggerFor: [{ type: Input, args: ['rteMenuTriggerFor',] }],
        rteMenuTriggerData: [{ type: Input, args: ['rteMenuTriggerData',] }]
    };
    return RteMenuTriggerDirective;
}(MatMenuTrigger));

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var _RteMatMenu = /** @class */ (function (_super) {
    __extends(_RteMatMenu, _super);
    function _RteMatMenu() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    _RteMatMenu.decorators = [
        { type: Component, args: [{
                    selector: 'rte-mat-menu',
                    template: "<ng-template>\r\n    <div\r\n        class=\"mat-menu-panel\"\r\n        [ngClass]=\"_classList\"\r\n        (keydown)=\"_handleKeydown($event)\"\r\n        (click)=\"closed.emit('click')\"\r\n        [@transformMenu]=\"_panelAnimationState\"\r\n        (@transformMenu.start)=\"_onAnimationStart($event)\"\r\n        (@transformMenu.done)=\"_onAnimationDone($event)\"\r\n        tabindex=\"-1\"\r\n        role=\"menu\">\r\n        <div class=\"mat-menu-content\">\r\n        <ng-content></ng-content>\r\n        </div>\r\n    </div>\r\n</ng-template>\r\n      ",
                    changeDetection: ChangeDetectionStrategy.OnPush,
                    encapsulation: ViewEncapsulation.None,
                    exportAs: 'rteMatMenu',
                    animations: [
                        matMenuAnimations.transformMenu,
                        matMenuAnimations.fadeInItems
                    ],
                    styles: [".mat-menu-panel{min-width:112px;max-width:280px;overflow:auto;-webkit-overflow-scrolling:touch;max-height:calc(100vh - 48px);border-radius:4px;outline:0}.mat-menu-panel.ng-animating{pointer-events:none}@media (-ms-high-contrast:active){.mat-menu-panel{outline:solid 1px}}.mat-menu-content:not(:empty){padding-top:8px;padding-bottom:8px}.mat-menu-item{-webkit-user-select:none;-moz-user-select:none;user-select:none;cursor:pointer;outline:0;border:none;-webkit-tap-highlight-color:transparent;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;display:block;line-height:48px;height:48px;padding:0 16px;text-align:left;text-decoration:none;max-width:100%;position:relative}.mat-menu-item::-moz-focus-inner{border:0}.mat-menu-item[disabled]{cursor:default}[dir=rtl] .mat-menu-item{text-align:right}.mat-menu-item .mat-icon{margin-right:16px;vertical-align:middle}.mat-menu-item .mat-icon svg{vertical-align:top}[dir=rtl] .mat-menu-item .mat-icon{margin-left:16px;margin-right:0}@media (-ms-high-contrast:active){.mat-menu-item-highlighted,.mat-menu-item.cdk-keyboard-focused,.mat-menu-item.cdk-program-focused{outline:dotted 1px}}.mat-menu-item-submenu-trigger{padding-right:32px}.mat-menu-item-submenu-trigger::after{width:0;height:0;border-style:solid;border-width:5px 0 5px 5px;border-color:transparent transparent transparent currentColor;content:'';display:inline-block;position:absolute;top:50%;right:16px;transform:translateY(-50%)}[dir=rtl] .mat-menu-item-submenu-trigger{padding-right:16px;padding-left:32px}[dir=rtl] .mat-menu-item-submenu-trigger::after{right:auto;left:16px;transform:rotateY(180deg) translateY(-50%)}button.mat-menu-item{width:100%}.mat-menu-item .mat-menu-ripple{top:0;left:0;right:0;bottom:0;position:absolute;pointer-events:none}"]
                }] }
    ];
    return _RteMatMenu;
}(MatMenu));

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var RteSortDirective = /** @class */ (function (_super) {
    __extends(RteSortDirective, _super);
    function RteSortDirective() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(RteSortDirective.prototype, "rteSortActive", {
        get: /**
         * @return {?}
         */
        function () { return this.active; },
        set: /**
         * @param {?} direction
         * @return {?}
         */
        function (direction) {
            this.active = direction;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(RteSortDirective.prototype, "rteSortStart", {
        get: /**
         * @return {?}
         */
        function () { return this.start; },
        set: /**
         * @param {?} value
         * @return {?}
         */
        function (value) {
            this.start = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(RteSortDirective.prototype, "rteSortDirection", {
        get: /**
         * @return {?}
         */
        function () { return this.direction; },
        set: /**
         * @param {?} value
         * @return {?}
         */
        function (value) {
            this.direction = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(RteSortDirective.prototype, "rteSortDisableClear", {
        get: /**
         * @return {?}
         */
        function () { return this.disableClear; },
        set: /**
         * @param {?} value
         * @return {?}
         */
        function (value) {
            this.disableClear = value;
        },
        enumerable: true,
        configurable: true
    });
    RteSortDirective.decorators = [
        { type: Directive, args: [{
                    selector: '[rteSort]',
                    exportAs: 'rteSort',
                    inputs: ['disabled: matSortDisabled']
                },] }
    ];
    RteSortDirective.propDecorators = {
        rteSortActive: [{ type: Input, args: ['rteSortActive',] }],
        rteSortStart: [{ type: Input, args: ['rteSortStart',] }],
        rteSortDirection: [{ type: Input, args: ['rteSortDirection',] }],
        rteSortDisableClear: [{ type: Input, args: ['rteSortDisableClear',] }]
    };
    return RteSortDirective;
}(MatSort));

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var RteSortHeader = /** @class */ (function (_super) {
    __extends(RteSortHeader, _super);
    function RteSortHeader(_intl, changeDetectorRef, _sort, _columnDef) {
        return _super.call(this, _intl, changeDetectorRef, _sort, _columnDef) || this;
    }
    Object.defineProperty(RteSortHeader.prototype, "rteSortHeader", {
        get: /**
         * @return {?}
         */
        function () { return this.id; },
        set: /**
         * @param {?} value
         * @return {?}
         */
        function (value) {
            this.id = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(RteSortHeader.prototype, "rteArrowPosition", {
        get: /**
         * @return {?}
         */
        function () { return this.arrowPosition; },
        set: /**
         * @param {?} value
         * @return {?}
         */
        function (value) {
            this.arrowPosition = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(RteSortHeader.prototype, "rteStart", {
        get: /**
         * @return {?}
         */
        function () { return this.start; },
        set: /**
         * @param {?} value
         * @return {?}
         */
        function (value) {
            this.start = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(RteSortHeader.prototype, "rteDisableClear", {
        get: /**
         * @return {?}
         */
        function () { return this.disableClear; },
        set: /**
         * @param {?} value
         * @return {?}
         */
        function (value) {
            this.disableClear = value;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @return {?}
     */
    RteSortHeader.prototype._rteRenderArrow = /**
     * @return {?}
     */
    function () {
        return !this._isRteDisabled() || this._isRteSorted();
    };
    /**
     * @return {?}
     */
    RteSortHeader.prototype._isRteDisabled = /**
     * @return {?}
     */
    function () {
        return this._sort.disabled || this.disabled;
    };
    /**
     * @return {?}
     */
    RteSortHeader.prototype._isRteSorted = /**
     * @return {?}
     */
    function () {
        return this._sort.active == this.id &&
            (this._sort.direction === 'asc' || this._sort.direction === 'desc');
    };
    RteSortHeader.decorators = [
        { type: Component, args: [{
                    selector: '[rte-sort-header]',
                    exportAs: 'rteSortHeader',
                    template: "<div class=\"mat-sort-header-container\"\r\n     [class.mat-sort-header-sorted]=\"_isSorted()\"\r\n     [class.mat-sort-header-position-before]=\"arrowPosition == 'before'\">\r\n  <button class=\"mat-sort-header-button\" type=\"button\"\r\n          [attr.disabled]=\"_isDisabled() || null\"\r\n          [attr.aria-label]=\"_intl.sortButtonLabel(id)\"\r\n          (focus)=\"_setIndicatorHintVisible(true)\"\r\n          (blur)=\"_setIndicatorHintVisible(false)\">\r\n    <ng-content></ng-content>\r\n  </button>\r\n\r\n  <!-- Disable animations while a current animation is running -->\r\n  <div class=\"mat-sort-header-arrow\"\r\n       *ngIf=\"_rteRenderArrow()\"\r\n       [@arrowOpacity]=\"_getArrowViewState()\"\r\n       [@arrowPosition]=\"_getArrowViewState()\"\r\n       [@allowChildren]=\"_getArrowDirectionState()\"\r\n       (@arrowPosition.start)=\"_disableViewStateAnimation = true\"\r\n       (@arrowPosition.done)=\"_disableViewStateAnimation = false\">\r\n    <div class=\"mat-sort-header-stem\"></div>\r\n    <div class=\"mat-sort-header-indicator\" [@indicator]=\"_getArrowDirectionState()\">\r\n      <div class=\"mat-sort-header-pointer-left\" [@leftPointer]=\"_getArrowDirectionState()\"></div>\r\n      <div class=\"mat-sort-header-pointer-right\" [@rightPointer]=\"_getArrowDirectionState()\"></div>\r\n      <div class=\"mat-sort-header-pointer-middle\"></div>\r\n    </div>\r\n  </div>\r\n</div>\r\n",
                    host: {
                        '(click)': '_handleClick()',
                        '(mouseenter)': '_setIndicatorHintVisible(true)',
                        '(longpress)': '_setIndicatorHintVisible(true)',
                        '(mouseleave)': '_setIndicatorHintVisible(false)',
                        '[attr.aria-sort]': '_getAriaSortAttribute()',
                        '[class.mat-sort-header-disabled]': '_isDisabled()',
                    },
                    encapsulation: ViewEncapsulation.None,
                    changeDetection: ChangeDetectionStrategy.OnPush,
                    inputs: ['disabled'],
                    animations: [
                        matSortAnimations.indicator,
                        matSortAnimations.leftPointer,
                        matSortAnimations.rightPointer,
                        matSortAnimations.arrowOpacity,
                        matSortAnimations.arrowPosition,
                        matSortAnimations.allowChildren,
                    ],
                    styles: [".mat-sort-header-container{display:flex;cursor:pointer;align-items:center}.mat-sort-header-disabled .mat-sort-header-container{cursor:default}.mat-sort-header-position-before{flex-direction:row-reverse}.mat-sort-header-button{border:none;background:0 0;display:flex;align-items:center;padding:0;cursor:inherit;outline:0;font:inherit;color:currentColor}.mat-sort-header-button::-moz-focus-inner{border:0}.mat-sort-header-arrow{height:12px;width:12px;min-width:12px;position:relative;display:flex;opacity:0}.mat-sort-header-arrow,[dir=rtl] .mat-sort-header-position-before .mat-sort-header-arrow{margin:0 0 0 6px}.mat-sort-header-position-before .mat-sort-header-arrow,[dir=rtl] .mat-sort-header-arrow{margin:0 6px 0 0}.mat-sort-header-stem{background:currentColor;height:10px;width:2px;margin:auto;display:flex;align-items:center}@media (-ms-high-contrast:active){.mat-sort-header-stem{width:0;border-left:2px solid}}.mat-sort-header-indicator{width:100%;height:2px;display:flex;align-items:center;position:absolute;top:0;left:0}.mat-sort-header-pointer-middle{margin:auto;height:2px;width:2px;background:currentColor;transform:rotate(45deg)}@media (-ms-high-contrast:active){.mat-sort-header-pointer-middle{width:0;height:0;border-top:2px solid;border-left:2px solid}}.mat-sort-header-pointer-left,.mat-sort-header-pointer-right{background:currentColor;width:6px;height:2px;position:absolute;top:0}@media (-ms-high-contrast:active){.mat-sort-header-pointer-left,.mat-sort-header-pointer-right{width:0;height:0;border-left:6px solid;border-top:2px solid}}.mat-sort-header-pointer-left{transform-origin:right;left:0}.mat-sort-header-pointer-right{transform-origin:left;right:0}"]
                }] }
    ];
    /** @nocollapse */
    RteSortHeader.ctorParameters = function () { return [
        { type: MatSortHeaderIntl },
        { type: ChangeDetectorRef },
        { type: RteSortDirective, decorators: [{ type: Optional }] },
        { type: undefined, decorators: [{ type: Inject, args: ['MAT_SORT_HEADER_COLUMN_DEF',] }, { type: Optional }] }
    ]; };
    RteSortHeader.propDecorators = {
        rteSortHeader: [{ type: Input, args: ['rte-sort-header',] }],
        rteArrowPosition: [{ type: Input, args: ['rteArrowPosition',] }],
        rteStart: [{ type: Input, args: ['rteStart',] }],
        rteDisableClear: [{ type: Input, args: ['rteDisableClear',] }]
    };
    return RteSortHeader;
}(MatSortHeader));

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var RteAccordionDirective = /** @class */ (function (_super) {
    __extends(RteAccordionDirective, _super);
    function RteAccordionDirective() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(RteAccordionDirective.prototype, "rteHideToggle", {
        get: /**
         * @return {?}
         */
        function () { return this.hideToggle; },
        set: /**
         * @param {?} val
         * @return {?}
         */
        function (val) { this.hideToggle = val; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(RteAccordionDirective.prototype, "rteDisplayMode", {
        get: /**
         * @return {?}
         */
        function () { return this.displayMode; },
        set: /**
         * @param {?} val
         * @return {?}
         */
        function (val) { this.displayMode = val; },
        enumerable: true,
        configurable: true
    });
    RteAccordionDirective.decorators = [
        { type: Directive, args: [{
                    selector: 'rte-accordion',
                    exportAs: 'rteAccordion',
                    inputs: ['multi'],
                    providers: [
                        { provide: MAT_ACCORDION, useExisting: MatAccordion },
                        { provide: MAT_ACCORDION, useExisting: RteAccordionDirective },
                    ],
                    host: {
                        class: 'rte-accordion'
                    }
                },] }
    ];
    RteAccordionDirective.propDecorators = {
        rteHideToggle: [{ type: Input }],
        rteDisplayMode: [{ type: Input }]
    };
    return RteAccordionDirective;
}(MatAccordion));

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var RteExpansionPanelActionRowDirective = /** @class */ (function (_super) {
    __extends(RteExpansionPanelActionRowDirective, _super);
    function RteExpansionPanelActionRowDirective() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    RteExpansionPanelActionRowDirective.decorators = [
        { type: Directive, args: [{
                    selector: 'rte-action-row',
                    host: {
                        class: 'mat-action-row'
                    }
                },] }
    ];
    return RteExpansionPanelActionRowDirective;
}(MatExpansionPanelActionRow));

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var ɵ0 = undefined;
var RteExpansionPanelComponent = /** @class */ (function (_super) {
    __extends(RteExpansionPanelComponent, _super);
    function RteExpansionPanelComponent(accordion, _changeDetectorRef, _uniqueSelectionDispatcher, _viewContainerRef, _document, _animationMode, defaultOptions) {
        return _super.call(this, accordion, _changeDetectorRef, _uniqueSelectionDispatcher, _viewContainerRef, _document, _animationMode, defaultOptions) || this;
    }
    Object.defineProperty(RteExpansionPanelComponent.prototype, "rteHideToggle", {
        get: /**
         * @return {?}
         */
        function () {
            return this.hideToggle;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(RteExpansionPanelComponent.prototype, "hideToggle", {
        set: /**
         * @param {?} value
         * @return {?}
         */
        function (value) {
            this.hideToggle = value;
        },
        enumerable: true,
        configurable: true
    });
    RteExpansionPanelComponent.decorators = [
        { type: Component, args: [{
                    selector: 'rte-expansion-panel',
                    exportAs: 'rteExpansionPanel',
                    template: "<ng-content select=\"rte-expansion-panel-header\"></ng-content>\r\n<div class=\"mat-expansion-panel-content\"\r\n     role=\"region\"\r\n     [@bodyExpansion]=\"_getExpandedState()\"\r\n     (@bodyExpansion.done)=\"_bodyAnimationDone.next($event)\"\r\n     [attr.aria-labelledby]=\"_headerId\"\r\n     [id]=\"id\"\r\n     #body>\r\n  <div class=\"mat-expansion-panel-body\">\r\n    <ng-content></ng-content>\r\n    <ng-template [cdkPortalOutlet]=\"_portal\"></ng-template>\r\n  </div>\r\n  <ng-content select=\"rte-action-row\"></ng-content>\r\n</div>\r\n",
                    encapsulation: ViewEncapsulation.None,
                    changeDetection: ChangeDetectionStrategy.OnPush,
                    inputs: ['disabled', 'expanded'],
                    outputs: ['opened', 'closed', 'expandedChange'],
                    animations: [matExpansionAnimations.bodyExpansion],
                    providers: [
                        { provide: MAT_ACCORDION, useValue: ɵ0 },
                    ],
                    host: {
                        'class': 'mat-expansion-panel',
                        '[class.mat-expanded]': 'expanded',
                        '[class._mat-animation-noopable]': '_animationMode === "NoopAnimations"',
                        '[class.mat-expansion-panel-spacing]': '_hasSpacing()',
                    },
                    styles: [".mat-expansion-panel{box-sizing:content-box;display:block;margin:0;border-radius:4px;overflow:hidden;transition:margin 225ms cubic-bezier(.4,0,.2,1),box-shadow 280ms cubic-bezier(.4,0,.2,1)}.mat-accordion .mat-expansion-panel:not(.mat-expanded),.mat-accordion .mat-expansion-panel:not(.mat-expansion-panel-spacing){border-radius:0}.mat-accordion .mat-expansion-panel:first-of-type{border-top-right-radius:4px;border-top-left-radius:4px}.mat-accordion .mat-expansion-panel:last-of-type{border-bottom-right-radius:4px;border-bottom-left-radius:4px}@media (-ms-high-contrast:active){.mat-expansion-panel{outline:solid 1px}}.mat-expansion-panel._mat-animation-noopable,.mat-expansion-panel.ng-animate-disabled,.ng-animate-disabled .mat-expansion-panel{transition:none}.mat-expansion-panel-content{display:flex;flex-direction:column;overflow:visible}.mat-expansion-panel-body{padding:0 24px 16px}.mat-expansion-panel-spacing{margin:16px 0}.mat-accordion>.mat-expansion-panel-spacing:first-child,.mat-accordion>:first-child:not(.mat-expansion-panel) .mat-expansion-panel-spacing{margin-top:0}.mat-accordion>.mat-expansion-panel-spacing:last-child,.mat-accordion>:last-child:not(.mat-expansion-panel) .mat-expansion-panel-spacing{margin-bottom:0}.mat-action-row{border-top-style:solid;border-top-width:1px;display:flex;flex-direction:row;justify-content:flex-end;padding:16px 8px 16px 24px}.mat-action-row button.mat-button{margin-left:8px}[dir=rtl] .mat-action-row button.mat-button{margin-left:0;margin-right:8px}"]
                }] }
    ];
    /** @nocollapse */
    RteExpansionPanelComponent.ctorParameters = function () { return [
        { type: undefined, decorators: [{ type: Optional }, { type: SkipSelf }, { type: Inject, args: [MAT_ACCORDION,] }] },
        { type: ChangeDetectorRef },
        { type: UniqueSelectionDispatcher },
        { type: ViewContainerRef },
        { type: undefined, decorators: [{ type: Inject, args: [DOCUMENT,] }] },
        { type: String, decorators: [{ type: Optional }, { type: Inject, args: [ANIMATION_MODULE_TYPE,] }] },
        { type: undefined, decorators: [{ type: Inject, args: [MAT_EXPANSION_PANEL_DEFAULT_OPTIONS,] }, { type: Optional }] }
    ]; };
    RteExpansionPanelComponent.propDecorators = {
        rteHideToggle: [{ type: Input }]
    };
    return RteExpansionPanelComponent;
}(MatExpansionPanel));

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var RteExpansionPanelHeaderComponent = /** @class */ (function (_super) {
    __extends(RteExpansionPanelHeaderComponent, _super);
    function RteExpansionPanelHeaderComponent(panel, _element, _focusMonitor, _changeDetectorRef, defaultOptions) {
        return _super.call(this, panel, _element, _focusMonitor, _changeDetectorRef, defaultOptions) || this;
    }
    RteExpansionPanelHeaderComponent.decorators = [
        { type: Component, args: [{
                    selector: 'rte-expansion-panel-header',
                    template: "<span class=\"mat-content\">\r\n    <ng-content select=\"rte-panel-title\"></ng-content>\r\n    <ng-content select=\"rte-panel-description\"></ng-content>\r\n    <ng-content></ng-content>\r\n  </span>\r\n  <span [@indicatorRotate]=\"_getExpandedState()\" *ngIf=\"_showToggle()\"\r\n        class=\"mat-expansion-indicator\"></span>\r\n  ",
                    encapsulation: ViewEncapsulation.None,
                    changeDetection: ChangeDetectionStrategy.OnPush,
                    animations: [
                        matExpansionAnimations.indicatorRotate,
                        matExpansionAnimations.expansionHeaderHeight
                    ],
                    host: {
                        'class': 'mat-expansion-panel-header',
                        'role': 'button',
                        '[attr.id]': 'panel._headerId',
                        '[attr.tabindex]': 'disabled ? -1 : 0',
                        '[attr.aria-controls]': '_getPanelId()',
                        '[attr.aria-expanded]': '_isExpanded()',
                        '[attr.aria-disabled]': 'panel.disabled',
                        '[class.mat-expanded]': '_isExpanded()',
                        '(click)': '_toggle()',
                        '(keydown)': '_keydown($event)',
                        '[@expansionHeight]': "{\n          value: _getExpandedState(),\n          params: {\n            collapsedHeight: collapsedHeight,\n            expandedHeight: expandedHeight\n          }\n      }",
                    },
                    styles: [".mat-expansion-panel-header{display:flex;flex-direction:row;align-items:center;padding:0 24px;border-radius:inherit}.mat-expansion-panel-header:focus,.mat-expansion-panel-header:hover{outline:0}.mat-expansion-panel-header.mat-expanded:focus,.mat-expansion-panel-header.mat-expanded:hover{background:inherit}.mat-expansion-panel-header:not([aria-disabled=true]){cursor:pointer}.mat-content{display:flex;flex:1;flex-direction:row;overflow:hidden}.mat-expansion-panel-header-description,.mat-expansion-panel-header-title{display:flex;flex-grow:1;margin-right:16px}[dir=rtl] .mat-expansion-panel-header-description,[dir=rtl] .mat-expansion-panel-header-title{margin-right:0;margin-left:16px}.mat-expansion-panel-header-description{flex-grow:2}.mat-expansion-indicator::after{border-style:solid;border-width:0 2px 2px 0;content:'';display:inline-block;padding:3px;transform:rotate(45deg);vertical-align:middle}"]
                }] }
    ];
    /** @nocollapse */
    RteExpansionPanelHeaderComponent.ctorParameters = function () { return [
        { type: RteExpansionPanelComponent, decorators: [{ type: Host }] },
        { type: ElementRef },
        { type: FocusMonitor },
        { type: ChangeDetectorRef },
        { type: undefined, decorators: [{ type: Inject, args: [MAT_EXPANSION_PANEL_DEFAULT_OPTIONS,] }, { type: Optional }] }
    ]; };
    return RteExpansionPanelHeaderComponent;
}(MatExpansionPanelHeader));

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var RteExpansionPanelDescriptionDirective = /** @class */ (function (_super) {
    __extends(RteExpansionPanelDescriptionDirective, _super);
    function RteExpansionPanelDescriptionDirective() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    RteExpansionPanelDescriptionDirective.decorators = [
        { type: Directive, args: [{
                    selector: 'rte-panel-description',
                    host: {
                        class: 'mat-expansion-panel-header-description'
                    }
                },] }
    ];
    return RteExpansionPanelDescriptionDirective;
}(MatExpansionPanelDescription));

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var RteExpansionPanelTitleDirective = /** @class */ (function (_super) {
    __extends(RteExpansionPanelTitleDirective, _super);
    function RteExpansionPanelTitleDirective() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    RteExpansionPanelTitleDirective.decorators = [
        { type: Directive, args: [{
                    selector: 'rte-panel-title',
                    host: {
                        class: 'mat-expansion-panel-header-title'
                    }
                },] }
    ];
    return RteExpansionPanelTitleDirective;
}(MatExpansionPanelTitle));

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
var MAT_SLIDER_VALUE_ACCESSOR = {
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(function () { return RteSliderComponent; }),
    multi: true
};
var RteSliderComponent = /** @class */ (function (_super) {
    __extends(RteSliderComponent, _super);
    function RteSliderComponent(elementRef, _focusMonitor, _changeDetectorRef, _dir, tabIndex, 
    // @breaking-change 8.0.0 `_animationMode` parameter to be made required.
    _animationMode) {
        return _super.call(this, elementRef, _focusMonitor, _changeDetectorRef, _dir, tabIndex, _animationMode) || this;
    }
    Object.defineProperty(RteSliderComponent.prototype, "rteInvert", {
        get: /**
         * @return {?}
         */
        function () { return this.invert; },
        set: /**
         * @param {?} value
         * @return {?}
         */
        function (value) {
            this.invert = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(RteSliderComponent.prototype, "rteMax", {
        get: /**
         * @return {?}
         */
        function () { return this.max; },
        set: /**
         * @param {?} value
         * @return {?}
         */
        function (value) {
            this.max = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(RteSliderComponent.prototype, "rteMin", {
        get: /**
         * @return {?}
         */
        function () { return this.min; },
        set: /**
         * @param {?} value
         * @return {?}
         */
        function (value) {
            this.min = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(RteSliderComponent.prototype, "rteStep", {
        get: /**
         * @return {?}
         */
        function () { return this.step; },
        set: /**
         * @param {?} value
         * @return {?}
         */
        function (value) {
            this.step = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(RteSliderComponent.prototype, "rteThumbLabel", {
        get: /**
         * @return {?}
         */
        function () { return this.thumbLabel; },
        set: /**
         * @param {?} value
         * @return {?}
         */
        function (value) {
            this.thumbLabel = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(RteSliderComponent.prototype, "rteTickInterval", {
        get: /**
         * @return {?}
         */
        function () { return this.tickInterval; },
        set: /**
         * @param {?} value
         * @return {?}
         */
        function (value) {
            this.tickInterval = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(RteSliderComponent.prototype, "rteValue", {
        get: /**
         * @return {?}
         */
        function () { return this.value; },
        set: /**
         * @param {?} value
         * @return {?}
         */
        function (value) {
            this.value = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(RteSliderComponent.prototype, "rteVertical", {
        get: /**
         * @return {?}
         */
        function () { return this.vertical; },
        set: /**
         * @param {?} value
         * @return {?}
         */
        function (value) {
            this.vertical = value;
        },
        enumerable: true,
        configurable: true
    });
    RteSliderComponent.decorators = [
        { type: Component, args: [{
                    selector: 'rte-slider',
                    exportAs: 'rteSlider',
                    providers: [MAT_SLIDER_VALUE_ACCESSOR],
                    host: {
                        '(focus)': '_onFocus()',
                        '(blur)': '_onBlur()',
                        '(mousedown)': '_onMousedown($event)',
                        '(keydown)': '_onKeydown($event)',
                        '(keyup)': '_onKeyup()',
                        '(mouseenter)': '_onMouseenter()',
                        '(slide)': '_onSlide($event)',
                        '(slideend)': '_onSlideEnd()',
                        '(slidestart)': '_onSlideStart($event)',
                        'class': 'mat-slider',
                        'role': 'slider',
                        '[tabIndex]': 'tabIndex',
                        '[attr.aria-disabled]': 'disabled',
                        '[attr.aria-valuemax]': 'max',
                        '[attr.aria-valuemin]': 'min',
                        '[attr.aria-valuenow]': 'value',
                        '[attr.aria-orientation]': 'vertical ? "vertical" : "horizontal"',
                        '[class.mat-slider-disabled]': 'disabled',
                        '[class.mat-slider-has-ticks]': 'tickInterval',
                        '[class.mat-slider-horizontal]': '!vertical',
                        '[class.mat-slider-axis-inverted]': '_invertAxis',
                        '[class.mat-slider-sliding]': '_isSliding',
                        '[class.mat-slider-thumb-label-showing]': 'thumbLabel',
                        '[class.mat-slider-vertical]': 'vertical',
                        '[class.mat-slider-min-value]': '_isMinValue',
                        '[class.mat-slider-hide-last-tick]': 'disabled || _isMinValue && _thumbGap && _invertAxis',
                        '[class._mat-animation-noopable]': '_animationMode === "NoopAnimations"',
                    },
                    template: "<div class=\"mat-slider-wrapper\" #sliderWrapper>\r\n    <div class=\"mat-slider-track-wrapper\">\r\n        <div class=\"mat-slider-track-background\" [ngStyle]=\"_trackBackgroundStyles\"></div>\r\n        <div class=\"mat-slider-track-fill\" [ngStyle]=\"_trackFillStyles\"></div>\r\n    </div>\r\n    <div class=\"mat-slider-ticks-container\" [ngStyle]=\"_ticksContainerStyles\">\r\n        <div class=\"mat-slider-ticks\" [ngStyle]=\"_ticksStyles\"></div>\r\n    </div>\r\n    <div class=\"mat-slider-thumb-container\" [ngStyle]=\"_thumbContainerStyles\">\r\n        <div class=\"mat-slider-focus-ring\"></div>\r\n        <div class=\"mat-slider-thumb\"></div>\r\n        <div class=\"mat-slider-thumb-label\">\r\n        <span class=\"mat-slider-thumb-label-text\">{{displayValue}}</span>\r\n        </div>\r\n    </div>\r\n</div>  ",
                    inputs: ['disabled', 'color', 'tabIndex'],
                    encapsulation: ViewEncapsulation.None,
                    changeDetection: ChangeDetectionStrategy.OnPush,
                    styles: [".mat-slider{display:inline-block;position:relative;box-sizing:border-box;padding:8px;outline:0;vertical-align:middle}.mat-slider-wrapper{position:absolute}.mat-slider-track-wrapper{position:absolute;top:0;left:0;overflow:hidden}.mat-slider-track-fill{position:absolute;transform-origin:0 0;transition:transform .4s cubic-bezier(.25,.8,.25,1),background-color .4s cubic-bezier(.25,.8,.25,1)}.mat-slider-track-background{position:absolute;transform-origin:100% 100%;transition:transform .4s cubic-bezier(.25,.8,.25,1),background-color .4s cubic-bezier(.25,.8,.25,1)}.mat-slider-ticks-container{position:absolute;left:0;top:0;overflow:hidden}.mat-slider-ticks{background-repeat:repeat;background-clip:content-box;box-sizing:border-box;opacity:0;transition:opacity .4s cubic-bezier(.25,.8,.25,1)}.mat-slider-thumb-container{position:absolute;z-index:1;transition:transform .4s cubic-bezier(.25,.8,.25,1)}.mat-slider-focus-ring{position:absolute;width:30px;height:30px;border-radius:50%;transform:scale(0);opacity:0;transition:transform .4s cubic-bezier(.25,.8,.25,1),background-color .4s cubic-bezier(.25,.8,.25,1),opacity .4s cubic-bezier(.25,.8,.25,1)}.mat-slider.cdk-keyboard-focused .mat-slider-focus-ring,.mat-slider.cdk-program-focused .mat-slider-focus-ring{transform:scale(1);opacity:1}.mat-slider:not(.mat-slider-disabled) .mat-slider-thumb,.mat-slider:not(.mat-slider-disabled) .mat-slider-thumb-label{cursor:grab}.mat-slider-sliding:not(.mat-slider-disabled) .mat-slider-thumb,.mat-slider-sliding:not(.mat-slider-disabled) .mat-slider-thumb-label,.mat-slider:not(.mat-slider-disabled) .mat-slider-thumb-label:active,.mat-slider:not(.mat-slider-disabled) .mat-slider-thumb:active{cursor:grabbing}.mat-slider-thumb{position:absolute;right:-10px;bottom:-10px;box-sizing:border-box;width:20px;height:20px;border:3px solid transparent;border-radius:50%;transform:scale(.7);transition:transform .4s cubic-bezier(.25,.8,.25,1),background-color .4s cubic-bezier(.25,.8,.25,1),border-color .4s cubic-bezier(.25,.8,.25,1)}.mat-slider-thumb-label{display:none;align-items:center;justify-content:center;position:absolute;width:28px;height:28px;border-radius:50%;transition:transform .4s cubic-bezier(.25,.8,.25,1),border-radius .4s cubic-bezier(.25,.8,.25,1),background-color .4s cubic-bezier(.25,.8,.25,1)}.mat-slider-thumb-label-text{z-index:1;opacity:0;transition:opacity .4s cubic-bezier(.25,.8,.25,1)}.mat-slider-sliding .mat-slider-thumb-container,.mat-slider-sliding .mat-slider-track-background,.mat-slider-sliding .mat-slider-track-fill{transition-duration:0s}.mat-slider-has-ticks .mat-slider-wrapper::after{content:'';position:absolute;border-width:0;border-style:solid;opacity:0;transition:opacity .4s cubic-bezier(.25,.8,.25,1)}.mat-slider-has-ticks.cdk-focused:not(.mat-slider-disabled) .mat-slider-ticks,.mat-slider-has-ticks.cdk-focused:not(.mat-slider-hide-last-tick) .mat-slider-wrapper::after,.mat-slider-has-ticks:hover:not(.mat-slider-disabled) .mat-slider-ticks,.mat-slider-has-ticks:hover:not(.mat-slider-hide-last-tick) .mat-slider-wrapper::after{opacity:1}.mat-slider-thumb-label-showing .mat-slider-focus-ring{display:none}.mat-slider-thumb-label-showing .mat-slider-thumb-label{display:flex}.mat-slider-axis-inverted .mat-slider-track-fill{transform-origin:100% 100%}.mat-slider-axis-inverted .mat-slider-track-background{transform-origin:0 0}.mat-slider:not(.mat-slider-disabled).cdk-focused.mat-slider-thumb-label-showing .mat-slider-thumb{transform:scale(0)}.mat-slider:not(.mat-slider-disabled).cdk-focused .mat-slider-thumb-label{border-radius:50% 50% 0}.mat-slider:not(.mat-slider-disabled).cdk-focused .mat-slider-thumb-label-text{opacity:1}.mat-slider:not(.mat-slider-disabled).cdk-mouse-focused .mat-slider-thumb,.mat-slider:not(.mat-slider-disabled).cdk-program-focused .mat-slider-thumb,.mat-slider:not(.mat-slider-disabled).cdk-touch-focused .mat-slider-thumb{border-width:2px;transform:scale(1)}.mat-slider-disabled .mat-slider-focus-ring{transform:scale(0);opacity:0}.mat-slider-disabled .mat-slider-thumb{border-width:4px;transform:scale(.5)}.mat-slider-disabled .mat-slider-thumb-label{display:none}.mat-slider-horizontal{height:48px;min-width:128px}.mat-slider-horizontal .mat-slider-wrapper{height:2px;top:23px;left:8px;right:8px}.mat-slider-horizontal .mat-slider-wrapper::after{height:2px;border-left-width:2px;right:0;top:0}.mat-slider-horizontal .mat-slider-track-wrapper{height:2px;width:100%}.mat-slider-horizontal .mat-slider-track-fill{height:2px;width:100%;transform:scaleX(0)}.mat-slider-horizontal .mat-slider-track-background{height:2px;width:100%;transform:scaleX(1)}.mat-slider-horizontal .mat-slider-ticks-container{height:2px;width:100%}@media (-ms-high-contrast:active){.mat-slider-thumb-label{outline:solid 1px}.mat-slider-horizontal .mat-slider-ticks-container{height:0;outline:solid 2px;top:1px}}.mat-slider-horizontal .mat-slider-ticks{height:2px;width:100%}.mat-slider-horizontal .mat-slider-thumb-container{width:100%;height:0;top:50%}.mat-slider-horizontal .mat-slider-focus-ring{top:-15px;right:-15px}.mat-slider-horizontal .mat-slider-thumb-label{right:-14px;top:-40px;transform:translateY(26px) scale(.01) rotate(45deg)}.mat-slider-horizontal .mat-slider-thumb-label-text{transform:rotate(-45deg)}.mat-slider-horizontal.cdk-focused .mat-slider-thumb-label{transform:rotate(45deg)}.mat-slider-vertical{width:48px;min-height:128px}.mat-slider-vertical .mat-slider-wrapper{width:2px;top:8px;bottom:8px;left:23px}.mat-slider-vertical .mat-slider-wrapper::after{width:2px;border-top-width:2px;bottom:0;left:0}.mat-slider-vertical .mat-slider-track-wrapper{height:100%;width:2px}.mat-slider-vertical .mat-slider-track-fill{height:100%;width:2px;transform:scaleY(0)}.mat-slider-vertical .mat-slider-track-background{height:100%;width:2px;transform:scaleY(1)}.mat-slider-vertical .mat-slider-ticks-container{width:2px;height:100%}@media (-ms-high-contrast:active){.mat-slider-horizontal.cdk-focused .mat-slider-thumb-label,.mat-slider-horizontal.cdk-focused .mat-slider-thumb-label-text{transform:none}.mat-slider-vertical .mat-slider-ticks-container{width:0;outline:solid 2px;left:1px}}.mat-slider-vertical .mat-slider-focus-ring{bottom:-15px;left:-15px}.mat-slider-vertical .mat-slider-ticks{width:2px;height:100%}.mat-slider-vertical .mat-slider-thumb-container{height:100%;width:0;left:50%}.mat-slider-vertical .mat-slider-thumb{-webkit-backface-visibility:hidden;backface-visibility:hidden}.mat-slider-vertical .mat-slider-thumb-label{bottom:-14px;left:-40px;transform:translateX(26px) scale(.01) rotate(-45deg)}.mat-slider-vertical .mat-slider-thumb-label-text{transform:rotate(45deg)}.mat-slider-vertical.cdk-focused .mat-slider-thumb-label{transform:rotate(-45deg)}[dir=rtl] .mat-slider-wrapper::after{left:0;right:auto}[dir=rtl] .mat-slider-horizontal .mat-slider-track-fill{transform-origin:100% 100%}[dir=rtl] .mat-slider-horizontal .mat-slider-track-background,[dir=rtl] .mat-slider-horizontal.mat-slider-axis-inverted .mat-slider-track-fill{transform-origin:0 0}[dir=rtl] .mat-slider-horizontal.mat-slider-axis-inverted .mat-slider-track-background{transform-origin:100% 100%}.mat-slider._mat-animation-noopable .mat-slider-focus-ring,.mat-slider._mat-animation-noopable .mat-slider-has-ticks .mat-slider-wrapper::after,.mat-slider._mat-animation-noopable .mat-slider-thumb,.mat-slider._mat-animation-noopable .mat-slider-thumb-container,.mat-slider._mat-animation-noopable .mat-slider-thumb-label,.mat-slider._mat-animation-noopable .mat-slider-thumb-label-text,.mat-slider._mat-animation-noopable .mat-slider-ticks,.mat-slider._mat-animation-noopable .mat-slider-track-background,.mat-slider._mat-animation-noopable .mat-slider-track-fill{transition:none}"]
                }] }
    ];
    /** @nocollapse */
    RteSliderComponent.ctorParameters = function () { return [
        { type: ElementRef },
        { type: FocusMonitor },
        { type: ChangeDetectorRef },
        { type: Directionality, decorators: [{ type: Optional }] },
        { type: String, decorators: [{ type: Attribute, args: ['tabindex',] }] },
        { type: String, decorators: [{ type: Optional }, { type: Inject, args: [ANIMATION_MODULE_TYPE,] }] }
    ]; };
    RteSliderComponent.propDecorators = {
        rteInvert: [{ type: Input }],
        rteMax: [{ type: Input }],
        rteMin: [{ type: Input }],
        rteStep: [{ type: Input }],
        rteThumbLabel: [{ type: Input }],
        rteTickInterval: [{ type: Input }],
        rteValue: [{ type: Input }],
        rteVertical: [{ type: Input }]
    };
    return RteSliderComponent;
}(MatSlider));

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var SpinnerComponent = /** @class */ (function () {
    function SpinnerComponent(_elementRef) {
        this._elementRef = _elementRef;
    }
    /**
     * @return {?}
     */
    SpinnerComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
    };
    SpinnerComponent.decorators = [
        { type: Component, args: [{
                    selector: 'rte-spinner',
                    template: "<div class=\"rte-spinner-container\">\r\n  <mat-spinner></mat-spinner>\r\n</div>\r\n",
                    styles: [".rte-spinner-container{width:100%;text-align:center;position:fixed;z-index:1000;background-color:rgba(90,90,90,.5);height:100%}.rte-spinner-container .mat-spinner{display:inline-block;top:40%}:host-context(.rte-dialog) .rte-spinner-container{margin:-24px;width:inherit;text-align:center;position:fixed;z-index:1000;background-color:rgba(90,90,90,.5);height:inherit}"]
                }] }
    ];
    /** @nocollapse */
    SpinnerComponent.ctorParameters = function () { return [
        { type: ElementRef }
    ]; };
    return SpinnerComponent;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var RteSpinnerModule = /** @class */ (function () {
    function RteSpinnerModule() {
    }
    RteSpinnerModule.decorators = [
        { type: NgModule, args: [{
                    declarations: [SpinnerComponent],
                    exports: [SpinnerComponent],
                    imports: [
                        CommonModule,
                        MatProgressSpinnerModule
                    ]
                },] }
    ];
    return RteSpinnerModule;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
var BUTTON_HOST_ATTRIBUTES$1 = [
    'rtenavbutton'
];
var RteNavbuttonComponent = /** @class */ (function (_super) {
    __extends(RteNavbuttonComponent, _super);
    function RteNavbuttonComponent(elementRef, platform, focusMonitor, rteColorService, animationMode) {
        var e_1, _a;
        var _this = _super.call(this, elementRef, platform, focusMonitor) || this;
        _this.rteColorService = rteColorService;
        _this.attrMap = new Map();
        _this._createAttributeMap();
        try {
            for (var BUTTON_HOST_ATTRIBUTES_1 = __values(BUTTON_HOST_ATTRIBUTES$1), BUTTON_HOST_ATTRIBUTES_1_1 = BUTTON_HOST_ATTRIBUTES_1.next(); !BUTTON_HOST_ATTRIBUTES_1_1.done; BUTTON_HOST_ATTRIBUTES_1_1 = BUTTON_HOST_ATTRIBUTES_1.next()) {
                var attr = BUTTON_HOST_ATTRIBUTES_1_1.value;
                if (_this._hasHostAttributes(attr)) {
                    ((/** @type {?} */ (elementRef.nativeElement))).classList.add(_this.attrMap.get(attr));
                }
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (BUTTON_HOST_ATTRIBUTES_1_1 && !BUTTON_HOST_ATTRIBUTES_1_1.done && (_a = BUTTON_HOST_ATTRIBUTES_1.return)) _a.call(BUTTON_HOST_ATTRIBUTES_1);
            }
            finally { if (e_1) throw e_1.error; }
        }
        return _this;
    }
    /**
     * @return {?}
     */
    RteNavbuttonComponent.prototype._createAttributeMap = /**
     * @return {?}
     */
    function () {
        this.attrMap.set('rtenavbutton', 'mat-button');
    };
    RteNavbuttonComponent.decorators = [
        { type: Component, args: [{
                    selector: 'button[rtenavbutton]',
                    exportAs: 'rteNavButton',
                    template: "\r\n  <span class=\"mat-button-wrapper\" >\r\n    <ng-content></ng-content>\r\n  </span>\r\n  <div matRipple class=\"mat-button-ripple\"\r\n     [class.mat-button-ripple-round]=\"isRoundButton || isIconButton\"\r\n     [matRippleDisabled]=\"_isRippleDisabled()\"\r\n     [matRippleCentered]=\"isIconButton\"\r\n     [matRippleTrigger]=\"_getHostElement()\"></div>\r\n  <div class=\"mat-button-focus-overlay\"></div>",
                    host: {
                        '[disabled]': 'disabled || null',
                        '[class._mat-animation-noopable]': '_animationMode === "NoopAnimations"',
                        '(mouseenter)': 'rteColorService.getHoverMenuColor(true, _elementRef)',
                        '(mouseleave)': 'rteColorService.getHoverMenuColor(false, _elementRef)'
                    },
                    inputs: ['disabled', 'disableRipple', 'color'],
                    encapsulation: ViewEncapsulation.None,
                    changeDetection: ChangeDetectionStrategy.OnPush,
                    styles: [".mat-button,.mat-icon-button{box-sizing:border-box;position:relative;-webkit-user-select:none;-moz-user-select:none;user-select:none;cursor:pointer;outline:0;border:none;-webkit-tap-highlight-color:transparent;display:inline-block;white-space:nowrap;text-decoration:none;vertical-align:baseline;text-align:center;margin:0;min-width:88px;line-height:36px;padding:0 16px;border-radius:2px;overflow:visible}.mat-button[disabled],.mat-icon-button[disabled]{cursor:default}.mat-button.cdk-keyboard-focused .mat-button-focus-overlay,.mat-button.cdk-program-focused .mat-button-focus-overlay,.mat-icon-button.cdk-keyboard-focused .mat-button-focus-overlay,.mat-icon-button.cdk-program-focused .mat-button-focus-overlay{opacity:1}.mat-button::-moz-focus-inner{border:0}.mat-button .mat-button-focus-overlay,.mat-icon-button .mat-button-focus-overlay{transition:none;opacity:0}.mat-button-focus-overlay,.mat-button:hover .mat-button-focus-overlay{opacity:1}.mat-fab{box-sizing:border-box;position:relative;-webkit-user-select:none;-moz-user-select:none;user-select:none;cursor:pointer;outline:0;border:none;-webkit-tap-highlight-color:transparent;display:inline-block;white-space:nowrap;text-decoration:none;vertical-align:baseline;text-align:center;margin:0;min-width:88px;line-height:36px;padding:0;border-radius:50%;overflow:visible;transform:translate3d(0,0,0);transition:background .4s cubic-bezier(.25,.8,.25,1),box-shadow 280ms cubic-bezier(.4,0,.2,1);min-width:0;width:56px;height:56px;flex-shrink:0}.mat-fab.cdk-keyboard-focused .mat-button-focus-overlay,.mat-fab.cdk-program-focused .mat-button-focus-overlay{opacity:1}.mat-fab::-moz-focus-inner{border:0}.mat-fab:not([class*=mat-elevation-z]){box-shadow:0 3px 1px -2px rgba(0,0,0,.2),0 2px 2px 0 rgba(0,0,0,.14),0 1px 5px 0 rgba(0,0,0,.12)}.mat-fab:not([disabled]):active:not([class*=mat-elevation-z]){box-shadow:0 5px 5px -3px rgba(0,0,0,.2),0 8px 10px 1px rgba(0,0,0,.14),0 3px 14px 2px rgba(0,0,0,.12);box-shadow:0 7px 8px -4px rgba(0,0,0,.2),0 12px 17px 2px rgba(0,0,0,.14),0 5px 22px 4px rgba(0,0,0,.12)}.mat-fab[disabled]{cursor:default;box-shadow:none}.mat-fab:not([class*=mat-elevation-z]){box-shadow:0 3px 5px -1px rgba(0,0,0,.2),0 6px 10px 0 rgba(0,0,0,.14),0 1px 18px 0 rgba(0,0,0,.12)}.mat-fab .mat-button-wrapper{padding:16px 0;display:inline-block;line-height:24px}.mat-mini-fab{box-sizing:border-box;position:relative;-webkit-user-select:none;-moz-user-select:none;user-select:none;cursor:pointer;outline:0;border:none;-webkit-tap-highlight-color:transparent;display:inline-block;white-space:nowrap;text-decoration:none;vertical-align:baseline;text-align:center;margin:0;min-width:88px;line-height:36px;padding:0;border-radius:50%;overflow:visible;transform:translate3d(0,0,0);transition:background .4s cubic-bezier(.25,.8,.25,1),box-shadow 280ms cubic-bezier(.4,0,.2,1);min-width:0;width:40px;height:40px;flex-shrink:0}.mat-mini-fab.cdk-keyboard-focused .mat-button-focus-overlay,.mat-mini-fab.cdk-program-focused .mat-button-focus-overlay{opacity:1}.mat-mini-fab::-moz-focus-inner{border:0}.mat-mini-fab:not([class*=mat-elevation-z]){box-shadow:0 3px 1px -2px rgba(0,0,0,.2),0 2px 2px 0 rgba(0,0,0,.14),0 1px 5px 0 rgba(0,0,0,.12)}.mat-mini-fab:not([disabled]):active:not([class*=mat-elevation-z]){box-shadow:0 5px 5px -3px rgba(0,0,0,.2),0 8px 10px 1px rgba(0,0,0,.14),0 3px 14px 2px rgba(0,0,0,.12);box-shadow:0 7px 8px -4px rgba(0,0,0,.2),0 12px 17px 2px rgba(0,0,0,.14),0 5px 22px 4px rgba(0,0,0,.12)}.mat-mini-fab[disabled]{cursor:default;box-shadow:none}.mat-mini-fab:not([class*=mat-elevation-z]){box-shadow:0 3px 5px -1px rgba(0,0,0,.2),0 6px 10px 0 rgba(0,0,0,.14),0 1px 18px 0 rgba(0,0,0,.12)}.mat-mini-fab .mat-button-wrapper{padding:8px 0;display:inline-block;line-height:24px}.mat-icon-button{padding:0;min-width:0;width:40px;height:40px;flex-shrink:0;line-height:40px;border-radius:50%}.mat-icon-button .mat-icon,.mat-icon-button i{line-height:24px}.mat-button-focus-overlay,.mat-button-ripple{top:0;left:0;right:0;bottom:0;position:absolute;pointer-events:none;border-radius:inherit}.mat-button-focus-overlay{background-color:rgba(0,0,0,.12);border-radius:inherit;opacity:0;transition:opacity .2s cubic-bezier(.35,0,.25,1),background-color .2s cubic-bezier(.35,0,.25,1)}.mat-button-ripple-round{border-radius:50%;z-index:1}.mat-button .mat-button-wrapper>*{vertical-align:middle}.mat-form-field:not(.mat-form-field-appearance-legacy) .mat-form-field-prefix .mat-icon-button,.mat-form-field:not(.mat-form-field-appearance-legacy) .mat-form-field-suffix .mat-icon-button{display:block;font-size:inherit;width:2.5em;height:2.5em}@media screen and (-ms-high-contrast:active){.mat-button-focus-overlay{background-color:rgba(255,255,255,.5)}.mat-button,.mat-fab,.mat-flat-button,.mat-icon-button,.mat-mini-fab,.mat-raised-button{outline:solid 1px}}"]
                }] }
    ];
    /** @nocollapse */
    RteNavbuttonComponent.ctorParameters = function () { return [
        { type: ElementRef },
        { type: Platform },
        { type: FocusMonitor },
        { type: undefined, decorators: [{ type: Inject, args: [RTE_COLOR_SERVICE_DATA,] }] },
        { type: String, decorators: [{ type: Optional }, { type: Inject, args: [ANIMATION_MODULE_TYPE,] }] }
    ]; };
    return RteNavbuttonComponent;
}(MatButton));

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
var EXPORTED_DECLARATIONS = [
    RteInputComponent,
    RteFormFieldComponent,
    RteSelectComponent,
    RteCheckboxComponent,
    RteOptionComponent,
    RteTableComponent,
    RteIconComponent,
    RteMatAutocompleteComponent,
    RteMatAutocompleteTrigger,
    RteButtonComponent,
    RteCellDefDirective,
    RteColumnDefDirective,
    RteCellDirective,
    RteHeaderCellDirective,
    RteHeaderCellDefDirective,
    RteRowComponent,
    RteRowDefDirective,
    RteHeaderRowComponent,
    RteHeaderRowDefDirective,
    RteCardComponent,
    RteDividerComponent,
    RteChipDirective,
    RteChipInputDirective,
    RteChipListComponent,
    RteChipRemoveDirective,
    RteTooltipComponent,
    RteTooltipDirective,
    RteRadioGroupDirective,
    RteRadioButtonComponent,
    RteDatepickerToggle,
    RteDatepickerComponent,
    RteDatepickerInput,
    RteDialogActionsDirective,
    RteDialogCloseDirective,
    RteDialogContainer,
    RteDialogContentDirective,
    RteDialogTitleDirective,
    RtePaginatorComponent,
    RteBadgeDirective,
    RteProgressBarComponent,
    RteMenuContentDirective,
    RteMenuItemComponent,
    RteMenuTriggerDirective,
    _RteMatMenu,
    RteErrorDirective,
    RteSortHeader,
    RteSortDirective,
    RteAccordionDirective,
    RteExpansionPanelActionRowDirective,
    RteExpansionPanelHeaderComponent,
    RteExpansionPanelComponent,
    RteExpansionPanelDescriptionDirective,
    RteExpansionPanelTitleDirective,
    RteSliderComponent,
    RteNavbuttonComponent,
    SafeStylePipe
];
var ɵ0$1 = MAT_MOMENT_DATE_FORMATS, ɵ1 = { useUtc: true };
var RteMaterialModule = /** @class */ (function () {
    function RteMaterialModule() {
    }
    RteMaterialModule.decorators = [
        { type: NgModule, args: [{
                    imports: [
                        CommonModule,
                        FormsModule,
                        BrowserAnimationsModule,
                        ReactiveFormsModule,
                        OverlayModule,
                        MatRippleModule,
                        MatCheckboxModule,
                        MatSelectModule,
                        MatOptionModule,
                        MatListModule,
                        MatTableModule,
                        MatIconModule,
                        MatAutocompleteModule,
                        MatFormFieldModule,
                        MatInputModule,
                        MatProgressSpinnerModule,
                        MatToolbarModule,
                        MatDialogModule,
                        MatCardModule,
                        CdkTableModule,
                        MatDividerModule,
                        MatChipsModule,
                        MatTooltipModule,
                        MatMenuModule,
                        MatSortModule,
                        PortalModule,
                        RteSpinnerModule,
                        MatButtonToggleModule
                    ],
                    declarations: EXPORTED_DECLARATIONS,
                    exports: EXPORTED_DECLARATIONS,
                    entryComponents: [RteTooltipComponent, RteDialogContainer],
                    providers: [RteDialog,
                        { provide: MAT_DATE_LOCALE, useValue: 'pt-BR' },
                        { provide: MAT_DATE_FORMATS, useValue: ɵ0$1 },
                        { provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS] },
                        { provide: MAT_MOMENT_DATE_ADAPTER_OPTIONS, useValue: ɵ1 }]
                },] }
    ];
    return RteMaterialModule;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var RteCurrencyPipe = /** @class */ (function (_super) {
    __extends(RteCurrencyPipe, _super);
    function RteCurrencyPipe(appService) {
        var _this = _super.call(this, appService.locale) || this;
        _this.appService = appService;
        return _this;
    }
    /**
     * @param {?} value
     * @param {?=} display
     * @param {?=} digitsInfo
     * @return {?}
     */
    RteCurrencyPipe.prototype.transform = /**
     * @param {?} value
     * @param {?=} display
     * @param {?=} digitsInfo
     * @return {?}
     */
    function (value, display, digitsInfo) {
        return _super.prototype.transform.call(this, value, this.appService.currencyCode, display, digitsInfo, this.appService.locale);
    };
    RteCurrencyPipe.decorators = [
        { type: Injectable },
        { type: Pipe, args: [{ name: 'rteCurrency' },] }
    ];
    /** @nocollapse */
    RteCurrencyPipe.ctorParameters = function () { return [
        { type: AppService }
    ]; };
    return RteCurrencyPipe;
}(CurrencyPipe));

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var RteDatePipe = /** @class */ (function (_super) {
    __extends(RteDatePipe, _super);
    function RteDatePipe(appService) {
        var _this = _super.call(this, appService.locale) || this;
        _this.appService = appService;
        return _this;
    }
    /**
     * @param {?} value
     * @param {?=} format
     * @param {?=} timezone
     * @return {?}
     */
    RteDatePipe.prototype.transform = /**
     * @param {?} value
     * @param {?=} format
     * @param {?=} timezone
     * @return {?}
     */
    function (value, format, timezone) {
        return _super.prototype.transform.call(this, value, format, timezone, this.appService.locale);
    };
    RteDatePipe.decorators = [
        { type: Injectable },
        { type: Pipe, args: [{ name: 'rteDate' },] }
    ];
    /** @nocollapse */
    RteDatePipe.ctorParameters = function () { return [
        { type: AppService }
    ]; };
    return RteDatePipe;
}(DatePipe));

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var RtePercentPipe = /** @class */ (function (_super) {
    __extends(RtePercentPipe, _super);
    function RtePercentPipe(appService) {
        var _this = _super.call(this, appService.locale) || this;
        _this.appService = appService;
        return _this;
    }
    /**
     * @param {?} value
     * @param {?=} digitsInfo
     * @return {?}
     */
    RtePercentPipe.prototype.transform = /**
     * @param {?} value
     * @param {?=} digitsInfo
     * @return {?}
     */
    function (value, digitsInfo) {
        return _super.prototype.transform.call(this, value, digitsInfo, this.appService.locale);
    };
    RtePercentPipe.decorators = [
        { type: Injectable },
        { type: Pipe, args: [{ name: 'rtePercent' },] }
    ];
    /** @nocollapse */
    RtePercentPipe.ctorParameters = function () { return [
        { type: AppService }
    ]; };
    return RtePercentPipe;
}(PercentPipe));

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var RteLibraryModule = /** @class */ (function () {
    function RteLibraryModule() {
    }
    RteLibraryModule.decorators = [
        { type: NgModule, args: [{
                    imports: [CommonModule, MatButtonModule, MatDialogModule, MatProgressSpinnerModule, RteMaterialModule],
                    declarations: [RteLibraryComponent, YesNoDialogComponent, ListButtonsComponent, RteCurrencyPipe, RteDatePipe, RtePercentPipe],
                    exports: [RteLibraryComponent, YesNoDialogComponent, ListButtonsComponent, RteCurrencyPipe, RteDatePipe, RtePercentPipe]
                },] }
    ];
    return RteLibraryModule;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @enum {number} */
var RteToolbarStatusEnum = {
    Searching: 1,
    Viewing: 2,
    Creating: 3,
    Editing: 4,
};
RteToolbarStatusEnum[RteToolbarStatusEnum.Searching] = 'Searching';
RteToolbarStatusEnum[RteToolbarStatusEnum.Viewing] = 'Viewing';
RteToolbarStatusEnum[RteToolbarStatusEnum.Creating] = 'Creating';
RteToolbarStatusEnum[RteToolbarStatusEnum.Editing] = 'Editing';

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @enum {number} */
var RteToolbarModeEnum = {
    Alternate: 1,
    Both: 2,
    SearchOnly: 3,
    EditOnly: 4,
};
RteToolbarModeEnum[RteToolbarModeEnum.Alternate] = 'Alternate';
RteToolbarModeEnum[RteToolbarModeEnum.Both] = 'Both';
RteToolbarModeEnum[RteToolbarModeEnum.SearchOnly] = 'SearchOnly';
RteToolbarModeEnum[RteToolbarModeEnum.EditOnly] = 'EditOnly';

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @template T
 */
var  /**
 * @template T
 */
RteToolbarDataSource = /** @class */ (function (_super) {
    __extends(RteToolbarDataSource, _super);
    function RteToolbarDataSource(initialData) {
        return _super.call(this, initialData) || this;
    }
    return RteToolbarDataSource;
}(MatTableDataSource));

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @template T
 */
var  /**
 * @template T
 */
RteToolbarViewModel = /** @class */ (function () {
    function RteToolbarViewModel() {
        this.dataSource = new RteToolbarDataSource([]);
        this.selectionModel = new SelectionModel(false, []);
        this.insertModeButton = false;
        this.firstModeButton = true;
        this.editModeButton = false;
        this.browserModeButton = false;
        this.readonlyFirstMode = true;
        this.readonlyInsertMode = false;
        this.readonlyBrowserMode = false;
        this.readonlyEditMode = false;
        this.currentStatus = RteToolbarStatusEnum.Searching;
        this.mode = RteToolbarModeEnum.Alternate;
        this.pageSize = 10;
        this.possibleStatus = RteToolbarStatusEnum;
        this.isFixedToolbar = true;
        this.searchObjectName = 'Filter';
        this.insertObjectName = 'Insert';
        this.updateObjectName = 'Update';
        this.deleteObjectName = 'Delete';
        this.webAPIPrefixName = 'webapi/';
    }
    /**
     * @param {?} newCurrent
     * @param {?=} fromToolbarComponent
     * @return {?}
     */
    RteToolbarViewModel.prototype.setCurrent = /**
     * @param {?} newCurrent
     * @param {?=} fromToolbarComponent
     * @return {?}
     */
    function (newCurrent, fromToolbarComponent) {
        if (fromToolbarComponent === void 0) { fromToolbarComponent = false; }
        this.current = newCurrent;
        if (this.selectionModel.isSelected(newCurrent) == false) {
            this.selectionModel.toggle(newCurrent);
            if (fromToolbarComponent == false) {
                this.toolbarComponent.setCurrent(newCurrent);
            }
        }
    };
    /**
     * @param {?} newCurrent
     * @return {?}
     */
    RteToolbarViewModel.prototype.viewMode = /**
     * @param {?} newCurrent
     * @return {?}
     */
    function (newCurrent) {
        this.current = newCurrent;
        if (this.selectionModel.isSelected(newCurrent) == false) {
            this.selectionModel.toggle(newCurrent);
        }
        this.toolbarComponent.toolbarPagination.currentRegister
            = this.toolbarComponent.toolbarPagination.page * this.toolbarComponent.toolbarObject.pageSize + this.toolbarComponent.toolbarPagination.currentIndex + 1;
        this.toolbarComponent.editMode(true);
        this.toolbarComponent.cancelOperation(true);
    };
    /**
     * @param {?} data
     * @return {?}
     */
    RteToolbarViewModel.prototype.setCurrentDataSource = /**
     * @param {?} data
     * @return {?}
     */
    function (data) {
        this.dataSource.data = data;
    };
    return RteToolbarViewModel;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var ShowButton = /** @class */ (function () {
    function ShowButton() {
        this.firstRegister = true;
        this.prevRegister = true;
        this.nextRegister = true;
        this.lastRegister = true;
        this.cleanSearch = true;
        this.insert = true;
        this.edit = true;
        this.search = true;
        this.cancel = true;
        this.save = true;
        this.cancelSave = true;
        this.delete = true;
        this.close = true;
        this.cancelEdit = false;
        this.rteSeparator = true;
        this.rteHistory = false;
        this.forceShowRteHistory = false;
    }
    return ShowButton;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var BeforeSave = /** @class */ (function () {
    function BeforeSave() {
        this.cancelSave = false;
    }
    return BeforeSave;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var AfterSave = /** @class */ (function () {
    function AfterSave() {
    }
    return AfterSave;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var BeforeDelete = /** @class */ (function () {
    function BeforeDelete() {
        this.cancelDelete = false;
        this.willOpenModal = true;
    }
    return BeforeDelete;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var AfterGet = /** @class */ (function () {
    function AfterGet() {
        this.success = true;
    }
    return AfterGet;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var BeforeGet = /** @class */ (function () {
    function BeforeGet() {
        this.cancelGet = false;
    }
    return BeforeGet;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var RteToolbarPagination = /** @class */ (function () {
    function RteToolbarPagination() {
        this.totalPage = 0;
        this.auxPage = 0;
        this.page = 0;
        this.hasMorePages = false;
        this.totalRegisters = 0;
        this.currentIndex = -1;
        this.currentRegister = 0;
    }
    return RteToolbarPagination;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var ToolbarBaseComponent = /** @class */ (function () {
    function ToolbarBaseComponent() {
        this.showPagination = true;
        this.toolbarPagination = new RteToolbarPagination();
        this.registerFieldWidth = '10px';
        this.toolbarPagination.page = 0;
        this.toolbarPagination.hasMorePages = true;
        this.toolbarPagination.totalPage = 0;
        this.toolbarPagination.auxPage = 0;
    }
    /**
     * @return {?}
     */
    ToolbarBaseComponent.prototype.getCurrentModeDescription = /**
     * @return {?}
     */
    function () {
        switch (this.toolbarObject.currentStatus) {
            case RteToolbarStatusEnum.Creating:
                return 'EM INCLUSÃO';
            case RteToolbarStatusEnum.Editing:
                return 'EM EDIÇÃO';
            case RteToolbarStatusEnum.Searching:
                return 'EM PESQUISA';
            case RteToolbarStatusEnum.Viewing:
                return 'EM VISUALIZAÇÃO';
            default:
                return 'EM PESQUISA';
        }
    };
    /**
     * @param {?} newCurrent
     * @return {?}
     */
    ToolbarBaseComponent.prototype.setCurrent = /**
     * @param {?} newCurrent
     * @return {?}
     */
    function (newCurrent) {
        for (var i = 0; i < this.toolbarObject.dataSource.data.length; i++) {
            if (this.toolbarObject.dataSource.data[i] == newCurrent) {
                this.toolbarPagination.currentIndex = i;
                break;
            }
        }
        this.toolbarPagination.currentRegister = this.toolbarPagination.page * this.toolbarObject.pageSize
            + this.toolbarPagination.currentIndex + 1;
    };
    /**
     * @param {?=} option
     * @return {?}
     */
    ToolbarBaseComponent.prototype.cancelOperation = /**
     * @param {?=} option
     * @return {?}
     */
    function (option) {
        if (option === void 0) { option = true; }
    };
    /**
     * @param {?} fromNavigation
     * @param {?=} wasCreating
     * @param {?=} fromSearching
     * @param {?=} firstOrLast
     * @return {?}
     */
    ToolbarBaseComponent.prototype.get = /**
     * @param {?} fromNavigation
     * @param {?=} wasCreating
     * @param {?=} fromSearching
     * @param {?=} firstOrLast
     * @return {?}
     */
    function (fromNavigation, wasCreating, fromSearching, firstOrLast) {
        if (wasCreating === void 0) { wasCreating = false; }
        if (fromSearching === void 0) { fromSearching = false; }
        if (firstOrLast === void 0) { firstOrLast = 0; }
    };
    /**
     * @param {?} option
     * @return {?}
     */
    ToolbarBaseComponent.prototype.editMode = /**
     * @param {?} option
     * @return {?}
     */
    function (option) { };
    /**
     * @return {?}
     */
    ToolbarBaseComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
    };
    ToolbarBaseComponent.decorators = [
        { type: Component, args: [{
                    selector: 'rte-toolbar-base',
                    template: "",
                    styles: [".rte-icon{padding:0;margin-left:1px}.rte-icon-arrows{min-width:0;padding:0}.rte-spacer{flex:1 1 auto}.rte-mat-vertical_line{height:40px!important}.rte-app-actions{text-align:right;padding-top:0}button rte-icon{margin-top:-3px;vertical-align:middle}button rte-icon.edit-icon{margin-top:-5px}.navigation-button{color:#212121}.navigation-button[disabled]{color:#bdbdbd}.toolbar-navigation-buttons{margin-left:13px}.register-input{width:10px;position:relative;border-bottom:1px solid #000;font:400 14px/34px Roboto,\"Helvetica Neue\",sans-serif;border:1px solid #757575;border-radius:4px;height:24px;top:-4.8px;text-align:center;padding-left:5px;padding-right:5px;margin-right:2px}.navigation-button rte-icon{margin-top:-2px}.mat-button-toggle-checked{background-color:inherit!important}"]
                }] }
    ];
    /** @nocollapse */
    ToolbarBaseComponent.ctorParameters = function () { return []; };
    ToolbarBaseComponent.propDecorators = {
        toolbarObject: [{ type: Input }],
        showPagination: [{ type: Input }]
    };
    return ToolbarBaseComponent;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var ApplicationSettingsService = /** @class */ (function () {
    function ApplicationSettingsService(http, environment) {
        this.http = http;
        this.environment = environment;
    }
    /**
     * @param {?} applicationSettingsRequest
     * @return {?}
     */
    ApplicationSettingsService.prototype.getApplicationSettings = /**
     * @param {?} applicationSettingsRequest
     * @return {?}
     */
    function (applicationSettingsRequest) {
        return this.http.post(this.environment.apiCore + 'api/framework/loadapplication', applicationSettingsRequest);
    };
    ApplicationSettingsService.decorators = [
        { type: Injectable, args: [{
                    providedIn: 'root'
                },] }
    ];
    /** @nocollapse */
    ApplicationSettingsService.ctorParameters = function () { return [
        { type: HttpClient },
        { type: undefined, decorators: [{ type: Inject, args: ['environment',] }] }
    ]; };
    /** @nocollapse */ ApplicationSettingsService.ngInjectableDef = defineInjectable({ factory: function ApplicationSettingsService_Factory() { return new ApplicationSettingsService(inject(HttpClient), inject("environment")); }, token: ApplicationSettingsService, providedIn: "root" });
    return ApplicationSettingsService;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var LoadApplicationSettingsRequest = /** @class */ (function () {
    function LoadApplicationSettingsRequest() {
    }
    return LoadApplicationSettingsRequest;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var ToolbarLiteComponent = /** @class */ (function () {
    function ToolbarLiteComponent() {
        this.showRteSeparator = true;
        this.rteSeparatorColor = '#eee';
        this.titleColor = '#757575';
        this.isMain = true;
        this.close = new EventEmitter();
        this.leftPadding = '44px';
        this.rightPadding = '44px';
        this.isFixedToolbar = true;
        this.showTitle = true;
        this.showRteDivider = true;
    }
    /**
     * @return {?}
     */
    ToolbarLiteComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        this.calculatePadding();
    };
    /**
     * @return {?}
     */
    ToolbarLiteComponent.prototype.onClose = /**
     * @return {?}
     */
    function () {
        this.close.emit();
    };
    /**
     * @return {?}
     */
    ToolbarLiteComponent.prototype.calculatePadding = /**
     * @return {?}
     */
    function () {
        if (this.isFixedToolbar === true) {
            /** @type {?} */
            var divsWrapper = document.getElementsByClassName('wrapper');
            /** @type {?} */
            var paddingWrapper = 0;
            for (var index = 0; index < divsWrapper.length; index++) {
                /** @type {?} */
                var element = divsWrapper[index];
                if (element instanceof HTMLElement) {
                    if (element.offsetLeft > 0) {
                        paddingWrapper = element.offsetLeft;
                    }
                }
            }
            if (paddingWrapper > 0) {
                this.leftPadding = this.rightPadding = paddingWrapper.toString() + 'px';
            }
            else if (window.innerWidth > 1200) {
                /** @type {?} */
                var padding = ((window.innerWidth - 18 - 1200) / 2 + 5);
                if (padding <= 30) {
                    this.leftPadding = this.rightPadding = '30px';
                }
                else {
                    this.leftPadding = this.rightPadding = padding + 'px';
                }
            }
            else {
                this.leftPadding = '30px';
                this.rightPadding = '30px';
            }
        }
        else {
            this.leftPadding = '15px';
            this.rightPadding = '15px';
        }
    };
    /**
     * @param {?} event
     * @return {?}
     */
    ToolbarLiteComponent.prototype.onScroll = /**
     * @param {?} event
     * @return {?}
     */
    function (event) {
        if (this.isFixedToolbar == true) {
            /** @type {?} */
            var scrollTop = event.currentTarget.document.children[0].scrollTop;
            if (scrollTop == 0 && document.body != null) {
                scrollTop = document.body.scrollTop;
            }
            if (scrollTop >= 90) {
                this.matToolbar._elementRef.nativeElement.style.top = '0px';
            }
            else {
                this.matToolbar._elementRef.nativeElement.style.top = (90 - scrollTop) + 'px';
            }
        }
        else {
            this.matToolbar._elementRef.nativeElement.style.top = '0px';
        }
    };
    /**
     * @param {?} event
     * @return {?}
     */
    ToolbarLiteComponent.prototype.onResize = /**
     * @param {?} event
     * @return {?}
     */
    function (event) {
        this.calculatePadding();
    };
    ToolbarLiteComponent.decorators = [
        { type: Component, args: [{
                    selector: 'rte-toolbar-lite',
                    template: "<mat-toolbar [style.padding-left]=\"leftPadding\" [style.padding-right]=\"rightPadding\" [class.fixed-toolbar]=\"isFixedToolbar\">\r\n    <ng-content select=\".custom-title\"></ng-content>\r\n    <span [class.mat-button]=\"isMain\" [class.mat-h4]=\"!isMain\" [style.color]=\"titleColor\" class=\"toolbar-title\" *ngIf=\"showTitle\">{{ title }}</span>\r\n    <div *ngIf=\"showRteSeparator\" class=\"rte-separator-div\" [style.border-color]=\"rteSeparatorColor\">\r\n    </div>\r\n    <ng-content></ng-content>\r\n</mat-toolbar>\r\n<rte-divider *ngIf=\"showRteDivider\"></rte-divider>\r\n",
                    styles: ["mat-toolbar{z-index:99;background-color:#fff;left:0;border-bottom:1px solid #e0e0e0}mat-toolbar.fixed-toolbar{position:fixed!important;top:90px}.mat-button{cursor:auto}.rte-icon{padding:0 2px}.rte-spacer{flex:1 1 auto}.rte-mat-vertical_line{height:40px!important}.rte-separator-div{border-left:2px solid #eee;height:24px;width:1px}.toolbar-title{padding-left:0}"]
                }] }
    ];
    /** @nocollapse */
    ToolbarLiteComponent.ctorParameters = function () { return []; };
    ToolbarLiteComponent.propDecorators = {
        title: [{ type: Input }],
        showCloseButton: [{ type: Input }],
        showRteSeparator: [{ type: Input }],
        rteSeparatorColor: [{ type: Input }],
        backgroundcolor: [{ type: Input }],
        titleColor: [{ type: Input }],
        isMain: [{ type: Input }],
        close: [{ type: Output }],
        matToolbar: [{ type: ViewChild, args: [MatToolbar,] }],
        isFixedToolbar: [{ type: Input }],
        showTitle: [{ type: Input }],
        showRteDivider: [{ type: Input }],
        onScroll: [{ type: HostListener, args: ['window:scroll', ['$event'],] }],
        onResize: [{ type: HostListener, args: ['window:resize', ['$event'],] }]
    };
    return ToolbarLiteComponent;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var ToolbarComponent = /** @class */ (function (_super) {
    __extends(ToolbarComponent, _super);
    function ToolbarComponent(iconRegistry, sanitizer, dialog, tabService, appService, renderer, appSettingsService) {
        var _this = _super.call(this) || this;
        _this.dialog = dialog;
        _this.tabService = tabService;
        _this.appService = appService;
        _this.renderer = renderer;
        _this.appSettingsService = appSettingsService;
        _this.toolbarObject = new RteToolbarViewModel();
        _this.showButton = new ShowButton();
        _this.isFixedToolbar = true;
        _this.logInfos = [];
        _this.showTitle = true;
        _this.validateBeforeSave = new EventEmitter();
        _this.customizeAfterSave = new EventEmitter();
        _this.validateBeforeDelete = new EventEmitter();
        _this.customizeAfterGet = new EventEmitter();
        _this.customizeBeforeGet = new EventEmitter();
        _this.customizeAfterClear = new EventEmitter();
        _this.customizeAfterCancelEdit = new EventEmitter();
        _this.customizeAfterCancelOperation = new EventEmitter();
        _this.customizeAfterInsertMode = new EventEmitter();
        _this.customizeAfterEditMode = new EventEmitter();
        _this.customizeAfterDelete = new EventEmitter();
        _this.customizeAfterOnInit = new EventEmitter();
        _this.insertModeButton = false;
        _this.incrementCurrentPage = true;
        _this.currentModeColor = '#757575';
        iconRegistry.addSvgIcon('vertical_line', sanitizer.bypassSecurityTrustResourceUrl('assets/vertical_line.svg'));
        return _this;
    }
    /**
     * @param {?} event
     * @return {?}
     */
    ToolbarComponent.prototype.hotkeys = /**
     * @param {?} event
     * @return {?}
     */
    function (event) {
        if (event.key === 'F8' &&
            this.firstModeButton === true &&
            this.showButton.search) {
            this.get(false);
            return false;
        }
        if (event.key === 'F7') {
            this.cancelOperation();
            return false;
        }
        if (this.browserModeButton) {
            if (event.key === 'ArrowDown' && this.showButton.prevRegister) {
                this.prev();
                return false;
            }
            if (event.key === 'ArrowUp' && this.showButton.nextRegister) {
                this.next();
                return false;
            }
        }
        if (event.code === 'KeyS' &&
            event.ctrlKey === true &&
            this.insertModeButton === true &&
            this.showButton.save) {
            this.save();
            return false;
        }
    };
    //#region Navegação
    //#region Navegação
    /**
     * @return {?}
     */
    ToolbarComponent.prototype.firstRegister = 
    //#region Navegação
    /**
     * @return {?}
     */
    function () {
        this.incrementCurrentPage = true;
        this.toolbarPagination.currentRegister = 1;
        if (this.toolbarObject.currentStatus == RteToolbarStatusEnum.Searching) {
            this.toolbarPagination.page = 0;
            this.toolbarPagination.currentIndex = 0;
            this.get(true, false, true, 1);
        }
        else {
            this.toolbarPagination.currentIndex = this.toolbarPagination.page = 0;
            this.get(true);
        }
    };
    /**
     * @return {?}
     */
    ToolbarComponent.prototype.prev = /**
     * @return {?}
     */
    function () {
        this.incrementCurrentPage = true;
        this.toolbarPagination.currentRegister--;
        if (this.toolbarObject.currentStatus == RteToolbarStatusEnum.Searching) {
            if (this.toolbarPagination.currentIndex > 0) {
                this.toolbarPagination.currentIndex--;
                this.toolbarObject.setCurrent(this.toolbarObject.dataSource.data[this.toolbarPagination.currentIndex], true);
            }
            else if (this.toolbarPagination.page > 0) {
                this.toolbarPagination.page--;
                this.get(true, false, true);
            }
        }
        else {
            if (this.toolbarPagination.currentIndex > 0) {
                this.toolbarPagination.page = (this.toolbarPagination.currentIndex + this.toolbarPagination.page - 1) - 1;
                this.get(true);
            }
            else if (this.toolbarPagination.page > 0) {
                this.toolbarPagination.page--;
                this.get(true);
            }
        }
    };
    /**
     * @return {?}
     */
    ToolbarComponent.prototype.next = /**
     * @return {?}
     */
    function () {
        this.incrementCurrentPage = true;
        this.toolbarPagination.currentRegister++;
        if (this.toolbarObject.currentStatus == RteToolbarStatusEnum.Searching) {
            if (this.toolbarPagination.currentIndex < (this.toolbarObject.pageSize - 1)) {
                this.toolbarPagination.currentIndex++;
                this.toolbarObject.setCurrent(this.toolbarObject.dataSource.data[this.toolbarPagination.currentIndex], true);
            }
            else {
                this.toolbarPagination.currentIndex++;
                this.toolbarPagination.page++;
                this.get(true, false, true);
            }
        }
        else {
            if (this.toolbarPagination.currentIndex != 0) {
                this.toolbarPagination.page = (this.toolbarPagination.currentIndex + this.toolbarPagination.page - 1) + 1;
                this.get(true);
            }
            else if (this.toolbarPagination.totalRegisters - 1 > this.toolbarPagination.page) {
                this.toolbarPagination.page++;
                this.get(true);
            }
        }
    };
    /**
     * @return {?}
     */
    ToolbarComponent.prototype.lastRegister = /**
     * @return {?}
     */
    function () {
        this.incrementCurrentPage = true;
        this.toolbarPagination.currentRegister = this.toolbarPagination.totalRegisters;
        if (this.toolbarObject.currentStatus == RteToolbarStatusEnum.Searching) {
            this.toolbarPagination.currentIndex = this.toolbarObject.pageSize - 1;
            this.toolbarPagination.page = this.toolbarPagination.totalPage - 1;
            this.get(true, false, true, 2);
        }
        else {
            this.toolbarPagination.page = this.toolbarPagination.currentIndex = this.toolbarPagination.totalRegisters - 1;
            this.get(true);
        }
    };
    /**
     * @return {?}
     */
    ToolbarComponent.prototype.nextAfterDelete = /**
     * @return {?}
     */
    function () {
        this.get(true);
    };
    //#endregion
    //#region Eventos
    //#endregion
    //#region Eventos
    /**
     * @param {?} fromNavigation
     * @param {?=} wasCreating
     * @param {?=} fromSearching
     * @param {?=} firstOrLast
     * @param {?=} fromDelete
     * @return {?}
     */
    ToolbarComponent.prototype.get = 
    //#endregion
    //#region Eventos
    /**
     * @param {?} fromNavigation
     * @param {?=} wasCreating
     * @param {?=} fromSearching
     * @param {?=} firstOrLast
     * @param {?=} fromDelete
     * @return {?}
     */
    function (fromNavigation, wasCreating, fromSearching, firstOrLast, fromDelete) {
        var _this = this;
        if (wasCreating === void 0) { wasCreating = false; }
        if (fromSearching === void 0) { fromSearching = false; }
        if (firstOrLast === void 0) { firstOrLast = 0; }
        if (fromDelete === void 0) { fromDelete = false; }
        /** @type {?} */
        var beforeGet = new BeforeGet();
        this.customizeBeforeGet.emit(beforeGet);
        if (beforeGet.cancelGet) {
            return;
        }
        this.toolbarPagination.auxPage = 1;
        /** @type {?} */
        var afterGet = new AfterGet();
        afterGet.fromNavigation = fromNavigation;
        /** @type {?} */
        var internalCurrentBackup = this.toolbarObject.current;
        if (fromNavigation === false) {
            this.toolbarPagination.page = 0;
            this.currentBackup = this.toolbarObject.current;
        }
        else {
            if (this.currentBackup != null) {
                this.toolbarObject.current = this.currentBackup;
            }
        }
        /** @type {?} */
        var pageSize = this.toolbarObject.pageSize;
        if (wasCreating == false && (this.toolbarObject.currentStatus == RteToolbarStatusEnum.Creating ||
            this.toolbarObject.currentStatus == RteToolbarStatusEnum.Editing ||
            this.toolbarObject.currentStatus == RteToolbarStatusEnum.Viewing)) {
            pageSize = 1;
        }
        this.service
            .get(this.toolbarObject.searchObject == null
            ? this.toolbarObject.current
            : this.toolbarObject.searchObject, this.toolbarPagination.page, pageSize)
            .subscribe(function (result) {
            if (result.hasOwnProperty('Data')) {
                _this.toolbarObject.current =
                    result.Data.length > 0 ? result.Data[0] : _this.currentBackup;
                _this.toolbarPagination.totalPage = result.AmountPages;
                if (result.Data.length === 0) {
                    _this.toolbarObject.dataSource.data = [];
                    if (fromDelete == false) {
                        afterGet.success = false;
                    }
                    else {
                        afterGet.success = true;
                        _this.toolbarPagination.currentRegister = 0;
                    }
                    _this.cancelOperation(false, fromDelete, wasCreating);
                }
                else {
                    _this.toolbarObject.dataSource.data = result.Data;
                    _this.toolbarObject.selectionModel = new SelectionModel(false, [result[0]]);
                }
            }
            else if (result.hasOwnProperty('length')) {
                _this.toolbarObject.current =
                    result.length > 0 ? result[0] : _this.currentBackup;
                _this.toolbarPagination.totalPage =
                    result.length > 0 ? result[0].AmountPages : 0;
                if (result.length === 0) {
                    _this.toolbarObject.dataSource.data = [];
                    afterGet.success = false;
                    _this.cancelOperation(false, fromDelete, wasCreating);
                }
                else {
                    _this.toolbarObject.dataSource.data = result;
                    _this.toolbarObject.selectionModel = new SelectionModel(false, [result[0]]);
                }
            }
            else {
                _this.toolbarObject.current = result ? result : _this.currentBackup;
                _this.toolbarPagination.totalPage = result ? result.AmountPages : 0;
                if (!result) {
                    afterGet.success = false;
                    _this.cancelOperation(false, fromDelete, wasCreating);
                    _this.toolbarObject.dataSource.data = [];
                }
                else {
                    _this.toolbarObject.dataSource.data = result;
                    _this.toolbarObject.selectionModel = new SelectionModel(false, [result[0]]);
                }
            }
            if (wasCreating == true) {
                _this.toolbarObject.current = internalCurrentBackup;
                _this.toolbarObject.current.Revision = 1;
            }
            afterGet.data = result;
            afterGet.fromNavigation = fromNavigation;
            if (afterGet.success) {
                if (fromSearching == true) {
                    _this.browserMode(true);
                    if (result.hasOwnProperty('TotalRegisters')) {
                        _this.toolbarPagination.totalRegisters = result.TotalRegisters;
                        _this.registerFieldWidth = (_this.toolbarPagination.totalRegisters.toString().length * 10) + 'px';
                        _this.customizeAfterGet.emit(afterGet);
                    }
                    else {
                        _this.service
                            .get(_this.toolbarObject.searchObject == null
                            ? _this.toolbarObject.current :
                            _this.toolbarObject.searchObject, 0, 1)
                            .subscribe(function (result) {
                            if (result.hasOwnProperty('Data')) {
                                _this.toolbarPagination.totalRegisters = result.AmountPages;
                            }
                            else {
                                _this.toolbarPagination.totalRegisters = result[0].AmountPages;
                            }
                            _this.registerFieldWidth = (_this.toolbarPagination.totalRegisters.toString().length * 10) + 'px';
                            _this.customizeAfterGet.emit(afterGet);
                        });
                    }
                    if (_this.toolbarPagination.currentIndex == -1) {
                        _this.toolbarPagination.currentIndex = 0;
                        _this.toolbarPagination.currentRegister = 1;
                    }
                    else {
                        if (firstOrLast == 1) {
                            _this.toolbarPagination.currentIndex = 0;
                        }
                        else if (firstOrLast == 2) {
                            _this.toolbarPagination.currentIndex = _this.toolbarObject.pageSize - 1;
                            if (_this.toolbarPagination.currentIndex > _this.toolbarObject.dataSource.data.length - 1) {
                                _this.toolbarPagination.currentIndex = _this.toolbarObject.dataSource.data.length - 1;
                            }
                        }
                        else if (firstOrLast != -1) {
                            if (_this.toolbarPagination.currentIndex == 0) {
                                _this.toolbarPagination.currentIndex = _this.toolbarObject.pageSize - 1;
                            }
                            else {
                                _this.toolbarPagination.currentIndex = 0;
                            }
                        }
                    }
                    _this.toolbarObject.setCurrent(_this.toolbarObject.dataSource.data[_this.toolbarPagination.currentIndex], true);
                }
                else {
                    _this.toolbarPagination.totalRegisters = _this.toolbarPagination.totalPage;
                    _this.registerFieldWidth = (_this.toolbarPagination.totalRegisters.toString().length * 10) + 'px';
                    _this.toolbarPagination.currentIndex = 0;
                    _this.toolbarObject.setCurrent(_this.toolbarObject.dataSource.data[_this.toolbarPagination.currentIndex], true);
                    _this.customizeAfterGet.emit(afterGet);
                }
            }
            else {
                _this.toolbarPagination.totalRegisters = 0;
                _this.registerFieldWidth = '10px';
                _this.customizeAfterGet.emit(afterGet);
            }
        });
    };
    /**
     * @return {?}
     */
    ToolbarComponent.prototype.save = /**
     * @return {?}
     */
    function () {
        return __awaiter(this, void 0, void 0, function () {
            var beforeSave, afterSave, wasCreating;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        beforeSave = new BeforeSave();
                        afterSave = new AfterSave();
                        wasCreating = this.toolbarObject.currentStatus === RteToolbarStatusEnum.Creating;
                        return [4 /*yield*/, this.validateBeforeSave.emit(beforeSave)];
                    case 1:
                        _a.sent();
                        if (beforeSave.cancelSave === false) {
                            this.service.save(this.toolbarObject.current).subscribe(function (data) {
                                afterSave.success = false;
                                if (data > 0) {
                                    afterSave.success = true;
                                    afterSave.newId = data;
                                    afterSave.oldId = _this.toolbarObject.current.Id;
                                    _this.toolbarObject.current.Id = wasCreating === true ? data : _this.toolbarObject.current.Id;
                                }
                                if (data.hasOwnProperty('Id')) {
                                    afterSave.success = true;
                                    afterSave.newId = data.Id;
                                    afterSave.oldId = _this.toolbarObject.current.Id;
                                    _this.toolbarObject.current.Id = wasCreating === true ? data.Id : _this.toolbarObject.current.Id;
                                }
                                if (afterSave.success) {
                                    if (afterSave.oldId == null || afterSave.oldId === -1) {
                                        _this.toolbarPagination.totalPage = data.toString.length > 0 ? 1 : 0;
                                        _this.toolbarPagination.auxPage = 1;
                                    }
                                    if (wasCreating === true) {
                                        //this.insertMode(true);
                                        _this.toolbarPagination.currentRegister = _this.toolbarPagination.totalRegisters + 1;
                                        _this.toolbarObject.current.Revision = 1;
                                        _this.backToGrid();
                                    }
                                    else {
                                        if (data.hasOwnProperty('Revision')) {
                                            _this.toolbarObject.current.Revision = data.Revision;
                                        }
                                        _this.checkState(false);
                                        _this.cancelOperation(true, false, wasCreating);
                                    }
                                }
                                _this.customizeAfterSave.emit(afterSave);
                            });
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * @return {?}
     */
    ToolbarComponent.prototype.delete = /**
     * @return {?}
     */
    function () {
        var _this = this;
        /** @type {?} */
        var beforeDelete = new BeforeDelete();
        this.validateBeforeDelete.emit(beforeDelete);
        if (beforeDelete.cancelDelete === false) {
            this.service.delete(this.toolbarObject.current).subscribe(function (data) {
                if (data) {
                    if (_this.toolbarPagination.currentRegister > 1) {
                        _this.prev();
                        _this.get(true);
                    }
                    else if (_this.toolbarPagination.currentRegister == 1 &&
                        _this.toolbarPagination.totalRegisters > 1) {
                        _this.get(true);
                    }
                    else {
                        _this.toolbarPagination.currentRegister = 1;
                        _this.backToGrid(true);
                    }
                }
                _this.customizeAfterDelete.emit(data);
            });
        }
    };
    /**
     * @return {?}
     */
    ToolbarComponent.prototype.clear = /**
     * @return {?}
     */
    function () {
        this.toolbarPagination.page = 0;
        this.toolbarPagination.totalPage = 0;
        this.toolbarPagination.auxPage = 0;
        this.toolbarPagination.totalRegisters = 0;
        this.registerFieldWidth = '10px';
        this.toolbarPagination.currentIndex = -1;
        this.toolbarPagination.currentRegister = 0;
        this.service.clear(this.toolbarObject.current);
        this.customizeAfterClear.emit();
    };
    /**
     * @param {?=} option
     * @param {?=} fromDelete
     * @param {?=} wasCreating
     * @param {?=} fromClear
     * @return {?}
     */
    ToolbarComponent.prototype.cancelOperation = /**
     * @param {?=} option
     * @param {?=} fromDelete
     * @param {?=} wasCreating
     * @param {?=} fromClear
     * @return {?}
     */
    function (option, fromDelete, wasCreating, fromClear) {
        var _this = this;
        if (option === void 0) { option = true; }
        if (fromDelete === void 0) { fromDelete = false; }
        if (wasCreating === void 0) { wasCreating = false; }
        if (fromClear === void 0) { fromClear = false; }
        /** @type {?} */
        var dontClearDataSource = this.toolbarObject.dataSource != null &&
            this.toolbarObject.dataSource.data != null &&
            this.toolbarObject.dataSource.data.length > 0 &&
            this.toolbarObject.currentStatus == RteToolbarStatusEnum.Creating;
        if (this.editModeButton || dontClearDataSource) {
            if (this.editModeButton) {
                this.checkState(true);
                this.toolbarObject.currentStatus = RteToolbarStatusEnum.Viewing;
                this.toolbarObject.readonlyBrowserMode = true;
                setTimeout(function () {
                    _this.toolbarLite.calculatePadding();
                }, 100);
            }
            else {
                if (this.toolbarObject.currentStatus == RteToolbarStatusEnum.Creating) {
                    this.firstMode(true);
                    this.browserMode(false);
                    this.insertMode(false);
                    this.editMode(false);
                    this.clear();
                    this.toolbarObject.dataSource.data = [];
                    if (this.toolbarObject.searchObject != null) {
                        this.toolbarObject.searchObject = {};
                    }
                    this.toolbarObject.currentStatus = RteToolbarStatusEnum.Searching;
                    this.editModeButton = false;
                    setTimeout(function () {
                        _this.toolbarLite.calculatePadding();
                    }, 100);
                }
                else {
                    this.toolbarPagination.totalPage++;
                    this.lastRegister();
                    this.toolbarObject.currentStatus = RteToolbarStatusEnum.Viewing;
                    this.toolbarObject.readonlyBrowserMode = true;
                    this.editModeButton = true;
                    setTimeout(function () {
                        _this.toolbarLite.calculatePadding();
                    }, 100);
                }
            }
        }
        else {
            if (this.toolbarObject.currentStatus == RteToolbarStatusEnum.Creating || wasCreating == true || fromClear == true) {
                this.firstMode(true);
                this.browserMode(false);
                this.insertMode(false);
                this.editMode(false);
                if (option) {
                    this.clear();
                    if (dontClearDataSource == false) {
                        this.toolbarObject.dataSource.data = [];
                        if (this.toolbarObject.searchObject != null) {
                            this.toolbarObject.searchObject = {};
                        }
                        this.toolbarObject.currentStatus = RteToolbarStatusEnum.Searching;
                        setTimeout(function () {
                            _this.toolbarLite.calculatePadding();
                        }, 100);
                    }
                    else {
                        this.toolbarObject.current = this.toolbarObject.dataSource.data[0];
                    }
                }
            }
            else if (fromDelete == false && this.currentOld != null && this.toolbarObject.currentStatus != RteToolbarStatusEnum.Searching) {
                this.checkState(true);
                this.toolbarObject.currentStatus = RteToolbarStatusEnum.Viewing;
                this.toolbarObject.readonlyBrowserMode = true;
                this.editModeButton = true;
                setTimeout(function () {
                    _this.toolbarLite.calculatePadding();
                }, 100);
            }
        }
        this.customizeAfterCancelOperation.emit(option);
    };
    /**
     * @return {?}
     */
    ToolbarComponent.prototype.cancelEdit = /**
     * @return {?}
     */
    function () {
        this.get(false);
        this.customizeAfterCancelEdit.emit();
    };
    /**
     * @return {?}
     */
    ToolbarComponent.prototype.closeTab = /**
     * @return {?}
     */
    function () {
        if (this.toolbarObject.readonlyEditMode ||
            this.toolbarObject.readonlyInsertMode) {
            this.openDialogBeforeExit();
        }
        else {
            this.afterValidateExit();
        }
    };
    /**
     * @return {?}
     */
    ToolbarComponent.prototype.afterValidateExit = /**
     * @return {?}
     */
    function () {
        if (this.tabService) {
            this.tabService.removeCurrentTab();
        }
    };
    /**
     * @return {?}
     */
    ToolbarComponent.prototype.openDialogBeforeExit = /**
     * @return {?}
     */
    function () {
        var _this = this;
        /** @type {?} */
        var title;
        /** @type {?} */
        var description;
        title = 'Confirmar';
        description = 'As alterações serão descartadas, deseja realmente sair?';
        /** @type {?} */
        var dialogConfig = new MatDialogConfig();
        dialogConfig.autoFocus = false;
        dialogConfig.width = '700px';
        dialogConfig.disableClose = true;
        dialogConfig.data = { title: title, description: description };
        /** @type {?} */
        var dialogRef = this.dialog.customOpen(YesNoDialogComponent, dialogConfig);
        dialogRef.afterClosed().subscribe(function (data) {
            if (data) {
                _this.afterValidateExit();
            }
        });
    };
    //#endregion
    //#region Modos de vizualização
    //#endregion
    //#region Modos de vizualização
    /**
     * @param {?} option
     * @return {?}
     */
    ToolbarComponent.prototype.firstMode = 
    //#endregion
    //#region Modos de vizualização
    /**
     * @param {?} option
     * @return {?}
     */
    function (option) {
        var _this = this;
        this.firstModeButton = option;
        this.toolbarObject.readonlyFirstMode = option;
        if (option) {
            this.insertMode(false);
            this.browserMode(false);
            this.editMode(false);
            this.toolbarObject.currentStatus = RteToolbarStatusEnum.Searching;
            setTimeout(function () {
                _this.toolbarLite.calculatePadding();
            }, 100);
            this.showButton.forceShowRteHistory = false;
        }
    };
    /**
     * @param {?} option
     * @return {?}
     */
    ToolbarComponent.prototype.insertMode = /**
     * @param {?} option
     * @return {?}
     */
    function (option) {
        var _this = this;
        this.insertModeButton = option;
        this.toolbarObject.readonlyInsertMode = option;
        if (option) {
            this.firstMode(false);
            this.browserMode(false);
            this.editMode(false);
            this.toolbarObject.currentStatus = RteToolbarStatusEnum.Creating;
            this.toolbarObject.current = {};
            this.toolbarObject.selectionModel.clear();
            setTimeout(function () {
                _this.toolbarLite.calculatePadding();
            }, 100);
        }
        this.customizeAfterInsertMode.emit(option);
    };
    /**
     * @param {?} option
     * @return {?}
     */
    ToolbarComponent.prototype.browserMode = /**
     * @param {?} option
     * @return {?}
     */
    function (option) {
        var _this = this;
        this.browserModeButton = option;
        this.toolbarObject.readonlyBrowserMode = option;
        if (option) {
            this.firstMode(false);
            this.insertMode(false);
            this.editMode(false);
            this.toolbarObject.currentStatus = RteToolbarStatusEnum.Searching;
            setTimeout(function () {
                _this.toolbarLite.calculatePadding();
            }, 100);
        }
    };
    /**
     * @param {?} option
     * @return {?}
     */
    ToolbarComponent.prototype.editMode = /**
     * @param {?} option
     * @return {?}
     */
    function (option) {
        var _this = this;
        this.editModeButton = option;
        this.toolbarObject.readonlyEditMode = option;
        if (option) {
            this.firstMode(false);
            this.insertMode(false);
            this.browserMode(false);
            this.checkState(false);
            this.toolbarObject.currentStatus = RteToolbarStatusEnum.Editing;
            this.toolbarPagination.page = this.toolbarPagination.currentRegister - 1;
            this.toolbarPagination.currentIndex = 0;
            setTimeout(function () {
                _this.toolbarLite.calculatePadding();
            }, 100);
        }
        this.customizeAfterEditMode.emit(option);
    };
    //#endregion
    //#endregion
    /**
     * @return {?}
     */
    ToolbarComponent.prototype.getButtonBackgroundColor = 
    //#endregion
    /**
     * @return {?}
     */
    function () {
        if (this.appService.SelectedBackColor) {
            return this.appService.SelectedBackColor;
        }
        else {
            return '#0054a6';
        }
    };
    /**
     * @param {?} action
     * @return {?}
     */
    ToolbarComponent.prototype.openDialog = /**
     * @param {?} action
     * @return {?}
     */
    function (action) {
        var _this = this;
        /** @type {?} */
        var title;
        /** @type {?} */
        var description;
        if (action === 'DELETE') {
            title = 'Confirmar a exclusão';
            description = 'Deseja realmente excluir o registro?';
        }
        /** @type {?} */
        var dialogConfig = new MatDialogConfig();
        dialogConfig.autoFocus = false;
        dialogConfig.width = '700px';
        dialogConfig.disableClose = true;
        dialogConfig.data = { title: title, description: description };
        /** @type {?} */
        var dialogRef = this.dialog.customOpen(YesNoDialogComponent, dialogConfig);
        dialogRef.afterClosed().subscribe(function (data) {
            if (data === true && action === 'DELETE') {
                _this.delete();
            }
        });
    };
    /**
     * @param {?} newState
     * @return {?}
     */
    ToolbarComponent.prototype.checkState = /**
     * @param {?} newState
     * @return {?}
     */
    function (newState) {
        if (newState === false) {
            this.currentOld = new this.toolbarObject.current.constructor();
            this.setOldState(this.toolbarObject.current, this.currentOld);
        }
        else {
            //  if (this.toolbarObject.current.HasChanged === true) {
            this.setOldState(this.currentOld, this.toolbarObject.current);
            //  }
        }
    };
    /**
     * @param {?} oldObject
     * @param {?} newObject
     * @return {?}
     */
    ToolbarComponent.prototype.setOldState = /**
     * @param {?} oldObject
     * @param {?} newObject
     * @return {?}
     */
    function (oldObject, newObject) {
        /** @type {?} */
        var keys = Object.keys(oldObject);
        for (var i = 0; i < keys.length; i++) {
            /** @type {?} */
            var key = keys[i];
            if (oldObject[key] instanceof Array && oldObject[key].length > 0) {
                if (!(newObject[key] instanceof Array) ||
                    newObject[key].length !== oldObject[key].length) {
                    newObject[key] = new Array(oldObject[key].length);
                }
                for (var j = 0; j < oldObject[key].length; j++) {
                    if (newObject[key][j] === undefined) {
                        newObject[key][j] = new Object();
                    }
                    this.setOldState(oldObject[key][j], newObject[key][j]);
                }
            }
            else {
                newObject[key] = oldObject[key];
            }
        }
    };
    /**
     * @return {?}
     */
    ToolbarComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        var _this = this;
        this.toolbarObject.toolbarComponent = this;
        this.firstMode(true);
        if (this.KeyDownElementArea != null) {
            /** @type {?} */
            var element = this.KeyDownElementArea.nativeElement == null
                ? this.KeyDownElementArea
                : this.KeyDownElementArea.nativeElement;
            this.renderer.listen(element, 'keydown', function (event) {
                _this.hotkeys(event);
            });
        }
        this.loadPermissions();
        this.customizeAfterOnInit.emit();
    };
    /**
     * @return {?}
     */
    ToolbarComponent.prototype.loadPermissions = /**
     * @return {?}
     */
    function () {
        var _this = this;
        if (this.toolbarObject != null && this.toolbarObject.objectNamespace != null) {
            /** @type {?} */
            var appSettingsRequest = new LoadApplicationSettingsRequest();
            appSettingsRequest.Permissions = [];
            /** @type {?} */
            var objectNamespace = this.toolbarObject.webAPIPrefixName + this.toolbarObject.objectNamespace;
            appSettingsRequest.Permissions.push({
                AssemblyName: null,
                ObjectNamespace: objectNamespace,
                ObjectName: this.toolbarObject.insertObjectName
            });
            appSettingsRequest.Permissions.push({
                AssemblyName: null,
                ObjectNamespace: objectNamespace,
                ObjectName: this.toolbarObject.updateObjectName
            });
            appSettingsRequest.Permissions.push({
                AssemblyName: null,
                ObjectNamespace: objectNamespace,
                ObjectName: this.toolbarObject.deleteObjectName
            });
            this.appSettingsService.getApplicationSettings(appSettingsRequest).subscribe(function (x) {
                if (_this.showButton.delete == true) {
                    _this.showButton.delete = x.PermissionsResponse[2].HasPermission;
                }
                if (_this.showButton.edit == true) {
                    _this.showButton.edit = x.PermissionsResponse[1].HasPermission;
                }
                if (_this.showButton.insert == true) {
                    _this.showButton.insert = x.PermissionsResponse[0].HasPermission;
                }
            });
        }
    };
    /**
     * @return {?}
     */
    ToolbarComponent.prototype.search = /**
     * @return {?}
     */
    function () {
        this.toolbarPagination.currentIndex = -1;
        this.toolbarPagination.currentRegister = 0;
        this.get(false, false, true);
    };
    /**
     * @return {?}
     */
    ToolbarComponent.prototype.prepareCurrentRegisterAndIndex = /**
     * @return {?}
     */
    function () {
        this.toolbarPagination.page = Math.trunc(this.toolbarPagination.currentRegister / this.toolbarObject.pageSize);
        this.toolbarPagination.currentIndex = Math.trunc(this.toolbarPagination.currentRegister % this.toolbarObject.pageSize) - 1;
        if ((this.toolbarPagination.currentRegister % this.toolbarObject.pageSize) === 0) {
            this.toolbarPagination.page--;
            this.toolbarPagination.currentIndex = this.toolbarObject.pageSize - 1;
        }
    };
    /**
     * @param {?=} fromDelete
     * @return {?}
     */
    ToolbarComponent.prototype.backToGrid = /**
     * @param {?=} fromDelete
     * @return {?}
     */
    function (fromDelete) {
        if (fromDelete === void 0) { fromDelete = false; }
        this.prepareCurrentRegisterAndIndex();
        this.browserMode(true);
        this.get(true, false, true, -1, fromDelete);
    };
    /**
     * @return {?}
     */
    ToolbarComponent.prototype.registerInputChanged = /**
     * @return {?}
     */
    function () {
        /** @type {?} */
        var currentRegisterNumber = Number(this.toolbarPagination.currentRegister);
        if (isNaN(currentRegisterNumber) == false) {
            if (this.toolbarPagination.totalRegisters > 0) {
                if (this.toolbarPagination.currentRegister == null || this.toolbarPagination.currentRegister <= 0) {
                    this.toolbarPagination.currentRegister = 1;
                }
                else if (this.toolbarPagination.currentRegister > this.toolbarPagination.totalRegisters) {
                    this.toolbarPagination.currentRegister = this.toolbarPagination.totalRegisters;
                }
                if (this.toolbarObject.currentStatus == RteToolbarStatusEnum.Searching) {
                    this.prepareCurrentRegisterAndIndex();
                    this.get(true, false, true, -1);
                }
                else {
                    this.toolbarPagination.currentIndex = 0;
                    this.toolbarPagination.page = this.toolbarPagination.currentRegister - 1;
                    this.get(true, false, false, -1);
                }
            }
            else {
                this.toolbarPagination.currentRegister = 0;
            }
        }
    };
    /**
     * @param {?} event
     * @return {?}
     */
    ToolbarComponent.prototype.registerInputKeyPressed = /**
     * @param {?} event
     * @return {?}
     */
    function (event) {
        if (isNaN(event.key) === true &&
            event.which !== 13) {
            return false;
        }
        return true;
    };
    /**
     * @return {?}
     */
    ToolbarComponent.prototype.getLogInfos = /**
     * @return {?}
     */
    function () {
        if (!this.logInfos || this.logInfos.length === 0) {
            return [this.toolbarObject.current];
        }
        return this.logInfos;
    };
    ToolbarComponent.decorators = [
        { type: Component, args: [{
                    selector: 'rte-toolbar',
                    template: "<rte-toolbar-lite #toolbarLite (close)=\"closeTab()\" [backgroundcolor]=\"getButtonBackgroundColor()\" [titleColor]=\"currentModeColor\"\r\n    [showCloseButton]=\"showButton.close\" [title]=\"getCurrentModeDescription()\"\r\n    [showRteSeparator]=\"showButton.rteSeparator\" [isFixedToolbar]=\"isFixedToolbar\" [showTitle]=\"showTitle\">\r\n    <ng-content select=\".custom-title\" class=\"custom-title\"></ng-content>\r\n\r\n    <div class=\"toolbar-navigation-buttons\"\r\n        *ngIf=\"(toolbarObject.currentStatus == toolbarObject.possibleStatus.Viewing ||  toolbarObject.currentStatus == toolbarObject.possibleStatus.Searching)\">\r\n        <span>\r\n            <button rtebutton class=\"rte-icon-arrows navigation-button\"\r\n                [disabled]=\"toolbarPagination.currentRegister == 0 || toolbarPagination.currentRegister == 1\"\r\n                (click)=\"firstRegister()\" title=\"Primeiro registro\" *ngIf=\"showButton.firstRegister\">\r\n                <rte-icon class=\"material-icons\">first_page</rte-icon>\r\n            </button>\r\n            <button rtebutton class=\"rte-icon-arrows navigation-button\"\r\n                [disabled]=\"toolbarPagination.currentRegister == 0 || toolbarPagination.currentRegister == 1\"\r\n                (click)=\"prev()\" title=\"Anterior (Down)\" *ngIf=\"showButton.prevRegister\">\r\n                <rte-icon class=\"material-icons\">chevron_left</rte-icon>\r\n            </button>\r\n            <input rteInput *ngIf=\"showPagination\" type=\"text\" [(ngModel)]=\"toolbarPagination.currentRegister\"\r\n                class=\"register-input\" placeholder=\"\" (change)=\"registerInputChanged()\"\r\n                (keypress)=\"registerInputKeyPressed($event)\" [disabled]=\"toolbarPagination.totalRegisters == 0\"\r\n                [style.width]=\"registerFieldWidth\" />\r\n            <label class=\"rte-label mat-body\" *ngIf=\"showPagination\">\r\n                de\r\n                <span style=\"margin-left: 2px;\">{{ toolbarPagination.totalRegisters }}</span>\r\n            </label>\r\n            <button rtebutton class=\"rte-icon-arrows navigation-button\"\r\n                [disabled]=\"toolbarPagination.currentRegister == 0 || toolbarPagination.currentRegister == toolbarPagination.totalRegisters\"\r\n                (click)=\"next()\" title=\"Pr\u00F3ximo (Up)\" *ngIf=\"showButton.nextRegister\">\r\n                <rte-icon class=\"material-icons\">chevron_right</rte-icon>\r\n            </button>\r\n            <button rtebutton class=\"rte-icon-arrows navigation-button\"\r\n                [disabled]=\"toolbarPagination.currentRegister == 0 || toolbarPagination.currentRegister == toolbarPagination.totalRegisters\"\r\n                (click)=\"lastRegister()\" title=\"\u00DAltimo registro\" *ngIf=\"showButton.lastRegister\">\r\n                <rte-icon class=\"material-icons\">last_page</rte-icon>\r\n            </button>\r\n        </span>\r\n    </div>\r\n    <span class=\"rte-spacer\"></span>\r\n    <div class=\"rte-app-actions\">\r\n        <ng-content></ng-content>\r\n    </div>\r\n    <span>\r\n        <!-- Pesquisado -->\r\n        <mat-button-toggle-group #group=\"matButtonToggleGroup\">\r\n            <mat-button-toggle title=\"Log de Altera\u00E7\u00E3o\" [rteLogDialog]=\"getLogInfos()\"\r\n                *ngIf=\"showButton.forceShowRteHistory || (browserModeButton && showButton.rteHistory)\">\r\n                <rte-icon class=\"material-icons\">history</rte-icon>\r\n                Log\r\n            </mat-button-toggle>\r\n            <mat-button-toggle (click)=\"insertMode(true)\" title=\"Inserir\"\r\n                *ngIf=\"showButton.insert && (browserModeButton ||  toolbarObject.currentStatus == toolbarObject.possibleStatus.Viewing)\">\r\n                <rte-icon class=\"material-icons\">add_circle_outline</rte-icon>\r\n                Inserir\r\n            </mat-button-toggle>\r\n            <mat-button-toggle (click)=\"editMode(true)\" title=\"Editar registro\"\r\n                *ngIf=\"showButton.edit && (browserModeButton || toolbarObject.currentStatus == toolbarObject.possibleStatus.Viewing)\">\r\n                <rte-icon class=\"material-icons\">edit</rte-icon>\r\n                Editar\r\n            </mat-button-toggle>\r\n            <mat-button-toggle (click)=\"search()\" title=\"Pesquisar (F8)\" *ngIf=\"showButton.search && browserModeButton\">\r\n                <rte-icon class=\"material-icons\">search</rte-icon>\r\n                Pesquisar\r\n            </mat-button-toggle>\r\n            <mat-button-toggle (click)=\"cancelOperation(true, false, false, true)\" title=\"Limpar Pesquisa (F7)\"\r\n                *ngIf=\"showButton.cleanSearch && browserModeButton\">\r\n                <rte-icon class=\"material-icons\">clear</rte-icon>\r\n                Limpar\r\n            </mat-button-toggle>\r\n            <mat-button-toggle (click)=\"backToGrid()\" title=\"Voltar\"\r\n                *ngIf=\"editModeButton && toolbarObject.currentStatus == toolbarObject.possibleStatus.Viewing\">\r\n                <rte-icon class=\"material-icons\">arrow_back</rte-icon>\r\n                Voltar\r\n            </mat-button-toggle>\r\n        </mat-button-toggle-group>\r\n        <button rtebutton-flat color=\"warn\" (click)=\"openDialog('DELETE')\" title=\"Delete registro\"\r\n            *ngIf=\"showButton.delete && (browserModeButton || toolbarObject.currentStatus == toolbarObject.possibleStatus.Viewing)\">\r\n            <rte-icon class=\"material-icons\">delete_outline</rte-icon>\r\n            Excluir\r\n        </button>\r\n        <button rtebutton-flat class=\"btn-salvar\" color=\"primary\" (click)=\"save()\" title=\"Salvar (Ctrl+S)\"\r\n            *ngIf=\"showButton.save && (insertModeButton || editModeButton) && toolbarObject.currentStatus != toolbarObject.possibleStatus.Viewing\">\r\n            <span class=\"rte-icon\">\r\n                Salvar\r\n            </span>\r\n        </button>\r\n\r\n        <button rtebutton-stroked (click)=\"cancelOperation()\" title=\"Cancelar\"\r\n            *ngIf=\"showButton.cancelSave && (insertModeButton || editModeButton) && toolbarObject.currentStatus != toolbarObject.possibleStatus.Viewing\">\r\n            <span class=\"rte-icon\">\r\n                <rte-icon class=\"material-icons\">clear</rte-icon>\r\n                Cancelar\r\n            </span>\r\n        </button>\r\n\r\n        <button rtebutton-stroked (click)=\"cancelEdit()\" title=\"Sair Edi\u00E7\u00E3o\" class=\"button-first button-last\"\r\n            *ngIf=\"showButton.cancelEdit && editModeButton && toolbarObject.currentStatus != toolbarObject.possibleStatus.Viewing\">\r\n            <span class=\"rte-icon\">\r\n                <rte-icon class=\"material-icons\">clear</rte-icon>\r\n                Cancelar\r\n            </span>\r\n        </button>\r\n        <!-- Pesquisa -->\r\n        <mat-button-toggle-group class=\"no-margin\" #group=\"matButtonToggleGroup\">\r\n            <mat-button-toggle (click)=\"insertMode(true)\" title=\"Inserir\"\r\n                *ngIf=\"showButton.insert && browserModeButton == false && (toolbarObject.currentStatus == toolbarObject.possibleStatus.Searching)\">\r\n                <rte-icon class=\"material-icons\">add_circle_outline</rte-icon>\r\n                Inserir\r\n            </mat-button-toggle>\r\n            <mat-button-toggle (click)=\"search()\" title=\"Pesquisar (F8)\" *ngIf=\"showButton.search && firstModeButton\">\r\n                <rte-icon class=\"material-icons\">search</rte-icon>\r\n                Pesquisar\r\n            </mat-button-toggle>\r\n            <mat-button-toggle (click)=\"cancelOperation()\" title=\"Cancelar (F7)\"\r\n                *ngIf=\"showButton.cancel && firstModeButton\">\r\n                <rte-icon class=\"material-icons\">clear</rte-icon>\r\n                Cancelar\r\n            </mat-button-toggle>\r\n        </mat-button-toggle-group>\r\n    </span>\r\n</rte-toolbar-lite>",
                    styles: [".rte-icon{padding:0;margin-left:1px}.rte-icon-arrows{min-width:0;padding:0}.rte-spacer{flex:1 1 auto}.rte-mat-vertical_line{height:40px!important}.rte-app-actions{text-align:right;padding-top:0}button rte-icon{margin-top:-3px;vertical-align:middle}button rte-icon.edit-icon{margin-top:-5px}.navigation-button{color:#212121}.navigation-button[disabled]{color:#bdbdbd}.toolbar-navigation-buttons{margin-left:13px}.register-input{width:10px;position:relative;border-bottom:1px solid #000;font:400 14px/34px Roboto,\"Helvetica Neue\",sans-serif;border:1px solid #757575;border-radius:4px;height:24px;top:-4.8px;text-align:center;padding-left:5px;padding-right:5px;margin-right:2px}.navigation-button rte-icon{margin-top:-2px}.mat-button-toggle-checked{background-color:inherit!important}.no-margin{margin:0!important}.mat-button,.mat-flat-button,.mat-icon-button,.mat-stroked-button{border-radius:4px!important;line-height:36px!important}.btn-salvar{margin-right:10px!important}"]
                }] }
    ];
    /** @nocollapse */
    ToolbarComponent.ctorParameters = function () { return [
        { type: MatIconRegistry },
        { type: DomSanitizer },
        { type: RteDialog },
        { type: TabService },
        { type: RteMaterialBaseService },
        { type: Renderer2 },
        { type: ApplicationSettingsService }
    ]; };
    ToolbarComponent.propDecorators = {
        toolbarObject: [{ type: Input }],
        KeyDownElementArea: [{ type: Input }],
        service: [{ type: Input }],
        showButton: [{ type: Input }],
        isFixedToolbar: [{ type: Input }],
        dialogRef: [{ type: Input }],
        logInfos: [{ type: Input }],
        showTitle: [{ type: Input }],
        validateBeforeSave: [{ type: Output }],
        customizeAfterSave: [{ type: Output }],
        validateBeforeDelete: [{ type: Output }],
        customizeAfterGet: [{ type: Output }],
        customizeBeforeGet: [{ type: Output }],
        customizeAfterClear: [{ type: Output }],
        customizeAfterCancelEdit: [{ type: Output }],
        customizeAfterCancelOperation: [{ type: Output }],
        customizeAfterInsertMode: [{ type: Output }],
        customizeAfterEditMode: [{ type: Output }],
        customizeAfterDelete: [{ type: Output }],
        customizeAfterOnInit: [{ type: Output }],
        toolbarLite: [{ type: ViewChild, args: ['toolbarLite',] }]
    };
    return ToolbarComponent;
}(ToolbarBaseComponent));

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var LogService = /** @class */ (function () {
    function LogService(httpClient, environment) {
        this.httpClient = httpClient;
        this.environment = environment;
    }
    /**
     * @param {?} infos
     * @return {?}
     */
    LogService.prototype.getLogs = /**
     * @param {?} infos
     * @return {?}
     */
    function (infos) {
        /** @type {?} */
        var params = new HttpParams();
        infos.forEach(function (item) {
            params = params.append('keys', item.CustomLogKey + "," + item.ClassName);
        });
        return this.httpClient.get(this.environment.apiUrl + 'Log', { params: params });
    };
    LogService.decorators = [
        { type: Injectable, args: [{
                    providedIn: 'root'
                },] }
    ];
    /** @nocollapse */
    LogService.ctorParameters = function () { return [
        { type: HttpClient },
        { type: undefined, decorators: [{ type: Inject, args: ['environment',] }] }
    ]; };
    /** @nocollapse */ LogService.ngInjectableDef = defineInjectable({ factory: function LogService_Factory() { return new LogService(inject(HttpClient), inject("environment")); }, token: LogService, providedIn: "root" });
    return LogService;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var LogComponent = /** @class */ (function () {
    function LogComponent(data, dialogRef, appService) {
        this.data = data;
        this.dialogRef = dialogRef;
        this.appService = appService;
        this.displayedColumns = ['CreationDate', 'Message', 'PropertyName', 'OldValue', 'NewValue', 'UserName', 'Justification'];
        this.showButton = new ShowButton();
        if (this.data.hasOwnProperty('logs')) {
            this.logs = this.data.logs;
        }
    }
    /**
     * @return {?}
     */
    LogComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        this.dataSource = new MatTableDataSource(this.logs);
        this.dataSource.paginator = this.paginator;
    };
    /**
     * @return {?}
     */
    LogComponent.prototype.onClose = /**
     * @return {?}
     */
    function () {
        this.dialogRef.close();
    };
    /**
     * @return {?}
     */
    LogComponent.prototype.getButtonBackgroundColor = /**
     * @return {?}
     */
    function () {
        if (this.appService.SelectedBackColor) {
            return this.appService.SelectedBackColor;
        }
        else {
            return '#0054a6';
        }
    };
    LogComponent.decorators = [
        { type: Component, args: [{
                    selector: 'rte-log',
                    template: "<rte-toolbar-lite\r\n  title=\"Log de Altera\u00E7\u00E3o\"\r\n  (close)=\"onClose();\"\r\n  [showCloseButton]=\"showButton.close\"\r\n  [showRteSeparator]=\"false\"\r\n  [isFixedToolbar]=\"false\"\r\n  [showRteDivider]=\"false\"\r\n  rte-dialog-title\r\n  \r\n>\r\n</rte-toolbar-lite>\r\n\r\n<rte-card>\r\n  <mat-card-content>\r\n      <div class=\"rte-log-container\">\r\n          <table mat-table [dataSource]=\"dataSource\">\r\n              <ng-container matColumnDef=\"CreationDate\">\r\n                <th mat-header-cell *matHeaderCellDef> Data/Hora </th>\r\n                <td mat-cell *matCellDef=\"let element\"> {{element.CreationDateStr}} </td>\r\n              </ng-container>\r\n\r\n              <ng-container matColumnDef=\"Message\">\r\n                <th mat-header-cell *matHeaderCellDef> Tipo </th>\r\n                <td mat-cell *matCellDef=\"let element\"> {{element.Message}} </td>\r\n              </ng-container>\r\n\r\n              <ng-container matColumnDef=\"PropertyName\">\r\n                <th mat-header-cell *matHeaderCellDef> Nome da Informa\u00E7\u00E3o </th>\r\n                <td mat-cell *matCellDef=\"let element\"> {{element.PropertyName}} </td>\r\n              </ng-container>\r\n\r\n              <ng-container matColumnDef=\"OldValue\">\r\n                <th mat-header-cell *matHeaderCellDef> Situa\u00E7\u00E3o Anterior </th>\r\n                <td mat-cell *matCellDef=\"let element\"> {{element.OldValue}} </td>\r\n              </ng-container>\r\n\r\n              <ng-container matColumnDef=\"NewValue\">\r\n                <th mat-header-cell *matHeaderCellDef> Situa\u00E7\u00E3o Posterior </th>\r\n                <td mat-cell *matCellDef=\"let element\"> {{element.NewValue}} </td>\r\n              </ng-container>\r\n\r\n              <ng-container matColumnDef=\"UserName\">\r\n                <th mat-header-cell *matHeaderCellDef> Usu\u00E1rio </th>\r\n                <td mat-cell *matCellDef=\"let element\"> {{element.UserName}} </td>\r\n              </ng-container>\r\n\r\n              <ng-container matColumnDef=\"Justification\">\r\n                <th mat-header-cell *matHeaderCellDef> Justificativa </th>\r\n                <td mat-cell *matCellDef=\"let element\"> {{element.Justification}} </td>\r\n              </ng-container>\r\n\r\n              <tr mat-header-row *matHeaderRowDef=\"displayedColumns\"></tr>\r\n              <tr mat-row *matRowDef=\"let row; columns: displayedColumns;\"></tr>\r\n          </table>\r\n        </div>\r\n        <mat-paginator [pageSizeOptions]=\"[10, 15, 20]\" showFirstLastButtons></mat-paginator>\r\n  </mat-card-content>\r\n</rte-card>",
                    styles: [".rte-log-container{max-height:58vh;min-height:58vh;overflow-y:auto}.rte-log-container table{width:1350px}.rte-log-container table tbody tr:hover{background-color:#f9f9f9}.mat-card{padding:0;margin:10px}rte-toolbar-lite{padding:0 30px!important}rte-toolbar-lite .mat-toolbar{background:#f5f5f5!important;border-bottom:none!important}"]
                }] }
    ];
    /** @nocollapse */
    LogComponent.ctorParameters = function () { return [
        { type: undefined, decorators: [{ type: Inject, args: [MAT_DIALOG_DATA,] }] },
        { type: RteDialogRef },
        { type: RteMaterialBaseService }
    ]; };
    LogComponent.propDecorators = {
        paginator: [{ type: ViewChild, args: [MatPaginator,] }]
    };
    return LogComponent;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var RteIndividualConfig = /** @class */ (function () {
    function RteIndividualConfig() {
        this.closeButton = true;
    }
    return RteIndividualConfig;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var RTEAlertService = /** @class */ (function () {
    function RTEAlertService(service) {
        this.service = service;
    }
    /**
     * @param {?} title
     * @param {?=} message
     * @param {?=} config
     * @return {?}
     */
    RTEAlertService.prototype.success = /**
     * @param {?} title
     * @param {?=} message
     * @param {?=} config
     * @return {?}
     */
    function (title, message, config) {
        if (config === void 0) { config = new RteIndividualConfig(); }
        this.service.success(message, title, config);
    };
    /**
     * @param {?} title
     * @param {?=} message
     * @param {?=} config
     * @return {?}
     */
    RTEAlertService.prototype.warning = /**
     * @param {?} title
     * @param {?=} message
     * @param {?=} config
     * @return {?}
     */
    function (title, message, config) {
        if (config === void 0) { config = new RteIndividualConfig(); }
        this.service.warning(message, title, config);
    };
    /**
     * @param {?} title
     * @param {?=} message
     * @param {?=} config
     * @return {?}
     */
    RTEAlertService.prototype.info = /**
     * @param {?} title
     * @param {?=} message
     * @param {?=} config
     * @return {?}
     */
    function (title, message, config) {
        if (config === void 0) { config = new RteIndividualConfig(); }
        this.service.info(message, title, config);
    };
    /**
     * @param {?} title
     * @param {?=} message
     * @param {?=} config
     * @return {?}
     */
    RTEAlertService.prototype.show = /**
     * @param {?} title
     * @param {?=} message
     * @param {?=} config
     * @return {?}
     */
    function (title, message, config) {
        if (config === void 0) { config = new RteIndividualConfig(); }
        this.service.show(message, title, config);
    };
    /**
     * @param {?} title
     * @param {?=} message
     * @param {?=} config
     * @return {?}
     */
    RTEAlertService.prototype.error = /**
     * @param {?} title
     * @param {?=} message
     * @param {?=} config
     * @return {?}
     */
    function (title, message, config) {
        if (config === void 0) { config = new RteIndividualConfig(); }
        this.service.error(message, title, config);
    };
    RTEAlertService.decorators = [
        { type: Injectable, args: [{
                    providedIn: 'root'
                },] }
    ];
    /** @nocollapse */
    RTEAlertService.ctorParameters = function () { return [
        { type: ToastrService }
    ]; };
    /** @nocollapse */ RTEAlertService.ngInjectableDef = defineInjectable({ factory: function RTEAlertService_Factory() { return new RTEAlertService(inject(ToastrService)); }, token: RTEAlertService, providedIn: "root" });
    return RTEAlertService;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var LogDialogDirective = /** @class */ (function () {
    function LogDialogDirective(el, dialog, service, rteAlertService) {
        this.dialog = dialog;
        this.service = service;
        this.rteAlertService = rteAlertService;
    }
    /**
     * @param {?} e
     * @return {?}
     */
    LogDialogDirective.prototype.onClick = /**
     * @param {?} e
     * @return {?}
     */
    function (e) {
        var _this = this;
        /** @type {?} */
        var validInfos = this.getValidInfos();
        if (validInfos && validInfos.length > 0) {
            this.service.getLogs(validInfos).subscribe(function (d) {
                if (d.length > 0) {
                    /** @type {?} */
                    var dialogConfig = new MatDialogConfig();
                    dialogConfig.disableClose = false;
                    dialogConfig.autoFocus = true;
                    dialogConfig.width = '80%';
                    dialogConfig.data = { title: 'title', description: 'description', logs: d };
                    _this.dialog.customOpen(LogComponent, dialogConfig);
                }
                else {
                    _this.rteAlertService.info('Nenhum log foi encontrado');
                }
            });
        }
    };
    /**
     * @return {?}
     */
    LogDialogDirective.prototype.getValidInfos = /**
     * @return {?}
     */
    function () {
        var _this = this;
        /** @type {?} */
        var validInfos;
        validInfos = new Array();
        if (!this.infos) {
            return [];
        }
        this.infos.forEach(function (item) {
            _this.setValidInfo(item, validInfos);
        });
        return validInfos;
    };
    /**
     * @param {?} item
     * @param {?} validInfos
     * @return {?}
     */
    LogDialogDirective.prototype.setValidInfo = /**
     * @param {?} item
     * @param {?} validInfos
     * @return {?}
     */
    function (item, validInfos) {
        if (item && (typeof (item) === 'object')) {
            if (item.hasOwnProperty('CustomLogKey') && item.hasOwnProperty('ClassName')) {
                if (item.CustomLogKey !== '' && item.ClassName !== '') {
                    validInfos.push(item);
                    for (var propt in item)
                        this.setValidInfo(item[propt], validInfos);
                }
            }
        }
    };
    LogDialogDirective.decorators = [
        { type: Directive, args: [{
                    selector: '[rteLogDialog]'
                },] }
    ];
    /** @nocollapse */
    LogDialogDirective.ctorParameters = function () { return [
        { type: ElementRef },
        { type: RteDialog },
        { type: LogService },
        { type: RTEAlertService }
    ]; };
    LogDialogDirective.propDecorators = {
        infos: [{ type: Input, args: ['rteLogDialog',] }],
        onClick: [{ type: HostListener, args: ['click', ['$event'],] }]
    };
    return LogDialogDirective;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var RteToolbarLiteModule = /** @class */ (function () {
    function RteToolbarLiteModule() {
    }
    RteToolbarLiteModule.decorators = [
        { type: NgModule, args: [{
                    imports: [
                        CommonModule,
                        MatToolbarModule,
                        RteMaterialModule,
                        MatDividerModule
                    ],
                    declarations: [ToolbarLiteComponent],
                    exports: [ToolbarLiteComponent]
                },] }
    ];
    return RteToolbarLiteModule;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var RteLogDialogModule$$1 = /** @class */ (function () {
    function RteLogDialogModule$$1() {
    }
    RteLogDialogModule$$1.decorators = [
        { type: NgModule, args: [{
                    imports: [
                        CommonModule,
                        RteToolbarLiteModule,
                        RteMaterialModule,
                        MatCardModule,
                        MatTableModule,
                        MatPaginatorModule
                    ],
                    declarations: [LogDialogDirective, LogComponent],
                    exports: [LogDialogDirective, LogComponent],
                    entryComponents: [LogComponent]
                },] }
    ];
    return RteLogDialogModule$$1;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @enum {number} */
var RteToolbarObjectStatusEnum = {
    Inserting: 1,
    Added: 2,
    Edited: 3,
    Deleted: 4,
};
RteToolbarObjectStatusEnum[RteToolbarObjectStatusEnum.Inserting] = 'Inserting';
RteToolbarObjectStatusEnum[RteToolbarObjectStatusEnum.Added] = 'Added';
RteToolbarObjectStatusEnum[RteToolbarObjectStatusEnum.Edited] = 'Edited';
RteToolbarObjectStatusEnum[RteToolbarObjectStatusEnum.Deleted] = 'Deleted';

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var ValidateItem = /** @class */ (function () {
    function ValidateItem() {
        this.cancelConfirm = true;
    }
    return ValidateItem;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var LocalDataSourceResult = /** @class */ (function () {
    function LocalDataSourceResult() {
        this.originalData = [];
        this.newData = [];
        this.stateData = [];
    }
    return LocalDataSourceResult;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @template T
 */
var  /**
 * @template T
 */
RteLocalDataToolbarViewModel = /** @class */ (function () {
    function RteLocalDataToolbarViewModel() {
        this.dataSource = new RteToolbarDataSource([]);
        this.selectionModel = new SelectionModel(false, []);
        this.currentStatus = RteToolbarStatusEnum.Searching;
        this.possibleStatus = RteToolbarStatusEnum;
        this.pageSize = 10;
    }
    /**
     * @param {?} newCurrent
     * @param {?=} fromToolbarComponent
     * @param {?=} fromInit
     * @return {?}
     */
    RteLocalDataToolbarViewModel.prototype.setCurrent = /**
     * @param {?} newCurrent
     * @param {?=} fromToolbarComponent
     * @param {?=} fromInit
     * @return {?}
     */
    function (newCurrent, fromToolbarComponent, fromInit) {
        if (fromToolbarComponent === void 0) { fromToolbarComponent = false; }
        if (fromInit === void 0) { fromInit = false; }
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.toolbarComponent.confirm(false, fromInit)];
                    case 1:
                        if ((_a.sent()) === false) {
                            return [2 /*return*/];
                        }
                        this.current = newCurrent;
                        if (!(this.selectionModel.isSelected(newCurrent) == false)) return [3 /*break*/, 3];
                        this.selectionModel.toggle(newCurrent);
                        if (!(fromToolbarComponent === false)) return [3 /*break*/, 3];
                        return [4 /*yield*/, this.toolbarComponent.setCurrent(newCurrent)];
                    case 2:
                        _a.sent();
                        _a.label = 3;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * @param {?} data
     * @return {?}
     */
    RteLocalDataToolbarViewModel.prototype.setCurrentDataSource = /**
     * @param {?} data
     * @return {?}
     */
    function (data) {
        this.dataSource.data = data;
    };
    /**
     * @return {?}
     */
    RteLocalDataToolbarViewModel.prototype.getCleanDataSource = /**
     * @return {?}
     */
    function () {
        return _.filter(this.dataSource.data, function (obj) {
            return obj.state !== RteToolbarObjectStatusEnum.Deleted;
        });
    };
    return RteLocalDataToolbarViewModel;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var ShowButtonLocalDataToolbar = /** @class */ (function () {
    function ShowButtonLocalDataToolbar() {
        this.firstRegister = true;
        this.prevRegister = true;
        this.nextRegister = true;
        this.lastRegister = true;
        this.insert = true;
        this.confirm = true;
        this.cancel = true;
        this.remove = true;
        this.close = true;
    }
    return ShowButtonLocalDataToolbar;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var LocalDataToolbarComponent = /** @class */ (function (_super) {
    __extends(LocalDataToolbarComponent, _super);
    function LocalDataToolbarComponent(modalRef) {
        var _this = _super.call(this) || this;
        _this.modalRef = modalRef;
        _this.toolbarObject = new RteLocalDataToolbarViewModel();
        _this.showButton = new ShowButtonLocalDataToolbar();
        _this.validateBeforeInsertEvent = new EventEmitter();
        _this.customizeAfterInsertEvent = new EventEmitter();
        _this.validateBeforeConfirmEvent = new EventEmitter();
        _this.customizeAfterConfirmEvent = new EventEmitter();
        _this.validateBeforeDeleteEvent = new EventEmitter();
        _this.customizeAfterDeleteEvent = new EventEmitter();
        _this.validateBeforeCancelEvent = new EventEmitter();
        _this.customizeAfterCancelEvent = new EventEmitter();
        _this.customizeAfterSetCurrent = new EventEmitter();
        _this.validateItemEvent = new EventEmitter();
        _this.closeEvent = new EventEmitter();
        _this.localDataResult = new LocalDataSourceResult();
        return _this;
    }
    /**
     * @return {?}
     */
    LocalDataToolbarComponent.prototype.firstRegister = /**
     * @return {?}
     */
    function () {
        /** @type {?} */
        var data = this.toolbarObject.getCleanDataSource();
        this.toolbarObject.setCurrent(data[0]);
    };
    /**
     * @return {?}
     */
    LocalDataToolbarComponent.prototype.prev = /**
     * @return {?}
     */
    function () {
        /** @type {?} */
        var data = this.toolbarObject.getCleanDataSource();
        this.toolbarObject.setCurrent(data[this.toolbarPagination.currentIndex - 1]);
    };
    /**
     * @return {?}
     */
    LocalDataToolbarComponent.prototype.registerInputChanged = /**
     * @return {?}
     */
    function () {
        /** @type {?} */
        var data = this.toolbarObject.getCleanDataSource();
        /** @type {?} */
        var currentRegisterNumber = Number(this.toolbarPagination.currentRegister);
        if (isNaN(currentRegisterNumber) === false) {
            if (this.toolbarPagination.currentRegister == null || this.toolbarPagination.currentRegister <= 0) {
                this.toolbarPagination.currentRegister = 1;
            }
            else if (this.toolbarPagination.currentRegister > this.toolbarObject.dataSource.data.length) {
                this.toolbarPagination.currentRegister = this.toolbarObject.dataSource.data.length;
            }
            this.toolbarObject.setCurrent(data[this.toolbarPagination.currentRegister - 1]);
        }
    };
    /**
     * @param {?} event
     * @return {?}
     */
    LocalDataToolbarComponent.prototype.registerInputKeyPressed = /**
     * @param {?} event
     * @return {?}
     */
    function (event) {
        if (isNaN(event.key) === true &&
            event.which !== 13) {
            return false;
        }
        return true;
    };
    /**
     * @return {?}
     */
    LocalDataToolbarComponent.prototype.next = /**
     * @return {?}
     */
    function () {
        /** @type {?} */
        var data = this.toolbarObject.getCleanDataSource();
        this.toolbarObject.setCurrent(data[this.toolbarPagination.currentIndex + 1]);
    };
    /**
     * @return {?}
     */
    LocalDataToolbarComponent.prototype.lastRegister = /**
     * @return {?}
     */
    function () {
        /** @type {?} */
        var data = this.toolbarObject.getCleanDataSource();
        this.toolbarObject.setCurrent(data[data.length - 1]);
    };
    /**
     * @param {?=} closeDialog
     * @param {?=} fromInit
     * @return {?}
     */
    LocalDataToolbarComponent.prototype.confirm = /**
     * @param {?=} closeDialog
     * @param {?=} fromInit
     * @return {?}
     */
    function (closeDialog, fromInit) {
        if (closeDialog === void 0) { closeDialog = true; }
        if (fromInit === void 0) { fromInit = false; }
        return __awaiter(this, void 0, void 0, function () {
            var validItem;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.validateBeforeConfirmEvent.emit();
                        if (!!fromInit) return [3 /*break*/, 2];
                        validItem = new ValidateItem();
                        return [4 /*yield*/, this.validateItemEvent.emit(validItem)];
                    case 1:
                        _a.sent();
                        if (validItem.cancelConfirm) {
                            return [2 /*return*/, false];
                        }
                        _a.label = 2;
                    case 2:
                        if (this.toolbarObject.current.state === RteToolbarObjectStatusEnum.Inserting) {
                            this.toolbarObject.current.state = RteToolbarObjectStatusEnum.Added;
                        }
                        this.customizeAfterConfirmEvent.emit();
                        if (closeDialog) {
                            this.closeDialog();
                        }
                        return [2 /*return*/, true];
                }
            });
        });
    };
    /**
     * @return {?}
     */
    LocalDataToolbarComponent.prototype.insert = /**
     * @return {?}
     */
    function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.validateBeforeInsertEvent.emit();
                        return [4 /*yield*/, this.confirm(false)];
                    case 1:
                        if ((_a.sent()) === false) {
                            return [2 /*return*/];
                        }
                        this.AddNewItem();
                        this.customizeAfterInsertEvent.emit();
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * @return {?}
     */
    LocalDataToolbarComponent.prototype.delete = /**
     * @return {?}
     */
    function () {
        return __awaiter(this, void 0, void 0, function () {
            var newCurrent, _i;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.validateBeforeDeleteEvent.emit();
                        if (!(this.toolbarObject.current.state === RteToolbarObjectStatusEnum.Inserting
                            || this.toolbarObject.current.state === RteToolbarObjectStatusEnum.Added)) return [3 /*break*/, 1];
                        this.RemovedAddItem();
                        return [3 /*break*/, 3];
                    case 1:
                        this.toolbarObject.current.state = RteToolbarObjectStatusEnum.Deleted;
                        newCurrent = null;
                        for (_i = 0; _i < this.toolbarObject.getCleanDataSource().length; _i++) {
                            newCurrent = this.toolbarObject.getCleanDataSource()[_i];
                            if (newCurrent) {
                                break;
                            }
                        }
                        if (!newCurrent) {
                            newCurrent = _.head(this.toolbarObject.getCleanDataSource());
                        }
                        if (!newCurrent) return [3 /*break*/, 3];
                        return [4 /*yield*/, this.toolbarObject.setCurrent(newCurrent)];
                    case 2:
                        _a.sent();
                        _a.label = 3;
                    case 3:
                        this.toolbarPagination.totalRegisters = this.toolbarObject.getCleanDataSource().length;
                        return [4 /*yield*/, this.customizeAfterDeleteEvent.emit()];
                    case 4:
                        _a.sent();
                        if (this.toolbarObject.getCleanDataSource().length === 0) {
                            this.closeDialog();
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * @return {?}
     */
    LocalDataToolbarComponent.prototype.cancel = /**
     * @return {?}
     */
    function () {
        if (this.toolbarObject.current.state === RteToolbarObjectStatusEnum.Inserting) {
            this.RemovedAddItem();
        }
        else {
            /** @type {?} */
            var newCurrent = __assign({}, this.oldCurrent);
            var data = this.toolbarObject.dataSource.data;
            data[this.toolbarPagination.currentIndex] = newCurrent;
            this.toolbarObject.dataSource.data = __spread(data);
            this.toolbarObject.setCurrent(newCurrent);
        }
        if (this.toolbarObject.getCleanDataSource().length === 0) {
            this.closeDialog();
        }
    };
    /**
     * @private
     * @return {?}
     */
    LocalDataToolbarComponent.prototype.RemovedAddItem = /**
     * @private
     * @return {?}
     */
    function () {
        var data = this.toolbarObject.dataSource.data;
        data.splice(this.toolbarPagination.currentIndex, 1);
        this.toolbarObject.dataSource.data = __spread(data);
        if (this.toolbarObject.getCleanDataSource().length > 0) {
            this.toolbarObject.setCurrent(this.toolbarObject.dataSource.data[this.toolbarPagination.currentIndex], false, true);
        }
        this.toolbarPagination.totalRegisters = this.toolbarObject.getCleanDataSource().length;
    };
    /**
     * @return {?}
     */
    LocalDataToolbarComponent.prototype.close = /**
     * @return {?}
     */
    function () {
        this.cancel();
        this.closeDialog();
    };
    /**
     * @private
     * @return {?}
     */
    LocalDataToolbarComponent.prototype.closeDialog = /**
     * @private
     * @return {?}
     */
    function () {
        this.localDataResult.newData = this.toolbarObject.getCleanDataSource();
        this.localDataResult.stateData = this.toolbarObject.dataSource.data;
        this.closeEvent.emit(this.localDataResult);
        this.modalRef.closeAll();
    };
    /**
     * @private
     * @return {?}
     */
    LocalDataToolbarComponent.prototype.generateUuid = /**
     * @private
     * @return {?}
     */
    function () {
        return (Math.floor(Math.random() * (9999 - 1 + 1) + 1)) * (-1);
    };
    /**
     * @private
     * @return {?}
     */
    LocalDataToolbarComponent.prototype.newItem = /**
     * @private
     * @return {?}
     */
    function () {
        return { state: RteToolbarObjectStatusEnum.Inserting, toolbarId: this.generateUuid() };
    };
    /**
     * @private
     * @param {?=} fromInit
     * @return {?}
     */
    LocalDataToolbarComponent.prototype.AddNewItem = /**
     * @private
     * @param {?=} fromInit
     * @return {?}
     */
    function (fromInit) {
        if (fromInit === void 0) { fromInit = false; }
        this.toolbarObject.currentStatus = RteToolbarStatusEnum.Creating;
        /** @type {?} */
        var newCurrent = this.newItem();
        var data = this.toolbarObject.dataSource.data;
        this.toolbarObject.dataSource.data = __spread([newCurrent], data);
        this.toolbarObject.setCurrent(newCurrent, false, fromInit);
        this.toolbarPagination.totalRegisters = this.toolbarObject.getCleanDataSource().length;
    };
    /**
     * @param {?} newCurrent
     * @return {?}
     */
    LocalDataToolbarComponent.prototype.setCurrent = /**
     * @param {?} newCurrent
     * @return {?}
     */
    function (newCurrent) {
        if (!newCurrent) {
            newCurrent = {};
        }
        this.oldCurrent = __assign({}, newCurrent);
        _super.prototype.setCurrent.call(this, newCurrent);
        if (!this.toolbarObject.current.hasOwnProperty('state')) {
            this.toolbarObject.current.state = RteToolbarObjectStatusEnum.Edited;
        }
        if (this.toolbarObject.current.state === RteToolbarObjectStatusEnum.Inserting) {
            this.toolbarObject.currentStatus = RteToolbarStatusEnum.Creating;
        }
        else {
            this.toolbarObject.currentStatus = RteToolbarStatusEnum.Editing;
        }
        this.customizeAfterSetCurrent.emit();
    };
    /**
     * @return {?}
     */
    LocalDataToolbarComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        this.toolbarObject.toolbarComponent = this;
        this.localDataResult.originalData = _.cloneDeep(this.toolbarObject.dataSource.data);
        this.toolbarPagination.currentRegister = 1;
        if (this.toolbarObject.current.Id) {
            this.toolbarObject.current.state = RteToolbarObjectStatusEnum.Edited;
            this.toolbarObject.setCurrent(this.toolbarObject.current);
        }
        else {
            this.AddNewItem(true);
        }
        this.toolbarPagination.totalRegisters = this.toolbarObject.dataSource.data.length;
    };
    LocalDataToolbarComponent.decorators = [
        { type: Component, args: [{
                    selector: 'rte-local-data-toolbar',
                    template: "<rte-toolbar-lite [isFixedToolbar]='false' [title]=\"getCurrentModeDescription()\" [showRteDivider]=\"false\">\r\n  <ng-content select=\".custom-title\" class=\"custom-title\"></ng-content>\r\n\r\n  <div class=\"toolbar-navigation-buttons\">\r\n    <span>\r\n      <button rtebutton class=\"rte-icon-arrows navigation-button\"\r\n        [disabled]=\"toolbarPagination.currentRegister == 0 || toolbarPagination.currentRegister == 1\"\r\n        (click)=\"firstRegister()\" title=\"Primeiro registro\" *ngIf=\"showButton.firstRegister\">\r\n        <rte-icon class=\"material-icons\">first_page</rte-icon>\r\n      </button>\r\n      <button rtebutton class=\"rte-icon-arrows navigation-button\"\r\n        [disabled]=\"toolbarPagination.currentRegister == 0 || toolbarPagination.currentRegister == 1\" (click)=\"prev()\"\r\n        title=\"Anterior (Down)\" *ngIf=\"showButton.prevRegister\">\r\n        <rte-icon class=\"material-icons\">chevron_left</rte-icon>\r\n      </button>\r\n      <input rteInput *ngIf=\"showPagination\" type=\"text\" [(ngModel)]=\"toolbarPagination.currentRegister\"\r\n        class=\"register-input\" placeholder=\"\" (change)=\"registerInputChanged()\"\r\n        (keypress)=\"registerInputKeyPressed($event)\" [disabled]=\"toolbarPagination.totalRegisters == 0\"\r\n        [style.width]=\"registerFieldWidth\" />\r\n      <label class=\"rte-label mat-body\" *ngIf=\"showPagination\">\r\n        de\r\n        <span style=\"margin-left: 2px;\">{{ toolbarPagination.totalRegisters }}</span>\r\n      </label>\r\n      <button rtebutton class=\"rte-icon-arrows navigation-button\"\r\n        [disabled]=\"toolbarPagination.currentRegister == 0 || toolbarPagination.currentRegister == toolbarPagination.totalRegisters\"\r\n        (click)=\"next()\" title=\"Pr\u00F3ximo (Up)\" *ngIf=\"showButton.nextRegister\">\r\n        <rte-icon class=\"material-icons\">chevron_right</rte-icon>\r\n      </button>\r\n      <button rtebutton class=\"rte-icon-arrows navigation-button\"\r\n        [disabled]=\"toolbarPagination.currentRegister == 0 || toolbarPagination.currentRegister == toolbarPagination.totalRegisters\"\r\n        (click)=\"lastRegister()\" title=\"\u00DAltimo registro\">\r\n        <rte-icon class=\"material-icons\" *ngIf=\"showButton.lastRegister\">last_page</rte-icon>\r\n      </button>\r\n    </span>\r\n  </div>\r\n\r\n  <span class=\"rte-spacer\"></span>\r\n  <div class=\"rte-app-actions\">\r\n    <ng-content></ng-content>\r\n  </div>\r\n  <button rtebutton-flat class=\"button-margin\" color=\"primary\" (click)=\"confirm()\" title=\"Salvar (Ctrl+S)\" *ngIf=\"showButton.confirm\">\r\n    <span class=\"rte-icon\">\r\n      Confirmar\r\n    </span>\r\n  </button>\r\n  <mat-button-toggle-group #group=\"matButtonToggleGroup\">\r\n    <mat-button-toggle (click)=\"insert()\" title=\"Inserir\" *ngIf=\"showButton.insert\">\r\n      <rte-icon class=\"material-icons\">add_circle_outline</rte-icon>\r\n      Inserir\r\n    </mat-button-toggle>\r\n    <mat-button-toggle (click)=\"cancel()\" title=\"Cancelar (F7)\" *ngIf=\"showButton.cancel\">\r\n      <rte-icon class=\"material-icons\">clear</rte-icon>\r\n      Cancelar\r\n    </mat-button-toggle>\r\n  </mat-button-toggle-group>\r\n  <button rtebutton-flat class=\"button-margin\" color=\"warn\" (click)=\"delete()\" title=\"Delete registro\" *ngIf=\"showButton.remove\">\r\n    <rte-icon class=\"material-icons\">delete_outline</rte-icon>\r\n    Remover\r\n  </button>\r\n  <button rtebutton-stroked (click)=\"close()\" title=\"Sair\" *ngIf=\"showButton.close\">\r\n    <rte-icon class=\"material-icons\">directions_run</rte-icon>\r\n    Sair\r\n  </button>\r\n</rte-toolbar-lite>",
                    styles: [".rte-icon{padding:0;margin-left:1px}.rte-icon-arrows{min-width:0;padding:0}.rte-spacer{flex:1 1 auto}.rte-mat-vertical_line{height:40px!important}.rte-app-actions{text-align:right;padding-top:0}button rte-icon{margin-top:-3px;vertical-align:middle}button rte-icon.edit-icon{margin-top:-5px}.navigation-button{color:#212121}.navigation-button[disabled]{color:#bdbdbd}.toolbar-navigation-buttons{margin-left:13px}.register-input{width:10px;position:relative;border-bottom:1px solid #000;font:400 14px/34px Roboto,\"Helvetica Neue\",sans-serif;border:1px solid #757575;border-radius:4px;height:24px;top:-4.8px;text-align:center;padding-left:5px;padding-right:5px;margin-right:2px}.navigation-button rte-icon{margin-top:-2px}.mat-button-toggle-checked{background-color:inherit!important}.mat-divider{padding-bottom:50px}.button-margin{margin-right:10px}"]
                }] }
    ];
    /** @nocollapse */
    LocalDataToolbarComponent.ctorParameters = function () { return [
        { type: RteDialog }
    ]; };
    LocalDataToolbarComponent.propDecorators = {
        toolbarObject: [{ type: Input }],
        showButton: [{ type: Input }],
        validateBeforeInsertEvent: [{ type: Output }],
        customizeAfterInsertEvent: [{ type: Output }],
        validateBeforeConfirmEvent: [{ type: Output }],
        customizeAfterConfirmEvent: [{ type: Output }],
        validateBeforeDeleteEvent: [{ type: Output }],
        customizeAfterDeleteEvent: [{ type: Output }],
        validateBeforeCancelEvent: [{ type: Output }],
        customizeAfterCancelEvent: [{ type: Output }],
        customizeAfterSetCurrent: [{ type: Output }],
        validateItemEvent: [{ type: Output }],
        closeEvent: [{ type: Output }]
    };
    return LocalDataToolbarComponent;
}(ToolbarBaseComponent));

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var RteToolbarModule = /** @class */ (function () {
    function RteToolbarModule() {
    }
    RteToolbarModule.decorators = [
        { type: NgModule, args: [{
                    imports: [
                        CommonModule,
                        MatIconModule,
                        MatToolbarModule,
                        MatButtonModule$1,
                        RteMaterialModule,
                        RteLogDialogModule$$1,
                        RteToolbarLiteModule,
                        FormsModule,
                        MatButtonToggleModule
                    ],
                    declarations: [ToolbarComponent, LocalDataToolbarComponent, ToolbarBaseComponent],
                    exports: [ToolbarComponent, LocalDataToolbarComponent, ToolbarBaseComponent]
                },] }
    ];
    return RteToolbarModule;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var AfterDelete = /** @class */ (function () {
    function AfterDelete() {
    }
    return AfterDelete;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
var RTE_COOKIE_SERVICE_DATA = new InjectionToken('ICookieServiceToken');

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
registerLocaleData(localePt, 'pt');
var AppService = /** @class */ (function (_super) {
    __extends(AppService, _super);
    function AppService(cookieService, router, http, environment, titleService) {
        var _this = _super.call(this) || this;
        _this.cookieService = cookieService;
        _this.router = router;
        _this.http = http;
        _this.environment = environment;
        _this.titleService = titleService;
        _this.requestingAPI = new Map();
        _this.requestApi = new EventEmitter();
        _this.applicationsToSearch = new Array();
        _this.countTryGetSystem = 0;
        _this.titleService.setTitle('');
        /** @type {?} */
        var authCookie = _this.cookieService.getCookie("auth");
        if (authCookie != '') {
            _this.currentUser = JSON.parse(authCookie);
        }
        /** @type {?} */
        var companyCookie = _this.cookieService.getCookie("company");
        if (companyCookie != '') {
            _this.currentCompany = JSON.parse(companyCookie);
            _this.CompanyBackColor = _this.currentCompany.CompanyBackColor;
            _this.CompanyForeColor = _this.currentCompany.CompanyForeColor;
            _this.IconForeColor = _this.currentCompany.IconForeColor;
            _this.SelectedBackColor = _this.currentCompany.SelectedBackColor;
            _this.SelectedForeColor = _this.currentCompany.SelectedForeColor;
            _this.RequiredFieldBackColor = _this.currentCompany.RequiredFieldBackColor;
            _this.RequiredFieldForeColor = _this.currentCompany.RequiredFieldForeColor;
            _this.ValidationFieldColor = _this.currentCompany.ValidationFieldColor;
            _this.MenuColor = _this.currentCompany.MenuColor;
            _this.PrimaryActionColor = _this.currentCompany.PrimaryActionColor;
            _this.SecundaryActionColor = _this.currentCompany.SecundaryActionColor;
            _this.InputColor = _this.currentCompany.InputColor;
            _this.HoverMenuColor = _this.currentCompany.HoverMenuColor;
            _this.LineMenuColor = _this.currentCompany.LineMenuColor;
            _this.BackgroundImage = _this.currentCompany.BackgroundImage;
            _this.LogoWeb = _this.currentCompany.LogoWeb;
            _this.WellcomeSystemMessage = _this.currentCompany.WellcomeSystemMessage;
        }
        _this.tryGetSystem();
        return _this;
    }
    /**
     * @return {?}
     */
    AppService.prototype.tryGetSystem = /**
     * @return {?}
     */
    function () {
        var _this = this;
        this.countTryGetSystem++;
        if (!this.environment.systemId && this.countTryGetSystem < 3) {
            setTimeout(function () {
                this.tryGetSystem();
            }, 1000);
        }
        else {
            this.getSystem().subscribe(function (system) {
                _this.titleService.setTitle(system.Description);
            });
        }
    };
    /**
     * @return {?}
     */
    AppService.prototype.logout = /**
     * @return {?}
     */
    function () {
        this.cookieService.deleteCookie('auth');
        this.cookieService.deleteCookie('company');
        window.location.href = this.router.url + '?logout=true';
    };
    /**
     * @return {?}
     */
    AppService.prototype.getSystem = /**
     * @return {?}
     */
    function () {
        return this.http.get(this.environment.apiCore + 'system/' + this.environment.systemId);
    };
    /**
     * @return {?}
     */
    AppService.prototype.getAllSystems = /**
     * @return {?}
     */
    function () {
        return this.http.get(this.environment.apiCore + 'system/getAllWithUrl');
    };
    AppService.decorators = [
        { type: Injectable, args: [{
                    providedIn: 'root'
                },] }
    ];
    /** @nocollapse */
    AppService.ctorParameters = function () { return [
        { type: undefined, decorators: [{ type: Inject, args: [RTE_COOKIE_SERVICE_DATA,] }] },
        { type: Router },
        { type: HttpClient },
        { type: undefined, decorators: [{ type: Inject, args: ['environment',] }] },
        { type: Title }
    ]; };
    /** @nocollapse */ AppService.ngInjectableDef = defineInjectable({ factory: function AppService_Factory() { return new AppService(inject(RTE_COOKIE_SERVICE_DATA), inject(Router), inject(HttpClient), inject("environment"), inject(Title)); }, token: AppService, providedIn: "root" });
    return AppService;
}(RteMaterialBaseService));

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var CookieService = /** @class */ (function () {
    function CookieService() {
    }
    /**
     * @param {?} name
     * @param {?} value
     * @return {?}
     */
    CookieService.prototype.setCookie = /**
     * @param {?} name
     * @param {?} value
     * @return {?}
     */
    function (name, value) {
        document.cookie = name + '=' + value + ';path=/';
    };
    /**
     * @param {?} name
     * @return {?}
     */
    CookieService.prototype.getCookie = /**
     * @param {?} name
     * @return {?}
     */
    function (name) {
        name = name + '=';
        /** @type {?} */
        var decodedCookie = decodeURIComponent(document.cookie);
        /** @type {?} */
        var ca = decodedCookie.split(';');
        for (var i = 0; i < ca.length; i++) {
            /** @type {?} */
            var c = ca[i];
            while (c.charAt(0) == ' ') {
                c = c.substring(1);
            }
            if (c.indexOf(name) == 0) {
                return c.substring(name.length, c.length);
            }
        }
        return '';
    };
    /**
     * @param {?} name
     * @return {?}
     */
    CookieService.prototype.deleteCookie = /**
     * @param {?} name
     * @return {?}
     */
    function (name) {
        document.cookie = name + '=;expires=Thu, 01 Jan 1970 00:00:01 GMT;path=/';
    };
    CookieService.decorators = [
        { type: Injectable, args: [{
                    providedIn: 'root'
                },] }
    ];
    /** @nocollapse */ CookieService.ngInjectableDef = defineInjectable({ factory: function CookieService_Factory() { return new CookieService(); }, token: CookieService, providedIn: "root" });
    return CookieService;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var RteSnackbarService = /** @class */ (function () {
    function RteSnackbarService(snackBar) {
        this.snackBar = snackBar;
        this.snackbarOptions = {
            duration: 6000,
            verticalPosition: 'top'
        };
    }
    /**
     * @param {?} message
     * @param {?} action
     * @return {?}
     */
    RteSnackbarService.prototype.showMessage = /**
     * @param {?} message
     * @param {?} action
     * @return {?}
     */
    function (message, action) {
        this.snackbarOptions.panelClass = 'rte-snackbar-message';
        this.snackBar.open(message, action, this.snackbarOptions);
    };
    /**
     * @param {?} message
     * @param {?} action
     * @return {?}
     */
    RteSnackbarService.prototype.showErrorMessage = /**
     * @param {?} message
     * @param {?} action
     * @return {?}
     */
    function (message, action) {
        this.snackbarOptions.panelClass = 'rte-snackbar-error-message';
        this.snackBar.open(message, action, this.snackbarOptions);
    };
    /**
     * @param {?} message
     * @param {?} action
     * @return {?}
     */
    RteSnackbarService.prototype.showSuccessMessage = /**
     * @param {?} message
     * @param {?} action
     * @return {?}
     */
    function (message, action) {
        this.snackbarOptions.panelClass = 'rte-snackbar-success-message';
        this.snackBar.open(message, action, this.snackbarOptions);
    };
    /**
     * @param {?} message
     * @param {?} action
     * @return {?}
     */
    RteSnackbarService.prototype.showWarningMessage = /**
     * @param {?} message
     * @param {?} action
     * @return {?}
     */
    function (message, action) {
        this.snackbarOptions.panelClass = 'rte-snackbar-warning-message';
        this.snackBar.open(message, action, this.snackbarOptions);
    };
    RteSnackbarService.decorators = [
        { type: Injectable, args: [{
                    providedIn: 'root'
                },] },
        { type: Injectable, args: [{
                    providedIn: 'root'
                },] }
    ];
    /** @nocollapse */
    RteSnackbarService.ctorParameters = function () { return [
        { type: MatSnackBar }
    ]; };
    /** @nocollapse */ RteSnackbarService.ngInjectableDef = defineInjectable({ factory: function RteSnackbarService_Factory() { return new RteSnackbarService(inject(MatSnackBar$1)); }, token: RteSnackbarService, providedIn: "root" });
    return RteSnackbarService;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var RteColorService$$1 = /** @class */ (function () {
    function RteColorService$$1(appService) {
        this.appService = appService;
    }
    /**
     * @return {?}
     */
    RteColorService$$1.prototype.getMenuColor = /**
     * @return {?}
     */
    function () {
        if (this.appService.currentCompany && this.appService.currentCompany.MenuColor) {
            return this.appService.currentCompany.MenuColor;
        }
        return '#01579b';
    };
    /**
     * @return {?}
     */
    RteColorService$$1.prototype.getLineMenuColor = /**
     * @return {?}
     */
    function () {
        if (this.appService.currentCompany && this.appService.currentCompany.LineMenuColor) {
            return this.appService.currentCompany.LineMenuColor;
        }
        return '#F57C00';
    };
    /**
     * @param {?} onHover
     * @param {?} elementRef
     * @return {?}
     */
    RteColorService$$1.prototype.getHoverMenuColor = /**
     * @param {?} onHover
     * @param {?} elementRef
     * @return {?}
     */
    function (onHover, elementRef) {
        if (this.appService.currentCompany) {
            if (onHover && this.appService.currentCompany.HoverMenuColor) {
                ((/** @type {?} */ (elementRef.nativeElement))).style.backgroundColor = this.appService.currentCompany.HoverMenuColor;
            }
            else if (this.appService.currentCompany.MenuColor) {
                ((/** @type {?} */ (elementRef.nativeElement))).style.backgroundColor = this.appService.currentCompany.MenuColor;
            }
            else {
                ((/** @type {?} */ (elementRef.nativeElement))).style.backgroundColor = '#01579b';
            }
        }
    };
    /**
     * @param {?} elementRef
     * @return {?}
     */
    RteColorService$$1.prototype.getInputColor = /**
     * @param {?} elementRef
     * @return {?}
     */
    function (elementRef) {
        if (this.appService.currentCompany) {
            /** @type {?} */
            var color = '';
            if (elementRef.nativeElement.classList.contains('mat-focused') === true) {
                color = '#3f51b5';
                if (this.appService.currentCompany.InputColor) {
                    color = this.appService.currentCompany.InputColor;
                }
            }
            else if (elementRef.nativeElement.classList.contains('mat-form-field-invalid') === true) {
                color = '#f44336';
                if (!this.appService.currentCompany.ValidationFieldColor) {
                    color = this.appService.currentCompany.ValidationFieldColor;
                }
            }
            else {
                color = '#e0e0e0';
                if (this.appService.CompanyBackColor) {
                    color = this.appService.CompanyBackColor;
                }
            }
            return color;
        }
    };
    /**
     * @return {?}
     */
    RteColorService$$1.prototype.getLabelColor = /**
     * @return {?}
     */
    function () {
        return 'rgba(0,0,0,.54)';
    };
    /**
     * @param {?} elementRef
     * @return {?}
     */
    RteColorService$$1.prototype.getBackgroundColor = /**
     * @param {?} elementRef
     * @return {?}
     */
    function (elementRef) {
        if (this.appService.currentCompany) {
            if (elementRef.nativeElement.classList.contains('mat-form-field-invalid') === true
                && this.appService.currentCompany.ValidationFieldColor) {
                /** @type {?} */
                var matErrorInput = elementRef.nativeElement.getElementsByClassName('mat-input-element');
                if (matErrorInput.length > 0) {
                    matErrorInput.item(0).setAttribute('style', 'caret-color: '
                        + this.appService.currentCompany.ValidationFieldColor + ' !important');
                }
                /** @type {?} */
                var matError = elementRef.nativeElement.getElementsByClassName('mat-error');
                if (matError.length > 0) {
                    matError.item(0).style.color = this.appService.currentCompany.ValidationFieldColor;
                }
                return this.appService.currentCompany.ValidationFieldColor;
            }
            return this.appService.currentCompany.InputColor;
        }
    };
    RteColorService$$1.decorators = [
        { type: Injectable, args: [{
                    providedIn: 'root'
                },] }
    ];
    /** @nocollapse */
    RteColorService$$1.ctorParameters = function () { return [
        { type: undefined, decorators: [{ type: Inject, args: [RTE_APP_SERVICE_DATA,] }] }
    ]; };
    /** @nocollapse */ RteColorService$$1.ngInjectableDef = defineInjectable({ factory: function RteColorService_Factory() { return new RteColorService$$1(inject(RTE_APP_SERVICE_DATA)); }, token: RteColorService$$1, providedIn: "root" });
    return RteColorService$$1;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
var RTE_INTERCEPTOR_SKIP_HEADER$$1 = 'RTE-Skip-Interceptor';
var AppHttpInterceptor$$1 = /** @class */ (function () {
    function AppHttpInterceptor$$1(appService, cookieService, rteAlertService, tabService, dialogs) {
        this.appService = appService;
        this.cookieService = cookieService;
        this.rteAlertService = rteAlertService;
        this.tabService = tabService;
        this.dialogs = dialogs;
    }
    /**
     * @param {?} req
     * @param {?} next
     * @return {?}
     */
    AppHttpInterceptor$$1.prototype.intercept = /**
     * @param {?} req
     * @param {?} next
     * @return {?}
     */
    function (req, next) {
        var _this = this;
        if (req.headers.has(RTE_INTERCEPTOR_SKIP_HEADER$$1)) {
            /** @type {?} */
            var headers = req.headers.delete(RTE_INTERCEPTOR_SKIP_HEADER$$1);
            return next.handle(req.clone({ headers: headers }));
        }
        /** @type {?} */
        var token = this.appService.currentUser != null ? this.appService.currentUser.accessToken :
            this.appService.currentUserNewPassword != null ? this.appService.currentUserNewPassword.accessToken : '';
        /** @type {?} */
        var authReq = req.clone({
            headers: req.headers.set('Authorization', 'Bearer ' + token)
        });
        /** @type {?} */
        var noSpinner = req.headers.get('no-loading');
        if (!noSpinner || noSpinner.toLowerCase() !== 'true') {
            setTimeout(function () {
                _this.appService.requestingAPI.set(req, _this.tabService.getCurrentIndex());
                _this.appService.requestApi.emit(true);
            });
        }
        return next.handle(authReq).pipe(tap(function (event) { }, function (err) { }), finalize(function () {
            setTimeout(function () {
                _this.appService.requestingAPI.delete(req);
                _this.appService.requestApi.emit(false);
            });
        }), catchError(function (err) {
            setTimeout(function () {
                _this.appService.requestingAPI.delete(req);
                _this.appService.requestApi.emit(false);
            });
            if (err.status === 401) {
                _this.appService.currentUser = null;
                _this.rteAlertService.error('Operação não autorizada.');
                _this.cookieService.deleteCookie('auth');
                _this.dialogs.openDialogs.forEach(function (element) {
                    element.close();
                });
            }
            else if (err.status === 500) {
                if (err.error.ExceptionMessage) {
                    _this.rteAlertService.error(err.error.ExceptionMessage);
                }
                else if (err.error.Message) {
                    _this.rteAlertService.error(err.error.Message);
                }
                else {
                    _this.rteAlertService.error('Um erro ocorreu durante a solicitação');
                }
            }
            else if (err.status === 403) {
                _this.rteAlertService.error('O usuário não possui acesso ao objeto.');
            }
            else if (err.status === 400) {
                if (err.error.error === 'invalid_grant') {
                    _this.rteAlertService.error('Login ou senha inválidos.');
                }
                else if (err.error.error_description !== undefined) {
                    _this.rteAlertService.error('Um erro ocorreu', err.error.error_description, { expanded: true });
                }
                else {
                    if (err.error.Message !== undefined) {
                        _this.rteAlertService.error('Um erro ocorreu', err.error.Message, { expanded: true });
                    }
                    else {
                        if (err.error.ErrorMessage !== undefined) {
                            _this.rteAlertService.error('Um erro ocorreu', '' + err.error.ErrorMessage, { expanded: true });
                        }
                        else {
                            _this.rteAlertService.error('Não foi possível concluir a solicitação.');
                        }
                    }
                }
                throw err;
            }
            else {
                _this.rteAlertService.error('Operação falhou, tente novamente.');
                return EMPTY;
            }
        }));
    };
    AppHttpInterceptor$$1.decorators = [
        { type: Injectable }
    ];
    /** @nocollapse */
    AppHttpInterceptor$$1.ctorParameters = function () { return [
        { type: undefined, decorators: [{ type: Inject, args: [RTE_APP_SERVICE_DATA,] }] },
        { type: undefined, decorators: [{ type: Inject, args: [RTE_COOKIE_SERVICE_DATA,] }] },
        { type: RTEAlertService },
        { type: TabService },
        { type: RteDialog }
    ]; };
    return AppHttpInterceptor$$1;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var Company = /** @class */ (function () {
    function Company() {
    }
    return Company;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var CurrentUser = /** @class */ (function () {
    function CurrentUser() {
    }
    return CurrentUser;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @template T
 */
var  /**
 * @template T
 */
PagedBaseResponse = /** @class */ (function () {
    function PagedBaseResponse() {
    }
    return PagedBaseResponse;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var Option = /** @class */ (function () {
    function Option() {
    }
    return Option;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var System = /** @class */ (function () {
    function System() {
    }
    return System;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var TabComponent = /** @class */ (function () {
    function TabComponent(componentFactoryResolver, injector, route, tabService, appService) {
        this.componentFactoryResolver = componentFactoryResolver;
        this.injector = injector;
        this.route = route;
        this.tabService = tabService;
        this.appService = appService;
        this.tabs = new Array();
        this.selected = new FormControl(0);
        this.hasDefaultTabOpened = false;
    }
    /**
     * @return {?}
     */
    TabComponent.prototype.openDefaultTab = /**
     * @return {?}
     */
    function () {
        this.openTab('Pesquisa', 'consultaaplicacao', false);
    };
    /**
     * @return {?}
     */
    TabComponent.prototype.removeCurrentTab = /**
     * @return {?}
     */
    function () {
        this.removeTab(this.currentIndexTab);
    };
    /**
     * @param {?} index
     * @return {?}
     */
    TabComponent.prototype.removeTab = /**
     * @param {?} index
     * @return {?}
     */
    function (index) {
        if (index === this.currentIndexTab) {
            this.tabs.splice(this.currentIndexTab, 1);
            this.viewContainerRef.remove(this.currentIndexTab);
            if (this.currentIndexTab === 0 && this.tabs.length >= 1) {
                this.currentIndexTab = 0;
            }
            else {
                this.currentIndexTab = this.currentIndexTab - 1;
            }
            if (this.currentIndexTab === -1) {
                this.openDefaultTab();
            }
            else {
                this.selected.setValue(this.currentIndexTab);
                this.tabs[this.currentIndexTab].RootElement.hidden = false;
            }
        }
        else {
            this.tabs.splice(index, 1);
            this.viewContainerRef.remove(index);
            if (this.tabs.length === 0) {
                this.openDefaultTab();
            }
        }
        this.transformTabs(false);
        return false;
    };
    /**
     * @param {?} pIndex
     * @return {?}
     */
    TabComponent.prototype.setIndiceTab = /**
     * @param {?} pIndex
     * @return {?}
     */
    function (pIndex) {
        /** @type {?} */
        var currentIndex = this.currentIndexTab;
        this.hideAllTabs();
        this.currentIndexTab = pIndex;
        this.selected.setValue(this.currentIndexTab);
        this.tabs[this.currentIndexTab].RootElement.hidden = false;
        /** @type {?} */
        var firstInput = this.tabs[this.currentIndexTab].RootElement.getElementsByTagName('input');
        if (firstInput.length > 0) {
            window.setTimeout(function () {
                firstInput[0].focus();
            }, 100);
        }
    };
    /**
     * @return {?}
     */
    TabComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        this.tabService.setTabComponent(this);
        this.openDefaultTab();
        this.limitHeight = window.innerHeight;
    };
    /**
     * @return {?}
     */
    TabComponent.prototype.hideAllTabs = /**
     * @return {?}
     */
    function () {
        for (var i = 0; i < this.tabs.length; i++) {
            this.tabs[i].RootElement.hidden = true;
        }
    };
    /**
     * @param {?} ptitle
     * @param {?} plink
     * @param {?} fromSearch
     * @param {?=} breadcrumb
     * @param {?=} parameters
     * @return {?}
     */
    TabComponent.prototype.openTab = /**
     * @param {?} ptitle
     * @param {?} plink
     * @param {?} fromSearch
     * @param {?=} breadcrumb
     * @param {?=} parameters
     * @return {?}
     */
    function (ptitle, plink, fromSearch, breadcrumb, parameters) {
        if (breadcrumb === void 0) { breadcrumb = ''; }
        if (parameters === void 0) { parameters = []; }
        if (plink.startsWith('/')) {
            plink = plink.substr(1);
        }
        /** @type {?} */
        var route = this.route.config.find(function (x) { return x.path === plink; });
        /** @type {?} */
        var componentType = route.component;
        /** @type {?} */
        var componentRef = this.componentFactoryResolver
            .resolveComponentFactory(componentType)
            .create(this.injector);
        if (componentRef.instance.toolbarObject != null) {
            /** @type {?} */
            var toolbarObject = componentRef.instance.toolbarObject;
            toolbarObject.objectNamespace = route.path;
        }
        componentRef.instance.Route = route;
        parameters.forEach(function (element) {
            componentRef.instance[element.PropertyName] = element.Value;
        });
        /** @type {?} */
        var rootElement = ((/** @type {?} */ (((/** @type {?} */ (componentRef.hostView))).rootNodes[0])));
        /** @type {?} */
        var appBreadcrumb = rootElement.getElementsByClassName('app-breadcrumb');
        if (appBreadcrumb.length > 0) {
            appBreadcrumb[0].innerHTML = breadcrumb;
        }
        /** @type {?} */
        var appTitle = rootElement.getElementsByClassName('app-title');
        if (appTitle.length > 0) {
            appTitle[0].innerHTML = ptitle;
        }
        if (fromSearch == false) {
            this.tabs.push({
                Title: ptitle,
                Path: plink,
                ComponentRef: componentRef,
                RootElement: rootElement,
                Breadcrumb: breadcrumb
            });
            this.setIndiceTab(this.tabs.length - 1);
            this.viewContainerRef.insert(componentRef.hostView);
        }
        else {
            this.tabs[this.currentIndexTab] = {
                Title: ptitle,
                Path: plink,
                ComponentRef: componentRef,
                RootElement: rootElement,
                Breadcrumb: breadcrumb
            };
            this.viewContainerRef.insert(componentRef.hostView, this.currentIndexTab);
            this.viewContainerRef.remove(this.currentIndexTab + 1);
        }
        this.transformTabs(false);
    };
    /**
     * @param {?} fromSidebar
     * @return {?}
     */
    TabComponent.prototype.transformTabs = /**
     * @param {?} fromSidebar
     * @return {?}
     */
    function (fromSidebar) {
        /** @type {?} */
        var self = this;
        /** @type {?} */
        var currentSelectedLinkToTransform;
        window.setTimeout(function () {
            /** @type {?} */
            var tabs = document.getElementsByClassName("tab-container");
            for (var i = 0; i < tabs.length; i++) {
                /** @type {?} */
                var tabHtmlElement = (/** @type {?} */ (tabs[i]));
                /** @type {?} */
                var width = tabHtmlElement.clientWidth;
                /** @type {?} */
                var transform = "perspective(100px) rotateX(20deg)";
                if (width < 200) {
                    /** @type {?} */
                    var perspective = (width / 200) * 100;
                    transform = "perspective(" + perspective + "px) rotateX(20deg)";
                }
                /** @type {?} */
                var linkToTransform = (/** @type {?} */ ((tabHtmlElement.getElementsByClassName("rte-tab")[0])));
                linkToTransform.style.transform = transform;
                linkToTransform.style.webkitTransform = transform;
                if (self.currentIndexTab == i) {
                    currentSelectedLinkToTransform = linkToTransform;
                    currentSelectedLinkToTransform.classList.remove("selected");
                    window.setTimeout(function () {
                        currentSelectedLinkToTransform.classList.add("selected");
                    }, 25);
                }
            }
        }, fromSidebar == false ? 1 : 150);
    };
    /**
     * @param {?} event
     * @return {?}
     */
    TabComponent.prototype.onResize = /**
     * @param {?} event
     * @return {?}
     */
    function (event) {
        this.limitHeight = event.target.innerHeight;
    };
    /**
     * @return {?}
     */
    TabComponent.prototype.getHeight = /**
     * @return {?}
     */
    function () {
        /** @type {?} */
        var height = this.limitHeight - 190;
        return height.toString() + 'px';
    };
    /**
     * @param {?} event
     * @return {?}
     */
    TabComponent.prototype.onScroll = /**
     * @param {?} event
     * @return {?}
     */
    function (event) {
        if (this.spinner) {
            /** @type {?} */
            var scrollTop = event.currentTarget.document.children[0].scrollTop;
            if (scrollTop == 0 && document.body != null) {
                scrollTop = document.body.scrollTop;
            }
            if (scrollTop >= 90) {
                this.spinner._elementRef.nativeElement.children[0].style.top = '0px';
            }
            else {
                this.spinner._elementRef.nativeElement.children[0].style.top = (90 - scrollTop) + 'px';
            }
        }
    };
    /**
     * @return {?}
     */
    TabComponent.prototype.showLoadSpinner = /**
     * @return {?}
     */
    function () {
        var _this = this;
        /** @type {?} */
        var isLoading = false;
        this.appService.requestingAPI.forEach(function (value) {
            if (value === _this.currentIndexTab) {
                isLoading = true;
            }
        });
        return isLoading;
    };
    TabComponent.decorators = [
        { type: Component, args: [{
                    selector: 'rte-tab',
                    template: "<nav mat-tab-nav-bar [class.only-one-tab]=\"(tabs.length == 1 && hasDefaultTabOpened == true) || (tabs.length == 1 && currentIndexTab == 0)\">\r\n  <div *ngFor=\"let tab of tabs; let indice = index\" class=\"tab-container\" (click)=\"setIndiceTab(indice)\">\r\n    <div class=\"tab-title\" fxFlex>\r\n      {{tab.Title}}\r\n    </div>\r\n    <div rtebutton-icon class=\"tab-close-button\" fxFlex fxLayoutAlign=\"end\">\r\n      <rte-icon (click)=\"removeTab(indice);\" matPrefix fontSet=\"fa\" fontIcon=\"fa-times\" class=\"tab-close-button-icon\" [class.selected]=\"indice == currentIndexTab\"></rte-icon>\r\n    </div>\r\n    <div class=\"mat-tab-link-border-left\"></div>\r\n    <a mat-tab-link routerLinkActive #rla=\"routerLinkActive\" [active]=\"rla.isActive\" [class.selected]=\"indice == currentIndexTab\" class=\"rte-tab\">\r\n      <div fxLayout=\"row\" fxFlex fxLayoutAlign=\"center center\">\r\n\r\n      </div>\r\n    </a>\r\n  </div>\r\n\r\n  <a (click)=\"openDefaultTab()\" class=\"new-tab\">\r\n    <rte-icon matPrefix fontSet=\"fa\" fontIcon=\"fa-plus\"></rte-icon>\r\n  </a>\r\n</nav>\r\n<rte-spinner [hidden]=\"showLoadSpinner() == false\"></rte-spinner>\r\n<div class=\"scroll tab-content-holder\"\r\n     [style.min-height]=\"getHeight()\">\r\n  \r\n  <ng-template #tabsContents></ng-template>\r\n</div>\r\n",
                    styles: ["::ng-deep .mat-tab-nav-bar .mat-tab-links a{margin:0 15px 0 -1px;border-top-left-radius:2px;border-top-right-radius:2px;border:1px solid #aaa;max-height:35px;position:relative;background:#d8d8d8;display:inline-flex;color:#222;text-decoration:none;padding:3px 3px 3px 15px;opacity:1}.mat-tab-nav-bar{border:none}.mat-tab-link:not(.selected):hover{background-color:rgba(216,216,216,.9)!important}.mat-tab-link:not(.selected){margin-bottom:-1px}.mat-tab-link{min-width:100%;width:100%}::ng-deep .mat-tab-nav-bar .mat-tab-links .mat-tab-label-active{z-index:2;border-top-left-radius:37px 190px;border-top-right-radius:37px 190px;max-height:35px;background:#fff}::ng-deep .mat-ink-bar{background-color:#fff!important}.mat-tab-link:focus:not(.mat-tab-disabled){background-color:#fff!important}::ng-deep .mat-tab-nav-bar .mat-tab-links{padding-left:15px;border-bottom:1px solid #aaa;margin-top:5px}rte-icon{border-radius:50%;width:20px;height:17px;padding-top:4px}rte-icon.tab-close-button-icon{margin-top:1.5px}rte-icon.tab-close-button-icon:hover{color:#fff;background-color:#c96363!important;cursor:default}.tab-container{display:inline-block!important;font-size:14px;width:100%;position:relative;cursor:default;max-width:200px}.tab-close-button{border-radius:50%;position:absolute;left:0;z-index:99;top:8px!important;display:inline-flex!important;text-align:center;right:5px}.tab-title{margin-right:5px;position:absolute;left:10px!important;z-index:99;top:8px!important;display:inline-flex;width:100%;overflow:hidden;height:20px}.new-tab{cursor:default;margin-top:7px!important;transform:skew(19deg);-o-transform:skew(19deg);-ms-transform:skew(19deg);-moz-transform:skew(19deg);-khtml-transform:skew(19deg);-webkit-transform:skew(19deg);opacity:.626;border-radius:2px;height:14px;margin-left:5px!important;width:auto;padding-left:10px!important;padding-right:10px!important;box-shadow:-1px 1px #aaa}.new-tab:hover{background-color:rgba(216,216,216,.9)!important}.new-tab>rte-icon{transform:skew(-14deg);padding-top:2px}.tab-close-button rte-icon{background-color:#d8d8d8}.tab-close-button rte-icon.selected{background-color:#fff}.rte-tab div{transform:perspective(100px) rotateX(-11deg)!important;-o-transform:perspective(100px) rotateX(-11deg)!important;-ms-transform:perspective(100px) rotateX(-11deg)!important;-moz-transform:perspective(100px) rotateX(-11deg)!important;-khtml-transform:perspective(100px) rotateX(-11deg)!important;-webkit-transform:perspective(100px) rotateX(-11deg)!important}.rte-tab div>rte-icon{transform:none!important;-o-transform:none!important;-ms-transform:none!important;-moz-transform:none!important;-khtml-transform:none!important;-webkit-transform:none!important}.rte-tab.selected{background-color:#fff!important;z-index:4;border-bottom-color:#fff!important;margin-bottom:-1px!important}.rte-tab{border-bottom-left-radius:0!important;border-bottom-right-radius:0!important;cursor:default!important}.rte-tab.selected.only-one-seleted{margin-top:1px!important}.mat-icon.fa.fa-plus{width:auto;height:auto}.scroll{overflow-y:auto;background-color:#fafafa}.tab-content-holder{padding-top:45px;padding-bottom:55px}"]
                }] }
    ];
    /** @nocollapse */
    TabComponent.ctorParameters = function () { return [
        { type: ComponentFactoryResolver },
        { type: Injector },
        { type: Router },
        { type: TabService },
        { type: undefined, decorators: [{ type: Inject, args: [RTE_APP_SERVICE_DATA,] }] }
    ]; };
    TabComponent.propDecorators = {
        viewContainerRef: [{ type: ViewChild, args: ['tabsContents', { read: ViewContainerRef },] }],
        spinner: [{ type: ViewChild, args: [SpinnerComponent,] }],
        onResize: [{ type: HostListener, args: ['window:resize', ['$event'],] }],
        onScroll: [{ type: HostListener, args: ['window:scroll', ['$event'],] }]
    };
    return TabComponent;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var RteTabModule = /** @class */ (function () {
    function RteTabModule() {
    }
    RteTabModule.decorators = [
        { type: NgModule, args: [{
                    imports: [
                        CommonModule,
                        MatTabsModule,
                        RouterModule,
                        FlexLayoutModule,
                        RteMaterialModule,
                        RteLibraryModule,
                        RteSpinnerModule
                    ],
                    declarations: [TabComponent],
                    exports: [TabComponent]
                },] }
    ];
    return RteTabModule;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var TabParameter = /** @class */ (function () {
    function TabParameter() {
    }
    return TabParameter;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @abstract
 */
var  /**
 * @abstract
 */
BaseValueAccessor = /** @class */ (function () {
    function BaseValueAccessor() {
        this._value = '';
        this.onChange = function (_$$1) { };
        this.onTouched = function () { };
    }
    Object.defineProperty(BaseValueAccessor.prototype, "value", {
        get: /**
         * @return {?}
         */
        function () { return this._value; },
        set: /**
         * @param {?} v
         * @return {?}
         */
        function (v) {
            if (v !== this._value) {
                this._value = v;
                this.onChange(v);
            }
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @param {?} value
     * @return {?}
     */
    BaseValueAccessor.prototype.writeValue = /**
     * @param {?} value
     * @return {?}
     */
    function (value) {
        this._value = value;
        this.onChange(value);
    };
    /**
     * @param {?} fn
     * @return {?}
     */
    BaseValueAccessor.prototype.registerOnChange = /**
     * @param {?} fn
     * @return {?}
     */
    function (fn) { this.onChange = fn; };
    /**
     * @param {?} fn
     * @return {?}
     */
    BaseValueAccessor.prototype.registerOnTouched = /**
     * @param {?} fn
     * @return {?}
     */
    function (fn) { this.onTouched = fn; };
    return BaseValueAccessor;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var AutoCompleteComponent = /** @class */ (function (_super) {
    __extends(AutoCompleteComponent, _super);
    function AutoCompleteComponent() {
        var _this = _super.call(this) || this;
        _this.placeholder = '<Search>';
        // tslint:disable-next-line:no-output-on-prefix
        _this.onSelectedOption = new EventEmitter();
        _this.icon = 'place';
        _this.filterControl = new FormControl();
        return _this;
    }
    /**
     * @return {?}
     */
    AutoCompleteComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
    };
    /**
     * @param {?=} option
     * @return {?}
     */
    AutoCompleteComponent.prototype.displayFn = /**
     * @param {?=} option
     * @return {?}
     */
    function (option) {
        return option ? option.Description : undefined;
    };
    /**
     * @private
     * @param {?} value
     * @return {?}
     */
    AutoCompleteComponent.prototype._filter = /**
     * @private
     * @param {?} value
     * @return {?}
     */
    function (value) {
        var _this = this;
        /** @type {?} */
        var filterValue = this.toLowerCaseRemoveAccents(value);
        /** @type {?} */
        var result = this.options.filter(function (option) { return _this.toLowerCaseRemoveAccents(option.Description).includes(filterValue); });
        return result;
    };
    /**
     * @param {?} value
     * @return {?}
     */
    AutoCompleteComponent.prototype.change = /**
     * @param {?} value
     * @return {?}
     */
    function (value) {
        if (value !== '' && value !== null) {
            this.filteredOptions = this._filter(value).slice(0, 9);
        }
        else {
            this.filteredOptions = [];
        }
    };
    /**
     * @param {?} option
     * @return {?}
     */
    AutoCompleteComponent.prototype.selectedOption = /**
     * @param {?} option
     * @return {?}
     */
    function (option) {
        this.filteredOptions = this._filter(option.Description).slice(0, 9);
        if (this.filteredOptions.length === 1) {
            this.filteredOptions = null;
        }
        this.onSelectedOption.emit(option);
        this.filterControl.setValue('');
    };
    /**
     * @param {?} valueFilter
     * @return {?}
     */
    AutoCompleteComponent.prototype.toLowerCaseRemoveAccents = /**
     * @param {?} valueFilter
     * @return {?}
     */
    function (valueFilter) {
        /** @type {?} */
        var text = typeof valueFilter === 'object' ? valueFilter.Description : valueFilter;
        text = text.normalize('NFD').replace(/[\u0300-\u036f]/g, "");
        if (text !== undefined && text !== '') {
            return text.toLowerCase();
        }
        else {
            return text;
        }
    };
    AutoCompleteComponent.decorators = [
        { type: Component, args: [{
                    selector: 'rte-auto-complete',
                    template: "<rte-form-field class=\"rte-autocomplete\">\r\n  \r\n\r\n  <input class=\"input-autocomplete\" type=\"text\" rteInput [placeholder]=\"placeholder\" [rteMatAutocomplete]=\"auto\" [formControl]=\"filterControl\" (keyup)=\"change(filterControl.value);\"\r\n    [(ngModel)]=\"value\">\r\n\r\n  <rte-matautocomplete #auto=\"rteMatAutocomplete\" [displayWith]=\"displayFn\">\r\n    <rte-option *ngFor=\"let option of filteredOptions\" [value]=\"option\" (onSelectionChange)=\"selectedOption(option);\">\r\n      {{ option.Description }}\r\n    </rte-option>\r\n  </rte-matautocomplete>\r\n  <rte-icon matSuffix class=\"material-icons\">search</rte-icon>\r\n</rte-form-field>\r\n\r\n",
                    styles: ["rte-form-field{width:100%;padding:11px}rte-matautocomplete{max-height:100px}rte-option{font-size:12px}.material-icons{margin-top:-18px;position:absolute;margin-left:-38px!important}"]
                }] }
    ];
    /** @nocollapse */
    AutoCompleteComponent.ctorParameters = function () { return []; };
    AutoCompleteComponent.propDecorators = {
        placeholder: [{ type: Input }],
        options: [{ type: Input }],
        onSelectedOption: [{ type: Output }],
        icon: [{ type: Input }]
    };
    return AutoCompleteComponent;
}(BaseValueAccessor));

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var RteAutoCompleteModule = /** @class */ (function () {
    function RteAutoCompleteModule() {
    }
    RteAutoCompleteModule.decorators = [
        { type: NgModule, args: [{
                    imports: [
                        CommonModule,
                        FormsModule,
                        ReactiveFormsModule,
                        MatIconModule,
                        MatToolbarModule,
                        MatButtonModule$1,
                        MatInputModule,
                        MatFormFieldModule,
                        RteMaterialModule
                    ],
                    declarations: [AutoCompleteComponent],
                    exports: [AutoCompleteComponent]
                },] }
    ];
    return RteAutoCompleteModule;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var HttpHelper = /** @class */ (function () {
    function HttpHelper() {
    }
    /**
     * @param {?} err
     * @return {?}
     */
    HttpHelper.prototype.getErrorMessage = /**
     * @param {?} err
     * @return {?}
     */
    function (err) {
        if (err.error && err.error.error_description) {
            return err.error.error_description;
        }
        return err.message;
    };
    return HttpHelper;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var RetroactiveLabelComponent = /** @class */ (function () {
    function RetroactiveLabelComponent() {
        this.timeDescriptor = [
            { time: 1000, singular: 'segundo', plural: 'segundos' },
            { time: 60000, singular: 'minuto', plural: 'minutos' },
            { time: 3600000, singular: 'hora', plural: 'horas' },
            { time: 86400000, singular: 'dia', plural: 'dias' },
            { time: 604800000, singular: 'semana', plural: 'semanas' },
            { time: 2592000000, singular: 'mês', plural: 'meses' },
            { time: 31104000000, singular: 'ano', plural: 'anos' }
        ];
    }
    /**
     * @return {?}
     */
    RetroactiveLabelComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
    };
    /**
     * @return {?}
     */
    RetroactiveLabelComponent.prototype.getTimePassed = /**
     * @return {?}
     */
    function () {
        this.date = typeof (this.date) === 'string' ? new Date(this.date) : this.date;
        /** @type {?} */
        var dif = +new Date() - (+this.date);
        /** @type {?} */
        var time = '';
        /** @type {?} */
        var unit = 'momentos';
        for (var i = 0; i < this.timeDescriptor.length; i++) {
            /** @type {?} */
            var item = this.timeDescriptor[i];
            /** @type {?} */
            var tempCalc = dif / item.time;
            if (tempCalc < 1) {
                break;
            }
            time = Math.round(tempCalc) + ' ';
            unit = tempCalc >= 2 ? item.plural : item.singular;
        }
        return time + unit + ' ';
    };
    RetroactiveLabelComponent.decorators = [
        { type: Component, args: [{
                    selector: 'rte-retroactive-label',
                    template: "{{getTimePassed()}} atr\u00E1s.\r\n",
                    styles: [""]
                }] }
    ];
    /** @nocollapse */
    RetroactiveLabelComponent.ctorParameters = function () { return []; };
    RetroactiveLabelComponent.propDecorators = {
        date: [{ type: Input }]
    };
    return RetroactiveLabelComponent;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var RteRetroactiveLabelModule = /** @class */ (function () {
    function RteRetroactiveLabelModule() {
    }
    RteRetroactiveLabelModule.decorators = [
        { type: NgModule, args: [{
                    imports: [
                        CommonModule
                    ],
                    exports: [RetroactiveLabelComponent],
                    declarations: [RetroactiveLabelComponent]
                },] }
    ];
    return RteRetroactiveLabelModule;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var BreadcrumbComponent = /** @class */ (function () {
    function BreadcrumbComponent() {
    }
    /**
     * @return {?}
     */
    BreadcrumbComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
    };
    BreadcrumbComponent.decorators = [
        { type: Component, args: [{
                    selector: 'rte-breadcrumb',
                    template: "<p class=\"mat-body-1 app-breadcrumb\"></p>\r\n",
                    styles: [".mat-body-1{margin-top:0;color:#9e9e9e}"]
                }] }
    ];
    /** @nocollapse */
    BreadcrumbComponent.ctorParameters = function () { return []; };
    return BreadcrumbComponent;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var RteBreadcrumbModule = /** @class */ (function () {
    function RteBreadcrumbModule() {
    }
    RteBreadcrumbModule.decorators = [
        { type: NgModule, args: [{
                    imports: [
                        CommonModule
                    ],
                    declarations: [BreadcrumbComponent],
                    exports: [BreadcrumbComponent]
                },] }
    ];
    return RteBreadcrumbModule;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var DisabledToolbarMinorButton = /** @class */ (function () {
    function DisabledToolbarMinorButton() {
        this.add = false;
        this.edit = false;
        this.remove = false;
    }
    return DisabledToolbarMinorButton;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var ShowToolbarMinorButton = /** @class */ (function () {
    function ShowToolbarMinorButton() {
        this.add = true;
        this.edit = true;
        this.remove = true;
    }
    return ShowToolbarMinorButton;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var ToolbarMinorComponent = /** @class */ (function () {
    function ToolbarMinorComponent() {
        this.showButton = new ShowToolbarMinorButton();
        this.disableButton = new DisabledToolbarMinorButton();
        this.isFixedToolbar = false;
        this.addEvent = new EventEmitter();
        this.editEvent = new EventEmitter();
        this.removeEvent = new EventEmitter();
    }
    /**
     * @return {?}
     */
    ToolbarMinorComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () { };
    /**
     * @return {?}
     */
    ToolbarMinorComponent.prototype.add = /**
     * @return {?}
     */
    function () {
        this.addEvent.emit();
    };
    /**
     * @return {?}
     */
    ToolbarMinorComponent.prototype.edit = /**
     * @return {?}
     */
    function () {
        this.editEvent.emit();
    };
    /**
     * @return {?}
     */
    ToolbarMinorComponent.prototype.remove = /**
     * @return {?}
     */
    function () {
        this.removeEvent.emit();
    };
    ToolbarMinorComponent.decorators = [
        { type: Component, args: [{
                    selector: 'rte-toolbar-minor',
                    template: "<rte-toolbar-lite [title]=\"title\" [isMain]=\"false\" [showRteSeparator]=\"false\" [isFixedToolbar]=\"isFixedToolbar\">\r\n  <span class=\"rte-spacer\"></span>\r\n  <div class=\"rte-app-actions\">\r\n    <ng-content></ng-content>\r\n  </div>\r\n  <mat-button-toggle-group #group=\"matButtonToggleGroup\">\r\n    <mat-button-toggle *ngIf=\"showButton.add\" [disabled]=\"disableButton.add\" title=\"Adicionar\" (click)=\"add()\">\r\n      <rte-icon class=\"material-icons\">add_circle_outline</rte-icon>\r\n      Adicionar\r\n    </mat-button-toggle>\r\n    <mat-button-toggle *ngIf=\"showButton.edit\" [disabled]=\"disableButton.edit\" title=\"Editar registro\" (click)=\"edit()\">\r\n      <rte-icon class=\"material-icons\">edit</rte-icon>\r\n      Editar\r\n    </mat-button-toggle>\r\n  </mat-button-toggle-group>\r\n  <button rtebutton-flat *ngIf=\"showButton.remove\" [disabled]=\"disableButton.remove\" color=\"warn\" title=\"Remover registro\" (click)=\"remove()\">\r\n    <rte-icon class=\"material-icons\">delete_outline</rte-icon>\r\n    Remover\r\n  </button>\r\n</rte-toolbar-lite>",
                    styles: [".rte-icon-arrows{min-width:0;padding:0}.rte-spacer{flex:1 1 auto}:host ::ng-deep mat-toolbar{border:none}:host ::ng-deep rte-divider{border:none}.mat-button-toggle-checked{background-color:inherit!important}"]
                }] }
    ];
    /** @nocollapse */
    ToolbarMinorComponent.ctorParameters = function () { return []; };
    ToolbarMinorComponent.propDecorators = {
        title: [{ type: Input }],
        showButton: [{ type: Input }],
        disableButton: [{ type: Input }],
        isFixedToolbar: [{ type: Input }],
        addEvent: [{ type: Output }],
        editEvent: [{ type: Output }],
        removeEvent: [{ type: Output }]
    };
    return ToolbarMinorComponent;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var RteToolbarMinorModule = /** @class */ (function () {
    function RteToolbarMinorModule() {
    }
    RteToolbarMinorModule.decorators = [
        { type: NgModule, args: [{
                    imports: [
                        CommonModule,
                        RteToolbarLiteModule,
                        RteMaterialModule,
                        MatButtonToggleModule
                    ],
                    declarations: [ToolbarMinorComponent],
                    exports: [ToolbarMinorComponent]
                },] }
    ];
    return RteToolbarMinorModule;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var AppTitleComponent = /** @class */ (function () {
    function AppTitleComponent() {
    }
    /**
     * @return {?}
     */
    AppTitleComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
    };
    AppTitleComponent.decorators = [
        { type: Component, args: [{
                    selector: 'rte-app-title',
                    template: "<h1 class=\"mat-title app-title\"></h1>\r\n<rte-breadcrumb></rte-breadcrumb>\r\n",
                    styles: [".mat-title{margin-bottom:0}"]
                }] }
    ];
    /** @nocollapse */
    AppTitleComponent.ctorParameters = function () { return []; };
    return AppTitleComponent;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var RteAppTitleModule = /** @class */ (function () {
    function RteAppTitleModule() {
    }
    RteAppTitleModule.decorators = [
        { type: NgModule, args: [{
                    imports: [
                        CommonModule,
                        RteBreadcrumbModule
                    ],
                    declarations: [AppTitleComponent],
                    exports: [AppTitleComponent]
                },] }
    ];
    return RteAppTitleModule;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var ApplicationSettingsModule = /** @class */ (function () {
    function ApplicationSettingsModule() {
    }
    ApplicationSettingsModule.decorators = [
        { type: NgModule, args: [{
                    imports: [
                        CommonModule
                    ],
                    declarations: []
                },] }
    ];
    return ApplicationSettingsModule;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var LoadApplicationSettingsResponse = /** @class */ (function () {
    function LoadApplicationSettingsResponse() {
    }
    return LoadApplicationSettingsResponse;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var PermissionRequest = /** @class */ (function () {
    function PermissionRequest() {
    }
    return PermissionRequest;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var PermissionResponse = /** @class */ (function () {
    function PermissionResponse() {
    }
    return PermissionResponse;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var ApplicationSettingsHelper = /** @class */ (function () {
    function ApplicationSettingsHelper() {
    }
    /**
     * @param {?} response
     * @param {?} assemblyName
     * @param {?} objectName
     * @return {?}
     */
    ApplicationSettingsHelper.HasPermission = /**
     * @param {?} response
     * @param {?} assemblyName
     * @param {?} objectName
     * @return {?}
     */
    function (response, assemblyName, objectName) {
        for (var i = 0; i < response.PermissionsResponse.length; i++) {
            if (response.PermissionsResponse[i].AssemblyName == assemblyName && response.PermissionsResponse[i].ObjectName == objectName) {
                return response.PermissionsResponse[i].HasPermission;
            }
        }
    };
    return ApplicationSettingsHelper;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var RteToastAlertComponent = /** @class */ (function (_super) {
    __extends(RteToastAlertComponent, _super);
    function RteToastAlertComponent(toastrService, toastPackage) {
        var _this = _super.call(this, toastrService, toastPackage) || this;
        _this.toastrService = toastrService;
        _this.toastPackage = toastPackage;
        return _this;
    }
    /**
     * @return {?}
     */
    RteToastAlertComponent.prototype.hasBody = /**
     * @return {?}
     */
    function () {
        /** @type {?} */
        var options = this.getOptions();
        if (!this.message && !options.actions) {
            return false;
        }
        return true;
    };
    /**
     * @param {?} action
     * @return {?}
     */
    RteToastAlertComponent.prototype.emitThis = /**
     * @param {?} action
     * @return {?}
     */
    function (action) {
        action.click();
    };
    /**
     * @return {?}
     */
    RteToastAlertComponent.prototype.getOptions = /**
     * @return {?}
     */
    function () {
        return (/** @type {?} */ (this.options));
    };
    RteToastAlertComponent.decorators = [
        { type: Component, args: [{
                    selector: 'rte-rte-toast-alert',
                    template: "<div style=\"display:flex; flex-direction: row;\">\r\n  <div style=\"flex:38 1 0;\">\r\n      <mat-expansion-panel\r\n          class=\"alert-expansible-area\"\r\n          [hideToggle]=\"!hasBody()\"\r\n          [ngClass]=\"!hasBody() ? 'disable-expansion' : ''\"\r\n          [expanded]=\"getOptions().expanded\"\r\n          >\r\n        <mat-expansion-panel-header>\r\n          <mat-panel-title>\r\n            {{ title }}\r\n          </mat-panel-title>\r\n        </mat-expansion-panel-header>\r\n        {{ message }}\r\n\r\n        <div *ngFor=\"let item of getOptions().actions\">\r\n          <button\r\n            rtebutton-stroked\r\n            (click)=\"emitThis(item)\"\r\n            [disabled]=\"item.disabled\"\r\n            >\r\n              {{item.description}}\r\n            </button>\r\n        </div>\r\n      </mat-expansion-panel>\r\n  </div>\r\n\r\n  <div style=\"flex:1 0 auto\">\r\n    <button *ngIf=\"options.closeButton\" (click)=\"remove()\" class=\"toast-close-button\" aria-label=\"Close\">\r\n      <span aria-hidden=\"true\">&times;</span>\r\n    </button>\r\n  </div>\r\n</div>\r\n<div *ngIf=\"options.progressBar\">\r\n  <div class=\"toast-progress\" [style.width]=\"width + '%'\"></div>\r\n</div>\r\n",
                    animations: [
                        trigger('flyInOut', [
                            state('inactive', style({
                                opacity: 0,
                            })),
                            transition('inactive => active', animate('800ms ease-out', keyframes([
                                style({
                                    transform: 'translate3d(100%, 0, 0) skewX(-30deg)',
                                    opacity: 0,
                                }),
                                style({
                                    transform: 'skewX(20deg)',
                                    opacity: 1,
                                }),
                                style({
                                    transform: 'skewX(-5deg)',
                                    opacity: 1,
                                }),
                                style({
                                    transform: 'none',
                                    opacity: 1,
                                }),
                            ]))),
                            transition('active => removed', animate('400ms ease-out', keyframes([
                                style({
                                    opacity: 1,
                                }),
                                style({
                                    transform: 'translate3d(100%, 0, 0) skewX(30deg)',
                                    opacity: 0,
                                }),
                            ]))),
                        ]),
                    ],
                    preserveWhitespaces: false,
                    styles: [".alert-expansible-area,.alert-expansible-area .mat-expansion-panel-header:hover,.alert-expansible-area:hover{box-shadow:none!important;background:0 0!important;color:inherit!important}.mat-accordion,.mat-expansion-panel-header-title{color:inherit!important;font-family:inherit!important;font-size:inherit!important;line-height:inherit!important}.mat-expansion-panel-header{padding:14px 12px 15px 18px}.disable-expansion .mat-expansion-panel-header{pointer-events:none}.mat-expansion-indicator::after,.mat-expansion-panel-header-description{color:inherit}button.mat-stroked-button{float:right;margin-right:5px;background-color:#f5f5f5;border-radius:4px}"]
                }] }
    ];
    /** @nocollapse */
    RteToastAlertComponent.ctorParameters = function () { return [
        { type: ToastrService },
        { type: ToastPackage }
    ]; };
    return RteToastAlertComponent;
}(Toast));

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var RteAlertModule = /** @class */ (function () {
    function RteAlertModule() {
    }
    RteAlertModule.decorators = [
        { type: NgModule, args: [{
                    imports: [
                        CommonModule,
                        MatExpansionModule,
                        MatIconModule,
                        ToastrModule.forRoot({
                            toastComponent: RteToastAlertComponent,
                            tapToDismiss: false,
                            disableTimeOut: false,
                            closeButton: true,
                            progressBar: true,
                            extendedTimeOut: 4000,
                            timeOut: 4000
                        }),
                        RteMaterialModule,
                        MatButtonModule$1
                    ],
                    declarations: [RteToastAlertComponent],
                    entryComponents: [RteToastAlertComponent]
                },] }
    ];
    return RteAlertModule;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var RteSimpleButtonAction = /** @class */ (function () {
    function RteSimpleButtonAction(action) {
        this.action = action;
    }
    /**
     * @return {?}
     */
    RteSimpleButtonAction.prototype.click = /**
     * @return {?}
     */
    function () {
        this.action();
    };
    return RteSimpleButtonAction;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var RteFileUploader = /** @class */ (function (_super) {
    __extends(RteFileUploader, _super);
    function RteFileUploader(options) {
        return _super.call(this, options) || this;
    }
    return RteFileUploader;
}(FileUploader));

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var RteFileSelectDirective = /** @class */ (function (_super) {
    __extends(RteFileSelectDirective, _super);
    function RteFileSelectDirective(element) {
        return _super.call(this, element) || this;
    }
    Object.defineProperty(RteFileSelectDirective.prototype, "rteUploader", {
        get: /**
         * @return {?}
         */
        function () { return this.uploader; },
        set: /**
         * @param {?} value
         * @return {?}
         */
        function (value) {
            this.uploader = value;
        },
        enumerable: true,
        configurable: true
    });
    RteFileSelectDirective.decorators = [
        { type: Directive, args: [{ selector: '[rteNg2FileSelect]' },] }
    ];
    /** @nocollapse */
    RteFileSelectDirective.ctorParameters = function () { return [
        { type: ElementRef }
    ]; };
    RteFileSelectDirective.propDecorators = {
        rteUploader: [{ type: Input, args: ['rteUploader',] }]
    };
    return RteFileSelectDirective;
}(FileSelectDirective));

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var RteFileDropDirective = /** @class */ (function (_super) {
    __extends(RteFileDropDirective, _super);
    function RteFileDropDirective(element) {
        return _super.call(this, element) || this;
    }
    Object.defineProperty(RteFileDropDirective.prototype, "rteUploader", {
        get: /**
         * @return {?}
         */
        function () { return this.uploader; },
        set: /**
         * @param {?} value
         * @return {?}
         */
        function (value) {
            this.uploader = value;
        },
        enumerable: true,
        configurable: true
    });
    RteFileDropDirective.decorators = [
        { type: Directive, args: [{ selector: '[rteNg2FileDrop]' },] }
    ];
    /** @nocollapse */
    RteFileDropDirective.ctorParameters = function () { return [
        { type: ElementRef }
    ]; };
    RteFileDropDirective.propDecorators = {
        rteUploader: [{ type: Input, args: ['rteUploader',] }]
    };
    return RteFileDropDirective;
}(FileDropDirective));

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var RteFileComponent = /** @class */ (function () {
    function RteFileComponent() {
        this.dropText = 'Arraste ou solte seu arquivo<br />para fazer upload ou';
        this.buttonText = 'Carregar Arquivos';
        this.id = 'attachment';
        this.fileOver = new EventEmitter();
        this.onFileDrop = new EventEmitter();
        this.onFileSelected = new EventEmitter();
        this.hasBaseDropZoneOver = false;
    }
    /**
     * @return {?}
     */
    RteFileComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
    };
    /**
     * @param {?} e
     * @return {?}
     */
    RteFileComponent.prototype.fileOverBase = /**
     * @param {?} e
     * @return {?}
     */
    function (e) {
        this.hasBaseDropZoneOver = e;
        this.fileOver.emit(e);
    };
    /**
     * @param {?} value
     * @return {?}
     */
    RteFileComponent.prototype.fileDropBase = /**
     * @param {?} value
     * @return {?}
     */
    function (value) {
        this.onFileDrop.emit(value);
        if (this.uploader.autoUpload) {
            this.uploadFile();
        }
    };
    /**
     * @param {?} value
     * @return {?}
     */
    RteFileComponent.prototype.fileSelectedBase = /**
     * @param {?} value
     * @return {?}
     */
    function (value) {
        this.onFileSelected.emit(value);
        if (this.uploader.autoUpload) {
            this.uploadFile();
        }
    };
    /**
     * @return {?}
     */
    RteFileComponent.prototype.uploadFile = /**
     * @return {?}
     */
    function () {
        if (this.uploader.queue.length > 0) {
            this.uploader.uploadAll();
        }
    };
    RteFileComponent.decorators = [
        { type: Component, args: [{
                    selector: 'rte-file',
                    template: "<div rteNg2FileDrop\r\n    [ngClass]=\"{'rte-drop-zone-file-over': hasBaseDropZoneOver}\"\r\n    (fileOver)=\"fileOverBase($event)\"\r\n    (onFileDrop)=\"fileDropBase($event)\"\r\n    [rteUploader]=\"uploader\"\r\n    class=\"rte-drop-zone\">\r\n    <div class=\"middle-content upload-icon\">\r\n        <i class=\"material-icons\">\r\n            cloud_upload\r\n        </i>\r\n    </div>\r\n    <div class=\"middle-content\" [innerHTML]=\"dropText\">\r\n        \r\n    </div>\r\n    <div>\r\n        <label [for]=\"id\" [innerHTML]=\"buttonText\"></label>\r\n    </div>\r\n    <input type=\"file\" \r\n        [name]=\"id\" \r\n        [id]=\"id\" \r\n        rteNg2FileSelect \r\n        (onFileSelected)=\"fileSelectedBase($event)\" \r\n        [rteUploader]=\"uploader\" />\r\n</div>\r\n<ul class=\"file-list\">\r\n    <li *ngFor=\"let item of uploader.queue\" [class.file-item-with-error]=\"item.isError\">\r\n        <div class=\"file-name\">\r\n            {{item?.file?.name}}\r\n            <i class=\"material-icons\" (click)=\"item.remove()\">\r\n                delete_outline\r\n            </i>\r\n        </div>\r\n        <mat-progress-bar mode=\"determinate\" value=\"item.progress\"></mat-progress-bar>\r\n    </li>\r\n</ul>",
                    styles: [".rte-drop-zone{border:1px dashed #bdbdbd;width:100%;border-radius:4px;padding-top:20px;padding-bottom:26px;font-size:16px;color:#9e9e9e;text-align:center}.rte-drop-zone label{cursor:pointer;border-radius:4px;background-color:#1565c0;color:#fff;font-size:14px;display:inline-block;padding:10px 15px}.rte-drop-zone input{display:none}.rte-drop-zone .material-icons{color:#e3f2fd;font-size:52px}.rte-drop-zone .middle-content{margin-bottom:13px}.rte-drop-zone .upload-icon{margin-bottom:0}.rte-drop-zone-file-over{color:#1565c0;border-color:#1565c0}.rte-drop-zone-file-over .material-icons{color:#1565c0;font-size:52px}.file-list{list-style:none;padding-left:0;padding-right:0;margin-top:0}.file-list .file-name{font-size:16px;color:#757575;margin-bottom:11px;margin-top:10px}.file-list .file-name .material-icons{float:right;color:#bdbdbd;cursor:pointer}.file-list mat-progress-bar{border-radius:100px;height:10px}.file-list mat-progress-bar .mat-progress-bar-buffer{background-color:#e3f2fd}.file-list li.file-item-with-error .file-name,.file-list li.file-item-with-error .file-name .material-icons{color:red}"]
                }] }
    ];
    /** @nocollapse */
    RteFileComponent.ctorParameters = function () { return []; };
    RteFileComponent.propDecorators = {
        uploader: [{ type: Input }],
        dropText: [{ type: Input }],
        buttonText: [{ type: Input }],
        id: [{ type: Input }],
        fileOver: [{ type: Output }],
        onFileDrop: [{ type: Output }],
        onFileSelected: [{ type: Output }]
    };
    return RteFileComponent;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var RteFileUploadModule = /** @class */ (function () {
    function RteFileUploadModule() {
    }
    RteFileUploadModule.decorators = [
        { type: NgModule, args: [{
                    imports: [
                        CommonModule,
                        MatProgressBarModule,
                        FileUploadModule
                    ],
                    declarations: [RteFileSelectDirective, RteFileDropDirective, RteFileComponent],
                    exports: [RteFileSelectDirective, RteFileDropDirective, RteFileComponent]
                },] }
    ];
    return RteFileUploadModule;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var RteLovService = /** @class */ (function () {
    function RteLovService(http) {
        this.http = http;
    }
    //#region NotImplemented
    //#region NotImplemented
    /**
     * @param {?} objectCurrent
     * @return {?}
     */
    RteLovService.prototype.save = 
    //#region NotImplemented
    /**
     * @param {?} objectCurrent
     * @return {?}
     */
    function (objectCurrent) {
        throw new Error('Method not implemented.');
    };
    /**
     * @param {?} objectCurrent
     * @return {?}
     */
    RteLovService.prototype.delete = /**
     * @param {?} objectCurrent
     * @return {?}
     */
    function (objectCurrent) {
        throw new Error('Method not implemented.');
    };
    /**
     * @param {?} objectCurrent
     * @return {?}
     */
    RteLovService.prototype.clear = /**
     * @param {?} objectCurrent
     * @return {?}
     */
    function (objectCurrent) {
        objectCurrent.Id = null;
        objectCurrent.Key = null;
        objectCurrent.Description = null;
        objectCurrent.Properties = null;
    };
    /**
     * @param {?} name
     * @param {?} value
     * @param {?} params
     * @return {?}
     */
    RteLovService.prototype.appendHttpParams = /**
     * @param {?} name
     * @param {?} value
     * @param {?} params
     * @return {?}
     */
    function (name, value, params) {
        return params.append(name, !value ? '' : value);
    };
    /**
     * @param {?} objectCurrent
     * @param {?} page
     * @param {?} pageSize
     * @return {?}
     */
    RteLovService.prototype.get = /**
     * @param {?} objectCurrent
     * @param {?} page
     * @param {?} pageSize
     * @return {?}
     */
    function (objectCurrent, page, pageSize) {
        page++;
        /** @type {?} */
        var params = new HttpParams()
            .set('page', page.toString())
            .set('amountByPage', pageSize.toString());
        if (objectCurrent) {
            params = this.appendHttpParams('Key', objectCurrent.Key, params);
            params = this.appendHttpParams('Description', objectCurrent.Description, params);
        }
        return this.http.get(this.apiEndpoint, { params: params });
    };
    /**
     * @return {?}
     */
    RteLovService.prototype.getColumns = /**
     * @return {?}
     */
    function () {
        return this.http.get(this.apiEndpointColumns);
    };
    return RteLovService;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var RteLovModalComponent = /** @class */ (function () {
    function RteLovModalComponent(data, http, modalRef, rteAlert) {
        this.data = data;
        this.http = http;
        this.modalRef = modalRef;
        this.rteAlert = rteAlert;
        this.ctrlV = false;
        this.preventNavigation = false;
        this.ok = false;
        this.MinSearchCharactersModal = 0;
        this.mask = function (rawValue) {
            /** @type {?} */
            var maskRegex = [];
            for (var i = 0; i < 2000; i++) {
                maskRegex.push(/./);
            }
            return maskRegex;
        };
        this.isFixedToolbar = false;
        this.showPagination = false;
        this.showTitle = false;
        this.showButton = new ShowButton();
        this.showButton.firstRegister = false;
        this.showButton.prevRegister = false;
        this.showButton.nextRegister = false;
        this.showButton.lastRegister = false;
        this.showButton.insert = false;
        this.showButton.edit = false;
        this.showButton.cancel = false;
        this.showButton.save = false;
        this.showButton.cancelSave = false;
        this.showButton.delete = false;
        this.showButton.close = false;
        this.showButton.cancelEdit = false;
        this.showButton.rteSeparator = false;
        this.showButton.rteHistory = false;
        this.showButton.forceShowRteHistory = false;
        this.toolbarObject = new RteToolbarViewModel();
        this.toolbarObject.searchObject = {};
        this.toolbarObject.insertModeButton = false;
        this.toolbarObject.firstModeButton = false;
        this.toolbarObject.editModeButton = false;
        this.toolbarObject.browserModeButton = false;
        this.serviceBaseUrl = data.serviceBaseUrl;
        this.serviceBaseColumnsUrl = data.serviceBaseColumnsUrl;
        this.columns = data.columns;
        this.mask = data.mask;
        this.codePlaceholder = data.codePlaceholder;
        this.descriptionPlaceholder = data.descriptionPlaceholder;
        this.customerService = new RteLovService(this.http);
        this.customerService.apiEndpoint = this.serviceBaseUrl;
        this.customerService.apiEndpointColumns = this.serviceBaseColumnsUrl;
        this.title = data.title;
        this.validateSearchEmptyFields = data.validateSearchEmptyFields;
        this.MinSearchCharactersModal = data.minSearchCharactersModal;
        this.displayedColumns = this.columns.map(function (c) { return c.columnDef; });
    }
    /**
     * @return {?}
     */
    RteLovModalComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        this.toolbarObject.dataSource.sort = this.sort;
        this.toolbarObject.pageSize = 5;
    };
    /**
     * @param {?} selected
     * @return {?}
     */
    RteLovModalComponent.prototype.selectAndClose = /**
     * @param {?} selected
     * @return {?}
     */
    function (selected) {
        this.ok = true;
        this.selected = selected;
        this.modalRef.close();
    };
    /**
     * @return {?}
     */
    RteLovModalComponent.prototype.confirmAndClose = /**
     * @return {?}
     */
    function () {
        if (this.toolbarObject.selectionModel.selected != null && this.toolbarObject.selectionModel.selected.length > 0) {
            this.selected = this.toolbarObject.selectionModel.selected[0];
            this.ok = true;
            this.modalRef.close();
        }
    };
    /**
     * @return {?}
     */
    RteLovModalComponent.prototype.close = /**
     * @return {?}
     */
    function () {
        this.ok = false;
        this.modalRef.close();
    };
    /**
     * @param {?} keyValue
     * @return {?}
     */
    RteLovModalComponent.prototype.maskTableElement = /**
     * @param {?} keyValue
     * @return {?}
     */
    function (keyValue) {
        /** @type {?} */
        var valor = '';
        if (keyValue != null && keyValue != '') {
            /** @type {?} */
            var codeMask = this.mask(keyValue);
            /** @type {?} */
            var valorMaskPos = 0;
            for (var i = 0; i < codeMask.length; i++) {
                if ((codeMask[i] instanceof RegExp) == false) {
                    valor += codeMask[i];
                }
                else {
                    valor += keyValue.substr(valorMaskPos++, 1);
                }
            }
        }
        return valor;
    };
    /**
     * @return {?}
     */
    RteLovModalComponent.prototype.codeChanged = /**
     * @return {?}
     */
    function () {
        if (this.toolbarObject.searchObject.Key != null && this.toolbarObject.searchObject.Code != '') {
            /** @type {?} */
            var codeMask = this.mask(this.toolbarObject.searchObject.Key);
            for (var i = 0; i < codeMask.length; i++) {
                if ((codeMask[i] instanceof RegExp) == false) {
                    while (this.toolbarObject.searchObject.Key.indexOf(codeMask[i]) != -1) {
                        this.toolbarObject.searchObject.Key = this.toolbarObject.searchObject.Key.replace(codeMask[i], '');
                    }
                }
            }
        }
    };
    /**
     * @param {?} data
     * @return {?}
     */
    RteLovModalComponent.prototype.customizeBeforeGet = /**
     * @param {?} data
     * @return {?}
     */
    function (data) {
        this.preventNavigation = false;
        if ((this.toolbarObject.searchObject.KeyDescription == null || this.toolbarObject.searchObject.KeyDescription == '') &&
            (this.toolbarObject.searchObject.Key === undefined || this.toolbarObject.searchObject.Key === null)) {
            this.rteAlert.warning('Atenção', "Informe o " + this.codePlaceholder + " ou " + this.descriptionPlaceholder + " para realizar a consulta.", {
                expanded: true
            });
            data.cancelGet = true;
        }
        else if (this.MinSearchCharactersModal > 0 &&
            (this.toolbarObject.searchObject.Key.split('').length < this.MinSearchCharactersModal)) {
            this.rteAlert.warning('Atenção', "Informe o " + this.codePlaceholder + " ou " + this.descriptionPlaceholder + " para realizar a consulta.", {
                expanded: true
            });
            data.cancelGet = true;
        }
        if (this.validateSearchEmptyFields && this.checkEmptyInputs()) {
            this.rteAlert.warning('Atenção', 'Nenhum parâmetro de busca informado.', {
                expanded: true
            });
            data.cancelGet = true;
        }
    };
    /**
     * @return {?}
     */
    RteLovModalComponent.prototype.checkEmptyInputs = /**
     * @return {?}
     */
    function () {
        if (this.toolbarObject.searchObject.KeyDescription == null || this.toolbarObject.searchObject.KeyDescription == '')
            return true;
        return false;
    };
    /**
     * @param {?} event
     * @return {?}
     */
    RteLovModalComponent.prototype.onKey = /**
     * @param {?} event
     * @return {?}
     */
    function (event) {
        /** @type {?} */
        var regex = new RegExp(/^\d+/);
        /** @type {?} */
        var maskRegex = new RegExp(/^[0-9]{11,14}$/gs);
        /** @type {?} */
        var withoutSpecials = this.toolbarObject.searchObject.KeyDescription.replace(/\D+/gs, '');
        /** @type {?} */
        var documentValid = maskRegex.exec(withoutSpecials);
        if (this.ctrlV || (documentValid != null && documentValid.length > 0)) {
            if (withoutSpecials != '')
                this.toolbarObject.searchObject.KeyDescription = withoutSpecials;
        }
        if (event.key.match(regex) || this.ctrlV) {
            if (this.toolbarObject.searchObject.KeyDescription.length == 11) {
                this.cpfFormat();
            }
            else if (this.toolbarObject.searchObject.KeyDescription.length == 14) {
                this.cnpjFormat();
            }
            else {
                if (this.ctrlV) {
                    this.toolbarObject.searchObject.Description = this.toolbarObject.searchObject.KeyDescription;
                }
                else {
                    this.toolbarObject.searchObject.Key = this.toolbarObject.searchObject.KeyDescription;
                }
            }
        }
        else if (!this.ctrlV) {
            this.toolbarObject.searchObject.Description = this.toolbarObject.searchObject.KeyDescription;
            this.toolbarObject.searchObject.Key = null;
        }
    };
    /**
     * @return {?}
     */
    RteLovModalComponent.prototype.cnpjFormat = /**
     * @return {?}
     */
    function () {
        /** @type {?} */
        var cnpjRegx = new RegExp(/^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/);
        /** @type {?} */
        var result = this.toolbarObject.searchObject.KeyDescription.replace(cnpjRegx, '$1.$2.$3/$4-$5');
        this.toolbarObject.searchObject.Key = this.toolbarObject.searchObject.KeyDescription;
        this.toolbarObject.searchObject.KeyDescription = result;
    };
    /**
     * @return {?}
     */
    RteLovModalComponent.prototype.cpfFormat = /**
     * @return {?}
     */
    function () {
        /** @type {?} */
        var cpfRegex = new RegExp(/^(\d{3})(\d{3})(\d{3})(\d{2})/);
        /** @type {?} */
        var result = this.toolbarObject.searchObject.KeyDescription.replace(cpfRegex, '$1.$2.$3-$4');
        this.toolbarObject.searchObject.Key = this.toolbarObject.searchObject.KeyDescription;
        this.toolbarObject.searchObject.KeyDescription = result;
    };
    /**
     * @param {?} $event
     * @return {?}
     */
    RteLovModalComponent.prototype.onKeyPress = /**
     * @param {?} $event
     * @return {?}
     */
    function ($event) {
        if (($event.ctrlKey || $event.metaKey) && $event.keyCode == 86) {
            this.ctrlV = true;
        }
        else {
            this.ctrlV = false;
        }
    };
    /**
     * @param {?} event
     * @return {?}
     */
    RteLovModalComponent.prototype.loadPage = /**
     * @param {?} event
     * @return {?}
     */
    function (event) {
        var _this = this;
        if (this.preventNavigation) {
            return;
        }
        this.customerService.get(this.toolbarObject.searchObject, event.pageIndex, event.pageSize).subscribe(function (response) {
            _this.toolbarObject.dataSource.data = response.Data;
        });
    };
    /**
     * @return {?}
     */
    RteLovModalComponent.prototype.customizeAfterClear = /**
     * @return {?}
     */
    function () {
        this.preventNavigation = true;
        this.paginator.firstPage();
    };
    RteLovModalComponent.decorators = [
        { type: Component, args: [{
                    selector: 'rte-lov-modal',
                    template: "<div>\r\n    <h2 class=\"header\" rte-dialog-title>{{ title }}</h2>    \r\n</div>\r\n\r\n<rte-dialog-content>\r\n    <form>\r\n        <div class=\"row-form\">\r\n            <div class=\"column-form set-input\">\r\n                <rte-form-field>\r\n                    <input rteInput\r\n                        name=\"codeModal\"\r\n                        type=\"text\"\r\n                        maxlength=\"65\"\r\n                        [placeholder]=\"columns[0].header\"\r\n                        [(ngModel)]=\"toolbarObject.searchObject.KeyDescription\"\r\n                        (keyup)=\"onKey($event)\"\r\n                        (onblur)=\"onKey($event)\"\r\n                        />\r\n                    </rte-form-field>\r\n            </div>\r\n            <rte-toolbar\r\n                [title]=\"title\"\r\n                [showTitle]=\"showTitle\"\r\n                [isFixedToolbar]=\"isFixedToolbar\"\r\n                [showButton]=\"showButton\"\r\n                [toolbarObject]=\"toolbarObject\"\r\n                [service]=\"customerService\"\r\n                [showPagination]=\"showPagination\"\r\n                (customizeBeforeGet)=\"customizeBeforeGet($event)\"\r\n                (customizeAfterClear)=\"customizeAfterClear()\">\r\n            </rte-toolbar>\r\n        </div>\r\n    </form>\r\n\r\n    <div class=\"mat-elevation-z4\">\r\n        <rte-table [dataSource]=\"toolbarObject.dataSource\" rteSort>\r\n            <ng-container *ngFor=\"let column of columns\" [rteColumnDef]=\"column.columnDef\">\r\n                <rte-header-cell \r\n                *rteHeaderCellDef>{{ column.header }}</rte-header-cell>\r\n                <rte-cell [matTooltip]=\"column.cell(row)\" *rteCellDef=\"let row\">\r\n                    <span class=\"ellipsis\">{{ column.cell(row) }}</span>\r\n                </rte-cell>\r\n            </ng-container>\r\n\r\n            <rte-header-row\r\n                *rteHeaderRowDef=\"displayedColumns\">\r\n            </rte-header-row>\r\n            <rte-row\r\n                *rteRowDef=\"let row; columns: displayedColumns\"\r\n                [ngClass]=\"{hovered: row.hovered, highlighted: row.highlighted, selected: toolbarObject.selectionModel.isSelected(row)}\"\r\n                (dblclick)=\"selectAndClose(row)\"  \r\n                (click)=\"toolbarObject.setCurrent(row)\"\r\n                (mouseover)=\"row.hovered = true\" \r\n                (mouseout)=\"row.hovered = false\"  \r\n            >\r\n            </rte-row>\r\n        </rte-table>\r\n        <rte-paginator #paginator [hidePageSize]=\"true\"\r\n            [length]=\"this.toolbarObject.toolbarComponent.toolbarPagination.totalRegisters\"\r\n            [pageSize]=\"5\" (page)=\"loadPage($event)\">\r\n        </rte-paginator>\r\n    </div>\r\n</rte-dialog-content>\r\n\r\n<rte-dialog-actions class=\"rte-dialog-footer action-set\" align=\"end\">\r\n    \r\n    <span class=\"toolbar-grouped-buttons\">\r\n        <button\r\n        rtebutton-flat \r\n        color=\"primary\"\r\n        (click)=\"confirmAndClose()\"\r\n        title=\"Selecionar\"\r\n        class=\"last-button\">\r\n            <span>\r\n                Selecionar\r\n            </span>\r\n        </button>\r\n    </span>\r\n    <span class=\"toolbar-grouped-buttons\">\r\n        <button\r\n            rtebutton\r\n            class=\"button-basic\"\r\n            (click)=\"close()\"\r\n            title=\"Cancelar\">\r\n                Cancelar\r\n        </button>\r\n    </span>\r\n</rte-dialog-actions>",
                    styles: ["button rte-icon{margin-top:-3px;vertical-align:middle}.set-input{margin-right:0!important}.action-set{margin-top:1px!important}:host::ng-deep.mat-toolbar{border:0!important;padding-left:0!important;height:82px!important;max-width:110px!important}:host::ng-deep.mat-button-toggle-button{width:40px!important;height:41px!important}:host::ng-deep.mat-divider{border:0!important}rte-cell>span.ellipsis{text-overflow:ellipsis!important;overflow:hidden!important;white-space:nowrap!important}.mat-column-Key{flex:2 0 0;padding-right:10px}.mat-column-second{flex:0 0 9%}.clear-button{width:40px!important;height:41px!important}.header{height:39px!important;margin-bottom:50px!important}.last-button{margin-right:10px!important}.button-basic{color:#3f51b5;height:38px!important}:host::ng-deep.mat-button-toggle-label-content>*{vertical-align:middle;text-indent:-1em;padding-left:10px}"]
                }] }
    ];
    /** @nocollapse */
    RteLovModalComponent.ctorParameters = function () { return [
        { type: undefined, decorators: [{ type: Inject, args: [MAT_DIALOG_DATA,] }] },
        { type: HttpClient },
        { type: RteDialogRef },
        { type: RTEAlertService }
    ]; };
    RteLovModalComponent.propDecorators = {
        sort: [{ type: ViewChild, args: [RteSortDirective,] }],
        paginator: [{ type: ViewChild, args: ['paginator',] }],
        codePlaceholder: [{ type: Input }],
        descriptionPlaceholder: [{ type: Input }],
        mask: [{ type: Input }],
        validateSearchEmptyFields: [{ type: Input }],
        onKeyPress: [{ type: HostListener, args: ['window:keydown', ['$event'],] }]
    };
    return RteLovModalComponent;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var RteLovComponent = /** @class */ (function () {
    function RteLovComponent(dialog, http, rteAlert) {
        var _this = this;
        this.dialog = dialog;
        this.http = http;
        this.rteAlert = rteAlert;
        this.result = [''];
        this.required = false;
        this.readOnly = false;
        this.mask = function (rawValue) {
            /** @type {?} */
            var maskRegex = [];
            for (var i = 0; i < 2000; i++) {
                maskRegex.push(/./);
            }
            return maskRegex;
        };
        this.minSearchCharacters = 1;
        this.minSearchCharactersModal = 0;
        this.validateSearchEmptyFields = true;
        this.onModelSelected = new EventEmitter();
        this.columns = [
            { columnDef: 'Key', header: 'first', cell: function (element) { return _this.maskTableElement(element.Key) + " - " + element.Description; } },
        ];
    }
    /**
     * @return {?}
     */
    RteLovComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        var _this = this;
        this.lovService = new RteLovService(this.http);
        this.lovService.apiEndpoint = this.apiEndpoint;
        this.lovService.apiEndpointColumns = this.apiEndpointColumns;
        this.lovService.getColumns().subscribe(function (response) {
            _this.result = response;
        });
    };
    /**
     * @param {?} keyValue
     * @return {?}
     */
    RteLovComponent.prototype.maskTableElement = /**
     * @param {?} keyValue
     * @return {?}
     */
    function (keyValue) {
        /** @type {?} */
        var valor = '';
        if (keyValue != null && keyValue != '') {
            /** @type {?} */
            var codeMask = this.mask(keyValue);
            /** @type {?} */
            var valorMaskPos = 0;
            for (var i = 0; i < codeMask.length; i++) {
                if ((codeMask[i] instanceof RegExp) == false) {
                    valor += codeMask[i];
                }
                else {
                    valor += keyValue.substr(valorMaskPos++, 1);
                }
            }
        }
        return valor;
    };
    /**
     * @return {?}
     */
    RteLovComponent.prototype.addExtraColumns = /**
     * @return {?}
     */
    function () {
        if (this.result.length > 2) {
            this.columns[0].header = this.result[0];
            this.columns.push({ columnDef: 'second', header: "" + this.result[1], cell: function (element) { return "" + element.Properties[0]; } });
            this.columns.push({ columnDef: 'third', header: "" + this.result[2], cell: function (element) { return "" + element.Properties[1]; } });
            this.columns.push({ columnDef: 'fourth', header: "" + this.result[3], cell: function (element) { return element.Properties[2] + " - " + element.Properties[3]; } });
        }
        else {
            this.columns[0].header = this.descriptionPlaceholder ? this.codePlaceholder + " - " + this.descriptionPlaceholder : "" + this.codePlaceholder;
        }
    };
    /**
     * @return {?}
     */
    RteLovComponent.prototype.openModal = /**
     * @return {?}
     */
    function () {
        var _this = this;
        this.addExtraColumns();
        /** @type {?} */
        var dialogConfig = new MatDialogConfig();
        dialogConfig.disableClose = false;
        dialogConfig.autoFocus = true;
        dialogConfig.width = '800px';
        dialogConfig.disableClose = true;
        dialogConfig.data = {
            serviceBaseUrl: this.apiEndpoint,
            serviceBaseColumnsUrl: this.apiEndpointColumns,
            columns: this.columns,
            mask: this.mask,
            codePlaceholder: this.codePlaceholder,
            descriptionPlaceholder: this.descriptionPlaceholder,
            title: this.modalTitle,
            validateSearchEmptyFields: this.validateSearchEmptyFields,
            minSearchCharactersModal: this.minSearchCharactersModal,
        };
        /** @type {?} */
        var currentDialog = this.dialog.open(RteLovModalComponent, dialogConfig);
        currentDialog.afterClosed().subscribe(function () {
            if (_this.columns.length > 2) {
                _this.columns.pop();
                _this.columns.pop();
                _this.columns.pop();
            }
            if (currentDialog.componentInstance.ok == true) {
                _this.model.Id = currentDialog.componentInstance.selected.Id;
                _this.model.Key = currentDialog.componentInstance.selected.Key;
                _this.model.Description = currentDialog.componentInstance.selected.Description;
                _this.model.Properties = currentDialog.componentInstance.selected.Properties;
                _this.emitterModelSelected();
            }
        });
    };
    /**
     * @return {?}
     */
    RteLovComponent.prototype.codeChanged = /**
     * @return {?}
     */
    function () {
        var _this = this;
        if (this.model.Key != null && this.model.Key != '') {
            /** @type {?} */
            var codeMask = this.mask(this.model.Key);
            for (var i = 0; i < codeMask.length; i++) {
                if ((codeMask[i] instanceof RegExp) == false) {
                    while (this.model.Key.indexOf(codeMask[i]) != -1) {
                        this.model.Key = this.model.Key.replace(codeMask[i], '');
                    }
                }
            }
            if (this.model.Key.length >= this.minSearchCharacters) {
                this.lovService.apiEndpoint = this.apiEndpoint;
                this.lovService.get({
                    Key: this.model.Key,
                    Id: null,
                    Description: null,
                    Properties: null
                }, 0, 1).subscribe(function (data) {
                    if (data.TotalRegisters > 0) {
                        _this.model.Id = data.Data[0].Id;
                        _this.model.Key = data.Data[0].Key;
                        _this.model.Description = data.Data[0].Description;
                        _this.model.Properties = data.Data[0].Properties;
                        _this.emitterModelSelected();
                    }
                    else {
                        _this.model.Id = null;
                        _this.model.Key = null;
                        _this.model.Description = null;
                        _this.model.Properties = null;
                        _this.emitterModelSelected();
                        _this.rteAlert.warning('Atenção', 'Nenhum registro encontrado.', {
                            expanded: true
                        });
                    }
                });
            }
        }
        else {
            this.model.Id = null;
            this.model.Key = null;
            this.model.Description = null;
            this.model.Properties = null;
            this.emitterModelSelected();
        }
    };
    /**
     * @return {?}
     */
    RteLovComponent.prototype.emitterModelSelected = /**
     * @return {?}
     */
    function () {
        this.onModelSelected.emit((/** @type {?} */ (this.model)));
    };
    /**
     * @return {?}
     */
    RteLovComponent.prototype.setFocusInInputField = /**
     * @return {?}
     */
    function () {
        this.keyField.nativeElement.focus();
    };
    RteLovComponent.decorators = [
        { type: Component, args: [{
                    selector: 'rte-lov',
                    template: "<div class='row-form'>\r\n    <div class='column-form'>\r\n        <rte-form-field>\r\n            <input rteInput #keyField\r\n                name=\"field1\"\r\n                type=\"text\"\r\n                [required]=\"required\"\r\n                maxlength=\"65\"\r\n                [placeholder]=\"codePlaceholder\"\r\n                [(ngModel)]=\"model.Key\"\r\n                (change)=\"codeChanged()\"\r\n                [textMask]=\"{ mask: mask, guide: false }\" \r\n                [readonly]=\"readOnly\"/>\r\n                <button mat-icon-button matSuffix class=\"search-button\" aria-label=\"Abrir pesquisa\" (click)=\"openModal()\" [disabled]=\"readOnly\">\r\n                    <mat-icon>search</mat-icon>\r\n                </button>\r\n        </rte-form-field>\r\n    </div>\r\n    <div class='column-form'>\r\n        <rte-form-field>\r\n            <input rteInput\r\n                name=\"field2\"\r\n                type=\"text\"\r\n                [placeholder]=\"descriptionPlaceholder\"\r\n                tabindex=\"-1\"\r\n                readonly=\"readonly\"\r\n                [(ngModel)]=\"model.Description\" />\r\n        </rte-form-field>\r\n    </div>\r\n</div>\r\n\r\n",
                    styles: [".search-button{padding:0;background-color:transparent;border:0;position:absolute;top:-16px;left:-30px;cursor:pointer}"]
                }] }
    ];
    /** @nocollapse */
    RteLovComponent.ctorParameters = function () { return [
        { type: RteDialog },
        { type: HttpClient },
        { type: RTEAlertService }
    ]; };
    RteLovComponent.propDecorators = {
        model: [{ type: Input }],
        apiEndpoint: [{ type: Input }],
        apiEndpointColumns: [{ type: Input }],
        codePlaceholder: [{ type: Input }],
        descriptionPlaceholder: [{ type: Input }],
        modalTitle: [{ type: Input }],
        required: [{ type: Input }],
        readOnly: [{ type: Input }],
        mask: [{ type: Input }],
        minSearchCharacters: [{ type: Input }],
        minSearchCharactersModal: [{ type: Input }],
        validateSearchEmptyFields: [{ type: Input }],
        onModelSelected: [{ type: Output }],
        keyField: [{ type: ViewChild, args: ['keyField',] }]
    };
    return RteLovComponent;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var RteMultiSelectService = /** @class */ (function () {
    function RteMultiSelectService(http) {
        this.http = http;
    }
    //#region NotImplemented
    //#region NotImplemented
    /**
     * @param {?} objectCurrent
     * @return {?}
     */
    RteMultiSelectService.prototype.save = 
    //#region NotImplemented
    /**
     * @param {?} objectCurrent
     * @return {?}
     */
    function (objectCurrent) {
        throw new Error('Method not implemented.');
    };
    /**
     * @param {?} objectCurrent
     * @return {?}
     */
    RteMultiSelectService.prototype.delete = /**
     * @param {?} objectCurrent
     * @return {?}
     */
    function (objectCurrent) {
        throw new Error('Method not implemented.');
    };
    /**
     * @param {?} objectCurrent
     * @return {?}
     */
    RteMultiSelectService.prototype.clear = /**
     * @param {?} objectCurrent
     * @return {?}
     */
    function (objectCurrent) {
        objectCurrent.Id = null;
        objectCurrent.Key = null;
        objectCurrent.Description = null;
    };
    /**
     * @param {?} name
     * @param {?} value
     * @param {?} params
     * @return {?}
     */
    RteMultiSelectService.prototype.appendHttpParams = /**
     * @param {?} name
     * @param {?} value
     * @param {?} params
     * @return {?}
     */
    function (name, value, params) {
        return params.append(name, !value ? '' : value);
    };
    /**
     * @param {?} objectCurrent
     * @param {?} page
     * @param {?} pageSize
     * @return {?}
     */
    RteMultiSelectService.prototype.get = /**
     * @param {?} objectCurrent
     * @param {?} page
     * @param {?} pageSize
     * @return {?}
     */
    function (objectCurrent, page, pageSize) {
        page++;
        /** @type {?} */
        var params = new HttpParams()
            .set('page', page.toString())
            .set('amountByPage', pageSize.toString());
        if (objectCurrent) {
            params = this.appendHttpParams('Key', objectCurrent.Key, params);
            params = this.appendHttpParams('Description', objectCurrent.Description, params);
        }
        return this.http.get(this.apiEndpoint, { params: params });
    };
    return RteMultiSelectService;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var RteLovMultiSelectModalComponent = /** @class */ (function () {
    function RteLovMultiSelectModalComponent(data, http, modalRef) {
        this.data = data;
        this.http = http;
        this.modalRef = modalRef;
        this.ok = false;
        this.displayedColumns = [
            'Select',
            'Key',
            'Description'
        ];
        this.selection = new SelectionModel(true, []);
        this.mask = function (rawValue) {
            /** @type {?} */
            var maskRegex = [];
            for (var i = 0; i < 2000; i++) {
                maskRegex.push(/./);
            }
            return maskRegex;
        };
        this.isFixedToolbar = false;
        this.showButton = new ShowButton();
        this.showButton.cancelEdit = false;
        this.showButton.cancelSave = false;
        this.showButton.close = false;
        this.showButton.delete = false;
        this.showButton.edit = false;
        this.showButton.insert = false;
        this.showButton.rteHistory = false;
        this.showButton.save = false;
        this.showButton.cancel = false;
        this.toolbarObject = new RteToolbarViewModel();
        this.toolbarObject.searchObject = {};
        this.serviceBaseUrl = data.serviceBaseUrl;
        this.mask = data.mask;
        this.codePlaceholder = data.codePlaceholder;
        this.descriptionPlaceholder = data.descriptionPlaceholder;
        this.service = new RteMultiSelectService(this.http);
        this.service.apiEndpoint = this.serviceBaseUrl;
        this.title = data.title;
    }
    /**
     * @return {?}
     */
    RteLovMultiSelectModalComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        this.toolbarObject.dataSource.sort = this.sort;
    };
    /**
     * @return {?}
     */
    RteLovMultiSelectModalComponent.prototype.confirmAndClose = /**
     * @return {?}
     */
    function () {
        if (this.selection != null && this.selection.selected.length > 0) {
            this.ok = true;
            this.modalRef.close();
        }
    };
    /**
     * @return {?}
     */
    RteLovMultiSelectModalComponent.prototype.close = /**
     * @return {?}
     */
    function () {
        this.ok = false;
        this.modalRef.close();
    };
    /**
     * @param {?} keyValue
     * @return {?}
     */
    RteLovMultiSelectModalComponent.prototype.maskTableElement = /**
     * @param {?} keyValue
     * @return {?}
     */
    function (keyValue) {
        /** @type {?} */
        var valor = '';
        if (keyValue != null && keyValue != '') {
            /** @type {?} */
            var codeMask = this.mask(keyValue);
            /** @type {?} */
            var valorMaskPos = 0;
            for (var i = 0; i < codeMask.length; i++) {
                if ((codeMask[i] instanceof RegExp) == false) {
                    valor += codeMask[i];
                }
                else {
                    valor += keyValue.substr(valorMaskPos++, 1);
                }
            }
        }
        return valor;
    };
    /**
     * @return {?}
     */
    RteLovMultiSelectModalComponent.prototype.codeChanged = /**
     * @return {?}
     */
    function () {
        if (this.toolbarObject.searchObject.Key != null && this.toolbarObject.searchObject.Code != '') {
            /** @type {?} */
            var codeMask = this.mask(this.toolbarObject.searchObject.Key);
            for (var i = 0; i < codeMask.length; i++) {
                if ((codeMask[i] instanceof RegExp) == false) {
                    while (this.toolbarObject.searchObject.Key.indexOf(codeMask[i]) != -1) {
                        this.toolbarObject.searchObject.Key = this.toolbarObject.searchObject.Key.replace(codeMask[i], '');
                    }
                }
            }
        }
    };
    /**
     * @return {?}
     */
    RteLovMultiSelectModalComponent.prototype.masterToggle = /**
     * @return {?}
     */
    function () {
        var _this = this;
        this.isAllSelected() ?
            this.selection.clear() :
            this.toolbarObject.dataSource.data.forEach(function (row) { return _this.selection.select(row); });
    };
    /**
     * @return {?}
     */
    RteLovMultiSelectModalComponent.prototype.isAllSelected = /**
     * @return {?}
     */
    function () {
        /** @type {?} */
        var numSelected = this.selection.selected.length;
        /** @type {?} */
        var numRows = this.toolbarObject.dataSource.data.length;
        return numSelected === numRows;
    };
    /**
     * @param {?=} row
     * @return {?}
     */
    RteLovMultiSelectModalComponent.prototype.checkboxLabel = /**
     * @param {?=} row
     * @return {?}
     */
    function (row) {
        if (!row) {
            return (this.isAllSelected() ? 'select' : 'deselect') + " all";
        }
        return (this.selection.isSelected(row) ? 'deselect' : 'select') + " row " + (row.Id + 1);
    };
    RteLovMultiSelectModalComponent.decorators = [
        { type: Component, args: [{
                    selector: 'app-rte-lov-multi-select-modal',
                    template: "<div class=\"dialog-overflow\">\r\n    <div class=\"header\">\r\n        <rte-toolbar\r\n            [title]=\"title\"\r\n            [isFixedToolbar]=\"isFixedToolbar\"\r\n            [showButton]=\"showButton\"\r\n            [toolbarObject]=\"toolbarObject\"\r\n            [service]=\"service\">\r\n            <span class=\"toolbar-grouped-buttons\">\r\n                <button\r\n                    *ngIf=\"selection.selected.length > 0\"\r\n                    rtebutton-flat\r\n                    color=\"primary\"\r\n                    (click)=\"confirmAndClose()\">\r\n                    <span class=\"rte-icon\">\r\n                        Confirmar\r\n                    </span>\r\n                </button>\r\n            </span>\r\n            <span class=\"toolbar-grouped-buttons\">\r\n                <button\r\n                    rtebutton-stroked\r\n                    (click)=\"close()\">\r\n                    <span class=\"rte-icon\">\r\n                        Fechar\r\n                    </span>\r\n                </button>\r\n            </span>\r\n        </rte-toolbar>\r\n    </div>\r\n    <rte-card>\r\n        <mat-card-content>\r\n            <form>\r\n                <div class=\"row-form\">\r\n                    <div class=\"column-form\">\r\n                        <rte-form-field>\r\n                            <input rteInput\r\n                                name=\"codeModal\"\r\n                                type=\"text\"\r\n                                maxlength=\"65\"\r\n                                [placeholder]=\"codePlaceholder\"\r\n                                [(ngModel)]=\"toolbarObject.searchObject.Key\"\r\n                                (change)=\"codeChanged()\"\r\n                                [textMask]=\"{ mask: mask, guide: false }\" />\r\n                        </rte-form-field>\r\n                    </div>\r\n                    <div class=\"column-form\">\r\n                        <rte-form-field>\r\n                            <input rteInput\r\n                                name=\"descriptionModal\"\r\n                                type=\"text\"\r\n                                maxlength=\"65\"\r\n                                [placeholder]=\"descriptionPlaceholder\"\r\n                                [(ngModel)]=\"toolbarObject.searchObject.Description\" />\r\n                        </rte-form-field>\r\n                    </div>\r\n                </div>\r\n            </form>\r\n        </mat-card-content>\r\n    </rte-card>\r\n    <rte-card>\r\n        <mat-card-content>\r\n            <rte-table [dataSource]=\"toolbarObject.dataSource\" rteSort>\r\n                <ng-container rteColumnDef=\"Select\">\r\n                    <rte-header-cell *rteHeaderCellDef>\r\n                      <rte-checkbox\r\n                        (change)=\"$event ? masterToggle() : null\"\r\n                        [checked]=\"selection.hasValue() && isAllSelected()\"\r\n                        [indeterminate]=\"selection.hasValue() && !isAllSelected()\"\r\n                        [aria-label]=\"checkboxLabel()\"\r\n                      >\r\n                      </rte-checkbox>\r\n                    </rte-header-cell>\r\n                    <rte-cell *rteCellDef=\"let row\">\r\n                      <rte-checkbox\r\n                        (click)=\"$event.stopPropagation()\"\r\n                        (change)=\"$event ? selection.toggle(row) : null;\"\r\n                        [checked]=\"selection.isSelected(row)\"\r\n                        [aria-label]=\"checkboxLabel(row)\"\r\n                      >\r\n                      </rte-checkbox>\r\n                    </rte-cell>\r\n                  </ng-container>\r\n\r\n                <ng-container rteColumnDef=\"Key\">\r\n                    <rte-header-cell *rteHeaderCellDef> {{codePlaceholder}} </rte-header-cell>\r\n                    <rte-cell *rteCellDef=\"let element\">\r\n                        {{ maskTableElement(element.Key) }}\r\n                    </rte-cell>\r\n                </ng-container>\r\n\r\n                <ng-container rteColumnDef=\"Description\">\r\n                    <rte-header-cell *rteHeaderCellDef> {{descriptionPlaceholder}} </rte-header-cell>\r\n                    <rte-cell *rteCellDef=\"let element\">\r\n                        {{ element.Description }}\r\n                    </rte-cell>\r\n                </ng-container>\r\n\r\n                <rte-header-row\r\n                    *rteHeaderRowDef=\"displayedColumns\">\r\n                </rte-header-row>\r\n                <rte-row\r\n                    *rteRowDef=\"let row; columns: displayedColumns\"\r\n                    [ngClass]=\"{hovered: row.hovered, highlighted: row.highlighted, selected: toolbarObject.selectionModel.isSelected(row)}\"\r\n                    (mouseover)=\"row.hovered = true\"\r\n                    (mouseout)=\"row.hovered = false\"\r\n                >\r\n                </rte-row>\r\n            </rte-table>\r\n        </mat-card-content>\r\n    </rte-card>\r\n</div>\r\n",
                    styles: [""]
                }] }
    ];
    /** @nocollapse */
    RteLovMultiSelectModalComponent.ctorParameters = function () { return [
        { type: undefined, decorators: [{ type: Inject, args: [MAT_DIALOG_DATA,] }] },
        { type: HttpClient },
        { type: RteDialogRef }
    ]; };
    RteLovMultiSelectModalComponent.propDecorators = {
        sort: [{ type: ViewChild, args: [RteSortDirective,] }],
        codePlaceholder: [{ type: Input }],
        descriptionPlaceholder: [{ type: Input }],
        mask: [{ type: Input }]
    };
    return RteLovMultiSelectModalComponent;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var RteLovMultiSelectComponent = /** @class */ (function () {
    function RteLovMultiSelectComponent(dialog, http, rteAlert) {
        this.dialog = dialog;
        this.http = http;
        this.rteAlert = rteAlert;
        this.current = { Id: '', Description: '', Key: '', Properties: '' };
        this.displayedColumns = [
            'Key',
            'Description',
            'Remove'
        ];
        this.expanded = true;
        this.readOnly = false;
        this.mask = function (rawValue) {
            /** @type {?} */
            var maskRegex = [];
            for (var i = 0; i < 2000; i++) {
                maskRegex.push(/./);
            }
            return maskRegex;
        };
        this.onModelSelected = new EventEmitter();
    }
    /**
     * @return {?}
     */
    RteLovMultiSelectComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        this.lovService = new RteMultiSelectService(this.http);
        this.lovService.apiEndpoint = this.apiEndpoint;
    };
    /**
     * @return {?}
     */
    RteLovMultiSelectComponent.prototype.openModal = /**
     * @return {?}
     */
    function () {
        var _this = this;
        /** @type {?} */
        var dialogConfig = new MatDialogConfig();
        dialogConfig.disableClose = false;
        dialogConfig.autoFocus = true;
        dialogConfig.width = '800px';
        dialogConfig.disableClose = true;
        dialogConfig.data = {
            serviceBaseUrl: this.apiEndpoint,
            mask: this.mask,
            codePlaceholder: this.codePlaceholder,
            descriptionPlaceholder: this.descriptionPlaceholder,
            title: this.modalTitle
        };
        /** @type {?} */
        var currentDialog = this.dialog.open(RteLovMultiSelectModalComponent, dialogConfig);
        currentDialog.afterClosed().subscribe(function () {
            if (currentDialog.componentInstance.ok === true) {
                if (currentDialog.componentInstance.selection.selected.length > 0) {
                    var data_1 = _this.model.data;
                    if (!data_1) {
                        data_1 = [];
                    }
                    currentDialog.componentInstance.selection.selected.forEach(function (element) {
                        _this.current.Id = element.Id;
                        _this.current.Key = element.Key;
                        _this.current.Description = element.Description;
                        data_1.push(__assign({}, _this.current));
                    });
                    _this.model.data = data_1;
                    _this.emitterModelSelected();
                }
                _this.current.Id = null;
                _this.current.Key = null;
                _this.current.Description = null;
            }
        });
    };
    /**
     * @param {?} element
     * @return {?}
     */
    RteLovMultiSelectComponent.prototype.removeItem = /**
     * @param {?} element
     * @return {?}
     */
    function (element) {
        var data = this.model.data;
        if (!data) {
            data = [];
        }
        /** @type {?} */
        var newData = _.remove(data, function (item) {
            return item.Id !== element.Id;
        });
        this.model.data = newData;
        this.emitterModelSelected();
    };
    /**
     * @param {?} keyValue
     * @return {?}
     */
    RteLovMultiSelectComponent.prototype.maskTableElement = /**
     * @param {?} keyValue
     * @return {?}
     */
    function (keyValue) {
        /** @type {?} */
        var valor = '';
        if (keyValue != null && keyValue != '') {
            /** @type {?} */
            var codeMask = this.mask(keyValue);
            /** @type {?} */
            var valorMaskPos = 0;
            for (var i = 0; i < codeMask.length; i++) {
                if ((codeMask[i] instanceof RegExp) == false) {
                    valor += codeMask[i];
                }
                else {
                    valor += keyValue.substr(valorMaskPos++, 1);
                }
            }
        }
        return valor;
    };
    /**
     * @return {?}
     */
    RteLovMultiSelectComponent.prototype.codeChanged = /**
     * @return {?}
     */
    function () {
        var _this = this;
        if (this.current.Key != null && this.current.Key != '') {
            /** @type {?} */
            var codeMask = this.mask(this.current.Key);
            for (var i = 0; i < codeMask.length; i++) {
                if ((codeMask[i] instanceof RegExp) == false) {
                    while (this.current.Key.indexOf(codeMask[i]) != -1) {
                        this.current.Key = this.current.Key.replace(codeMask[i], '');
                    }
                }
            }
            this.lovService.apiEndpoint = this.apiEndpoint;
            this.lovService.get({
                Key: this.current.Key,
                Id: null,
                Description: null
            }, 0, 1).subscribe(function (result) {
                if (result.TotalRegisters > 0) {
                    _this.current.Id = result.Data[0].Id;
                    _this.current.Key = result.Data[0].Key;
                    _this.current.Description = result.Data[0].Description;
                    var data = _this.model.data;
                    if (!data) {
                        data = [];
                    }
                    data.push(__assign({}, _this.current));
                    _this.model.data = data;
                    _this.emitterModelSelected();
                }
                _this.current.Id = null;
                _this.current.Key = null;
                _this.current.Description = null;
            });
        }
        else {
            this.current.Id = null;
            this.current.Key = null;
            this.current.Description = null;
        }
    };
    /**
     * @return {?}
     */
    RteLovMultiSelectComponent.prototype.emitterModelSelected = /**
     * @return {?}
     */
    function () {
        this.onModelSelected.emit((/** @type {?} */ (this.model.data)));
    };
    RteLovMultiSelectComponent.decorators = [
        { type: Component, args: [{
                    selector: 'rte-lov-multi-select',
                    template: "<rte-accordion>\r\n  <rte-expansion-panel [expanded]=\"expanded\">\r\n    <rte-expansion-panel-header>\r\n      <rte-panel-title>\r\n        {{ExpansionPanelDescription}}(s)\r\n      </rte-panel-title>\r\n      <rte-panel-description>\r\n        Expanda para visualizar {{model.data.length}} {{ExpansionPanelDescription}}(s) selecionados\r\n      </rte-panel-description>\r\n    </rte-expansion-panel-header>\r\n    <div class='row-form' *ngIf=\"!readOnly\">\r\n      <div class='column-form'>\r\n        <rte-form-field>\r\n          <input rteInput name=\"field1\" type=\"text\" required maxlength=\"65\" [placeholder]=\"codePlaceholder\"\r\n            [(ngModel)]=\"current.Key\" (change)=\"codeChanged()\" [textMask]=\"{ mask: mask, guide: false }\" />\r\n          <button mat-icon-button matSuffix class=\"search-button\" aria-label=\"Abrir pesquisa\" (click)=\"openModal()\">\r\n            <mat-icon>search</mat-icon>\r\n          </button>\r\n        </rte-form-field>\r\n      </div>\r\n      <div class='column-form'>\r\n        <rte-form-field>\r\n          <input rteInput name=\"field2\" type=\"text\" required [placeholder]=\"descriptionPlaceholder\" tabindex=\"-1\" readonly=\"readonly\"\r\n            [(ngModel)]=\"current.Description\" />\r\n        </rte-form-field>\r\n      </div>\r\n    </div>\r\n    <rte-card>\r\n      <mat-card-content>\r\n        <rte-table [dataSource]=\"model\" rteSort>\r\n          <ng-container rteColumnDef=\"Key\">\r\n            <rte-header-cell *rteHeaderCellDef> {{codePlaceholder}} </rte-header-cell>\r\n            <rte-cell *rteCellDef=\"let element\">\r\n              {{ element.Key }}\r\n            </rte-cell>\r\n          </ng-container>\r\n\r\n          <ng-container rteColumnDef=\"Description\">\r\n            <rte-header-cell *rteHeaderCellDef> {{descriptionPlaceholder}} </rte-header-cell>\r\n            <rte-cell *rteCellDef=\"let element\">\r\n              {{ element.Description }}\r\n            </rte-cell>\r\n          </ng-container>\r\n\r\n          <ng-container rteColumnDef=\"Remove\"  >\r\n            <rte-header-cell *rteHeaderCellDef></rte-header-cell>\r\n            <rte-cell *rteCellDef=\"let element\">\r\n              <rte-icon *ngIf=\"!readOnly\" (click)=\"removeItem(element)\">delete</rte-icon>\r\n            </rte-cell>\r\n          </ng-container>\r\n\r\n          <rte-header-row *rteHeaderRowDef=\"displayedColumns\">\r\n          </rte-header-row>\r\n          <rte-row *rteRowDef=\"let row; columns: displayedColumns\"\r\n            [ngClass]=\"{hovered: row.hovered, highlighted: row.highlighted }\" (mouseover)=\"row.hovered = true\"\r\n            (mouseout)=\"row.hovered = false\">\r\n          </rte-row>\r\n        </rte-table>\r\n      </mat-card-content>\r\n    </rte-card>\r\n  </rte-expansion-panel>\r\n</rte-accordion>\r\n",
                    styles: ["::ng-deep .mat-expansion-panel-body{padding-top:50px!important}.search-button{padding:0;background-color:transparent;border:0;position:absolute;top:-16px;left:-30px;cursor:pointer}"]
                }] }
    ];
    /** @nocollapse */
    RteLovMultiSelectComponent.ctorParameters = function () { return [
        { type: RteDialog },
        { type: HttpClient },
        { type: RTEAlertService }
    ]; };
    RteLovMultiSelectComponent.propDecorators = {
        model: [{ type: Input }],
        apiEndpoint: [{ type: Input }],
        codePlaceholder: [{ type: Input }],
        descriptionPlaceholder: [{ type: Input }],
        ExpansionPanelDescription: [{ type: Input }],
        modalTitle: [{ type: Input }],
        expanded: [{ type: Input }],
        readOnly: [{ type: Input }],
        mask: [{ type: Input }],
        onModelSelected: [{ type: Output }]
    };
    return RteLovMultiSelectComponent;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var RteLovModule = /** @class */ (function () {
    function RteLovModule() {
    }
    RteLovModule.decorators = [
        { type: NgModule, args: [{
                    imports: [
                        CommonModule,
                        FormsModule,
                        RteMaterialModule,
                        MatIconModule,
                        MatFormFieldModule,
                        RteToolbarModule,
                        MatCardModule,
                        MatTooltipModule,
                        RteAlertModule,
                        TextMaskModule
                    ],
                    declarations: [RteLovComponent, RteLovModalComponent, RteLovMultiSelectComponent, RteLovMultiSelectModalComponent],
                    exports: [RteLovComponent, RteLovModalComponent, RteLovMultiSelectComponent, RteLovMultiSelectModalComponent],
                    entryComponents: [RteLovModalComponent, RteLovMultiSelectModalComponent]
                },] }
    ];
    return RteLovModule;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @template T
 */
var /**
 * @template T
 */
AfterCancel = /** @class */ (function () {
    function AfterCancel(PreviousStatus, Current) {
        this.PreviousStatus = PreviousStatus;
        this.Current = Current;
    }
    return AfterCancel;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @template T
 */
var /**
 * @template T
 */
AfterModeChange = /** @class */ (function () {
    function AfterModeChange(Current, Status, Success) {
        this.Current = Current;
        this.Status = Status;
        this.Success = Success;
    }
    return AfterModeChange;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var BeforeDeleteTerm = /** @class */ (function () {
    function BeforeDeleteTerm() {
        this.cancel = false;
    }
    return BeforeDeleteTerm;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var BeforeEditTerm = /** @class */ (function () {
    function BeforeEditTerm() {
        this.cancel = false;
    }
    return BeforeEditTerm;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var BeforeGetTerm = /** @class */ (function () {
    function BeforeGetTerm() {
        this.cancel = false;
    }
    return BeforeGetTerm;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var BeforeInsertTerm = /** @class */ (function () {
    function BeforeInsertTerm() {
        this.cancel = false;
    }
    return BeforeInsertTerm;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @enum {number} */
var FormTermStatus = {
    Viewing: 0,
    Inserting: 1,
    Editing: 2,
};
FormTermStatus[FormTermStatus.Viewing] = 'Viewing';
FormTermStatus[FormTermStatus.Inserting] = 'Inserting';
FormTermStatus[FormTermStatus.Editing] = 'Editing';

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @enum {number} */
var TermPeriodEnum = {
    Current: 0,
    Future: 1,
    Past: 2,
    None: 3,
};
TermPeriodEnum[TermPeriodEnum.Current] = 'Current';
TermPeriodEnum[TermPeriodEnum.Future] = 'Future';
TermPeriodEnum[TermPeriodEnum.Past] = 'Past';
TermPeriodEnum[TermPeriodEnum.None] = 'None';

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @template T
 */
var  /**
 * @template T
 */
RteTermViewModel = /** @class */ (function () {
    function RteTermViewModel() {
        this.formStatus = FormTermStatus.Viewing;
    }
    /**
     * @param {?} newCurrent
     * @return {?}
     */
    RteTermViewModel.prototype.setCurrent = /**
     * @param {?} newCurrent
     * @return {?}
     */
    function (newCurrent) {
        this.current = newCurrent;
    };
    /**
     * @return {?}
     */
    RteTermViewModel.prototype.isViewingMode = /**
     * @return {?}
     */
    function () {
        return this.formStatus === FormTermStatus.Viewing;
    };
    /**
     * @return {?}
     */
    RteTermViewModel.prototype.isPossibleDelete = /**
     * @return {?}
     */
    function () {
        return this.formStatus !== FormTermStatus.Inserting;
    };
    /**
     * @return {?}
     */
    RteTermViewModel.prototype.isSaveMode = /**
     * @return {?}
     */
    function () {
        return this.formStatus === FormTermStatus.Inserting || this.formStatus === FormTermStatus.Editing;
    };
    /**
     * @return {?}
     */
    RteTermViewModel.prototype.isEditMode = /**
     * @return {?}
     */
    function () {
        return this.formStatus === FormTermStatus.Editing;
    };
    /**
     * @return {?}
     */
    RteTermViewModel.prototype.isInsertMode = /**
     * @return {?}
     */
    function () {
        return this.formStatus === FormTermStatus.Inserting;
    };
    /**
     * @return {?}
     */
    RteTermViewModel.prototype.canEditOrInsert = /**
     * @return {?}
     */
    function () {
        return this.canInsert() || this.canEdit();
    };
    /**
     * @return {?}
     */
    RteTermViewModel.prototype.canEdit = /**
     * @return {?}
     */
    function () {
        return this.current.PeriodType === TermPeriodEnum.Future && this.formStatus === FormTermStatus.Editing;
    };
    /**
     * @return {?}
     */
    RteTermViewModel.prototype.canInsert = /**
     * @return {?}
     */
    function () {
        return this.formStatus === FormTermStatus.Inserting;
    };
    return RteTermViewModel;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var ShowButtonTerm = /** @class */ (function () {
    function ShowButtonTerm() {
        this.confirm = true;
        this.insert = true;
        this.edit = true;
        this.cancel = true;
        this.delete = true;
        this.pagination = true;
    }
    return ShowButtonTerm;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var TermPagination = /** @class */ (function () {
    function TermPagination() {
        this.page = 1;
        this.pageSize = 10;
        this.totalPages = 0;
        this.totalRegisters = 0;
        this.currentRegister = 0;
        this.resetPages();
    }
    /**
     * @return {?}
     */
    TermPagination.prototype.hasPrevPage = /**
     * @return {?}
     */
    function () {
        return this.page > 1 || this.currentRegister > 0;
    };
    /**
     * @return {?}
     */
    TermPagination.prototype.hasNextPage = /**
     * @return {?}
     */
    function () {
        return ((this.pageSize * (this.page - 1)) + this.currentRegister) < this.totalRegisters - 1;
    };
    //#region Navegação
    //#region Navegação
    /**
     * @return {?}
     */
    TermPagination.prototype.firstRegister = 
    //#region Navegação
    /**
     * @return {?}
     */
    function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(this.page !== 1)) return [3 /*break*/, 2];
                        this.page = 1;
                        return [4 /*yield*/, this.get()];
                    case 1:
                        _a.sent();
                        return [3 /*break*/, 3];
                    case 2:
                        this.setCurrent(0);
                        _a.label = 3;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * @return {?}
     */
    TermPagination.prototype.prev = /**
     * @return {?}
     */
    function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!((this.currentRegister - 1) >= 0)) return [3 /*break*/, 1];
                        this.setCurrent(this.currentRegister - 1);
                        return [3 /*break*/, 3];
                    case 1:
                        this.page--;
                        return [4 /*yield*/, this.get(true)];
                    case 2:
                        _a.sent();
                        _a.label = 3;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * @return {?}
     */
    TermPagination.prototype.next = /**
     * @return {?}
     */
    function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!((this.currentRegister + 1) < this.pageSize)) return [3 /*break*/, 1];
                        this.setCurrent(this.currentRegister + 1);
                        return [3 /*break*/, 3];
                    case 1:
                        this.page++;
                        return [4 /*yield*/, this.get()];
                    case 2:
                        _a.sent();
                        _a.label = 3;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * @return {?}
     */
    TermPagination.prototype.lastRegister = /**
     * @return {?}
     */
    function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(this.page !== this.totalPages)) return [3 /*break*/, 2];
                        this.page = this.totalPages;
                        return [4 /*yield*/, this.get(true)];
                    case 1:
                        _a.sent();
                        return [3 /*break*/, 3];
                    case 2:
                        this.setCurrent(this.dataSource.Data.length - 1);
                        _a.label = 3;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * @return {?}
     */
    TermPagination.prototype.resetPages = /**
     * @return {?}
     */
    function () {
        this.page = 1;
        this.pageSize = 10;
        this.totalPages = 0;
        this.totalRegisters = 0;
        this.currentRegister = 0;
    };
    /**
     * @private
     * @param {?=} fromPrevious
     * @return {?}
     */
    TermPagination.prototype.get = /**
     * @private
     * @param {?=} fromPrevious
     * @return {?}
     */
    function (fromPrevious) {
        if (fromPrevious === void 0) { fromPrevious = false; }
        this.termComponent.get(this.page, this.pageSize, fromPrevious);
        this.totalRegisters = this.dataSource.TotalRegisters;
    };
    /**
     * @private
     * @param {?} index
     * @return {?}
     */
    TermPagination.prototype.setCurrent = /**
     * @private
     * @param {?} index
     * @return {?}
     */
    function (index) {
        this.currentRegister = index;
        this.termComponent.setCurrent(this.dataSource.Data[this.currentRegister]);
    };
    return TermPagination;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var TermComponent = /** @class */ (function () {
    function TermComponent(dialog, rteAlertService) {
        this.dialog = dialog;
        this.rteAlertService = rteAlertService;
        this.showButton = new ShowButtonTerm();
        this.disabled = false;
        this.customizeBeforeInsert = new EventEmitter();
        this.customizeAfterInsert = new EventEmitter();
        this.customizeBeforeEdit = new EventEmitter();
        this.customizeAfterEdit = new EventEmitter();
        this.customizeBeforeDelete = new EventEmitter();
        this.customizeAfterDelete = new EventEmitter();
        this.customizeBeforeGet = new EventEmitter();
        this.customizeAfterGet = new EventEmitter();
        this.customizeAfterEditMode = new EventEmitter();
        this.customizeAfterInsertMode = new EventEmitter();
        this.customizeAfterCurrentChange = new EventEmitter();
        this.customizeAfterCancel = new EventEmitter();
        this.pagination = new TermPagination();
        this.maskDate = {
            modeClean: true,
            guide: false,
            showMask: true,
            mask: [/\d/, /\d/, '/', /\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/]
        };
        this.maskTime = {
            modeClean: true,
            guide: false,
            showMask: true,
            mask: [/\d/, /\d/, ':', /\d/, /\d/]
        };
        this.subscriptions = Subscription.EMPTY;
        this.moment = moment_;
    }
    /**
     * @return {?}
     */
    TermComponent.prototype.getTermStatus = /**
     * @return {?}
     */
    function () {
        switch (this.termObject.current.PeriodType) {
            case 0:
                return 'VIGENTE';
            case 1:
                return 'FUTURA';
            case 2:
                return 'EXPIRADA';
            case 3:
                return ' ';
            default:
                break;
        }
    };
    /**
     * @return {?}
     */
    TermComponent.prototype.getTermStatusClass = /**
     * @return {?}
     */
    function () {
        switch (this.termObject.current.PeriodType) {
            case 0:
                return 'status current';
            case 1:
                return 'status future';
            case 2:
                return 'status past';
            case 3:
                return 'status none';
            default:
                break;
        }
    };
    /**
     * @return {?}
     */
    TermComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        this.termObject.setCurrent(this.service.clear());
        this.pagination.termComponent = this;
    };
    /**
     * @param {?} evt
     * @return {?}
     */
    TermComponent.prototype.onDateChanges = /**
     * @param {?} evt
     * @return {?}
     */
    function (evt) {
    };
    /**
     * @return {?}
     */
    TermComponent.prototype.setStartTime = /**
     * @return {?}
     */
    function () {
        if (this.termObject.current.StartingTimeView) {
            /** @type {?} */
            var hour = 0;
            /** @type {?} */
            var minute = 0;
            hour = +this.termObject.current.StartingTimeView.substr(0, 2);
            minute = +this.termObject.current.StartingTimeView.substr(3, 2);
            if (typeof (this.termObject.current.StartingDate) === 'string') {
                /** @type {?} */
                var str = this.termObject.current.StartingDate;
                this.termObject.current.StartingDate = this.moment(new Date(str));
            }
            this.termObject.current.StartingDate.hours(hour);
            this.termObject.current.StartingDate.minutes(minute);
            if (this.termObject.current.StartingDate.isUTC()) {
                this.termObject.current.StartingDate.add(3, 'hour');
            }
            this.setTermStatus();
        }
    };
    /**
     * @return {?}
     */
    TermComponent.prototype.setEndTime = /**
     * @return {?}
     */
    function () {
        if (this.termObject.current.EndingTimeView) {
            /** @type {?} */
            var hour = 0;
            /** @type {?} */
            var minute = 0;
            hour = +this.termObject.current.EndingTimeView.substr(0, 2);
            minute = +this.termObject.current.EndingTimeView.substr(3, 2);
            if (this.termObject.current.EndingDate) {
                if (typeof (this.termObject.current.EndingDate) === 'string') {
                    /** @type {?} */
                    var str = this.termObject.current.EndingDate;
                    this.termObject.current.EndingDate = this.moment(new Date(str));
                }
                this.termObject.current.EndingDate.hours(hour);
                this.termObject.current.EndingDate.minutes(minute);
                if (this.termObject.current.EndingDate.isUTC()) {
                    this.termObject.current.EndingDate.add(3, 'hour');
                }
                this.setTermStatus();
            }
        }
    };
    /**
     * @return {?}
     */
    TermComponent.prototype.setTermStatus = /**
     * @return {?}
     */
    function () {
        /** @type {?} */
        var date = new Date();
        if (typeof (this.termObject.current.StartingDate) === 'string') {
            /** @type {?} */
            var str = this.termObject.current.StartingDate;
            this.termObject.current.StartingDate = this.moment(new Date(str));
        }
        if (typeof (this.termObject.current.EndingDate) === 'string') {
            /** @type {?} */
            var str = this.termObject.current.EndingDate;
            this.termObject.current.EndingDate = this.moment(new Date(str));
        }
        if (this.termObject.current.StartingDate.toDate() > date) {
            this.termObject.current.PeriodType = TermPeriodEnum.Future;
            return;
        }
        if ((this.termObject.current.EndingDate) &&
            this.termObject.current.EndingDate.toDate() < date) {
            this.termObject.current.PeriodType = TermPeriodEnum.Past;
            return;
        }
        if (this.termObject.current.StartingDate.toDate() <= date &&
            (!this.termObject.current.EndingDate || this.termObject.current.EndingDate.toDate() >= date)) {
            this.termObject.current.PeriodType = TermPeriodEnum.Current;
            return;
        }
        this.termObject.current.PeriodType = TermPeriodEnum.None;
    };
    /**
     * @return {?}
     */
    TermComponent.prototype.insertMode = /**
     * @return {?}
     */
    function () {
        this.oldModelTerm = __assign({}, this.termObject.current);
        this.termObject.current = this.service.clear();
        this.termObject.current.StartingDate = this.moment(new Date()).add(30, 'm');
        /** @type {?} */
        var hour = this.termObject.current.StartingDate.hours();
        /** @type {?} */
        var minute = this.termObject.current.StartingDate.minutes();
        this.termObject.current.StartingTimeView = this.padWithZeroTime(hour) + ':' + this.padWithZeroTime(minute);
        this.setTermStatus();
        this.termObject.formStatus = FormTermStatus.Inserting;
        this.customizeAfterInsertMode.emit(new AfterModeChange(this.termObject.current, this.termObject.formStatus, true));
    };
    /**
     * @return {?}
     */
    TermComponent.prototype.editMode = /**
     * @return {?}
     */
    function () {
        if (this.termObject.current.PeriodType === TermPeriodEnum.Past) {
            this.rteAlertService.warning('Não é possível alterar uma vigência expirada');
            this.customizeAfterEditMode.emit(new AfterModeChange(this.termObject.current, this.termObject.formStatus, false));
            return;
        }
        this.oldModelTerm = __assign({}, this.termObject.current);
        this.termObject.formStatus = FormTermStatus.Editing;
        this.periodTypeAtStartEdit = this.termObject.current.PeriodType;
        this.customizeAfterEditMode.emit(new AfterModeChange(this.termObject.current, this.termObject.formStatus, true));
    };
    /**
     * @return {?}
     */
    TermComponent.prototype.cancel = /**
     * @return {?}
     */
    function () {
        if (this.termObject.formStatus === FormTermStatus.Viewing) {
            return;
        }
        this.termObject.current = this.oldModelTerm;
        /** @type {?} */
        var previousStatus = this.termObject.formStatus;
        this.termObject.formStatus = FormTermStatus.Viewing;
        this.customizeAfterCancel.emit(new AfterCancel(previousStatus, this.termObject.current));
    };
    /**
     * @return {?}
     */
    TermComponent.prototype.confirmDelete = /**
     * @return {?}
     */
    function () {
        var _this = this;
        if (this.termObject.current.PeriodType === TermPeriodEnum.Past) {
            this.rteAlertService.warning('Não é possível excluir uma vigência expirada');
            return;
        }
        /** @type {?} */
        var title = 'Confirmar a exclusão';
        /** @type {?} */
        var description = 'Deseja realmente excluir o registro?';
        /** @type {?} */
        var dialogConfig = new MatDialogConfig();
        dialogConfig.autoFocus = false;
        dialogConfig.width = '450px';
        dialogConfig.disableClose = true;
        dialogConfig.data = { title: title, description: description };
        /** @type {?} */
        var dialogRef = this.dialog.customOpen(YesNoDialogComponent, dialogConfig);
        dialogRef.afterClosed().subscribe(function (data) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(data === true)) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.delete()];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        }); });
    };
    /**
     * @return {?}
     */
    TermComponent.prototype.delete = /**
     * @return {?}
     */
    function () {
        return __awaiter(this, void 0, void 0, function () {
            var beforeDelete;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        beforeDelete = new BeforeDeleteTerm();
                        return [4 /*yield*/, this.customizeBeforeDelete.emit(beforeDelete)];
                    case 1:
                        _a.sent();
                        if (!beforeDelete.cancel) {
                            this.service.delete(this.termObject.current).subscribe(function (result) { return __awaiter(_this, void 0, void 0, function () {
                                return __generator(this, function (_a) {
                                    switch (_a.label) {
                                        case 0:
                                            if (!result) return [3 /*break*/, 3];
                                            return [4 /*yield*/, this.customizeAfterDelete.emit()];
                                        case 1:
                                            _a.sent();
                                            this.pagination.resetPages();
                                            return [4 /*yield*/, this.get(1, this.pagination.pageSize)];
                                        case 2:
                                            _a.sent();
                                            _a.label = 3;
                                        case 3: return [2 /*return*/];
                                    }
                                });
                            }); });
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * @return {?}
     */
    TermComponent.prototype.confirm = /**
     * @return {?}
     */
    function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                if (this.termObject.formStatus === FormTermStatus.Inserting) {
                    this.insert();
                }
                if (this.termObject.formStatus === FormTermStatus.Editing) {
                    this.edit();
                }
                return [2 /*return*/];
            });
        });
    };
    /**
     * @return {?}
     */
    TermComponent.prototype.insert = /**
     * @return {?}
     */
    function () {
        return __awaiter(this, void 0, void 0, function () {
            var beforeInsert;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        beforeInsert = new BeforeInsertTerm();
                        return [4 /*yield*/, this.customizeBeforeInsert.emit(beforeInsert)];
                    case 1:
                        _a.sent();
                        if (!beforeInsert.cancel) {
                            this.setSecondsAndMilliseconds(this.termObject.current.StartingDate, this.termObject.current.EndingDate);
                            this.service.insert(this.termObject.current).subscribe(function (result) { return __awaiter(_this, void 0, void 0, function () {
                                return __generator(this, function (_a) {
                                    switch (_a.label) {
                                        case 0:
                                            this.termObject.current = result;
                                            this.termObject.formStatus = FormTermStatus.Viewing;
                                            return [4 /*yield*/, this.customizeAfterInsert.emit()];
                                        case 1:
                                            _a.sent();
                                            this.pagination.resetPages();
                                            return [4 /*yield*/, this.get(1, this.pagination.pageSize)];
                                        case 2:
                                            _a.sent();
                                            return [2 /*return*/];
                                    }
                                });
                            }); });
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * @return {?}
     */
    TermComponent.prototype.edit = /**
     * @return {?}
     */
    function () {
        return __awaiter(this, void 0, void 0, function () {
            var beforeEdit;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        beforeEdit = new BeforeEditTerm();
                        return [4 /*yield*/, this.customizeBeforeEdit.emit(beforeEdit)];
                    case 1:
                        _a.sent();
                        if (!beforeEdit.cancel) {
                            this.setSecondsAndMilliseconds(this.termObject.current.StartingDate, this.termObject.current.EndingDate);
                            this.service.edit(this.termObject.current).subscribe(function (result) { return __awaiter(_this, void 0, void 0, function () {
                                return __generator(this, function (_a) {
                                    switch (_a.label) {
                                        case 0:
                                            this.termObject.current = result;
                                            this.termObject.formStatus = FormTermStatus.Viewing;
                                            return [4 /*yield*/, this.customizeAfterEdit.emit()];
                                        case 1:
                                            _a.sent();
                                            this.pagination.resetPages();
                                            return [4 /*yield*/, this.get(1, this.pagination.pageSize)];
                                        case 2:
                                            _a.sent();
                                            return [2 /*return*/];
                                    }
                                });
                            }); });
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * @param {?=} setLastIndex
     * @return {?}
     */
    TermComponent.prototype.getFirstPage = /**
     * @param {?=} setLastIndex
     * @return {?}
     */
    function (setLastIndex) {
        if (setLastIndex === void 0) { setLastIndex = false; }
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.get(1, this.pagination.pageSize, setLastIndex)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * @param {?} page
     * @param {?} pageSize
     * @param {?=} setLastIndex
     * @return {?}
     */
    TermComponent.prototype.get = /**
     * @param {?} page
     * @param {?} pageSize
     * @param {?=} setLastIndex
     * @return {?}
     */
    function (page, pageSize, setLastIndex) {
        if (setLastIndex === void 0) { setLastIndex = false; }
        return __awaiter(this, void 0, void 0, function () {
            var beforeGet;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        beforeGet = new BeforeGetTerm;
                        return [4 /*yield*/, this.customizeBeforeGet.emit(beforeGet)];
                    case 1:
                        _a.sent();
                        if (beforeGet.cancel === true) {
                            return [2 /*return*/];
                        }
                        this.service.get(this.toolbarParentObject.current, page, pageSize).subscribe(function (result) { return __awaiter(_this, void 0, void 0, function () {
                            var index;
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0:
                                        this.pagination.dataSource = result;
                                        this.pagination.totalPages = result.AmountPages;
                                        this.pagination.totalRegisters = result.TotalRegisters;
                                        this.pagination.page = page;
                                        this.pagination.pageSize = pageSize;
                                        index = 0;
                                        if (setLastIndex) {
                                            index = pageSize - 1;
                                        }
                                        this.pagination.currentRegister = index;
                                        this.termObject.setCurrent(result.Data[index]);
                                        return [4 /*yield*/, this.customizeAfterGet.emit()];
                                    case 1:
                                        _a.sent();
                                        return [2 /*return*/];
                                }
                            });
                        }); });
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * @param {?} newCurrent
     * @return {?}
     */
    TermComponent.prototype.setCurrent = /**
     * @param {?} newCurrent
     * @return {?}
     */
    function (newCurrent) {
        this.termObject.setCurrent(newCurrent);
        this.customizeAfterCurrentChange.emit(newCurrent);
    };
    /**
     * @return {?}
     */
    TermComponent.prototype.ngOnDestroy = /**
     * @return {?}
     */
    function () {
        this.subscriptions.unsubscribe();
    };
    /**
     * @return {?}
     */
    TermComponent.prototype.preventChangeStartingDate = /**
     * @return {?}
     */
    function () {
        return this.termObject.isViewingMode() ||
            this.disabled ||
            (this.termObject.current.PeriodType !== TermPeriodEnum.Future &&
                !this.termObject.isInsertMode() &&
                this.periodTypeAtStartEdit !== TermPeriodEnum.Future);
    };
    /**
     * @private
     * @param {?} input
     * @return {?}
     */
    TermComponent.prototype.padWithZeroTime = /**
     * @private
     * @param {?} input
     * @return {?}
     */
    function (input) {
        /** @type {?} */
        var str = '' + input;
        /** @type {?} */
        var result = ('00' + str).substring(str.length);
        return result;
    };
    /**
     * @return {?}
     */
    TermComponent.prototype.minStartingDate = /**
     * @return {?}
     */
    function () {
        return this.moment();
    };
    /**
     * @return {?}
     */
    TermComponent.prototype.minEndingDate = /**
     * @return {?}
     */
    function () {
        if (this.termObject.current.PeriodType === TermPeriodEnum.Current) {
            return this.moment();
        }
        return this.termObject.current.StartingDate;
    };
    /**
     * @param {?} startingDate
     * @param {?} endingDate
     * @return {?}
     */
    TermComponent.prototype.setSecondsAndMilliseconds = /**
     * @param {?} startingDate
     * @param {?} endingDate
     * @return {?}
     */
    function (startingDate, endingDate) {
        if (startingDate) {
            startingDate.set({
                seconds: 0,
                milliseconds: 0
            });
        }
        if (endingDate) {
            endingDate.set({
                seconds: 59,
                milliseconds: 999
            });
        }
    };
    TermComponent.decorators = [
        { type: Component, args: [{
                    selector: 'rte-term',
                    template: "<div class=\"row-form\">\r\n  <div class=\"column-form\">\r\n    <rte-toolbar-lite [isFixedToolbar]='false' [title]=\"'Vig\u00EAncia'\" [showRteDivider]=\"false\">\r\n      <ng-content select=\".custom-title\" class=\"custom-title\"></ng-content>\r\n      <div  *ngIf=\"showButton.pagination\" class=\"toolbar-navigation-buttons\">\r\n        <span>\r\n          <button (click)=\"this.pagination.firstRegister()\" class=\"rte-icon-arrows navigation-button\" rtebutton\r\n                  [disabled]=\"!this.pagination.hasPrevPage() || !termObject.isViewingMode() || disabled \">\r\n            <rte-icon class=\"material-icons\">first_page</rte-icon>\r\n          </button>\r\n          <button (click)=\"this.pagination.prev()\" class=\"rte-icon-arrows navigation-button\" rtebutton\r\n                  [disabled]=\"!this.pagination.hasPrevPage() || !termObject.isViewingMode() || disabled \">\r\n            <rte-icon class=\"material-icons\">chevron_left</rte-icon>\r\n          </button>\r\n          <button rtebutton class=\"rte-icon-arrows navigation-button\" title=\"Pr\u00F3ximo (Up)\" (click)=\"this.pagination.next()\"\r\n            [disabled]=\"!this.pagination.hasNextPage() || !termObject.isViewingMode() || disabled \">\r\n            <rte-icon class=\"material-icons\">chevron_right</rte-icon>\r\n          </button>\r\n          <button rtebutton class=\"rte-icon-arrows navigation-button\" title=\"\u00DAltimo registro\" (click)=\"this.pagination.lastRegister()\"\r\n                  [disabled]=\"!this.pagination.hasNextPage() || !termObject.isViewingMode() || disabled \">\r\n            <rte-icon class=\"material-icons\">last_page</rte-icon>\r\n          </button>\r\n        </span>\r\n      </div>\r\n      <span [ngClass]=\"getTermStatusClass()\">{{ getTermStatus() }}</span>\r\n      <span class=\"rte-spacer\"></span>\r\n      <div class=\"rte-app-actions\">\r\n        <ng-content></ng-content>\r\n      </div>\r\n      <button \r\n        rtebutton-flat \r\n        class=\"button-margin\" \r\n        color=\"primary\" \r\n        *ngIf=\"showButton.confirm\" \r\n        title=\"Salvar (Ctrl+S)\" \r\n        [disabled]=\"!termObject.isSaveMode() || disabled\" \r\n        (click)=\"confirm()\">\r\n        <span class=\"rte-icon\">\r\n          Confirmar\r\n        </span>\r\n      </button>\r\n      <mat-button-toggle-group #group=\"matButtonToggleGroup\">\r\n        <mat-button-toggle \r\n          *ngIf=\"showButton.insert\" \r\n          title=\"Inserir\" \r\n          (click)=\"insertMode()\" \r\n          [disabled]=\"!termObject.isViewingMode() || disabled\">\r\n          <rte-icon class=\"material-icons\">add_circle_outline</rte-icon>\r\n          Inserir\r\n        </mat-button-toggle>\r\n        <mat-button-toggle \r\n          *ngIf=\"showButton.edit\" \r\n          (click)=\"editMode()\" \r\n          title=\"Editar registro\" \r\n          [disabled]=\"!termObject.isViewingMode() || disabled\">\r\n          <rte-icon class=\"material-icons\">edit_icon</rte-icon>\r\n          Editar\r\n        </mat-button-toggle>\r\n        <mat-button-toggle \r\n          *ngIf=\"showButton.cancel\"\r\n          [disabled]=\"termObject.isViewingMode()\"\r\n          (click)=\"cancel()\"\r\n          title=\"Cancelar (F7)\">\r\n          <rte-icon class=\"material-icons\">clear</rte-icon>\r\n          Cancelar\r\n        </mat-button-toggle>\r\n      </mat-button-toggle-group>\r\n      <button \r\n        rtebutton-flat \r\n        color=\"warn\" \r\n        *ngIf=\"showButton.delete\" \r\n        color=\"warn\" \r\n        title=\"Delete registro\" \r\n        [disabled]=\"!termObject.isPossibleDelete() || disabled\" \r\n        (click)=\"confirmDelete()\">\r\n        <rte-icon class=\"material-icons\">delete_outline</rte-icon>\r\n        Remover\r\n      </button>\r\n    </rte-toolbar-lite>\r\n  </div>\r\n</div>\r\n<div class=\"row-form\">\r\n  <div class=\"column-form\">\r\n    <rte-form-field class=\"input-date-width\">\r\n      <input \r\n        rteInput #inputStartDate [rteDatepicker]=\"startDate\" placeholder=\"Data Inicial\"\r\n        [(ngModel)]=\"termObject.current.StartingDate\"\r\n        [disabled]=\"preventChangeStartingDate()\"\r\n        [max]=\"termObject.current.EndingDate\"\r\n        [min]=\"minStartingDate()\"\r\n        (dateChange)=\"setStartTime()\"\r\n        required>\r\n      <rte-datepicker-toggle matSuffix [for]=\"startDate\"></rte-datepicker-toggle>\r\n      <rte-datepicker #startDate></rte-datepicker>\r\n    </rte-form-field>\r\n  </div>\r\n  <div class=\"column-form\">\r\n    <rte-form-field>\r\n      <input\r\n        (change)=\"setStartTime()\"\r\n        [(ngModel)]=\"termObject.current.StartingTimeView\"\r\n        placeholder=\" \"\r\n        rteInput\r\n        type=\"time\"\r\n        required\r\n        [disabled]=\"preventChangeStartingDate()\">\r\n    </rte-form-field>\r\n  </div>\r\n  <div class=\"column-form\">\r\n    <rte-form-field class=\"input-date-width\">\r\n      <input\r\n        #inputEndDate\r\n        [rteDatepicker]=\"endDate\"\r\n        rteInput\r\n        placeholder=\"Data final\"\r\n        [disabled]=\"termObject.isViewingMode() || disabled\"\r\n        [(ngModel)]=\"termObject.current.EndingDate\"\r\n        [min]=\"minEndingDate()\"\r\n        (dateChange)=\"setEndTime()\">\r\n      <rte-datepicker-toggle matSuffix [for]=\"endDate\"></rte-datepicker-toggle>\r\n      <rte-datepicker #endDate></rte-datepicker>\r\n    </rte-form-field>\r\n  </div>\r\n  <div class=\"column-form\">\r\n    <rte-form-field>\r\n      <input\r\n        [(ngModel)]=\"termObject.current.EndingTimeView\"\r\n        placeholder=\" \"\r\n        rteInput\r\n        (change)=\"setEndTime()\"\r\n        [disabled]=\"termObject.isViewingMode() || disabled\"\r\n        type=\"time\">\r\n    </rte-form-field>\r\n  </div>\r\n</div>\r\n",
                    styles: [".rte-icon{padding:0;margin-left:1px}.rte-icon-arrows{min-width:0;padding:0}.rte-spacer{flex:1 1 auto}.rte-mat-vertical_line{height:40px!important}.rte-app-actions{text-align:right;padding-top:0}button rte-icon{margin-top:-3px;vertical-align:middle}button rte-icon.edit-icon{margin-top:-5px}.navigation-button{color:#212121}.navigation-button[disabled]{color:#bdbdbd}.toolbar-navigation-buttons{margin-left:13px}.register-input{width:10px;position:relative;border-bottom:1px solid #000;font:400 14px/34px Roboto,\"Helvetica Neue\",sans-serif;border:1px solid #757575;border-radius:4px;height:24px;top:-4.8px;text-align:center;padding-left:5px;padding-right:5px;margin-right:2px}.navigation-button rte-icon{margin-top:-2px}.mat-button-toggle-checked{background-color:inherit!important}span{margin-top:16px}.status{padding-left:15px;font-size:14px!important;margin-top:2px;font:500 14px/32px Roboto,\"Helvetica Neue\",sans-serif}.current{color:#43a047}.future{color:#1e88e5}.past{color:#f44336}.button-margin{margin-right:10px}.mat-button-toggle-disabled{color:rgba(0,0,0,.26)!important}"]
                }] }
    ];
    /** @nocollapse */
    TermComponent.ctorParameters = function () { return [
        { type: RteDialog },
        { type: RTEAlertService }
    ]; };
    TermComponent.propDecorators = {
        termObject: [{ type: Input }],
        toolbarParentObject: [{ type: Input }],
        showButton: [{ type: Input }],
        service: [{ type: Input }],
        disabled: [{ type: Input }],
        customizeBeforeInsert: [{ type: Output }],
        customizeAfterInsert: [{ type: Output }],
        customizeBeforeEdit: [{ type: Output }],
        customizeAfterEdit: [{ type: Output }],
        customizeBeforeDelete: [{ type: Output }],
        customizeAfterDelete: [{ type: Output }],
        customizeBeforeGet: [{ type: Output }],
        customizeAfterGet: [{ type: Output }],
        customizeAfterEditMode: [{ type: Output }],
        customizeAfterInsertMode: [{ type: Output }],
        customizeAfterCurrentChange: [{ type: Output }],
        customizeAfterCancel: [{ type: Output }]
    };
    return TermComponent;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var RteTermModule = /** @class */ (function () {
    function RteTermModule() {
    }
    RteTermModule.decorators = [
        { type: NgModule, args: [{
                    declarations: [TermComponent],
                    imports: [
                        CommonModule,
                        CommonModule,
                        RteLibraryModule,
                        FormsModule,
                        MatFormFieldModule,
                        RteMaterialModule,
                        MatToolbarModule,
                        ReactiveFormsModule,
                        RteToolbarLiteModule,
                        TextMaskModule,
                        MatButtonToggleModule
                    ],
                    exports: [TermComponent]
                },] }
    ];
    return RteTermModule;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
var APP_MAIN_URL = new InjectionToken('AppMainUrl');

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var EnumListService = /** @class */ (function () {
    function EnumListService(httpClient, mainUrl) {
        this.httpClient = httpClient;
        this.mainUrl = mainUrl;
        this.dictionary = {};
    }
    /**
     * @param {?} key
     * @return {?}
     */
    EnumListService.prototype.getCollection = /**
     * @param {?} key
     * @return {?}
     */
    function (key) {
        if (this.dictionary[key] === undefined) {
            /** @type {?} */
            var result = this.httpClient.get(this.mainUrl + 'Enumlist/' + key);
            this.dictionary[key] = result;
        }
        return this.dictionary[key];
    };
    EnumListService.decorators = [
        { type: Injectable, args: [{
                    providedIn: 'root'
                },] }
    ];
    /** @nocollapse */
    EnumListService.ctorParameters = function () { return [
        { type: HttpClient },
        { type: String, decorators: [{ type: Inject, args: [APP_MAIN_URL,] }] }
    ]; };
    /** @nocollapse */ EnumListService.ngInjectableDef = defineInjectable({ factory: function EnumListService_Factory() { return new EnumListService(inject(HttpClient), inject(APP_MAIN_URL)); }, token: EnumListService, providedIn: "root" });
    return EnumListService;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var EnumItem = /** @class */ (function () {
    function EnumItem() {
    }
    return EnumItem;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var RteNoWrapTextComponent = /** @class */ (function () {
    function RteNoWrapTextComponent() {
        this.matTooltipPosition = 'above';
    }
    /**
     * @return {?}
     */
    RteNoWrapTextComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
    };
    RteNoWrapTextComponent.decorators = [
        { type: Component, args: [{
                    selector: 'rte-no-wrap-text',
                    template: "<div [matTooltip]=\"text\"\r\n    [matTooltipPosition]=\"matTooltipPosition\"\r\n    class=\"no-wrap-text\">\r\n    {{text}}\r\n</div>",
                    host: {
                        'class': 'no-wrap-text-component',
                    },
                    styles: [".no-wrap-text-component{width:100%;max-width:100%}.no-wrap-text{width:calc(100% - 10px);white-space:nowrap;overflow:hidden;text-overflow:ellipsis}"]
                }] }
    ];
    RteNoWrapTextComponent.propDecorators = {
        text: [{ type: Input }],
        matTooltipPosition: [{ type: Input }]
    };
    return RteNoWrapTextComponent;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var RteNoWrapTextModule = /** @class */ (function () {
    function RteNoWrapTextModule() {
    }
    RteNoWrapTextModule.decorators = [
        { type: NgModule, args: [{
                    imports: [
                        CommonModule,
                        MatTooltipModule
                    ],
                    exports: [RteNoWrapTextComponent],
                    declarations: [RteNoWrapTextComponent]
                },] }
    ];
    return RteNoWrapTextModule;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

export { RteLibraryService, RteLibraryComponent, RteLibraryModule, YesNoDialogComponent, ActionYesNoButton, RteToolbarModule, AfterDelete, BeforeGet, AfterGet, AfterSave, BeforeDelete, BeforeSave, ShowButton, RteToolbarPagination, RteToolbarViewModel, ToolbarComponent, RteToolbarDataSource, RteToolbarModeEnum, RteToolbarStatusEnum, LocalDataToolbarComponent, ToolbarBaseComponent, RteToolbarObjectStatusEnum, LocalDataSourceResult, ValidateItem, ShowButtonLocalDataToolbar, RteLocalDataToolbarViewModel, RteMaterialModule, RteIconComponent, RteMaterialBaseService, AppService, RTE_APP_SERVICE_DATA, RTE_COLOR_SERVICE_DATA, CookieService, RTE_COOKIE_SERVICE_DATA, RteSnackbarService, RteColorService$$1 as RteColorService, RTE_INTERCEPTOR_SKIP_HEADER$$1 as RTE_INTERCEPTOR_SKIP_HEADER, AppHttpInterceptor$$1 as AppHttpInterceptor, Company, CurrentUser, PagedBaseResponse, Option, System, SpinnerComponent, RteSpinnerModule, RteTabModule, TabComponent, TabService, TabParameter, RteAutoCompleteModule, AutoCompleteComponent, HttpHelper, RteToolbarLiteModule, ToolbarLiteComponent, RteLogDialogModule$$1 as RteLogDialogModule, LogDialogDirective, RteRetroactiveLabelModule, RetroactiveLabelComponent, RteBreadcrumbModule, RteToolbarMinorModule, ShowToolbarMinorButton, DisabledToolbarMinorButton, RteAppTitleModule, ApplicationSettingsModule, ApplicationSettingsService, LoadApplicationSettingsRequest, LoadApplicationSettingsResponse, PermissionRequest, PermissionResponse, ApplicationSettingsHelper, RteAlertModule, RteToastAlertComponent, RTEAlertService, RteSimpleButtonAction, RteIndividualConfig, RteDialog, RteDialogRef, RteSortDirective, RteFileSelectDirective, RteFileDropDirective, RteFileUploadModule, RteFileUploader, RteLovModule, RteLovComponent, RteLovMultiSelectComponent, RteTermModule, TermComponent, ShowButtonTerm, TermPeriodEnum, BeforeEditTerm, BeforeGetTerm, BeforeInsertTerm, FormTermStatus, TermPagination, BeforeDeleteTerm, RteTermViewModel, RtePaginatorComponent, APP_MAIN_URL, EnumListService, EnumItem, RteInputComponent, RteLovModalComponent, RteNoWrapTextModule, RteNoWrapTextComponent, ListButtonsComponent as ɵcg, RteCurrencyPipe as ɵch, RteDatePipe as ɵci, RtePercentPipe as ɵcj, AppTitleComponent as ɵcp, BaseValueAccessor as ɵcm, BreadcrumbComponent as ɵcn, RteFileComponent as ɵcq, LogService as ɵck, LogComponent as ɵcl, RteLovMultiSelectModalComponent as ɵcr, RteChipInputDirective as ɵy, RteChipListComponent as ɵz, RteChipRemoveDirective as ɵba, RteChipDirective as ɵx, RteBadgeDirective as ɵbq, RteButtonComponent as ɵl, RteCardComponent as ɵv, RTE_CHECKBOX_CONTROL_VALUE_ACCESSOR as ɵf, RteCheckboxComponent as ɵg, RTE_DATEPICKER_VALIDATORS as ɵbj, RTE_DATEPICKER_VALUE_ACCESSOR as ɵbi, RteDatepickerInput as ɵbk, RteDatepickerToggle as ɵbg, RteDatepickerComponent as ɵbh, RteDialogActionsDirective as ɵbl, RteDialogCloseDirective as ɵbm, RteDialogContainer as ɵbn, RteDialogContentDirective as ɵbo, RteDialogTitleDirective as ɵbp, RteDividerComponent as ɵw, RteAccordionDirective as ɵbx, RteExpansionPanelActionRowDirective as ɵby, RteExpansionPanelHeaderComponent as ɵbz, RteExpansionPanelComponent as ɵca, RteExpansionPanelDescriptionDirective as ɵcb, RteExpansionPanelTitleDirective as ɵcc, RteErrorDirective as ɵc, RteFormFieldComponent as ɵb, SafeStylePipe as ɵa, RteMatAutocompleteComponent as ɵi, RteMenuContentDirective as ɵbs, RteMenuItemComponent as ɵbt, RteMenuTriggerDirective as ɵbu, _RteMatMenu as ɵbv, RteNavbuttonComponent as ɵcf, RteOptionComponent as ɵe, RteProgressBarComponent as ɵbr, RTE_RADIO_GROUP_CONTROL_VALUE_ACCESSOR as ɵbd, RteRadioButtonComponent as ɵbf, RteRadioGroupDirective as ɵbe, RteSelectComponent as ɵd, MAT_SLIDER_VALUE_ACCESSOR as ɵcd, RteSliderComponent as ɵce, RteSortHeader as ɵbw, RteHeaderRowComponent as ɵt, RteRowComponent as ɵr, RteCellDefDirective as ɵm, RteCellDirective as ɵo, RteColumnDefDirective as ɵn, RteHeaderCellDefDirective as ɵq, RteHeaderCellDirective as ɵp, RteHeaderRowDefDirective as ɵu, RteRowDefDirective as ɵs, RteTableComponent as ɵh, RteTooltipComponent as ɵbb, RteTooltipDirective as ɵbc, MAT_AUTOCOMPLETE_VALUE_ACCESSOR as ɵj, RteMatAutocompleteTrigger as ɵk, ToolbarMinorComponent as ɵco };

//# sourceMappingURL=rte-library.js.map